module.exports = {
    BubblesData: () => {
        return [
            [
                {
                    num:"502",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[619.693,434.916],[619.693,331.999],[439.873,441.226],[439.873,344.533]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[619.693,553.302],[619.693,450.385],[439.873,552.452],[439.873,455.76]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[619.693,565.093],[619.693,668.01],[439.873,563.53],[439.873,660.223]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[619.693,686.426],[619.693,789.343],[439.873,677.526],[439.873,774.218]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[618.984,808.338],[618.984,911.23],[439.247,792.068],[439.247,888.739]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[575.088,325.842],[575.088,230.781],[534.593,328.792],[534.593,235.046]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[581.021,318.937],[581.021,220.8],[549.612,323.127],[549.612,226.857]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[605.693,315.941],[605.693,216.47],[581.021,318.937],[581.021,220.801]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[647.099,311.663],[647.099,210.286],[605.693,315.941],[605.693,216.47]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[825.512,427.694],[825.512,317.653],[620.793,434.878],[620.793,331.923]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[825.512,554.274],[825.512,444.233],[620.793,553.307],[620.793,450.352]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[825.512,566.882],[825.512,676.923],[620.793,565.103],[620.793,668.058]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[825.512,696.614],[825.512,806.655],[620.793,686.481],[620.793,789.436]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[825.512,827.033],[825.512,937.074],[620.793,808.501],[620.793,911.456]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[706.353,308.505],[706.353,205.722],[651.372,311.497],[651.372,210.047]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[745.861,306.723],[745.861,203.145],[706.353,308.505],[706.353,205.722]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[803.099,304.418],[803.099,199.814],[745.86,306.723],[745.86,203.145]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[803.1,304.418],[803.1,199.814],[827.296,307.619],[827.296,204.441]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[914.405,427.787],[825.511,427.694],[914.405,317.838],[825.511,317.653]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[914.405,554.262],[825.511,554.274],[914.405,444.313],[825.511,444.233]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[914.405,566.859],[825.511,566.882],[914.405,676.808],[825.511,676.923]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[914.405,696.482],[825.511,696.614],[914.405,806.431],[825.511,806.655]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[914.634,826.74],[825.511,827.033],[914.634,936.668],[825.511,937.074]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[876.451,304.039],[876.451,199.267],[827.296,307.619],[827.296,204.44]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[876.45,304.04],[876.45,199.267],[962.379,305.541],[962.379,201.438]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[914.405,427.787],[914.405,317.838],[954.879,430.499],[954.879,323.224]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[914.405,554.262],[914.405,444.313],[954.879,553.897],[954.879,446.623]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[914.405,566.859],[914.405,676.808],[954.879,566.187],[954.879,673.461]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[914.405,696.482],[914.405,806.431],[954.879,692.657],[954.879,799.931]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[914.634,826.74],[914.634,936.668],[953.215,820.072],[953.215,927.451]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[995.414,823.655],[995.414,932.405],[953.215,820.072],[953.215,927.451]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[995.526,429.162],[995.525,320.57],[954.88,430.499],[954.88,323.224]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[995.526,554.077],[995.525,445.484],[954.88,553.897],[954.88,446.622]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[995.525,566.518],[995.526,675.11],[954.88,566.187],[954.88,673.461]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[995.525,694.542],[995.526,803.134],[954.88,692.657],[954.88,799.931]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[962.379,305.541],[962.379,201.438],[1047.5,309.842],[1047.5,207.654]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[995.524,429.163],[995.523,320.571],[1072.62,434.526],[1072.62,331.224]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[995.524,554.077],[995.523,445.485],[1072.62,553.354],[1072.62,450.053]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[995.523,566.518],[995.524,675.11],[1072.62,565.19],[1072.62,668.492]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[995.523,694.542],[995.524,803.134],[1072.62,686.976],[1072.62,790.278]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[995.413,823.655],[995.413,932.405],[1077.68,808.873],[1077.68,911.97]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1047.5,309.842],[1047.5,207.654],[1152.18,317.437],[1152.18,218.632]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1143.1,432.372],[1143.1,326.945],[1072.62,434.526],[1072.62,331.224]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1143.1,553.645],[1143.1,448.218],[1072.62,553.354],[1072.62,450.053]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1143.1,565.723],[1143.1,671.15],[1072.62,565.19],[1072.62,668.492]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1143.1,690.015],[1143.1,795.441],[1072.62,686.977],[1072.62,790.278]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1140.81,814.986],[1140.81,920.42],[1070.66,809.451],[1070.66,912.769]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1140.81,814.986],[1140.81,920.42],[1248.04,804.559],[1248.04,906.006]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1143.1,432.372],[1143.1,326.945],[1244.71,436.18],[1244.71,334.511]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1143.1,553.645],[1143.1,448.218],[1244.71,553.132],[1244.71,451.462]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1143.1,565.723],[1143.1,671.15],[1244.71,564.78],[1244.71,666.45]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1143.1,690.015],[1143.1,795.442],[1244.71,684.643],[1244.71,786.313]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1162.77,316.767],[1162.77,217.663],[1246.61,325.556],[1246.61,230.368]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1246.61,325.556],[1246.61,230.368],[1312.93,336.2],[1312.93,245.753]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1228.37,440.011],[1228.37,338.827],[1405.43,453.029],[1405.43,365.119]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1228.37,556.403],[1228.37,455.219],[1405.43,554.153],[1405.43,466.242]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1228.37,567.995],[1228.37,669.179],[1405.43,564.225],[1405.43,652.135]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1228.37,687.285],[1228.37,788.468],[1405.43,667.866],[1405.43,755.776]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1228.37,803.868],[1228.37,905.052],[1405.43,769.157],[1405.43,857.067]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1312.93,336.2],[1312.93,245.752],[1343.61,345.521],[1343.61,259.224]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1337.64,346.27],[1337.64,260.309],[1349.45,355.084],[1349.45,273.049]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1425.17,450.13],[1425.17,362.219],[1436.88,454.253],[1436.88,370.41]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1425.17,551.253],[1425.17,463.343],[1436.88,550.698],[1436.88,466.855]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1425.17,561.325],[1425.17,649.235],[1436.88,560.304],[1436.88,644.147]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:1,
                    verts:[[1425.17,664.966],[1425.17,752.877],[1436.88,659.15],[1436.88,742.993]]
                },
                ],
                [
                {
                    num:"102",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[655.248,809.042],[655.248,912.204],[457.459,794.684],[457.459,892.355]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[656.022,434.646],[656.022,331.463],[458.153,440.214],[458.153,342.524]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[656.022,553.338],[656.022,450.155],[458.153,552.588],[458.153,454.898]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[656.022,565.16],[656.022,668.343],[458.153,563.781],[458.153,661.472]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[656.022,686.807],[656.022,789.99],[458.153,678.953],[458.153,776.643]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[547.916,327.3],[547.916,232.888],[540.901,334.019],[540.901,242.6]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[592.235,324.697],[592.235,229.125],[547.915,327.299],[547.915,232.888]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[605.562,317.898],[605.562,219.299],[569.221,321.794],[569.221,224.929]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[633.721,315.139],[633.721,215.31],[605.561,317.898],[605.561,219.299]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[680.053,311.262],[680.053,209.706],[633.721,315.139],[633.721,215.31]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[878.816,428.376],[878.816,319.008],[657.224,434.612],[657.224,331.396]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[878.816,554.183],[878.816,444.815],[657.224,553.343],[657.224,450.126]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[878.816,566.713],[878.816,676.081],[657.224,565.169],[657.224,668.385]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[878.816,695.651],[878.816,805.019],[657.224,686.855],[657.224,790.072]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[878.816,825.272],[878.816,934.64],[657.224,809.186],[657.224,912.402]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[742.97,308.66],[742.97,205.945],[684.535,311.135],[684.535,209.524]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[784.416,307.249],[784.416,203.905],[742.97,308.66],[742.97,205.945]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[843.941,305.485],[843.941,201.357],[784.416,307.249],[784.416,203.906]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[843.942,305.485],[843.942,201.357],[864.719,308.837],[864.719,206.201]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[917.185,305.757],[917.185,201.75],[864.72,308.837],[864.72,206.201]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[878.816,428.376],[878.816,319.008],[966.592,428.835],[966.592,319.921]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[878.816,554.183],[878.816,444.815],[966.592,554.121],[966.592,445.206]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[878.816,566.713],[878.816,676.081],[966.592,566.599],[966.592,675.514]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[878.816,695.651],[966.592,695.003],[878.816,805.019],[966.592,803.918]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[878.816,825.272],[966.772,824.034],[878.816,934.64],[966.772,932.928]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[917.184,305.757],[917.184,201.75],[1000.49,307.971],[1000.49,204.95]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[966.592,428.835],[966.592,319.921],[1000.35,431.645],[1000.35,325.502]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[966.592,554.121],[966.592,445.206],[1000.35,553.742],[1000.35,447.599]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[966.592,566.599],[966.592,675.514],[1000.35,565.903],[1000.35,672.046]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[966.592,695.003],[966.592,803.918],[1000.35,691.04],[1000.35,797.183]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[966.772,824.034],[966.772,932.928],[998.957,817.124],[998.957,923.376]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1043.54,820.176],[1043.54,927.594],[998.957,817.124],[998.957,923.376]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1000.49,307.971],[1000.49,204.95],[1079.67,312.888],[1079.67,212.057]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1043.29,430.508],[1043.29,323.243],[1000.35,431.645],[1000.35,325.502]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1043.29,553.896],[1043.29,446.63],[1000.35,553.742],[1000.35,447.599]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1043.29,566.185],[1043.29,673.45],[1000.35,565.903],[1000.35,672.046]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1043.29,692.644],[1043.29,799.909],[1000.35,691.04],[1000.35,797.183]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1043.29,430.508],[1043.29,323.243],[1106.75,436.029],[1106.75,334.209]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1043.29,553.896],[1043.29,446.63],[1106.75,553.152],[1106.75,451.333]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1043.29,566.185],[1043.29,673.45],[1106.75,564.818],[1106.75,666.637]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1043.29,692.644],[1043.29,799.909],[1106.75,684.857],[1106.75,786.677]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1043.54,820.175],[1043.54,927.594],[1111.22,804.962],[1111.22,906.563]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1079.67,312.888],[1079.67,212.057],[1174.1,321.133],[1174.1,223.974]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1180.15,434.211],[1180.15,330.598],[1106.75,436.029],[1106.75,334.209]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1180.15,553.397],[1180.15,449.784],[1106.75,553.152],[1106.75,451.333]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1180.15,565.268],[1180.15,668.881],[1106.75,564.818],[1106.75,666.637]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1180.15,687.421],[1180.15,791.034],[1106.75,684.857],[1106.75,786.677]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1177.94,810.265],[1177.94,913.894],[1104.87,805.593],[1104.87,907.436]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1177.94,810.265],[1177.94,913.894],[1272.79,799.122],[1272.79,898.49]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1180.15,434.211],[1180.15,330.598],[1270.07,438.283],[1270.07,338.687]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1180.15,553.397],[1180.15,449.784],[1270.07,552.849],[1270.07,453.253]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1180.15,565.268],[1180.15,668.881],[1270.07,564.259],[1270.07,663.855]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1180.15,687.421],[1180.15,791.034],[1270.07,681.677],[1270.07,781.272]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1185.06,320.568],[1185.06,223.158],[1257.48,329.749],[1257.48,236.428]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1257.48,329.749],[1257.48,236.428],[1310.85,340.545],[1310.85,252.033]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1253.22,441.97],[1253.22,342.785],[1393.94,455.133],[1393.94,369.367]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1253.22,556.064],[1253.22,456.878],[1393.94,553.789],[1393.94,468.024]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1253.22,567.428],[1253.22,666.613],[1393.94,563.616],[1393.94,649.381]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1253.22,684.362],[1253.22,783.547],[1393.94,664.728],[1393.94,750.493]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1253.22,798.644],[1253.22,897.829],[1393.94,763.547],[1393.94,849.313]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1310.85,340.545],[1310.85,252.033],[1331.14,349.776],[1331.14,265.374]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1412.8,452.367],[1412.8,366.664],[1415.05,456.378],[1415.05,374.631]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1412.8,550.952],[1412.8,465.249],[1415.05,550.412],[1415.05,468.665]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1412.8,560.771],[1412.8,646.474],[1415.05,559.778],[1415.05,641.525]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:2,
                    verts:[[1412.8,661.81],[1412.8,747.513],[1415.05,656.152],[1415.05,737.899]]
                },
                ],
                [
                {
                    num:"102",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[693.736,809.411],[693.736,912.714],[479.91,797.117],[479.91,895.719]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[694.566,434.506],[694.566,331.185],[480.667,439.274],[480.667,340.655]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[694.566,553.357],[694.566,450.036],[480.667,552.715],[480.667,454.097]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[694.566,565.195],[694.566,668.516],[480.667,564.014],[480.667,662.633]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[694.566,687.004],[694.566,790.326],[480.667,680.28],[480.667,778.898]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[564.502,325.911],[564.502,230.881],[550.277,332.538],[550.277,240.46]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[612.254,323.681],[612.254,227.658],[564.501,325.911],[564.501,230.881]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[632.875,317.051],[632.875,218.074],[591.948,320.615],[591.948,223.225]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[664.229,314.553],[664.229,214.464],[632.874,317.051],[632.874,218.074]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[714.963,311.112],[714.963,209.49],[664.229,314.553],[664.229,214.464]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[931.307,429.23],[931.307,320.704],[695.854,434.478],[695.854,331.128]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[931.307,554.068],[931.307,445.542],[695.854,553.361],[695.854,450.012]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[931.307,566.502],[931.307,675.028],[695.854,565.202],[695.854,668.551]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[931.307,694.447],[931.307,802.973],[695.854,687.045],[695.854,790.394]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[931.307,823.071],[931.307,931.597],[695.854,809.533],[695.854,912.883]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[780.796,309.081],[780.796,206.555],[719.602,311.025],[719.602,209.364]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[823.673,308.047],[823.673,205.06],[780.796,309.081],[780.796,206.555]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[884.743,306.826],[884.743,203.295],[823.673,308.048],[823.673,205.06]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[884.744,306.826],[884.744,203.295],[901.949,310.289],[901.949,208.3]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[957.027,307.719],[957.027,204.586],[901.95,310.289],[901.95,208.3]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[931.307,429.23],[931.307,320.704],[1016.87,430.032],[1016.87,322.298]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[931.307,554.068],[931.307,445.542],[1016.87,553.96],[1016.87,446.225]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[931.307,566.502],[931.307,675.028],[1016.87,566.303],[1016.87,674.037]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[931.307,694.447],[931.307,802.974],[1016.87,693.315],[1016.87,801.05]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[931.307,823.071],[931.307,931.597],[1017,820.946],[1017,928.66]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[957.025,307.719],[957.025,204.586],[1036.85,310.587],[1036.85,208.73]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1016.87,430.032],[1016.87,322.298],[1043.77,432.905],[1043.77,328.005]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1016.87,553.96],[1016.87,446.225],[1043.77,553.573],[1043.77,448.672]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1016.87,566.303],[1016.87,674.037],[1043.77,565.591],[1043.77,670.492]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1016.87,693.315],[1016.87,801.05],[1043.77,689.263],[1043.77,794.163]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1017,820.946],[1017,928.66],[1042.65,813.882],[1042.65,918.894]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1036.86,310.587],[1036.86,208.73],[1109.48,316.033],[1109.48,216.602]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1088.96,816.401],[1088.96,922.377],[1042.65,813.882],[1042.65,918.894]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1088.37,431.966],[1088.37,326.138],[1043.77,432.905],[1043.77,328.005]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1088.37,553.699],[1088.37,447.872],[1043.77,553.573],[1043.77,448.672]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1088.37,565.824],[1088.37,671.651],[1043.77,565.591],[1043.77,670.492]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1088.37,690.588],[1088.37,796.415],[1043.77,689.263],[1043.77,794.163]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1088.37,431.966],[1088.37,326.139],[1138.12,437.577],[1138.12,337.284]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1088.37,553.699],[1088.37,447.872],[1138.12,552.944],[1138.12,452.651]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1088.37,565.824],[1088.37,671.651],[1138.12,564.434],[1138.12,664.727]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1088.37,690.588],[1088.37,796.415],[1138.12,682.674],[1138.12,782.966]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1088.96,816.401],[1088.96,922.377],[1141.99,800.942],[1141.99,901.006]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1109.48,316.033],[1109.48,216.602],[1193.24,324.802],[1193.24,229.278]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1213.47,436.087],[1213.46,334.325],[1138.12,437.577],[1138.12,337.284]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1213.47,553.144],[1213.46,451.382],[1138.12,552.944],[1138.12,452.651]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1213.46,564.803],[1213.47,666.565],[1138.12,564.434],[1138.12,664.727]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1213.46,684.775],[1213.47,786.537],[1138.12,682.674],[1138.12,782.966]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1211.36,805.444],[1211.36,907.23],[1136.34,801.616],[1136.34,901.938]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1204.44,324.34],[1204.44,228.61],[1265.46,333.796],[1265.46,242.279]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1211.36,805.444],[1211.36,907.23],[1293.6,793.76],[1293.6,891.078]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1213.47,436.087],[1213.46,334.325],[1291.48,440.36],[1291.48,342.812]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1213.47,553.144],[1213.46,451.382],[1291.48,552.569],[1291.48,455.021]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1213.46,564.803],[1213.47,666.565],[1291.48,563.745],[1291.48,661.293]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1213.46,684.775],[1213.47,786.537],[1291.48,678.748],[1291.48,776.295]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1265.46,333.796],[1265.46,242.279],[1306.32,344.641],[1306.32,257.953]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1274.33,443.907],[1274.33,346.697],[1380.1,457.086],[1380.1,373.312]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1274.33,555.729],[1274.33,458.519],[1380.1,553.452],[1380.1,469.678]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1274.33,566.867],[1274.33,664.077],[1380.1,563.05],[1380.1,646.824]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1274.33,681.472],[1274.33,778.683],[1380.1,661.815],[1380.1,745.589]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1274.33,793.479],[1274.33,890.689],[1380.1,758.339],[1380.1,842.114]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:3,
                    verts:[[1306.32,344.641],[1306.32,257.953],[1316.81,353.72],[1316.81,271.075]]
                },
                ],
                [
                {
                    num:"102",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[507.093,786.158],[507.093,880.57],[468.323,784.525],[468.323,878.311]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[509.12,443.623],[509.12,349.294],[471.752,444.232],[471.752,350.505]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[509.12,552.129],[509.12,457.801],[471.752,552.047],[471.752,458.32]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[509.12,562.937],[509.12,657.265],[471.752,562.786],[471.752,656.513]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[509.12,674.145],[509.12,768.473],[471.752,673.285],[471.752,767.012]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[506.242,799.406],[506.242,898.884],[475.959,792.063],[475.959,888.733]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[507.054,438.389],[507.054,338.898],[476.472,441.221],[476.472,344.523]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[507.054,552.834],[507.054,453.343],[476.472,552.453],[476.472,455.755]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[507.054,564.233],[507.054,663.724],[476.472,563.532],[476.472,660.23]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[507.054,681.527],[507.054,781.018],[476.472,677.533],[476.472,774.231]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[734.797,434.47],[734.797,331.112],[507.054,438.389],[507.054,338.898]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[734.797,553.362],[734.797,450.005],[507.054,552.834],[507.054,453.343]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[734.797,565.204],[734.797,668.561],[507.054,564.233],[507.054,663.724]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[734.797,687.056],[734.797,790.414],[507.054,681.527],[507.054,781.018]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[733.921,809.515],[733.921,912.858],[506.242,799.406],[506.242,898.884]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[584.06,324.591],[584.06,228.973],[562.67,331.073],[562.67,238.341]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[634.826,322.755],[634.826,226.319],[584.06,324.591],[584.06,228.973]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[662.562,316.348],[662.562,217.058],[617.439,319.549],[617.439,221.685]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[696.787,314.133],[696.787,213.857],[662.562,316.348],[662.562,217.058]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[751.363,311.154],[751.363,209.55],[696.787,314.133],[696.787,213.857]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[982.429,430.208],[982.429,322.646],[736.158,434.446],[736.158,331.066]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[982.429,553.936],[982.429,446.375],[736.158,553.365],[736.158,449.985]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[982.429,566.259],[982.429,673.821],[736.158,565.21],[736.158,668.59]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[982.429,693.068],[982.429,800.629],[736.158,687.089],[736.158,790.47]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[982.429,820.548],[982.429,928.11],[736.158,809.614],[736.158,912.995]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[819.363,309.703],[819.363,207.453],[756.108,311.107],[756.108,209.482]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[863.174,309.045],[819.362,309.703],[863.174,206.502],[819.362,207.453]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[925.075,308.359],[863.173,309.045],[925.075,205.51],[863.173,206.502]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[925.076,308.359],[925.076,205.51],[938.62,311.898],[938.62,210.625]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[995.628,309.838],[995.628,207.648],[938.621,311.898],[938.621,210.625]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[982.428,430.208],[982.428,322.646],[1064.82,431.327],[1064.82,324.871]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[982.428,553.936],[982.428,446.375],[1064.82,553.785],[1064.82,447.328]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[982.428,566.259],[982.428,673.821],[1064.82,565.982],[1064.82,672.439]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[982.428,693.068],[982.428,800.629],[1064.82,691.488],[1064.82,797.945]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[982.428,820.548],[982.428,928.11],[1064.9,817.605],[1064.9,924.041]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[995.627,309.838],[995.627,207.648],[1071.25,313.297],[1071.25,212.649]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1064.82,431.327],[1064.82,324.871],[1084.84,434.232],[1084.84,330.64]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1064.82,553.785],[1064.82,447.328],[1084.84,553.394],[1084.84,449.802]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1064.82,565.982],[1064.82,672.439],[1084.84,565.263],[1084.84,668.855]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1064.82,691.488],[1064.82,797.945],[1084.84,687.392],[1084.84,790.984]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1064.9,817.605],[1064.9,924.041],[1083.99,810.463],[1083.99,914.168]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1071.25,313.297],[1071.25,212.649],[1136.87,319.191],[1136.87,221.167]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1131.43,812.462],[1083.99,810.463],[1131.43,916.931],[1083.99,914.168]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1130.52,433.486],[1130.52,329.159],[1084.84,434.232],[1084.84,330.639]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1130.52,553.494],[1130.52,449.167],[1084.84,553.394],[1084.84,449.802]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1130.52,565.447],[1130.52,669.774],[1084.84,565.263],[1084.84,668.855]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1130.52,688.443],[1130.52,792.77],[1084.84,687.392],[1084.84,790.984]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1130.52,433.487],[1130.52,329.16],[1166.71,439.129],[1166.71,340.368]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1130.52,553.494],[1130.52,449.167],[1166.71,552.735],[1166.71,453.974]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1130.52,565.447],[1130.52,669.774],[1166.71,564.05],[1166.71,662.811]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1130.52,688.443],[1130.52,792.77],[1166.71,680.483],[1166.71,779.245]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1131.42,812.462],[1131.42,916.931],[1169.97,796.917],[1169.97,895.442]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1136.87,319.191],[1136.87,221.167],[1209.73,328.372],[1209.73,234.438]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1243.11,437.956],[1243.11,338.037],[1166.71,439.129],[1166.71,340.368]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1243.11,552.893],[1243.11,452.974],[1166.71,552.735],[1166.71,453.974]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1243.11,564.34],[1243.11,664.259],[1166.71,564.05],[1166.71,662.811]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1243.11,682.138],[1243.11,782.057],[1166.71,680.483],[1166.71,779.245]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1241.13,800.641],[1241.13,900.591],[1165.04,797.625],[1165.04,896.421]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1221.05,328.008],[1221.05,233.912],[1270.85,337.641],[1270.85,247.836]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1241.13,800.641],[1241.13,900.591],[1310.74,788.568],[1310.74,883.9]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1243.11,437.956],[1243.11,338.037],[1309.2,442.372],[1309.2,346.811]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1243.11,552.893],[1243.11,452.974],[1309.2,552.298],[1309.2,456.736]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1243.11,564.34],[1243.11,664.259],[1309.2,563.247],[1309.2,658.808]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1243.11,682.138],[1243.11,782.057],[1309.2,675.908],[1309.2,771.47]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1270.85,337.641],[1270.85,247.836],[1299.69,348.449],[1299.69,263.459]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1299.69,348.449],[1299.69,263.459],[1300.93,357.329],[1300.93,276.292]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1291.92,445.787],[1291.92,350.492],[1364.32,458.878],[1364.32,376.931]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1291.92,555.404],[1291.92,460.11],[1364.32,553.142],[1364.32,471.195]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1291.92,566.322],[1291.92,661.617],[1364.32,562.531],[1364.32,644.478]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1291.92,678.669],[1291.92,773.963],[1364.32,659.142],[1364.32,741.088]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:4,
                    verts:[[1291.92,788.468],[1291.92,883.762],[1364.32,753.561],[1364.32,835.508]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[542.679,448.042],[542.679,358.073],[478.159,448.776],[478.159,359.53]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[542.679,551.534],[542.679,461.565],[478.159,551.436],[478.159,462.19]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[542.679,561.842],[542.679,651.811],[478.159,561.661],[478.159,650.906]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[542.679,667.911],[542.679,757.88],[478.159,666.876],[478.159,756.121]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[542.488,774.673],[542.488,864.693],[478.202,772.787],[478.202,862.085]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[525.14,788.37],[525.14,883.628],[484.024,787.091],[484.024,881.859]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[527.016,442.772],[527.016,347.605],[487.396,443.25],[487.396,348.553]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[527.016,552.244],[527.016,457.077],[487.396,552.18],[487.396,457.483]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[527.016,563.148],[527.016,658.315],[487.396,563.029],[487.396,657.726]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[527.016,675.345],[527.016,770.512],[487.396,674.671],[487.396,769.368]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[536.115,801.59],[536.115,901.902],[498.603,794.551],[498.603,892.171]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[536.976,437.546],[536.976,337.223],[499.195,440.259],[499.195,342.611]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[536.976,552.948],[536.976,452.625],[499.195,552.583],[499.195,454.935]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[536.976,564.442],[536.976,664.765],[499.195,563.77],[499.195,661.417]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[536.976,682.717],[536.976,783.04],[499.195,678.89],[499.195,776.538]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[776.261,434.51],[776.261,331.193],[536.976,437.546],[536.976,337.223]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[776.261,553.357],[776.261,450.039],[536.976,552.948],[536.976,452.625]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[776.261,565.194],[776.261,668.511],[536.976,564.442],[536.976,664.765]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[776.261,686.999],[776.261,790.316],[536.976,682.717],[536.976,783.039]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[775.348,809.419],[775.348,912.725],[536.115,801.59],[536.115,901.902]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[577.87,329.591],[577.87,236.2],[572.276,336.995],[572.276,246.901]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[606.327,323.304],[606.327,227.113],[577.871,329.591],[577.871,236.2]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[659.665,321.88],[659.665,225.054],[606.327,323.304],[606.327,227.113]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[694.269,315.746],[694.269,216.187],[645.375,318.558],[645.375,220.252]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[731.018,313.83],[731.018,213.419],[694.268,315.746],[694.268,216.187]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[788.852,311.332],[788.852,209.808],[731.018,313.83],[731.018,213.419]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1031.78,431.268],[1031.78,324.753],[777.677,434.492],[777.677,331.157]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1031.78,553.793],[1031.78,447.278],[777.677,553.359],[777.677,450.024]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1031.78,565.997],[1031.78,672.512],[777.677,565.198],[777.677,668.533]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1031.78,691.572],[1031.78,798.086],[777.677,687.024],[777.677,790.359]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1031.78,817.811],[1031.78,924.326],[777.677,809.495],[777.677,912.831]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[858.282,310.461],[858.282,208.549],[793.654,311.325],[793.654,209.797]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[902.548,310.175],[858.282,310.461],[902.548,208.135],[858.282,208.549]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[964.607,310.011],[902.548,310.175],[964.607,207.898],[902.548,208.136]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[964.608,310.011],[964.608,207.898],[974.454,313.593],[974.454,213.075]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1032.75,312.037],[1032.75,210.826],[974.454,313.593],[974.454,213.075]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1031.77,431.268],[1031.77,324.754],[1110.17,432.678],[1110.17,327.554]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1031.77,553.793],[1031.77,447.278],[1110.17,553.603],[1110.17,448.479]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1031.77,565.997],[1031.77,672.512],[1110.17,565.648],[1110.17,670.772]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1031.77,691.572],[1031.77,798.086],[1110.17,689.583],[1110.17,794.707]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1031.77,817.811],[1031.77,924.326],[1110.2,814.121],[1110.2,919.225]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1032.75,312.037],[1032.75,210.826],[1103.55,316.028],[1103.55,216.595]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1103.55,316.028],[1103.55,216.595],[1161.86,322.293],[1161.86,225.651]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1110.17,432.678],[1110.17,327.554],[1123.39,435.586],[1123.39,333.33]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1110.17,553.603],[1110.17,448.479],[1123.39,553.212],[1123.39,450.956]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1110.17,565.648],[1110.17,670.772],[1123.39,564.927],[1123.39,667.184]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1110.17,689.583],[1110.17,794.707],[1123.39,685.481],[1123.39,787.737]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1110.2,814.121],[1110.2,919.225],[1122.81,806.97],[1122.81,909.34]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1169.61,435.029],[1169.61,332.224],[1123.39,435.586],[1123.39,333.33]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1169.61,553.287],[1169.61,450.481],[1123.39,553.212],[1123.39,450.956]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1169.61,565.065],[1169.61,667.871],[1123.39,564.927],[1123.39,667.183]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1169.61,686.267],[1123.39,685.481],[1169.61,789.072],[1123.39,787.737]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1170.81,808.464],[1122.81,806.97],[1170.81,911.405],[1122.81,909.34]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1161.86,322.293],[1161.86,225.651],[1223.74,331.786],[1223.74,239.373]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1169.61,435.029],[1169.61,332.224],[1192.55,440.654],[1192.55,343.396]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1169.61,553.287],[1169.61,450.481],[1192.55,552.529],[1192.55,455.272]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1169.61,565.065],[1169.61,667.871],[1192.55,563.672],[1192.55,660.93]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1169.61,686.267],[1169.61,789.072],[1192.55,678.333],[1192.55,775.59]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1170.81,808.464],[1170.81,911.405],[1195.21,792.971],[1195.21,889.987]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1269.23,439.782],[1269.23,341.665],[1192.55,440.654],[1192.55,343.396]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1269.23,552.647],[1269.23,454.529],[1192.55,552.529],[1192.55,455.272]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1269.23,563.888],[1269.23,662.005],[1192.55,563.672],[1192.55,660.93]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1269.23,679.563],[1269.23,777.68],[1192.55,678.333],[1192.55,775.59]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1267.38,795.946],[1191.01,793.705],[1267.38,894.101],[1191.01,891.002]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1235.08,331.516],[1235.08,238.982],[1273.91,341.242],[1273.91,253.041]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1267.38,795.947],[1267.38,894.101],[1324.51,783.615],[1324.51,877.054]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1269.23,439.782],[1269.23,341.665],[1323.53,444.294],[1323.53,350.628]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1269.23,552.647],[1269.23,454.529],[1323.53,552.039],[1323.53,458.373]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1269.23,563.888],[1269.23,662.005],[1323.53,562.771],[1323.53,656.437]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1269.23,679.563],[1269.23,777.68],[1323.53,673.198],[1323.53,766.864]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1273.91,341.242],[1273.91,253.041],[1291.25,351.946],[1291.25,268.513]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1306.28,447.582],[1306.28,354.118],[1346.94,460.504],[1346.94,380.215]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1306.28,555.094],[1306.28,461.63],[1346.94,552.861],[1346.94,472.572]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1306.28,565.802],[1306.28,659.267],[1346.94,562.06],[1346.94,642.349]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1306.28,675.991],[1306.28,769.455],[1346.94,656.716],[1346.94,737.005]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:5,
                    verts:[[1306.28,783.681],[1306.28,877.145],[1346.94,749.225],[1346.94,829.514]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[551.928,447.228],[551.928,356.456],[484.265,447.748],[484.265,357.489]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[551.928,551.644],[551.928,460.872],[484.265,551.574],[484.265,461.315]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[551.928,562.044],[551.928,652.816],[484.265,561.915],[484.265,652.174]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[551.928,669.059],[551.928,759.832],[484.265,668.325],[484.265,758.585]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[551.85,776.776],[551.85,867.599],[484.433,775.438],[484.433,865.75]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[546.308,790.612],[546.308,886.727],[503.149,789.705],[503.149,885.473]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[548.013,441.91],[548.013,345.891],[506.434,442.248],[506.434,346.563]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[548.013,552.36],[548.013,456.342],[506.434,552.315],[506.434,456.63]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[548.013,563.361],[548.013,659.38],[506.434,563.277],[506.434,658.962]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[548.013,676.561],[548.013,772.58],[506.434,676.084],[506.434,771.769]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[569.221,803.704],[569.221,904.824],[524.7,797.03],[524.7,895.599]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[570.122,436.73],[570.122,335.602],[525.367,439.3],[525.367,340.707]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[570.122,553.058],[570.122,451.93],[525.367,552.712],[525.367,454.119]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[570.122,564.644],[570.122,665.772],[525.367,564.008],[525.367,662.601]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[570.122,683.868],[570.122,784.996],[525.367,680.243],[525.367,778.836]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[817.633,809.184],[817.633,912.4],[569.221,803.704],[569.221,904.824]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[818.572,434.605],[818.572,331.381],[570.122,436.73],[570.122,335.602]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[818.572,553.344],[818.572,450.12],[570.122,553.058],[570.122,451.93]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[818.572,565.17],[818.572,668.394],[570.122,564.644],[570.122,665.772]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[818.572,686.865],[818.572,790.089],[570.122,683.868],[570.122,784.996]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[595.698,328.064],[595.698,233.992],[582.376,335.409],[582.376,244.61]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[631.065,322.018],[631.065,225.254],[595.699,328.064],[595.699,233.993]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[686.519,321.019],[686.519,223.809],[631.065,322.018],[631.065,225.254]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[727.688,315.203],[727.688,215.403],[675.474,317.605],[675.474,218.874]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[766.602,313.601],[766.602,213.087],[727.687,315.203],[727.687,215.403]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[827.1,311.598],[827.1,210.192],[766.602,313.601],[766.602,213.087]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1079.06,432.377],[1079.06,326.956],[820.03,434.592],[820.03,331.356]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1079.06,553.644],[1079.06,448.223],[820.03,553.346],[820.03,450.109]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1079.06,565.722],[1079.06,671.143],[820.03,565.174],[820.03,668.41]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1079.06,690.008],[1079.06,795.429],[820.03,686.883],[820.03,790.119]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1079.06,814.952],[1079.06,920.373],[820.03,809.237],[820.03,912.473]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[897.241,311.302],[831.908,311.629],[897.241,209.764],[831.908,210.238]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[897.241,311.302],[941.509,311.379],[897.241,209.764],[941.509,209.876]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[941.508,311.379],[1003.1,311.719],[941.508,209.876],[1003.1,210.367]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1003.1,311.719],[1003.1,210.367],[1009.25,315.315],[1009.25,215.565]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1068.22,314.253],[1009.25,315.315],[1068.22,214.029],[1009.25,215.565]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1068.22,314.253],[1068.22,214.029],[1133.72,318.717],[1133.72,220.482]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1079.06,432.377],[1079.06,326.956],[1152.77,434.049],[1152.77,330.276]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1079.06,553.644],[1079.06,448.223],[1152.77,553.419],[1152.77,449.646]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1079.06,565.722],[1079.06,671.143],[1152.77,565.308],[1152.77,669.08]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1079.06,690.008],[1079.06,795.429],[1152.77,687.65],[1152.77,791.422]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1079.06,814.952],[1079.06,920.373],[1152.75,810.586],[1152.75,914.339]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1133.72,318.717],[1133.72,220.482],[1184.5,325.285],[1184.5,229.976]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1152.77,434.049],[1152.77,330.276],[1159.35,436.936],[1159.35,336.012]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1152.77,553.419],[1152.77,449.646],[1159.35,553.03],[1159.35,452.106]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1152.77,565.308],[1152.77,669.08],[1159.35,564.593],[1159.35,665.517]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1152.77,687.65],[1152.77,791.422],[1159.35,683.576],[1159.35,784.5]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1152.75,810.586],[1152.75,914.339],[1159.03,803.485],[1159.03,904.522]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1205.62,436.56],[1159.35,436.936],[1205.61,335.265],[1159.35,336.012]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1205.62,553.081],[1205.61,451.785],[1159.35,553.03],[1159.35,452.106]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1205.61,564.686],[1205.62,665.981],[1159.35,564.593],[1159.35,665.517]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1205.61,684.107],[1159.35,683.576],[1205.62,785.402],[1159.35,784.5]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1207.08,804.495],[1159.03,803.485],[1207.08,905.917],[1159.03,904.522]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1184.5,325.285],[1184.5,229.976],[1235.42,335.003],[1235.42,244.022]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1205.61,436.56],[1205.61,335.265],[1215.74,442.125],[1215.74,346.318]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1205.61,553.081],[1205.61,451.785],[1215.74,552.331],[1215.74,456.525]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1205.61,564.686],[1205.61,665.981],[1215.74,563.308],[1215.74,659.114]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1205.61,684.107],[1205.61,785.402],[1215.74,676.258],[1215.74,772.064]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1207.08,804.495],[1207.08,905.917],[1217.79,789.169],[1217.79,884.731]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1292.01,441.538],[1215.74,442.125],[1292,345.154],[1215.74,346.318]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1292.01,552.41],[1292,456.025],[1215.74,552.331],[1215.74,456.525]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1292,563.453],[1292.01,659.838],[1215.74,563.308],[1215.74,659.114]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1292,677.085],[1215.74,676.258],[1292.01,773.47],[1215.74,772.064]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1290.3,791.429],[1214.33,789.922],[1290.3,887.856],[1214.33,885.772]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1246.7,334.821],[1246.7,243.759],[1274.86,344.571],[1274.86,257.852]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1274.86,344.571],[1274.86,257.852],[1281.24,355.116],[1281.24,273.095]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1290.3,791.429],[1290.3,887.856],[1335.19,778.951],[1335.19,870.606]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1292.01,441.538],[1292,345.154],[1334.74,446.106],[1334.74,354.227]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1292.01,552.41],[1292,456.025],[1334.74,551.795],[1334.74,459.916]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1292,563.453],[1292.01,659.838],[1334.74,562.322],[1334.74,654.201]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:6,
                    verts:[[1292,677.085],[1292.01,773.47],[1334.74,670.642],[1334.74,762.522]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[563.835,446.358],[563.835,354.728],[493.449,446.655],[493.449,355.317]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[563.835,551.761],[563.835,460.131],[493.449,551.721],[493.449,460.383]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[563.835,562.259],[563.835,653.89],[493.449,562.186],[493.449,653.524]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[563.835,670.286],[563.835,761.917],[493.449,669.868],[493.449,761.206]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[563.875,779.02],[563.875,870.702],[493.743,778.257],[493.743,869.648]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[570.429,792.912],[570.429,889.906],[525.553,792.396],[525.553,889.192]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[571.947,441.024],[571.947,344.132],[528.721,441.217],[528.721,344.515]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[571.947,552.479],[571.947,455.588],[528.721,552.454],[528.721,455.752]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[571.947,563.581],[571.947,660.472],[528.721,563.533],[528.721,660.235]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[571.947,677.81],[571.947,774.702],[528.721,677.539],[528.721,774.241]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[605.296,805.78],[605.296,907.695],[554.049,799.53],[554.049,899.054]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[606.23,435.928],[606.23,334.009],[554.787,438.333],[554.787,338.786]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[606.23,553.166],[606.23,451.247],[554.787,552.842],[554.787,453.295]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[606.23,564.843],[606.23,666.761],[554.787,564.247],[554.787,663.794]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[606.23,684.999],[606.23,786.917],[554.787,681.607],[554.787,781.153]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[594.927,333.707],[594.927,242.149],[585.183,343.749],[585.183,256.665]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[616.006,326.466],[616.006,231.683],[594.927,333.707],[594.927,242.149]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[860.461,808.86],[860.461,911.952],[605.296,805.78],[605.296,907.695]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[861.418,434.734],[861.418,331.638],[606.23,435.928],[606.23,334.009]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[861.418,553.326],[861.418,450.23],[606.23,553.166],[606.23,451.247]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[861.418,565.138],[861.418,668.235],[606.23,564.843],[606.23,666.761]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[861.418,686.683],[861.418,789.779],[606.23,684.999],[606.23,786.917]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[658.08,320.706],[658.08,223.357],[616.007,326.466],[616.007,231.684]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[715.181,320.142],[715.181,222.543],[658.08,320.706],[658.08,223.357]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[762.563,314.687],[762.563,214.657],[707.502,316.659],[707.502,217.507]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[803.271,313.408],[803.271,212.808],[762.563,314.687],[762.563,214.657]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[865.833,311.909],[865.833,210.642],[803.271,313.407],[803.271,212.808]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1124.09,433.505],[1124.09,329.197],[862.901,434.727],[862.901,331.624]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1124.09,553.492],[1124.09,449.183],[862.901,553.327],[862.901,450.224]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1124.09,565.443],[1124.09,669.751],[862.901,565.14],[862.901,668.243]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1124.09,688.416],[1124.09,792.725],[862.901,686.693],[862.901,789.796]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1124.09,812.041],[1124.09,916.35],[862.901,808.889],[862.901,911.992]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[870.602,311.979],[935.996,312.18],[870.602,210.744],[935.996,211.034]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[935.996,312.18],[979.836,312.61],[935.996,211.034],[979.836,211.655]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[979.835,312.61],[1040.37,313.436],[979.835,211.655],[1040.37,212.848]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1040.37,313.436],[1040.37,212.848],[1042.88,317.02],[1042.88,218.029]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1101.96,316.437],[1042.88,317.02],[1101.96,217.186],[1042.88,218.029]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1101.95,316.437],[1101.95,217.186],[1161.74,321.318],[1161.74,224.242]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1124.09,433.505],[1124.09,329.197],[1192.54,435.412],[1192.54,332.984]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1124.09,553.492],[1124.09,449.183],[1192.54,553.235],[1192.54,450.807]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1124.09,565.443],[1124.09,669.751],[1192.54,564.97],[1192.54,667.398]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1124.09,688.416],[1124.09,792.725],[1192.54,685.727],[1192.54,788.155]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1124.09,812.041],[1124.09,916.35],[1192.48,807.072],[1192.48,909.48]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1161.74,321.318],[1161.74,224.242],[1204.88,328.128],[1204.88,234.085]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1192.54,435.412],[1192.54,332.984],[1192.69,438.259],[1192.69,338.639]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1192.54,553.235],[1192.54,450.807],[1192.69,552.852],[1192.69,453.232]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1192.54,564.971],[1192.54,667.398],[1192.69,564.265],[1192.69,663.885]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1192.54,685.727],[1192.54,788.155],[1192.69,681.711],[1192.69,781.33]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1192.48,807.072],[1192.48,909.48],[1192.63,800.07],[1192.63,899.801]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1192.69,438.259],[1238.57,438.055],[1192.69,338.639],[1238.57,338.233]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1192.69,552.852],[1238.57,552.879],[1192.69,453.232],[1238.57,453.058]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1192.69,564.265],[1238.57,564.316],[1192.69,663.885],[1238.57,664.137]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1192.69,681.711],[1238.57,681.999],[1192.69,781.33],[1238.57,781.82]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1192.63,800.07],[1240.27,800.618],[1192.63,899.801],[1240.27,900.558]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1204.88,328.128],[1204.88,234.085],[1244.95,337.995],[1244.95,248.347]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1236.39,443.524],[1311.63,443.207],[1236.39,349.098],[1311.63,348.468]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1236.39,552.143],[1236.39,457.717],[1311.63,552.186],[1311.63,457.447]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1236.39,562.961],[1311.63,563.04],[1236.39,657.388],[1311.63,657.779]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1236.39,674.284],[1311.63,674.732],[1236.39,768.71],[1311.63,769.47]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1235.11,786.322],[1310.07,787.137],[1235.11,880.795],[1310.07,881.922]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1256.08,337.896],[1256.08,248.204],[1273.92,347.612],[1273.92,262.248]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1310.07,787.137],[1310.07,881.922],[1343.07,774.605],[1343.07,864.599]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1311.63,443.207],[1311.63,348.468],[1343.12,447.795],[1343.12,357.582]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1311.63,552.186],[1311.63,457.447],[1343.12,551.568],[1343.12,461.354]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1311.63,563.04],[1311.63,657.779],[1343.12,561.904],[1343.12,652.117]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:7,
                    verts:[[1311.63,674.732],[1311.63,769.471],[1343.12,668.26],[1343.12,758.473]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[505.671,445.487],[505.671,352.997],[494.372,450.058],[494.372,362.077]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[505.671,551.878],[505.671,459.389],[494.372,551.263],[494.372,463.282]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[505.671,562.475],[505.671,654.965],[494.372,561.343],[494.372,649.324]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[505.671,671.515],[505.671,764.005],[494.372,665.068],[494.372,753.049]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[578.337,445.424],[578.337,352.872],[505.671,445.487],[505.671,352.997]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[578.337,551.887],[578.337,459.335],[505.671,551.878],[505.671,459.389]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[578.337,562.491],[578.337,655.043],[505.671,562.475],[505.671,654.965]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[578.337,671.604],[578.337,764.156],[505.671,671.515],[505.671,764.005]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[578.496,781.43],[578.496,874.033],[506.094,781.268],[506.094,873.81]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[597.378,795.292],[551.126,795.183],[597.378,893.197],[551.126,893.046]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[598.69,440.107],[598.69,342.31],[554.146,440.148],[554.146,342.391]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[598.69,552.603],[598.69,454.806],[554.146,552.598],[554.146,454.841]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[598.69,563.808],[598.69,661.604],[554.146,563.798],[554.146,661.554]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[598.69,679.104],[598.69,776.901],[554.146,679.047],[554.146,776.803]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[644.118,807.843],[644.118,910.546],[586.492,802.072],[586.492,902.568]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[645.077,435.132],[645.077,332.428],[587.295,437.35],[587.295,336.834]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[645.077,553.273],[645.077,450.569],[587.295,552.974],[587.295,452.458]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[645.077,565.04],[645.077,667.744],[587.295,564.491],[587.295,665.007]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[645.077,686.122],[645.077,788.826],[587.295,682.993],[587.295,783.509]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[609.857,331.868],[609.857,239.49],[589.665,341.861],[589.665,253.935]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[638.681,324.779],[638.681,229.244],[609.857,331.868],[609.857,239.491]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[687.216,319.346],[687.216,221.392],[638.682,324.779],[638.682,229.244]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[903.576,808.484],[903.576,911.433],[644.118,807.843],[644.118,910.546]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[904.54,434.883],[904.54,331.934],[645.077,435.132],[645.077,332.428]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[904.54,553.306],[904.54,450.357],[645.077,553.273],[645.077,450.569]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[904.54,565.101],[904.54,668.051],[645.077,565.04],[645.077,667.744]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[904.54,686.473],[904.54,789.422],[645.077,686.122],[645.077,788.826]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[745.485,319.228],[687.216,319.346],[745.485,221.221],[687.216,221.392]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[798.684,314.17],[798.684,213.91],[741.264,315.697],[741.264,216.117]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[840.807,313.223],[840.807,212.541],[798.684,314.17],[798.684,213.91]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[904.834,312.236],[904.834,211.114],[840.807,313.223],[840.807,212.541]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[906.034,434.882],[1166.75,434.632],[906.034,331.931],[1166.75,331.434]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[906.034,553.307],[906.034,450.356],[1166.75,553.34],[1166.75,450.143]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[906.034,565.102],[1166.75,565.164],[906.034,668.053],[1166.75,668.361]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[906.034,686.475],[1166.75,686.827],[906.034,789.426],[1166.75,790.025]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[906.034,808.491],[1166.75,809.135],[906.034,911.441],[1166.75,912.333]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[909.52,312.343],[974.357,313.062],[909.52,211.269],[974.357,212.308]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[974.357,313.062],[1017.36,313.833],[974.357,212.308],[1017.36,213.423]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1017.36,313.833],[1017.36,213.423],[1076.31,315.122],[1076.31,215.286]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1075.24,318.671],[1133.89,318.552],[1075.24,220.416],[1133.89,220.244]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1133.89,318.552],[1133.89,220.244],[1187.64,323.8],[1187.64,227.829]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1166.75,434.632],[1166.75,331.434],[1229.46,436.747],[1229.46,335.636]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1166.75,553.34],[1166.75,450.143],[1229.46,553.055],[1229.46,451.945]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1166.75,565.164],[1166.75,668.361],[1229.46,564.64],[1229.46,665.751]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1166.75,686.827],[1166.75,790.025],[1229.46,683.844],[1229.46,784.954]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1166.75,809.135],[1166.75,912.333],[1229.36,803.629],[1229.36,904.72]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1187.64,323.8],[1187.64,227.829],[1223.08,330.795],[1223.08,237.94]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1223.08,330.795],[1223.08,237.94],[1252.46,340.745],[1252.46,252.322]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1223.45,439.536],[1268.54,439.495],[1223.45,341.177],[1268.54,341.095]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1223.45,552.68],[1223.45,454.32],[1268.54,552.685],[1268.54,454.285]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1223.45,563.949],[1223.45,662.309],[1268.54,563.959],[1268.54,662.359]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1223.45,679.909],[1268.54,679.967],[1223.45,778.269],[1268.54,778.368]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1223.63,796.77],[1270.46,796.88],[1223.63,895.239],[1270.46,895.391]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1263.39,340.725],[1263.39,252.293],[1271.25,350.357],[1271.25,266.216]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1254.61,444.839],[1254.61,351.711],[1328.28,444.776],[1328.28,351.584]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1254.61,551.966],[1254.61,458.837],[1328.28,551.974],[1328.28,458.783]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1254.61,562.636],[1254.61,655.764],[1328.28,562.651],[1328.28,655.843]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1254.61,672.429],[1254.61,765.557],[1328.28,672.519],[1328.28,765.71]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1253.47,782.936],[1326.87,783.1],[1253.47,876.116],[1326.87,876.342]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1326.87,783.1],[1326.87,876.342],[1348.35,770.595],[1348.35,859.056]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1328.28,444.776],[1328.28,351.584],[1348.88,449.355],[1348.88,360.681]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1328.28,551.974],[1328.28,458.783],[1348.88,551.358],[1348.88,462.683]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1328.28,562.651],[1328.28,655.843],[1348.88,561.517],[1348.88,650.192]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:8,
                    verts:[[1328.28,672.519],[1328.28,765.71],[1348.88,666.059],[1348.88,754.734]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[520.93,444.238],[520.93,350.517],[498.947,448.807],[498.947,359.592]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[520.93,552.047],[520.93,458.325],[498.947,551.431],[498.947,462.216]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[520.93,562.784],[520.93,656.506],[498.947,561.653],[498.947,650.868]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[520.93,673.276],[520.93,766.998],[498.947,666.832],[498.947,756.047]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[595.402,444.42],[595.402,350.878],[520.929,444.238],[520.929,350.517]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[595.402,552.022],[595.402,458.48],[520.929,552.047],[520.929,458.325]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[595.402,562.739],[595.402,656.282],[520.929,562.784],[520.929,656.506]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[595.402,673.02],[595.402,766.563],[520.929,673.276],[520.929,766.998]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[595.682,784.02],[521.482,784.486],[595.682,877.613],[521.483,878.258]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[627.059,797.767],[579.797,798.081],[627.059,896.617],[579.797,897.052]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[628.149,439.153],[582.639,439.036],[628.149,340.415],[582.639,340.182]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[628.149,552.731],[628.149,453.993],[582.639,552.747],[582.639,453.894]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[628.149,564.044],[628.149,662.782],[582.639,564.073],[582.639,662.927]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[628.149,680.45],[582.639,680.616],[628.149,779.188],[582.639,779.469]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[596.26,339.856],[596.26,251.038],[586.724,349.492],[586.724,264.965]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[627.124,329.879],[627.124,236.617],[596.359,339.767],[596.359,250.909]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[685.504,809.905],[685.504,913.397],[621.902,804.669],[621.902,906.158]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[686.478,434.336],[686.478,330.847],[622.766,436.346],[622.766,334.84]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[686.478,553.38],[686.478,449.891],[622.766,553.109],[622.766,451.603]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[686.478,565.237],[686.478,668.726],[622.766,564.739],[622.766,666.245]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[686.478,687.244],[686.478,790.734],[622.766,684.409],[622.766,785.915]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[663.643,322.988],[663.643,226.656],[627.124,329.879],[627.124,236.617]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[718.347,317.925],[718.347,219.338],[663.644,322.988],[663.644,226.656]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[946.76,808.084],[685.504,809.905],[946.76,910.88],[685.504,913.397]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[947.721,435.042],[686.478,434.336],[947.721,332.249],[686.478,330.847]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[947.721,553.285],[686.478,553.38],[947.721,450.492],[686.478,449.891]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[947.721,565.062],[686.478,565.237],[947.721,667.855],[686.478,668.726]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[947.721,686.249],[686.478,687.244],[947.721,789.042],[686.478,790.734]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[777.293,318.261],[718.347,317.925],[777.293,219.824],[718.347,219.338]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[835.874,313.637],[835.874,213.139],[776.602,314.705],[776.602,214.683]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[879.027,313.028],[835.873,313.637],[879.027,212.26],[835.873,213.14]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[943.92,312.556],[879.027,313.028],[943.92,211.577],[879.027,212.26]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[948.478,312.7],[948.478,211.785],[1012.16,313.924],[1012.16,213.554]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[949.213,435.046],[949.213,332.257],[1206.95,435.742],[1206.95,333.64]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[949.213,553.284],[949.213,450.496],[1206.95,553.191],[1206.95,451.089]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[949.213,565.061],[949.213,667.85],[1206.95,564.889],[1206.95,666.991]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[949.213,686.243],[949.213,789.032],[1206.95,685.261],[1206.95,787.363]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[949.213,808.067],[949.213,910.856],[1206.95,806.271],[1206.95,908.373]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1012.16,313.924],[1012.16,213.554],[1053.96,315.024],[1053.96,215.144]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1053.96,315.024],[1053.96,215.144],[1110.81,316.755],[1110.81,217.646]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1106.25,320.247],[1163.99,320.577],[1106.25,222.694],[1163.99,223.17]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1163.99,320.577],[1163.99,223.17],[1211.44,326.141],[1211.44,231.213]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1206.94,435.742],[1206.94,333.64],[1263.54,438.041],[1263.54,338.207]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1206.94,553.191],[1206.94,451.089],[1263.54,552.881],[1263.54,453.047]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1206.94,564.889],[1206.94,666.991],[1263.54,564.319],[1263.54,664.153]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1206.94,685.261],[1206.94,787.363],[1263.54,682.018],[1263.54,781.852]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1206.94,806.271],[1206.94,908.373],[1263.4,800.292],[1263.4,900.107]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1211.44,326.141],[1211.44,231.213],[1239.19,333.271],[1239.19,241.52]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1239.19,333.272],[1239.19,241.52],[1258.08,343.247],[1258.08,255.938]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1252.06,793.613],[1297.7,793.309],[1252.06,890.875],[1297.7,890.455]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1251.64,440.757],[1251.64,343.602],[1295.6,440.87],[1295.6,343.827]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1251.64,552.515],[1251.64,455.36],[1295.6,552.5],[1295.6,455.457]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1251.64,563.647],[1251.64,660.802],[1295.6,563.618],[1295.6,660.662]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1251.64,678.187],[1251.64,775.342],[1295.6,678.027],[1295.6,775.071]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1270.5,446.065],[1270.5,354.145],[1342.14,446.239],[1342.14,354.491]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1270.5,551.801],[1270.5,459.881],[1342.14,551.777],[1342.14,460.029]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1270.5,562.332],[1270.5,654.252],[1342.14,562.289],[1342.14,654.037]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1270.5,670.7],[1270.5,762.62],[1342.14,670.454],[1342.14,762.202]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1269.5,779.783],[1269.5,871.756],[1340.88,779.334],[1340.88,871.136]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1340.88,779.334],[1340.88,871.136],[1351.23,766.924],[1351.23,853.98]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1342.14,446.239],[1342.14,354.491],[1352.2,450.785],[1352.2,363.52]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1342.14,551.777],[1342.14,460.029],[1352.2,551.165],[1352.2,463.901]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1342.14,562.289],[1342.14,654.037],[1352.2,561.163],[1352.2,648.427]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:9,
                    verts:[[1342.14,670.454],[1342.14,762.202],[1352.2,664.043],[1352.2,751.307]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[539.275,442.906],[539.275,347.871],[506.342,447.446],[506.342,356.888]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[539.275,552.226],[539.275,457.191],[506.342,551.615],[506.342,461.057]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[539.275,563.114],[539.275,658.15],[506.342,561.99],[506.342,652.548]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[539.275,675.155],[539.275,770.191],[506.342,668.752],[506.342,759.31]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[544.628,775.068],[528.924,775.29],[544.628,865.239],[528.925,865.545]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[615.042,443.343],[539.275,442.906],[615.042,348.738],[539.275,347.871]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[615.042,552.167],[615.042,457.563],[539.275,552.226],[539.275,457.191]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[615.042,563.006],[539.275,563.114],[615.042,657.611],[539.275,658.15]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[615.042,674.54],[539.275,675.155],[615.042,769.144],[539.275,770.191]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[615.445,786.796],[539.959,787.919],[615.445,881.452],[539.959,883.003]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[605.108,337.549],[605.108,247.702],[585.539,347.188],[585.539,261.636]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[646.731,327.736],[646.731,233.518],[605.3,337.46],[605.3,247.574]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[611.539,801.091],[659.42,800.339],[611.539,901.213],[659.42,900.172]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[614.172,437.88],[660.273,438.16],[614.172,337.886],[660.273,338.443]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[614.172,552.903],[660.273,552.865],[614.172,452.909],[660.273,453.148]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[614.172,564.359],[660.273,564.29],[614.172,664.353],[660.273,664.007]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[614.172,682.246],[660.273,681.85],[614.172,782.24],[660.273,781.567]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[690.852,321.09],[690.852,223.913],[646.731,327.736],[646.731,233.518]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[660.199,807.321],[660.199,909.825],[659.42,800.339],[659.42,900.172]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[661.115,435.321],[661.115,332.804],[660.273,438.16],[660.273,338.443]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[661.115,553.247],[661.115,450.73],[660.273,552.865],[660.273,453.148]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[661.115,564.993],[661.115,667.51],[660.273,564.29],[660.273,664.007]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[661.115,685.855],[661.115,788.372],[660.273,681.85],[660.273,781.567]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[729.303,811.969],[729.303,916.249],[660.199,807.321],[660.199,909.825]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[730.284,433.54],[730.284,329.265],[661.115,435.321],[661.115,332.804]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[730.284,553.487],[730.284,449.213],[661.115,553.247],[661.115,450.73]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[730.284,565.434],[730.284,669.709],[661.115,564.993],[661.115,667.51]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[730.284,688.368],[730.284,792.642],[661.115,685.855],[661.115,788.372]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[751.385,316.439],[751.385,217.19],[690.852,321.091],[690.852,223.913]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[729.303,811.969],[729.303,916.249],[989.832,807.671],[989.832,910.309]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[730.284,433.54],[730.284,329.265],[990.781,435.205],[990.781,332.574]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[730.284,553.487],[730.284,449.213],[990.781,553.263],[990.781,450.631]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[730.284,565.434],[730.284,669.709],[990.781,565.022],[990.781,667.653]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[730.284,688.368],[730.284,792.642],[990.781,686.018],[990.781,788.65]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[751.385,316.439],[810.501,317.237],[751.385,217.19],[810.501,218.343]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[813.39,313.677],[813.39,213.197],[810.501,317.237],[810.501,218.343]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[873.99,313.081],[813.39,313.677],[873.99,212.336],[813.39,213.197]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[917.781,312.817],[873.989,313.081],[917.781,211.954],[873.989,212.336]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[917.781,312.817],[982.939,312.861],[917.781,211.954],[982.939,212.017]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[987.327,313.04],[987.327,212.276],[1049.29,314.755],[1049.29,214.755]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[992.255,435.215],[992.255,332.593],[1244.63,436.828],[1244.63,335.798]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[992.255,553.262],[992.255,450.639],[1244.63,553.044],[1244.63,452.014]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[992.255,565.019],[992.255,667.642],[1244.63,564.62],[1244.63,665.65]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[992.255,686.005],[992.255,788.627],[1244.63,683.729],[1244.63,784.759]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[992.255,807.631],[992.255,910.254],[1244.63,803.469],[1244.63,904.499]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1049.29,314.755],[1049.29,214.755],[1089.51,316.17],[1089.51,216.801]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1089.51,316.17],[1089.51,216.801],[1143.8,318.321],[1143.8,219.91]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1135.87,321.737],[1135.87,224.848],[1192.24,322.498],[1192.24,225.947]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1192.24,322.498],[1192.24,225.947],[1233.19,328.334],[1233.19,234.383]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1233.19,328.334],[1233.19,234.383],[1253.26,335.554],[1253.26,244.819]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1244.62,436.829],[1244.62,335.798],[1294.78,439.288],[1294.78,340.684]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1244.62,553.044],[1244.62,452.014],[1294.78,552.713],[1294.78,454.109]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1244.62,564.62],[1244.62,665.65],[1294.78,564.01],[1294.78,662.615]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1244.62,683.729],[1244.62,784.759],[1294.78,680.259],[1294.78,778.864]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1244.62,803.469],[1244.62,904.499],[1294.61,797.078],[1294.61,895.665]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1253.26,335.554],[1253.26,244.819],[1261.89,345.502],[1261.89,259.198]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1277.31,441.917],[1277.31,345.906],[1319.81,442.176],[1319.81,346.42]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1277.31,552.359],[1277.31,456.348],[1319.81,552.324],[1319.81,456.569]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1277.31,563.359],[1277.31,659.37],[1319.81,563.295],[1319.81,659.051]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1277.31,676.551],[1277.31,772.561],[1319.81,676.185],[1319.81,771.941]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1277.95,790.612],[1277.95,886.727],[1322.08,789.919],[1322.08,885.768]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1284.14,447.198],[1284.14,356.395],[1353.33,447.596],[1353.32,357.187]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1284.14,551.648],[1284.14,460.846],[1353.33,551.594],[1353.32,461.185]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1284.14,562.052],[1284.14,652.854],[1353.32,561.953],[1353.33,652.362]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1284.14,669.102],[1284.14,759.905],[1353.32,668.54],[1353.33,758.949]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:10,
                    verts:[[1283.29,776.866],[1283.29,867.724],[1352.23,775.841],[1352.23,866.307]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[560.785,441.492],[560.785,345.061],[516.67,445.973],[516.67,353.963]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[560.785,552.416],[560.785,455.986],[516.67,551.813],[516.67,459.803]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[560.785,563.465],[560.785,659.895],[516.67,562.355],[516.67,654.365]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[560.785,677.151],[560.785,773.581],[516.67,670.83],[516.67,762.84]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[561.6,791.563],[561.6,888.041],[555.102,778.529],[555.102,870.023]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[560.785,441.492],[637.29,442.195],[560.785,345.061],[637.29,346.457]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[560.785,552.416],[560.785,455.986],[637.29,552.322],[637.29,456.584]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[560.785,563.465],[560.785,659.895],[637.29,563.291],[637.29,659.028]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[560.785,677.151],[637.29,676.159],[560.785,773.581],[637.29,771.897]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[561.6,791.563],[637.818,789.756],[561.6,888.041],[637.818,885.544]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[586.417,344.619],[586.417,257.921],[578.32,355.082],[578.32,273.046]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[616.261,335.025],[616.261,244.055],[586.417,344.619],[586.417,257.921]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[668.694,325.44],[668.694,230.2],[616.548,334.937],[616.548,243.927]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[646.338,804.205],[646.338,905.517],[634.274,789.022],[634.274,884.528]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[648.73,436.683],[648.73,335.51],[637.289,442.195],[637.289,346.457]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[648.73,553.064],[648.73,451.89],[637.289,552.322],[637.289,456.584]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[648.73,564.656],[648.73,665.829],[637.289,563.291],[637.289,659.028]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[648.73,683.934],[648.73,785.107],[637.289,676.16],[637.289,771.897]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[646.339,804.205],[694.42,802.998],[646.339,905.517],[694.42,903.849]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[648.731,436.683],[695.021,437.133],[648.731,335.51],[695.021,336.403]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[648.731,553.064],[648.731,451.89],[695.021,553.003],[695.021,452.273]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[648.731,564.656],[648.731,665.829],[695.021,564.544],[695.021,665.274]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[648.731,683.933],[695.021,683.299],[648.731,785.107],[695.021,784.029]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[720.275,319.091],[720.275,221.023],[668.694,325.44],[668.694,230.2]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[701.302,810.017],[701.302,913.552],[694.42,802.998],[694.42,903.849]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[702.264,434.279],[702.264,330.734],[695.021,437.133],[695.021,336.403]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[702.264,553.388],[702.264,449.843],[695.021,553.003],[695.021,452.273]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[702.264,565.251],[702.264,668.796],[695.021,564.544],[695.021,665.274]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[702.264,687.325],[702.264,790.87],[695.021,683.299],[695.021,784.029]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[775.37,814.022],[775.37,919.087],[701.302,810.017],[701.302,913.552]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[776.347,432.748],[776.347,327.692],[702.264,434.279],[702.264,330.734]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[776.347,553.594],[776.347,448.538],[702.264,553.388],[702.264,449.843]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[776.347,565.63],[776.347,670.686],[702.264,565.251],[702.264,668.796]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[776.347,689.485],[776.347,794.541],[702.264,687.325],[702.264,790.87]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[786.249,314.895],[786.249,214.957],[720.276,319.091],[720.276,221.023]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[775.37,814.022],[775.37,919.087],[1032.6,807.245],[1032.6,909.719]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[776.347,432.748],[776.347,327.692],[1033.53,435.374],[1033.53,332.909]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[776.347,553.594],[776.347,448.538],[1033.53,553.24],[1033.53,450.775]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[776.347,565.63],[776.347,670.686],[1033.53,564.98],[1033.53,667.445]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[776.347,689.485],[776.347,794.541],[1033.53,685.78],[1033.53,788.245]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[786.248,314.894],[845.01,316.16],[786.248,214.957],[845.01,216.786]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[851.505,312.619],[851.505,211.668],[845.01,316.16],[845.01,216.786]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[912.886,312.506],[851.505,312.619],[912.886,211.504],[851.505,211.668]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[912.885,312.506],[956.913,312.59],[912.885,211.505],[956.913,211.627]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[956.913,312.59],[1021.73,313.151],[956.913,211.627],[1021.73,212.437]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1025.91,313.363],[1025.91,212.744],[1085.6,315.555],[1085.6,215.911]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1034.97,435.389],[1034.97,332.938],[1279.71,437.888],[1279.71,337.903]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1034.97,553.238],[1034.97,450.788],[1279.71,552.902],[1279.71,452.917]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1034.97,564.976],[1034.97,667.427],[1279.71,564.357],[1279.71,664.342]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1034.97,685.759],[1034.97,788.21],[1279.71,682.234],[1279.71,782.219]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1034.97,807.182],[1034.97,909.633],[1279.71,800.735],[1279.71,900.72]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1085.6,315.555],[1085.6,215.911],[1123.9,317.271],[1123.9,218.393]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1123.9,317.272],[1123.9,218.393],[1175.21,319.819],[1175.21,222.075]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1164.02,323.14],[1164.02,226.876],[1218.58,324.315],[1218.58,228.573]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1218.58,324.315],[1218.58,228.573],[1252.86,330.379],[1252.86,237.339]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1252.86,330.379],[1252.86,237.339],[1265.34,337.645],[1265.34,247.842]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1279.71,437.888],[1279.71,337.903],[1323.18,440.485],[1323.18,343.061]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1279.71,552.902],[1279.71,452.917],[1323.18,552.552],[1323.18,455.128]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1279.71,564.357],[1279.71,664.342],[1323.18,563.714],[1323.18,661.138]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1279.71,682.234],[1279.71,782.219],[1323.18,678.571],[1323.18,775.994]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1279.71,800.735],[1279.71,900.72],[1322.98,793.992],[1322.98,891.399]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1300.45,443.016],[1300.45,348.088],[1341.21,443.412],[1341.21,348.874]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1300.45,552.211],[1300.45,457.284],[1341.21,552.158],[1341.21,457.621]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1300.45,563.087],[1300.45,658.015],[1341.21,562.989],[1341.21,657.526]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1300.45,675.001],[1300.45,769.929],[1341.21,674.443],[1341.21,768.98]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1301.31,787.77],[1301.31,882.797],[1343.62,786.708],[1343.62,881.329]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1295.59,448.241],[1295.59,358.467],[1361.93,448.85],[1361.93,359.677]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1295.59,551.508],[1295.59,461.734],[1361.93,551.426],[1361.93,462.253]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1295.59,561.793],[1295.59,651.567],[1361.93,561.642],[1361.93,650.815]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1295.59,667.631],[1295.59,757.405],[1361.93,666.772],[1361.93,755.945]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:11,
                    verts:[[1294.89,774.18],[1294.89,864.012],[1361,772.613],[1361,861.845]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[549.36,447.721],[549.36,354.399],[505.272,460.49],[505.272,380.187]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[549.36,555.07],[549.36,461.748],[505.272,552.863],[505.272,472.56]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[549.36,565.762],[549.36,659.085],[505.272,562.064],[505.272,642.367]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[549.36,675.784],[549.36,769.106],[505.272,656.737],[505.272,737.04]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[585.581,440],[585.581,342.099],[530.096,444.391],[530.096,350.819]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[585.581,552.617],[585.581,454.716],[530.096,552.026],[530.096,458.455]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[585.581,563.834],[585.581,661.736],[530.096,562.747],[530.096,656.318]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[585.581,679.254],[585.581,777.156],[530.096,673.062],[530.096,766.633]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[589.475,341.783],[589.475,253.823],[570.464,352.325],[570.464,269.06]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[586.524,795.405],[586.525,893.352],[568.397,782.258],[568.398,875.178]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[585.581,440],[585.581,342.099],[662.214,440.98],[662.214,344.045]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[585.581,552.617],[585.581,454.716],[662.214,552.485],[662.214,455.55]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[585.581,563.834],[585.581,661.736],[662.214,563.591],[662.214,660.526]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[585.581,679.254],[585.581,777.156],[662.214,677.872],[662.214,774.807]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[586.524,795.405],[662.866,792.885],[586.525,893.352],[662.866,889.869]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[629.819,332.292],[629.819,240.104],[589.476,341.783],[589.476,253.823]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[693.063,323.005],[693.063,226.68],[630.203,332.204],[630.203,239.977]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[684.203,807.397],[684.203,909.929],[658.608,792.175],[658.608,888.887]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[686.323,435.456],[686.323,333.072],[662.213,440.98],[662.213,344.045]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[686.323,553.229],[686.323,450.845],[662.213,552.485],[662.213,455.55]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[686.323,564.96],[686.323,667.344],[662.213,563.591],[662.213,660.526]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[686.323,685.665],[686.323,788.049],[662.213,677.872],[662.213,774.807]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[684.204,807.397],[732.036,805.723],[684.204,909.929],[732.036,907.616]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[686.323,435.456],[686.323,333.072],[732.37,436.08],[732.37,334.311]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[686.323,553.229],[686.323,450.845],[732.37,553.145],[732.37,451.376]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[686.323,564.96],[686.323,667.344],[732.37,564.805],[732.37,666.574]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[686.323,685.665],[686.323,788.049],[732.37,684.785],[732.37,786.554]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[751.906,317.005],[751.906,218.008],[693.063,323.005],[693.063,226.68]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[746.148,433.231],[746.148,328.652],[732.37,436.08],[732.37,334.311]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[746.148,553.529],[746.148,448.95],[732.37,553.145],[732.37,451.376]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[746.148,565.511],[746.148,670.09],[732.37,564.805],[732.37,666.574]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[746.148,688.803],[746.148,793.382],[732.37,684.785],[732.37,786.554]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[745.149,812.73],[745.149,917.302],[732.036,805.723],[732.036,907.616]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[823.562,816.037],[823.562,921.873],[745.149,812.73],[745.149,917.302]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[824.525,431.97],[824.525,326.147],[746.148,433.231],[746.148,328.652]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[824.525,553.699],[824.525,447.876],[746.148,553.529],[746.148,448.95]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[824.525,565.823],[824.525,671.646],[746.148,565.511],[746.148,670.09]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[824.525,690.582],[824.525,796.405],[746.148,688.803],[746.148,793.382]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[822.865,313.308],[822.865,212.664],[751.907,317.006],[751.907,218.008]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[822.865,313.308],[822.865,212.664],[880.727,315.046],[880.727,215.175]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[823.562,816.037],[823.562,921.873],[1074.89,806.791],[1074.89,909.092]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[824.525,431.97],[824.525,326.147],[1075.79,435.553],[1075.79,333.265]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[824.525,553.699],[824.525,447.876],[1075.79,553.216],[1075.79,450.928]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[824.525,565.823],[824.525,671.646],[1075.79,564.935],[1075.79,667.224]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[824.525,690.582],[824.525,796.405],[1075.79,685.527],[1075.79,787.816]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[890.827,311.548],[890.827,210.119],[880.727,315.046],[880.727,215.175]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[890.827,311.548],[952.424,311.927],[890.827,210.119],[952.424,210.668]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[952.423,311.927],[996.274,312.364],[952.423,210.668],[996.274,211.299]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[996.274,312.364],[996.274,211.299],[1060.15,313.438],[1060.15,212.852]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1064.08,313.683],[1064.08,213.206],[1120.95,316.333],[1120.95,217.036]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1077.18,435.573],[1077.18,333.305],[1312.11,438.924],[1312.11,339.96]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1077.18,553.213],[1077.18,450.945],[1312.11,552.762],[1312.11,453.798]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1077.18,564.931],[1077.18,667.199],[1312.11,564.101],[1312.11,663.065]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1077.18,685.499],[1077.18,787.768],[1312.11,680.773],[1312.11,779.737]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1077.18,806.707],[1077.18,908.975],[1312.11,798.064],[1312.11,897.028]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1120.95,316.333],[1120.95,217.036],[1157.02,318.336],[1157.02,219.932]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1157.02,318.336],[1157.02,219.932],[1204.92,321.257],[1204.92,224.153]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1190.63,324.465],[1190.63,228.79],[1242.96,326.035],[1242.96,231.061]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1242.96,326.035],[1242.96,231.06],[1270.46,332.285],[1270.46,240.094]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1270.46,332.285],[1270.46,240.094],[1275.44,339.557],[1275.44,250.605]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1312.11,438.924],[1312.11,339.96],[1348.72,441.636],[1348.72,345.347]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1312.11,552.762],[1312.11,453.798],[1348.72,552.397],[1348.72,456.108]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1312.11,564.101],[1312.11,663.065],[1348.72,563.429],[1348.72,659.718]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1312.11,680.773],[1312.11,779.737],[1348.72,676.948],[1348.72,773.236]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1312.11,798.064],[1312.11,897.028],[1348.48,791.026],[1348.48,887.299]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1321.06,444.056],[1321.06,350.154],[1359.82,444.581],[1359.82,351.197]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1321.06,552.071],[1321.06,458.17],[1359.82,552],[1359.82,458.617]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1321.06,562.83],[1321.06,656.731],[1359.82,562.7],[1359.82,656.083]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1321.06,673.534],[1321.06,767.435],[1359.82,672.793],[1359.82,766.177]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1322.12,785.075],[1322.12,879.073],[1362.34,783.668],[1362.34,877.127]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1304.87,449.198],[1304.87,360.369],[1368.02,450.006],[1368.02,361.973]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1304.87,551.379],[1304.87,462.55],[1368.02,551.27],[1368.02,463.237]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1304.87,561.556],[1304.87,650.385],[1368.02,561.356],[1368.02,649.389]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1304.87,666.28],[1304.87,755.109],[1368.02,665.141],[1368.02,753.174]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:12,
                    verts:[[1304.31,771.713],[1304.31,860.601],[1367.24,769.636],[1367.24,857.73]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[566.061,446.159],[566.061,351.244],[490.554,459.007],[490.554,377.192]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[566.061,555.34],[566.061,460.425],[490.554,553.12],[490.554,471.304]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[566.061,566.215],[566.061,661.129],[490.554,562.494],[490.554,644.309]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[566.061,678.114],[566.061,773.028],[490.554,658.949],[490.554,740.764]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[568.663,786.888],[568.663,881.578],[541.513,774.657],[541.513,864.67]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[613.797,438.443],[613.797,339.006],[546.823,442.705],[546.823,347.471]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[613.797,552.827],[613.797,453.389],[546.823,552.253],[546.823,457.019]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[613.797,564.22],[613.797,663.657],[546.823,563.164],[546.823,658.398]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[613.797,681.451],[613.797,780.888],[546.823,675.439],[546.823,770.673]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[564.527,349.257],[564.527,264.626],[562.051,358.013],[562.051,277.281]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[594.868,338.691],[594.868,249.353],[564.527,349.257],[564.527,264.626]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[645.907,329.364],[645.907,235.872],[594.869,338.69],[594.869,249.353]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[614.869,799.414],[614.87,898.894],[584.685,786.237],[584.686,880.678]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[613.797,438.443],[613.797,339.006],[689.885,439.711],[689.885,341.525]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[613.797,552.827],[613.797,453.389],[689.885,552.656],[689.885,454.469]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[613.797,564.22],[613.797,663.657],[689.885,563.906],[689.885,662.092]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[613.797,681.451],[613.797,780.888],[689.885,679.662],[689.885,777.849]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[614.869,799.414],[614.87,898.894],[690.661,796.154],[690.661,894.388]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[719.89,320.452],[719.89,222.99],[646.388,329.279],[646.388,235.749]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[725.13,810.628],[725.13,914.396],[685.697,795.475],[685.697,893.449]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[726.945,434.213],[726.945,330.603],[689.884,439.711],[689.884,341.525]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[726.945,553.397],[726.945,449.786],[689.884,552.656],[689.884,454.469]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[726.945,565.267],[726.945,668.878],[689.884,563.906],[689.884,662.093]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[726.945,687.418],[726.945,791.029],[689.884,679.662],[689.884,777.849]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[785.725,314.861],[785.725,214.909],[719.89,320.452],[719.89,222.99]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[725.13,810.628],[772.227,808.476],[725.13,914.396],[772.227,911.421]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[726.946,434.213],[726.946,330.603],[772.283,435.015],[772.283,332.196]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[726.946,553.397],[726.946,449.786],[772.283,553.289],[772.283,450.469]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[726.946,565.267],[726.946,668.878],[772.283,565.069],[772.283,667.888]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[726.946,687.418],[726.946,791.029],[772.283,686.286],[772.283,789.106]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[792.677,432.193],[792.677,326.59],[772.283,435.015],[772.283,332.196]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[792.677,553.669],[792.677,448.066],[772.283,553.289],[772.283,450.469]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[792.677,565.768],[792.677,671.37],[772.283,565.069],[772.283,667.888]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[792.677,690.267],[792.677,795.87],[772.283,686.286],[772.283,789.106]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[791.649,815.418],[791.649,921.017],[772.227,808.476],[772.227,911.421]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[861.146,311.709],[861.146,210.352],[785.725,314.861],[785.725,214.909]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[873.701,817.973],[873.701,924.549],[791.649,815.418],[791.649,921.017]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[874.639,431.224],[874.639,324.664],[792.677,432.193],[792.677,326.591]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[874.639,553.799],[874.639,447.24],[792.677,553.669],[792.677,448.066]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[874.639,566.008],[874.639,672.567],[792.677,565.768],[792.677,671.37]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[874.639,691.635],[874.639,798.194],[792.677,690.267],[792.677,795.87]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[861.146,311.709],[861.146,210.352],[917.542,313.921],[917.542,213.549]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[873.701,817.973],[873.701,924.549],[1116.47,806.285],[1116.47,908.392]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[874.639,431.224],[874.639,324.664],[1117.33,435.753],[1117.33,333.661]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[874.639,553.799],[874.639,447.24],[1117.33,553.189],[1117.33,451.098]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[874.639,566.008],[874.639,672.567],[1117.33,564.886],[1117.33,666.977]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[874.639,691.635],[874.639,798.194],[1117.33,685.246],[1117.33,787.337]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[931.216,310.491],[931.216,208.593],[917.541,313.921],[917.541,213.549]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[931.217,310.491],[992.434,311.37],[931.217,208.592],[992.434,209.863]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[992.434,311.371],[1035.68,312.16],[992.434,209.863],[1035.68,211.005]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1035.68,312.16],[1035.68,211.005],[1098.01,313.744],[1098.01,213.294]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1101.65,314.02],[1101.65,213.693],[1155.18,317.108],[1155.18,218.157]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1118.67,435.778],[1118.67,333.711],[1341.72,439.941],[1341.72,341.98]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1118.67,553.186],[1118.67,451.119],[1341.72,552.625],[1341.72,454.665]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1118.67,564.88],[1118.67,666.947],[1341.72,563.849],[1341.72,661.809]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1118.67,685.211],[1118.67,787.277],[1341.72,679.339],[1341.72,777.299]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1118.67,806.179],[1118.67,908.246],[1341.72,795.44],[1341.72,893.401]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1155.19,317.108],[1155.19,218.157],[1188.7,319.382],[1188.7,221.443]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1188.7,319.382],[1188.7,221.443],[1232.83,322.65],[1232.83,226.167]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1215.59,325.727],[1215.59,230.615],[1265.31,327.676],[1265.31,233.432]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1265.3,327.676],[1265.3,233.432],[1285.94,334.069],[1285.94,242.673]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1341.72,439.941],[1341.72,341.98],[1371.31,442.746],[1371.31,347.553]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1341.72,552.625],[1341.72,454.665],[1371.31,552.248],[1371.31,457.054]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1341.72,563.849],[1341.72,661.809],[1371.31,563.154],[1371.31,658.347]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1341.72,679.339],[1341.72,777.299],[1371.31,675.381],[1371.31,770.575]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1341.72,795.44],[1341.72,893.401],[1371.04,788.165],[1371.04,883.343]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1339.1,445.045],[1339.1,352.12],[1375.59,445.691],[1375.59,353.402]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1339.1,551.938],[1339.1,459.012],[1375.59,551.851],[1375.59,459.562]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1339.1,562.585],[1339.1,655.51],[1375.59,562.425],[1375.59,654.713]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1339.1,672.138],[1339.1,765.064],[1375.59,671.227],[1375.59,763.516]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:13,
                    verts:[[1340.34,782.511],[1340.34,875.528],[1378.21,780.78],[1378.21,873.135]]
                },
                ],
                [
                {
                    num:"503",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[586.129,444.513],[586.129,347.921],[477.857,457.364],[477.857,373.873]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[586.129,555.625],[586.129,459.032],[477.857,553.404],[477.857,469.913]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[586.129,566.691],[586.129,663.284],[477.857,562.969],[477.857,646.46]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[586.129,680.568],[586.129,777.161],[477.857,661.4],[477.857,744.891]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[560.706,345.887],[560.706,259.754],[549.117,354.781],[549.117,272.609]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[588.282,791.241],[588.283,887.596],[549.503,779.032],[549.504,870.719]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[602.787,335.357],[602.787,244.535],[560.706,345.887],[560.706,259.754]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[645.574,436.839],[645.574,335.818],[567.084,440.93],[567.084,343.945]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[645.574,553.043],[645.574,452.023],[567.084,552.492],[567.084,455.507]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[645.574,564.617],[645.574,665.637],[567.084,563.604],[567.084,660.589]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[645.574,683.714],[645.574,784.735],[567.084,677.943],[567.084,774.928]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[664.664,326.27],[664.664,231.4],[602.787,335.357],[602.787,244.535]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[646.77,803.545],[646.771,904.605],[604.16,790.433],[604.161,886.479]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[645.574,436.839],[645.574,335.818],[720.372,438.405],[720.372,338.929]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[645.574,553.043],[645.574,452.023],[720.372,552.832],[720.372,453.356]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[645.574,564.617],[645.574,665.637],[720.372,564.229],[720.372,663.705]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[645.574,683.714],[645.574,784.735],[720.372,681.506],[720.372,780.981]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[646.77,803.545],[646.771,904.605],[721.269,799.519],[721.269,899.04]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[749.222,317.819],[749.222,219.185],[665.244,326.187],[665.244,231.28]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[769.083,813.841],[769.083,918.838],[715.616,798.878],[715.616,898.153]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[770.562,432.976],[770.562,328.146],[720.372,438.405],[720.372,338.929]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[770.562,553.563],[770.562,448.733],[720.372,552.832],[720.372,453.356]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[770.562,565.574],[770.562,670.404],[720.372,564.229],[720.372,663.705]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[770.562,689.163],[770.562,793.993],[720.372,681.506],[720.372,780.982]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[821.69,312.699],[821.69,211.784],[749.221,317.819],[749.221,219.185]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[769.084,813.841],[769.084,918.838],[814.924,811.202],[814.924,915.189]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[770.563,432.976],[770.563,328.146],[814.689,433.96],[814.689,330.1]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[770.563,553.563],[770.563,448.733],[814.689,553.431],[814.689,449.571]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[770.563,565.574],[770.563,670.404],[814.689,565.33],[814.689,669.19]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[770.563,689.162],[770.563,793.993],[814.689,687.775],[814.689,791.635]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[841.713,431.189],[841.713,324.595],[814.689,433.96],[814.689,330.1]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[841.713,553.804],[841.713,447.21],[814.689,553.431],[814.689,449.571]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[841.713,566.016],[841.713,672.61],[814.689,565.33],[814.689,669.19]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[841.713,691.684],[841.713,798.277],[814.689,687.775],[814.689,791.635]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[840.667,818.018],[840.667,924.612],[814.923,811.202],[814.923,915.189]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[900.967,310.138],[900.967,208.082],[821.69,312.699],[821.69,211.784]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[925.556,819.77],[925.556,927.034],[840.667,818.018],[840.667,924.612]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[926.458,430.531],[926.458,323.288],[841.713,431.189],[841.713,324.596]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[926.458,553.893],[926.458,446.65],[841.713,553.804],[841.713,447.21]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[926.458,566.18],[926.458,673.422],[841.713,566.016],[841.713,672.61]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[926.458,692.612],[926.458,799.855],[841.713,691.684],[841.713,798.277]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[900.967,310.138],[900.967,208.082],[955.306,312.823],[955.306,211.963]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[925.556,819.77],[925.556,927.034],[1157.09,805.688],[1157.09,907.568]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[926.458,430.531],[926.458,323.288],[1157.9,435.987],[1157.9,334.127]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[926.458,553.893],[926.458,446.65],[1157.9,553.158],[1157.9,451.297]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[926.458,566.18],[926.458,673.422],[1157.9,564.828],[1157.9,666.688]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[926.458,692.612],[926.458,799.855],[1157.9,684.915],[1157.9,786.776]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[972.491,309.489],[972.491,207.144],[955.306,312.823],[955.306,211.963]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[972.491,309.489],[972.491,207.144],[1032.71,310.873],[1032.71,209.144]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[1032.71,310.873],[1032.71,209.144],[1074.93,312.015],[1074.93,210.795]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[1074.93,312.015],[1074.93,210.795],[1135.08,314.1],[1135.08,213.809]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[1138.4,314.404],[1138.4,214.248],[1188.1,317.909],[1188.1,219.314]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[1159.16,436.017],[1159.16,334.186],[1368.37,440.949],[1368.37,343.984]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[1159.16,553.154],[1159.16,451.323],[1368.37,552.49],[1368.37,455.524]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[1159.16,564.821],[1159.16,666.652],[1368.37,563.599],[1368.37,660.565]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[1159.16,684.873],[1159.16,786.704],[1368.37,677.916],[1368.37,774.882]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[1159.16,805.562],[1159.16,907.393],[1368.37,792.838],[1368.37,889.804]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[1188.1,317.909],[1188.1,219.314],[1218.77,320.434],[1218.77,222.964]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[1218.77,320.434],[1218.77,222.964],[1258.77,324.023],[1258.77,228.152]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[1238.76,326.951],[1238.76,232.384],[1285.49,329.258],[1285.49,235.719]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:14,
                    verts:[[1285.48,329.258],[1285.48,235.719],[1299.21,335.752],[1299.21,245.105]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[446.86,452.755],[446.86,367.435],[444.078,456.706],[444.078,375.282]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[446.86,550.9],[446.86,465.579],[444.078,550.368],[444.078,468.944]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[446.86,560.675],[446.86,645.995],[444.078,559.697],[444.078,641.12]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[446.86,661.263],[446.86,746.583],[444.078,655.69],[444.078,737.114]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[609.798,442.802],[609.798,344.465],[467.476,455.563],[467.476,370.236]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[609.798,555.92],[609.798,457.583],[467.476,553.715],[467.476,468.388]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[609.798,567.187],[609.798,665.524],[467.476,563.491],[467.476,648.818]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[609.798,683.12],[609.798,781.458],[467.476,664.087],[467.476,749.413]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[534.963,351.478],[534.963,267.835],[531.833,359.947],[531.833,280.078]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[559.252,342.229],[559.252,254.468],[538.068,351.219],[538.068,267.46]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[613.457,331.812],[613.457,239.411],[559.252,342.229],[559.252,254.468]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[611.456,795.771],[611.457,893.859],[560.67,783.68],[560.67,877.143]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[681.037,435.212],[681.037,332.586],[591.134,439.084],[591.134,340.278]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[681.037,553.262],[681.037,450.637],[591.134,552.741],[591.134,453.935]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[681.037,565.02],[681.037,667.645],[591.134,564.061],[591.134,662.867]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[681.037,686.009],[681.037,788.635],[591.134,680.547],[591.134,779.353]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[686.241,323.049],[686.241,226.744],[613.457,331.812],[613.457,239.411]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[682.352,807.733],[682.352,910.393],[627.036,794.799],[627.036,892.515]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[681.037,435.212],[681.037,332.586],[753.726,437.083],[753.726,336.303]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[681.037,553.262],[681.037,450.637],[753.726,553.01],[753.726,452.231]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[681.037,565.02],[681.037,667.646],[753.726,564.557],[753.726,665.336]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[681.037,686.009],[681.037,788.635],[753.726,683.37],[753.726,784.149]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[682.352,807.733],[682.352,910.393],[754.742,802.922],[754.742,903.743]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[781.086,315.155],[781.086,215.333],[686.92,322.969],[686.92,226.628]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[815.976,816.96],[815.976,923.149],[748.421,802.325],[748.421,902.919]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[817.089,431.775],[817.089,325.76],[753.725,437.083],[753.725,336.303]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[817.089,553.725],[817.089,447.71],[753.725,553.01],[753.725,452.231]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[817.089,565.871],[817.089,671.886],[753.725,564.557],[753.725,665.336]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[817.089,690.857],[817.089,796.872],[753.725,683.37],[753.725,784.149]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[859.725,310.572],[859.725,208.709],[781.086,315.155],[781.086,215.333]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[815.977,816.96],[815.977,923.149],[860.002,813.83],[860.002,918.823]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[817.089,431.775],[817.089,325.76],[859.47,432.941],[859.47,328.077]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[817.089,553.725],[817.089,447.71],[859.47,553.568],[859.47,448.703]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[817.089,565.871],[817.089,671.886],[859.47,565.582],[859.47,670.447]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[817.089,690.857],[817.089,796.872],[859.47,689.212],[859.47,794.076]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[942.158,308.648],[942.158,205.928],[859.726,310.572],[859.726,208.709]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[893.053,430.248],[893.053,322.726],[859.47,432.941],[859.47,328.077]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[893.053,553.931],[893.053,446.409],[859.47,553.568],[859.47,448.703]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[893.053,566.249],[893.053,673.771],[859.47,565.582],[859.47,670.447]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[893.053,693.011],[893.053,800.533],[859.47,689.212],[859.47,794.076]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[892,820.457],[892,927.983],[860.002,813.83],[860.002,918.823]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[978.822,821.356],[892,820.457],[978.822,929.226],[892,927.983]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[979.678,429.919],[979.678,322.074],[893.053,430.248],[893.053,322.726]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[979.678,553.975],[979.678,446.129],[893.053,553.931],[893.053,446.409]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[979.678,566.331],[979.678,674.176],[893.053,566.25],[893.053,673.771]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[979.678,693.475],[893.053,693.011],[979.678,801.32],[893.053,800.533]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[942.158,308.648],[942.158,205.928],[993.832,311.8],[993.832,210.484]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[979.678,429.919],[979.678,322.074],[1197.2,436.274],[1197.2,334.696]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[979.678,553.975],[979.678,446.129],[1197.2,553.119],[1197.2,451.541]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[979.678,566.331],[979.678,674.176],[1197.2,564.757],[1197.2,666.335]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[979.678,693.475],[979.678,801.32],[1197.2,684.511],[1197.2,786.089]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[978.822,821.356],[978.822,929.226],[1196.44,804.957],[1196.44,906.557]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1014.42,308.592],[1014.42,205.847],[993.832,311.8],[993.832,210.484]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1014.42,308.592],[1014.42,205.847],[1073,310.479],[1073,208.575]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1073,310.479],[1073,208.575],[1113.74,311.97],[1113.74,210.73]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1113.74,311.97],[1113.74,210.73],[1171.1,314.544],[1171.1,214.45]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1174.07,314.874],[1174.07,214.928],[1219.45,318.768],[1219.45,220.556]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1198.37,436.308],[1198.37,334.764],[1391.87,441.961],[1391.87,345.993]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1198.37,553.115],[1198.37,451.571],[1391.87,552.353],[1391.87,456.385]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1198.37,564.749],[1198.37,666.292],[1391.87,563.349],[1391.87,659.317]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1198.37,684.463],[1198.37,786.007],[1391.87,676.489],[1391.87,772.457]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1198.37,804.811],[1198.37,906.355],[1391.87,790.229],[1391.87,886.197]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1219.45,318.768],[1219.45,220.556],[1247.01,321.525],[1247.01,224.541]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1247.01,321.525],[1247.01,224.54],[1282.55,325.405],[1282.55,230.15]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1259.99,328.166],[1259.99,234.14],[1303.36,330.81],[1303.36,237.962]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:15,
                    verts:[[1303.36,330.81],[1303.36,237.962],[1310.17,337.36],[1310.17,247.429]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[438.337,450.67],[438.337,363.292],[426.261,454.712],[426.261,371.321]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[438.337,551.181],[438.337,463.803],[426.261,550.636],[426.261,467.246]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[438.337,561.192],[438.337,648.569],[426.261,560.19],[426.261,643.581]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[438.337,664.205],[438.337,751.582],[426.261,658.503],[426.261,741.894]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[637.285,441.052],[637.285,340.931],[459.775,453.611],[459.775,366.293]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[637.285,556.223],[637.285,456.101],[459.775,554.052],[459.775,466.735]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[637.285,567.694],[637.285,667.815],[459.775,564.056],[459.775,651.374]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[637.285,685.731],[637.285,785.853],[459.775,666.999],[459.775,754.316]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[525.71,347.584],[525.71,262.208],[513.608,356.219],[513.608,274.689]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[560.46,338.312],[560.46,248.806],[529.193,347.342],[529.193,261.856]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[627.117,328.097],[627.117,234.04],[560.459,338.312],[560.459,248.806]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[638.401,800.409],[638.401,900.27],[575.315,788.55],[575.316,883.875]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[720.257,433.595],[720.257,329.375],[619.214,437.195],[619.214,336.526]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[720.257,553.48],[720.257,449.26],[619.214,552.995],[619.214,452.326]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[720.257,565.42],[720.257,669.64],[619.214,564.529],[619.214,665.198]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[720.257,688.29],[720.257,792.51],[619.214,683.212],[619.214,783.881]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[710.773,319.754],[710.773,221.982],[627.117,328.097],[627.117,234.04]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[815.461,312.521],[815.461,211.527],[711.55,319.679],[711.55,221.872]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[721.682,811.891],[721.682,916.142],[653.51,799.268],[653.511,898.692]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[720.257,433.595],[720.257,329.375],[789.943,435.777],[789.943,333.708]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[720.257,553.48],[720.257,449.26],[789.943,553.186],[789.943,451.118]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[720.257,565.42],[720.257,669.64],[789.943,564.88],[789.943,666.948]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[720.257,688.29],[720.257,792.51],[789.943,685.213],[789.943,787.281]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[721.682,811.891],[721.682,916.142],[791.073,806.284],[791.073,908.39]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[865.625,819.892],[865.625,927.202],[784.121,805.741],[784.121,907.64]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[866.343,430.645],[866.343,323.516],[789.943,435.777],[789.943,333.708]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[866.343,553.877],[866.343,446.747],[789.943,553.186],[789.943,451.118]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[866.343,566.151],[866.343,673.281],[789.943,564.88],[789.943,666.948]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[866.343,692.451],[866.343,799.58],[789.943,685.213],[789.943,787.281]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[899.683,308.545],[899.683,205.779],[815.461,312.521],[815.461,211.527]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[865.626,819.892],[865.626,927.202],[907.25,816.275],[907.25,922.203]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[866.344,430.645],[866.344,323.516],[906.416,431.993],[906.416,326.193]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[866.344,553.877],[866.344,446.747],[906.416,553.696],[906.416,447.895]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[866.344,566.151],[866.344,673.281],[906.416,565.817],[906.416,671.617]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[866.344,692.451],[866.344,799.58],[906.416,690.55],[906.416,796.35]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[984.471,307.302],[984.471,203.983],[899.682,308.545],[899.682,205.779]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[946.384,429.406],[946.384,321.054],[906.416,431.993],[906.416,326.193]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[946.384,554.044],[946.384,445.692],[906.416,553.696],[906.416,447.895]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[946.384,566.458],[946.384,674.81],[906.416,565.817],[906.416,671.617]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[946.384,694.199],[946.384,802.55],[906.416,690.55],[906.416,796.35]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[945.338,822.639],[945.338,931],[907.25,816.275],[907.25,922.203]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[945.338,822.639],[1033.09,822.645],[945.338,931],[1033.09,931.008]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[946.384,429.406],[1033.89,429.423],[946.384,321.054],[1033.89,321.088]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[946.384,554.044],[1033.89,554.042],[946.384,445.692],[1033.89,445.707]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[946.384,566.458],[1033.89,566.454],[946.384,674.81],[1033.89,674.789]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[946.384,694.199],[1033.89,694.174],[946.384,802.551],[1033.89,802.509]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[984.471,307.302],[984.471,203.983],[1032.86,310.91],[1032.86,209.197]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1056.7,307.858],[1056.7,204.786],[1032.86,310.91],[1032.86,209.197]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1033.09,822.645],[1033.09,931.008],[1234.16,804.039],[1234.16,905.287]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1033.89,429.423],[1033.89,321.088],[1234.86,436.633],[1234.86,335.409]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1033.89,554.042],[1033.89,445.707],[1234.86,553.071],[1234.86,451.847]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1033.89,566.454],[1033.89,674.789],[1234.86,564.668],[1234.86,665.892]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1033.89,694.174],[1033.89,802.509],[1234.86,684.005],[1234.86,785.229]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1056.7,307.858],[1056.7,204.786],[1112.97,310.244],[1112.97,208.235]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1112.97,310.244],[1112.97,208.235],[1151.78,312.076],[1151.78,210.883]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1151.78,312.076],[1151.78,210.883],[1205.75,315.12],[1205.75,215.283]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1208.34,315.474],[1208.34,215.795],[1248.96,319.725],[1248.96,221.939]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1235.93,436.671],[1235.93,335.486],[1412.02,442.988],[1412.02,348.032]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1235.93,553.066],[1235.93,451.88],[1412.02,552.215],[1412.02,457.26]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1235.93,564.659],[1235.93,665.844],[1412.02,563.094],[1412.02,658.049]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1235.93,683.951],[1235.93,785.136],[1412.02,675.041],[1412.02,769.996]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1235.93,803.874],[1235.93,905.06],[1412.02,787.58],[1412.02,882.535]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1248.96,319.725],[1248.96,221.939],[1273.16,322.69],[1273.16,226.225]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1273.15,322.69],[1273.15,226.225],[1303.96,326.829],[1303.96,232.207]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:16,
                    verts:[[1279.06,329.404],[1279.06,235.929],[1318.75,332.361],[1318.75,240.204]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[433.032,448.432],[433.032,358.848],[410.978,452.544],[410.978,367.016]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[433.032,551.482],[433.032,461.897],[410.978,550.928],[410.978,465.4]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[433.032,561.746],[433.032,651.33],[410.978,560.727],[410.978,646.256]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[433.032,667.361],[433.032,756.945],[410.978,661.561],[410.978,747.089]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[668.776,439.296],[668.776,337.384],[455.196,451.519],[455.196,362.068]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[668.776,556.526],[668.776,454.614],[455.196,554.414],[455.196,464.964]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[668.776,568.202],[668.776,670.114],[455.196,564.662],[455.196,654.113]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[668.776,688.35],[668.776,790.262],[455.196,670.119],[455.196,759.569]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[497.339,352.151],[497.339,268.809],[495.21,358.075],[495.21,277.372]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[518.981,343.398],[518.981,256.156],[497.339,352.151],[497.339,268.809]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[564.665,334.174],[564.665,242.824],[522.844,343.175],[522.844,255.834]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[644.015,324.266],[644.015,228.503],[564.665,334.174],[564.665,242.824]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[669.302,805.067],[669.303,906.708],[593.753,793.573],[593.753,890.819]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[738.359,316.455],[738.359,217.212],[644.016,324.266],[644.016,228.504]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[763.224,432.03],[763.224,326.267],[651.533,435.298],[651.533,332.759]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[763.224,553.691],[763.224,447.927],[651.533,553.25],[651.533,450.711]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[763.224,565.808],[763.224,671.571],[651.533,564.999],[651.533,667.538]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[763.224,690.497],[763.224,796.26],[651.533,685.887],[651.533,788.427]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[852.257,309.995],[852.257,207.875],[739.231,316.384],[739.231,217.11]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[764.749,815.914],[764.749,921.703],[683.75,803.753],[683.75,904.892]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[763.225,432.03],[763.225,326.267],[828.948,434.522],[828.948,331.216]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[763.225,553.691],[763.225,447.927],[828.948,553.355],[828.948,450.049]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[763.225,565.808],[763.225,671.571],[828.948,565.191],[828.948,668.497]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[763.225,690.497],[763.225,796.26],[828.948,686.983],[828.948,790.289]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[764.749,815.914],[764.749,921.703],[830.184,809.511],[830.184,912.852]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[917.731,822.527],[917.731,930.844],[822.65,809.03],[822.65,912.187]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[918.029,429.629],[918.029,321.497],[828.948,434.522],[828.948,331.216]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[918.029,554.014],[918.029,445.882],[828.948,553.355],[828.948,450.049]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[918.029,566.403],[918.029,674.535],[828.948,565.191],[828.948,668.497]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[918.029,693.884],[918.029,802.016],[828.948,686.983],[828.948,790.289]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[941.33,306.695],[941.33,203.105],[852.257,309.995],[852.257,207.875]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[917.731,822.527],[917.731,930.844],[956.348,818.436],[956.348,925.189]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[918.03,429.629],[918.03,321.497],[955.213,431.153],[955.213,324.525]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[918.03,554.014],[918.03,445.882],[955.213,553.809],[955.213,447.18]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[918.03,566.403],[918.03,674.535],[955.213,566.025],[955.213,672.654]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[918.03,693.884],[918.03,802.016],[955.213,691.734],[955.213,798.362]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1027.57,306.174],[941.33,306.695],[1027.57,202.352],[941.33,203.105]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1001.27,428.704],[1001.27,319.66],[955.213,431.153],[955.213,324.525]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1001.27,554.138],[1001.27,445.094],[955.213,553.809],[955.213,447.18]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1001.27,566.632],[1001.27,675.676],[955.213,566.025],[955.213,672.654]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1001.27,695.188],[1001.27,804.232],[955.213,691.734],[955.213,798.362]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1000.24,824.46],[1000.24,933.518],[956.348,818.436],[956.348,925.189]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1000.24,824.46],[1087.82,823.541],[1000.24,933.518],[1087.82,932.247]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1001.27,428.704],[1001.27,319.66],[1088.55,429.079],[1088.55,320.405]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1001.27,554.138],[1001.27,445.094],[1088.55,554.088],[1088.55,445.414]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1001.27,566.632],[1001.27,675.676],[1088.55,566.539],[1088.55,675.213]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1001.27,695.188],[1001.27,804.232],[1088.55,694.66],[1088.55,803.334]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1027.57,306.174],[1027.57,202.352],[1072.05,310.217],[1072.05,208.196]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1098.93,307.354],[1098.93,204.057],[1072.05,310.217],[1072.05,208.196]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1088.55,429.079],[1088.55,320.405],[1270.46,437.085],[1270.46,336.307]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1088.55,554.088],[1088.55,445.414],[1270.46,553.01],[1270.46,452.232]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1088.55,566.539],[1088.55,675.213],[1270.46,564.556],[1270.46,665.334]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1088.55,694.66],[1088.55,803.334],[1270.46,683.367],[1270.46,784.145]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1087.82,823.541],[1087.82,932.247],[1269.83,802.878],[1269.83,903.683]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1098.93,307.354],[1098.93,204.057],[1152.24,310.226],[1152.24,208.209]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1152.24,310.226],[1152.24,208.209],[1188.68,312.386],[1188.68,211.331]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1188.68,312.386],[1188.68,211.331],[1238.66,315.876],[1238.66,216.375]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1240.84,316.251],[1240.84,216.918],[1276.29,320.821],[1276.29,223.523]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1271.43,437.128],[1271.43,336.392],[1428.56,444.043],[1428.56,350.129]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1271.43,553.004],[1271.43,452.269],[1428.56,552.073],[1428.56,458.159]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1271.43,564.546],[1271.43,665.281],[1428.56,562.833],[1428.56,656.747]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1271.43,683.307],[1271.43,784.042],[1428.56,673.552],[1428.56,767.466]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1271.43,802.697],[1271.43,903.433],[1428.56,784.858],[1428.56,878.772]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1276.29,320.821],[1276.29,223.523],[1296.91,323.968],[1296.91,228.072]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1296.91,323.968],[1296.91,228.072],[1322.74,328.329],[1322.74,234.375]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:17,
                    verts:[[1295.75,330.7],[1295.75,237.803],[1331.45,333.943],[1331.45,242.49]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[457.454,452.099],[457.454,366.131],[393.956,454.979],[393.956,371.852]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[457.454,550.988],[457.454,465.02],[393.956,550.6],[393.956,467.473]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[457.454,560.838],[457.454,646.806],[393.956,560.124],[393.956,643.251]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[457.454,662.189],[457.454,748.157],[393.956,658.126],[393.956,741.253]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[431.482,446.062],[431.482,354.139],[398.751,450.214],[398.751,362.388]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[431.482,551.801],[431.482,459.878],[398.751,551.242],[398.751,463.415]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[431.482,562.333],[431.482,654.256],[398.751,561.304],[398.751,649.131]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[431.482,670.704],[431.482,762.627],[398.751,664.847],[398.751,752.674]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[704.379,437.577],[704.379,333.911],[454.247,449.306],[454.247,357.599]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[704.379,556.823],[704.379,453.158],[454.247,554.796],[454.247,463.09]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[704.379,568.7],[704.379,672.365],[454.247,565.303],[454.247,657.01]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[704.379,690.916],[704.379,794.581],[454.247,673.42],[454.247,765.127]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[483.433,347.767],[483.433,262.473],[474.917,353.827],[474.917,271.231]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[515.189,338.956],[515.189,249.737],[483.433,347.767],[483.433,262.473]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[572.23,329.869],[572.23,236.601],[519.429,338.758],[519.429,249.449]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[664.376,320.393],[664.376,222.905],[572.23,329.869],[572.23,236.601]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[704.274,809.633],[704.275,913.02],[616.277,798.659],[616.278,897.851]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[769.039,313.233],[769.039,212.555],[664.377,320.393],[664.377,222.905]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[809.807,430.566],[809.807,323.358],[688.223,433.439],[688.223,329.066]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[809.807,553.888],[809.807,446.68],[688.223,553.501],[688.223,449.127]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[809.807,566.171],[809.807,673.379],[688.223,565.459],[688.223,669.833]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[809.807,692.562],[809.807,799.77],[688.223,688.51],[688.223,792.883]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[891.288,307.664],[891.288,204.506],[770.001,313.169],[770.001,212.462]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[811.418,819.677],[811.418,926.904],[717.851,808.145],[717.852,910.964]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[809.807,430.566],[809.807,323.358],[870.561,433.361],[870.561,328.91]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[809.807,553.888],[809.807,446.68],[870.561,553.511],[870.561,449.06]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[809.807,566.171],[809.807,673.379],[870.561,565.478],[870.561,669.93]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[809.807,692.563],[809.807,799.77],[870.561,688.62],[870.561,793.071]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[811.418,819.677],[811.418,926.904],[871.893,812.494],[871.893,916.975]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[971.84,824.742],[971.84,933.907],[863.841,812.084],[863.841,916.409]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[971.7,428.773],[971.7,319.797],[870.561,433.361],[870.561,328.91]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[971.7,554.129],[971.7,445.153],[870.561,553.511],[870.561,449.06]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[971.7,566.615],[971.7,675.591],[870.561,565.479],[870.561,669.93]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[971.7,695.091],[971.7,804.068],[870.561,688.62],[870.561,793.071]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[984.33,305.109],[984.33,200.813],[891.288,307.664],[891.288,204.506]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[971.7,428.773],[971.7,319.797],[1005.41,430.466],[1005.41,323.159]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[971.7,554.129],[971.7,445.153],[1005.41,553.901],[1005.41,446.594]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[971.7,566.615],[971.7,675.591],[1005.41,566.196],[1005.41,673.503]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[971.7,695.091],[971.7,804.068],[1005.41,692.704],[1005.41,800.011]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[971.84,824.742],[971.84,933.907],[1006.84,820.201],[1006.84,927.63]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[984.33,305.109],[1071.02,305.342],[984.33,200.813],[1071.02,201.15]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1057.13,428.187],[1057.13,318.633],[1005.41,430.466],[1005.41,323.159]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1057.13,554.208],[1057.13,444.654],[1005.41,553.901],[1005.41,446.594]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1057.13,566.76],[1057.13,676.314],[1005.41,566.196],[1005.41,673.503]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1057.13,695.918],[1057.13,805.472],[1005.41,692.704],[1005.41,800.011]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1056.14,825.806],[1056.14,935.378],[1006.84,820.201],[1006.84,927.63]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1056.14,825.806],[1056.14,935.378],[1142.37,823.945],[1142.37,932.805]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1057.13,428.187],[1057.13,318.633],[1143.01,428.926],[1143.01,320.1]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1057.13,554.208],[1057.13,444.654],[1143.01,554.109],[1143.01,445.283]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1057.13,566.76],[1057.13,676.314],[1143.01,566.577],[1143.01,675.402]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1057.13,695.918],[1057.13,805.472],[1143.01,694.876],[1143.01,803.701]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1071.02,305.342],[1071.02,201.149],[1110.99,309.791],[1110.99,207.581]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1140.64,307.149],[1140.64,203.762],[1110.99,309.791],[1110.99,207.581]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1140.64,307.149],[1140.64,203.762],[1190.33,310.486],[1190.33,208.585]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1142.37,823.945],[1142.37,932.805],[1302.98,801.421],[1302.98,901.668]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1143.01,428.926],[1143.01,320.1],[1303.53,437.652],[1303.53,337.434]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1143.01,554.109],[1143.01,445.283],[1303.53,552.934],[1303.53,452.715]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1143.01,566.577],[1143.01,675.402],[1303.53,564.416],[1303.53,664.634]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1143.01,694.876],[1143.01,803.701],[1303.53,682.567],[1303.53,782.785]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1190.33,310.486],[1190.33,208.585],[1223.97,312.957],[1223.97,212.156]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1223.97,312.957],[1223.97,212.156],[1269.41,316.86],[1269.41,217.798]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1271.15,317.252],[1271.15,218.365],[1301.09,322.098],[1301.09,225.369]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1301.09,322.098],[1301.09,225.369],[1317.96,325.397],[1317.96,230.138]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1304.38,437.698],[1304.38,337.526],[1441.25,445.139],[1441.25,352.305]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1304.38,552.927],[1304.38,452.755],[1441.25,551.925],[1441.25,459.092]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1304.38,564.404],[1304.38,664.577],[1441.25,562.561],[1441.25,655.395]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1304.38,682.502],[1304.38,782.674],[1441.25,672.006],[1441.25,764.84]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1304.38,801.225],[1304.38,901.398],[1441.25,782.031],[1441.25,874.864]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1317.96,325.397],[1317.96,230.138],[1338.61,329.938],[1338.61,236.702]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:18,
                    verts:[[1309.81,332.089],[1309.81,239.811],[1341.26,335.587],[1341.26,244.867]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[405.524,453.757],[405.524,369.424],[371.898,454.985],[371.898,371.865]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[405.524,550.765],[405.524,466.432],[371.898,550.599],[371.898,467.479]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[405.524,560.427],[405.524,644.76],[371.898,560.123],[371.898,643.243]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[405.524,659.85],[405.524,744.183],[371.898,658.117],[371.898,741.238]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[446.972,449.885],[446.972,361.734],[373.817,452.631],[373.817,367.187]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[446.972,551.286],[446.972,463.135],[373.817,550.917],[373.817,465.473]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[446.972,561.386],[446.972,649.537],[373.817,560.706],[373.817,646.149]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[446.972,665.311],[446.972,753.463],[373.817,661.439],[373.817,746.882]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[434.287,443.585],[434.287,349.22],[390.198,447.74],[390.198,357.473]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[434.287,552.135],[434.287,457.769],[390.198,551.575],[390.198,461.308]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[434.287,562.946],[434.287,657.312],[390.198,561.917],[390.198,652.184]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[434.287,674.197],[434.287,768.563],[390.198,668.337],[390.198,758.604]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[472.374,343.105],[472.374,255.733],[457.009,349.261],[457.009,264.632]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[744.095,435.943],[744.095,330.612],[457.488,446.997],[457.488,352.937]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[744.095,557.106],[744.095,451.775],[457.488,555.195],[457.488,461.135]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[744.095,569.173],[744.095,674.504],[457.488,565.972],[457.488,660.032]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[744.095,693.352],[744.095,798.683],[457.488,676.863],[457.488,770.923]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[514.796,334.313],[514.796,243.026],[472.375,343.105],[472.375,255.733]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[583.527,325.468],[583.527,230.24],[519.407,334.144],[519.407,242.779]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[688.381,316.565],[688.381,217.372],[583.527,325.468],[583.527,230.24]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[743.323,813.976],[743.323,919.025],[643.131,803.697],[643.131,904.815]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[802.761,310.187],[802.761,208.152],[688.382,316.565],[688.382,217.372]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[859.716,429.257],[859.716,320.758],[729.299,431.67],[729.299,325.552]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[859.716,554.064],[859.716,445.565],[729.299,553.739],[729.299,447.621]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[859.716,566.495],[859.716,674.994],[729.299,565.897],[729.299,672.016]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[859.716,694.409],[859.716,802.908],[729.299,691.004],[729.299,797.123]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[932.252,305.626],[932.252,201.559],[803.806,310.13],[803.806,208.07]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[861.394,823.036],[861.394,931.549],[755.806,812.319],[755.806,916.733]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[859.716,429.257],[859.716,320.758],[914.472,432.341],[914.472,326.884]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[859.716,554.064],[859.716,445.565],[914.472,553.649],[914.472,448.192]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[859.716,566.495],[859.716,674.994],[914.472,565.731],[914.472,671.188]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[859.716,694.409],[859.716,802.908],[914.472,690.059],[914.472,795.516]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[861.394,823.036],[861.394,931.549],[915.886,815.111],[915.886,920.594]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1026.74,428.128],[1026.74,318.515],[914.471,432.341],[914.471,326.884]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1026.74,554.216],[1026.74,444.603],[914.471,553.649],[914.471,448.192]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1026.74,566.775],[1026.74,676.388],[914.471,565.731],[914.471,671.188]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1026.74,696.002],[1026.74,805.615],[914.471,690.059],[914.471,795.516]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1027.33,826.41],[1027.33,936.213],[907.398,814.782],[907.398,920.138]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1028.22,303.879],[1028.22,199.035],[932.252,305.626],[932.252,201.559]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1026.74,428.128],[1026.74,318.515],[1056.42,429.974],[1056.42,322.183]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1026.74,554.216],[1026.74,444.603],[1056.42,553.967],[1056.42,446.176]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1026.74,566.775],[1026.74,676.388],[1056.42,566.317],[1056.42,674.109]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1026.74,696.002],[1026.74,805.615],[1056.42,693.397],[1056.42,801.189]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1027.33,826.41],[1027.33,936.213],[1058.14,821.455],[1058.14,929.363]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1028.22,303.879],[1028.22,199.035],[1114.27,304.887],[1114.27,200.492]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1113.22,427.899],[1113.22,318.061],[1056.42,429.974],[1056.42,322.183]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1113.22,554.247],[1113.22,444.408],[1056.42,553.967],[1056.42,446.176]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1113.22,566.831],[1113.22,676.67],[1056.42,566.317],[1056.42,674.109]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1113.22,696.324],[1113.22,806.163],[1056.42,693.397],[1056.42,801.189]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1112.28,826.56],[1112.28,936.421],[1058.14,821.455],[1058.14,929.363]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1112.28,826.56],[1112.28,936.421],[1195.93,823.758],[1195.93,932.547]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1113.22,427.899],[1113.22,318.061],[1196.49,429.001],[1196.49,320.25]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1113.22,554.247],[1113.22,444.408],[1196.49,554.098],[1196.49,445.347]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1113.22,566.831],[1113.22,676.67],[1196.49,566.558],[1196.49,675.31]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1113.22,696.324],[1113.22,806.163],[1196.49,694.77],[1196.49,803.521]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1114.27,304.887],[1114.27,200.492],[1149.18,309.703],[1149.18,207.454]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1181.26,307.315],[1181.26,204.001],[1149.18,309.703],[1149.18,207.454]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1181.27,307.315],[1181.27,204.001],[1226.7,311.086],[1226.7,209.452]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1196.49,429.001],[1196.49,320.25],[1333.59,438.354],[1333.59,338.827]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1196.49,554.098],[1196.49,445.347],[1333.59,552.839],[1333.59,453.313]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1196.49,566.558],[1196.49,675.31],[1333.59,564.242],[1333.59,663.768]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1196.49,694.77],[1196.49,803.521],[1333.59,681.578],[1333.59,781.104]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1195.93,823.758],[1195.93,932.547],[1333.12,799.617],[1333.12,899.174]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1226.7,311.086],[1226.7,209.452],[1257.14,313.842],[1257.14,213.435]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1257.14,313.842],[1257.14,213.435],[1297.54,318.117],[1297.54,219.615]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1298.83,318.522],[1298.83,220.201],[1322.98,323.594],[1322.98,227.531]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1322.98,323.594],[1322.98,227.531],[1335.97,327.012],[1335.97,232.472]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1334.31,438.403],[1334.31,338.925],[1449.86,446.285],[1449.86,354.583]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1334.31,552.833],[1334.31,453.355],[1449.86,551.771],[1449.86,460.068]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1334.31,564.23],[1334.31,663.708],[1449.86,562.278],[1449.86,653.98]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1334.31,681.508],[1334.31,780.986],[1449.86,670.389],[1449.86,762.092]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1334.31,799.408],[1334.31,898.886],[1449.86,779.074],[1449.86,870.776]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:19,
                    verts:[[1335.97,327.012],[1335.97,232.472],[1351.31,331.689],[1351.31,239.233]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[387.568,451.4],[387.568,364.742],[349.387,452.549],[349.387,367.025]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[387.568,551.082],[387.568,464.425],[349.387,550.928],[349.387,465.404]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[387.568,561.011],[387.568,647.669],[349.387,560.726],[349.387,646.25]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[387.568,663.175],[387.568,749.833],[349.387,661.554],[349.387,747.077]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[440.157,447.564],[440.157,357.124],[357.07,450.129],[357.07,362.218]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[440.157,551.599],[440.157,461.158],[357.07,551.253],[357.07,463.342]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[440.157,561.961],[440.157,652.401],[357.07,561.326],[357.07,649.237]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[440.157,668.585],[440.157,759.026],[357.07,664.968],[357.07,752.879]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[442.074,441.04],[442.074,344.164],[386.009,445.15],[386.009,352.327]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[442.074,552.477],[442.074,455.601],[386.009,551.924],[386.009,459.101]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[442.074,563.577],[442.074,660.453],[386.009,562.559],[386.009,655.381]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[442.074,677.788],[442.074,774.664],[386.009,671.991],[386.009,764.814]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[464.709,338.215],[464.71,248.666],[442.037,344.417],[442.037,257.631]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[518.289,329.539],[518.29,236.124],[464.71,338.215],[464.71,248.666]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[787.766,434.451],[787.766,327.6],[465.506,444.63],[465.506,348.156]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[787.766,557.363],[787.766,450.512],[465.506,555.604],[465.506,459.13]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[787.766,569.605],[787.766,676.457],[465.506,566.658],[465.506,663.131]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[787.766,695.577],[787.766,802.429],[465.506,680.395],[465.506,776.868]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[598.903,321.059],[598.903,223.868],[523.256,329.403],[523.256,235.926]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[716.126,312.886],[716.126,212.053],[598.903,321.059],[598.903,223.868]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[786.298,817.95],[786.298,924.517],[674.461,808.552],[674.461,911.526]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[839.351,307.424],[839.351,204.159],[716.127,312.886],[716.127,212.053]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[912.463,428.162],[912.463,318.583],[774.612,430.053],[774.612,322.338]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[912.463,554.211],[912.463,444.633],[774.612,553.957],[774.612,446.243]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[912.463,566.766],[912.463,676.345],[774.612,566.298],[774.612,674.012]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[912.463,695.953],[912.463,805.532],[774.612,693.287],[774.612,801.001]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[974.711,303.982],[974.711,199.184],[840.47,307.376],[840.47,204.089]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[914.187,825.842],[914.187,935.428],[797.459,816.13],[797.46,922.002]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[912.463,428.162],[912.463,318.583],[960.217,431.512],[960.217,325.237]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[912.463,554.211],[912.463,444.633],[960.217,553.76],[960.217,447.486]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[912.463,566.766],[912.463,676.345],[960.217,565.936],[960.217,672.211]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[912.463,695.953],[912.463,805.532],[960.217,691.228],[960.217,797.503]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[914.187,825.842],[914.187,935.428],[961.697,817.235],[961.697,923.53]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1082.37,427.742],[1082.37,317.748],[960.216,431.512],[960.216,325.237]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1082.37,554.268],[1082.37,444.274],[960.216,553.76],[960.216,447.486]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1082.37,566.87],[1082.37,676.864],[960.216,565.936],[960.216,672.211]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1082.37,696.547],[1082.37,806.541],[960.216,691.228],[960.216,797.503]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1083.41,827.402],[1083.41,937.585],[952.873,816.993],[952.873,923.196]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1072.42,303.096],[974.711,303.982],[1072.42,197.903],[974.711,199.184]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1072.42,303.096],[1072.42,197.903],[1156.69,304.886],[1156.69,200.491]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1082.37,427.742],[1082.37,317.748],[1107.5,429.724],[1107.5,321.685]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1082.37,554.268],[1082.37,444.274],[1107.5,554.001],[1107.5,445.962]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1082.37,566.87],[1082.37,676.864],[1107.5,566.379],[1107.5,674.418]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1082.37,696.547],[1082.37,806.541],[1107.5,693.751],[1107.5,801.79]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1083.41,827.402],[1083.41,937.585],[1109.49,822.085],[1109.49,930.233]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1168.65,427.883],[1168.65,318.028],[1107.5,429.724],[1107.5,321.685]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1168.65,554.249],[1168.65,444.394],[1107.5,554.001],[1107.5,445.962]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1168.65,566.835],[1168.65,676.69],[1107.5,566.379],[1107.5,674.418]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1168.65,696.347],[1168.65,806.202],[1107.5,693.751],[1107.5,801.789]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1167.77,826.613],[1167.77,936.494],[1109.49,822.085],[1109.49,930.233]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1156.69,304.886],[1156.69,200.491],[1186.03,310.019],[1186.03,207.91]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1167.77,826.613],[1167.77,936.494],[1247.62,822.894],[1247.62,931.352]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1168.65,427.883],[1168.65,318.028],[1248.08,429.339],[1248.08,320.92]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1168.65,554.249],[1168.65,444.394],[1248.08,554.053],[1248.08,445.634]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1168.65,566.835],[1168.65,676.69],[1248.08,566.475],[1248.08,674.893]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1168.65,696.348],[1168.65,806.202],[1248.08,694.294],[1248.08,802.712]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1220.16,307.914],[1220.16,204.867],[1186.02,310.019],[1186.02,207.91]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1220.16,307.914],[1220.16,204.867],[1260.77,312.078],[1260.77,210.886]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1248.08,429.339],[1248.08,320.92],[1360.11,439.205],[1360.11,340.519]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1248.08,554.053],[1248.08,445.634],[1360.11,552.724],[1360.11,454.038]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1248.08,566.475],[1248.08,674.893],[1360.11,564.031],[1360.11,662.717]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1248.08,694.294],[1248.08,802.712],[1360.11,680.377],[1360.11,779.063]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1247.62,822.894],[1247.62,931.352],[1359.73,797.424],[1359.73,896.143]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1260.77,312.078],[1260.77,210.886],[1287.65,315.088],[1287.65,215.237]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1287.65,315.088],[1287.65,215.236],[1322.58,319.686],[1322.58,221.883]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1323.41,320.1],[1323.41,222.481],[1341.58,325.341],[1341.58,230.057]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1341.58,325.341],[1341.58,230.057],[1350.6,328.842],[1350.6,235.117]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1350.6,328.842],[1350.6,235.117],[1360.58,333.607],[1360.58,242.005]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1360.7,439.257],[1360.7,340.621],[1454.18,447.489],[1454.18,356.975]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1360.7,552.717],[1360.7,454.082],[1454.18,551.609],[1454.18,461.094]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1360.7,564.018],[1360.7,662.654],[1454.18,561.979],[1454.18,652.494]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1360.7,680.304],[1360.7,778.939],[1454.18,668.691],[1454.18,759.205]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:20,
                    verts:[[1360.7,797.205],[1360.7,895.841],[1454.18,775.967],[1454.18,866.482]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[373.375,448.919],[373.375,359.815],[330.524,449.966],[330.524,361.895]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[373.375,551.416],[373.375,462.312],[330.524,551.275],[330.524,463.204]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[373.375,561.625],[373.375,650.729],[330.524,561.366],[330.524,649.437]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[373.375,666.674],[373.375,755.778],[330.524,665.197],[330.524,753.268]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[437.646,445.169],[437.646,352.365],[344.48,447.499],[344.48,356.994]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[437.646,551.921],[437.646,459.118],[344.48,551.608],[344.48,461.103]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[437.646,562.554],[437.646,655.358],[344.48,561.977],[344.48,652.482]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[437.646,671.964],[437.646,764.768],[344.48,668.677],[344.48,759.182]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[455.467,438.473],[455.467,339.065],[386.927,442.479],[386.927,347.022]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[455.467,552.823],[455.467,453.415],[386.927,552.284],[386.927,456.826]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[455.467,564.212],[455.467,663.621],[386.927,563.22],[386.927,658.677]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[455.467,681.409],[455.467,780.817],[386.927,675.759],[386.927,771.216]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[430.625,339.352],[430.625,250.309],[426.097,345.309],[426.097,258.919]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[461.035,333.168],[461.035,241.369],[430.625,339.352],[430.625,250.309]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[526.159,324.72],[526.16,229.159],[461.035,333.168],[461.035,241.37]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[835.044,433.162],[835.044,324.995],[478.873,442.248],[478.873,343.345]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[835.044,557.586],[835.044,449.42],[478.873,556.016],[478.873,457.114]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[835.044,569.979],[835.044,678.145],[478.873,567.347],[478.873,666.25]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[835.044,697.501],[835.044,805.667],[478.873,683.948],[478.873,782.85]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[618.649,316.748],[618.649,217.636],[531.456,324.624],[531.456,229.018]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[747.597,309.47],[747.597,207.117],[618.649,316.748],[618.649,217.636]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[832.866,821.394],[832.867,929.279],[710.283,813.073],[710.283,917.776]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[878.495,305.058],[878.495,200.74],[747.598,309.47],[747.598,207.117]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[967.356,427.341],[967.356,316.952],[823.808,428.65],[823.808,319.553]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[967.356,554.322],[967.356,443.933],[823.808,554.146],[823.808,445.048]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[967.356,566.969],[967.356,677.359],[823.808,566.645],[823.808,675.743]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[967.356,697.112],[967.356,807.501],[823.808,695.265],[823.808,804.362]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1018.09,302.834],[1018.09,197.525],[879.677,305.02],[879.677,200.684]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[969.101,827.942],[969.101,938.33],[842.48,819.427],[842.48,926.559]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[967.356,427.341],[967.356,316.952],[1007.18,430.923],[1007.18,324.067]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[967.356,554.322],[967.356,443.933],[1007.18,553.84],[1007.18,446.984]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[967.356,566.969],[967.356,677.359],[1007.18,566.082],[1007.18,672.938]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[967.356,697.112],[967.356,807.501],[1007.18,692.059],[1007.18,798.915]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[969.101,827.942],[969.101,938.33],[1008.7,818.739],[1008.7,925.609]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1137.65,427.659],[1137.65,317.585],[1007.18,430.923],[1007.18,324.067]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1137.65,554.279],[1137.65,444.204],[1007.18,553.84],[1007.18,446.984]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1137.65,566.891],[1137.65,676.965],[1007.18,566.082],[1007.18,672.938]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1137.65,696.662],[1137.65,806.737],[1007.18,692.059],[1007.18,798.915]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1139.13,827.604],[1139.13,937.863],[999.66,818.592],[999.66,925.406]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1018.09,302.834],[1116.23,302.846],[1018.09,197.525],[1116.23,197.541]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1116.23,302.846],[1116.23,197.542],[1197.54,305.408],[1197.54,201.244]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1137.65,427.659],[1137.65,317.585],[1157.79,429.753],[1157.79,321.743]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1137.65,554.279],[1137.65,444.204],[1157.79,553.997],[1157.79,445.987]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1137.65,566.891],[1137.65,676.965],[1157.79,566.372],[1157.79,674.382]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1137.65,696.662],[1137.65,806.737],[1157.79,693.709],[1157.79,801.719]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1139.13,827.604],[1139.13,937.863],[1160.01,821.987],[1160.01,930.099]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1222.41,428.174],[1222.41,318.607],[1157.79,429.753],[1157.79,321.743]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1222.41,554.21],[1222.41,444.642],[1157.79,553.997],[1157.79,445.987]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1222.41,566.763],[1222.41,676.33],[1157.79,566.372],[1157.79,674.382]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1222.41,695.937],[1222.41,805.504],[1157.79,693.709],[1157.79,801.719]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1221.61,825.871],[1221.61,935.468],[1160.01,821.987],[1160.01,930.099]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1197.54,305.408],[1197.54,201.244],[1220.91,310.796],[1220.91,209.033]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1256.64,309],[1256.64,206.437],[1220.91,310.796],[1220.91,209.033]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1222.41,428.174],[1222.41,318.607],[1296.82,429.965],[1296.82,322.164]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1222.41,554.21],[1222.41,444.643],[1296.82,553.969],[1296.82,446.168]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1222.41,566.763],[1222.41,676.33],[1296.82,566.32],[1296.82,674.12]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1222.41,695.937],[1222.41,805.504],[1296.82,693.41],[1296.82,801.211]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1221.61,825.871],[1221.61,935.468],[1296.47,821.282],[1296.47,929.124]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1256.64,309],[1256.64,206.437],[1291.93,313.505],[1291.93,212.948]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1291.93,313.505],[1291.93,212.948],[1314.96,316.731],[1314.96,217.612]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1296.47,821.282],[1296.47,929.124],[1382.34,794.816],[1382.34,892.538]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1296.82,429.965],[1296.82,322.164],[1382.63,440.217],[1382.63,342.529]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1296.82,553.969],[1296.82,446.168],[1382.63,552.588],[1382.63,454.9]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1296.82,566.32],[1296.82,674.12],[1382.63,563.78],[1382.63,661.468]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1296.82,693.41],[1296.82,801.211],[1382.63,678.949],[1382.63,776.637]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1314.96,316.731],[1314.96,217.612],[1344.08,321.595],[1344.08,224.642]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1344.45,322.013],[1344.45,225.246],[1356.53,327.363],[1356.53,232.98]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1356.53,327.363],[1356.53,232.98],[1361.57,330.908],[1361.57,238.103]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1361.57,330.908],[1361.57,238.103],[1366.19,335.71],[1366.19,245.044]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1383.07,440.27],[1383.07,342.635],[1454.08,448.755],[1454.08,359.489]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1383.07,552.581],[1383.07,454.945],[1454.08,551.438],[1454.08,462.172]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1383.07,563.767],[1383.07,661.403],[1454.08,561.666],[1454.08,650.932]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1383.07,678.874],[1383.07,776.509],[1454.08,666.905],[1454.08,756.171]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:21,
                    verts:[[1383.07,794.59],[1383.07,892.225],[1454.08,772.702],[1454.08,861.968]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[363.718,446.348],[363.718,354.707],[316.147,447.266],[316.147,356.53]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[363.718,551.763],[363.718,460.122],[316.147,551.639],[316.147,460.904]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[363.718,562.262],[363.718,653.902],[316.147,562.035],[316.147,652.77]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[363.718,670.301],[363.718,761.941],[316.147,669.006],[316.147,759.742]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[440.089,442.74],[440.089,347.541],[336.877,444.776],[336.877,351.586]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[440.089,552.248],[440.089,457.049],[336.877,551.974],[336.877,458.783]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[440.089,563.156],[440.089,658.355],[336.877,562.651],[336.877,655.842]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[440.089,675.39],[440.089,770.589],[336.877,672.518],[336.877,765.709]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[475.019,435.943],[475.019,334.038],[393.697,439.775],[393.697,341.652]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[475.019,553.164],[475.019,451.259],[393.697,552.648],[393.697,454.524]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[475.019,564.839],[475.019,666.744],[393.697,563.89],[393.697,662.013]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[475.019,684.978],[475.019,786.883],[393.697,679.572],[393.697,777.695]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[423.442,334.138],[423.442,242.772],[412.136,340.216],[412.136,251.557]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[461.958,328.048],[461.958,233.97],[423.441,334.138],[423.441,242.772]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[538.85,319.963],[538.85,222.284],[461.958,328.048],[461.959,233.97]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[885.357,432.135],[885.357,322.921],[498.095,439.906],[498.095,338.616]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[885.357,557.764],[885.357,448.55],[498.095,556.421],[498.095,455.131]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[885.357,570.276],[885.357,679.49],[498.095,568.026],[498.095,669.315]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[885.357,699.033],[885.357,808.247],[498.095,687.44],[498.095,788.73]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[642.95,312.654],[642.95,211.719],[544.441,319.911],[544.441,222.207]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[782.622,306.443],[782.622,202.741],[642.95,312.654],[642.95,211.719]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[882.473,824.15],[882.473,933.089],[750.419,817.098],[750.419,923.34]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[919.716,303.203],[919.716,198.058],[782.622,306.443],[782.622,202.741]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1023.49,426.847],[1023.49,315.972],[876.297,427.529],[876.297,317.326]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1023.49,554.388],[1023.49,443.513],[876.297,554.297],[876.297,444.093]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1023.49,567.092],[1023.49,677.967],[876.297,566.923],[876.297,677.126]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1023.49,697.808],[1023.49,808.684],[876.297,696.846],[876.297,807.05]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[882.473,824.15],[882.473,933.089],[890.328,822.054],[890.329,930.191]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1061.68,302.274],[920.946,303.176],[1061.68,196.714],[920.946,198.018]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1025.22,829.195],[1025.22,940.062],[890.328,822.054],[890.329,930.191]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1023.49,426.847],[1023.49,315.972],[1054.58,430.618],[1054.58,323.462]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1023.49,554.388],[1023.49,443.513],[1054.58,553.881],[1054.58,446.724]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1023.49,567.092],[1023.49,677.967],[1054.58,566.158],[1054.58,673.314]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1023.49,697.808],[1023.49,808.684],[1054.58,692.489],[1054.58,799.645]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1025.22,829.195],[1025.22,940.062],[1056.13,819.508],[1056.13,926.672]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1191.48,427.918],[1191.48,318.097],[1054.58,430.618],[1054.58,323.462]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1191.48,554.244],[1191.48,444.424],[1054.58,553.881],[1054.58,446.724]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1191.48,566.827],[1191.48,676.647],[1054.58,566.158],[1054.58,673.314]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1191.48,696.298],[1191.48,806.119],[1054.58,692.489],[1054.58,799.645]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1193.39,826.92],[1193.39,936.918],[1046.99,819.461],[1046.99,926.607]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1061.68,302.273],[1061.68,196.714],[1158.86,303.199],[1158.86,198.053]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1158.86,303.2],[1158.86,198.053],[1236.07,306.503],[1236.07,202.828]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1191.48,427.917],[1191.48,318.097],[1206.32,430.094],[1206.32,322.42]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1191.48,554.244],[1191.48,444.424],[1206.32,553.951],[1206.32,446.278]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1191.48,566.827],[1191.48,676.647],[1206.32,566.288],[1206.32,673.961]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1191.48,696.298],[1191.48,806.119],[1206.32,693.229],[1206.32,800.903]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1193.39,826.92],[1193.39,936.918],[1208.75,821.083],[1208.75,928.849]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1273.43,428.799],[1273.43,319.848],[1206.32,430.094],[1206.32,322.42]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1273.43,554.126],[1273.43,445.175],[1206.32,553.951],[1206.32,446.278]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1273.43,566.608],[1273.43,675.559],[1206.32,566.288],[1206.32,673.961]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1273.43,695.055],[1273.43,804.006],[1206.32,693.229],[1206.32,800.902]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1272.72,824.268],[1272.72,933.251],[1208.75,821.083],[1208.75,928.849]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1236.07,306.503],[1236.07,202.828],[1253.17,312.077],[1253.17,210.885]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1290.02,310.61],[1253.17,312.077],[1290.02,208.764],[1253.17,210.885]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1273.43,428.799],[1273.43,319.848],[1341.75,430.897],[1341.75,324.015]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1273.43,554.126],[1273.43,445.175],[1341.75,553.843],[1341.75,446.961]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1273.43,566.608],[1273.43,675.559],[1341.75,566.089],[1341.75,672.971]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1273.43,695.055],[1273.43,804.006],[1341.75,692.096],[1341.75,798.978]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1272.72,824.268],[1272.72,933.251],[1341.51,818.882],[1341.51,925.806]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1290.02,310.61],[1290.02,208.764],[1319.59,315.394],[1319.59,215.679]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1319.59,315.394],[1319.59,215.679],[1338.54,318.793],[1338.54,220.593]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1338.54,318.793],[1338.54,220.593],[1361.62,323.859],[1361.62,227.915]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1341.75,430.897],[1341.75,324.015],[1400.7,441.394],[1400.7,344.867]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1341.75,553.843],[1341.75,446.961],[1400.7,552.43],[1400.7,455.902]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1341.75,566.089],[1341.75,672.971],[1400.7,563.489],[1400.7,660.016]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1341.75,692.096],[1341.75,798.978],[1400.7,677.289],[1400.7,773.816]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1341.51,818.882],[1341.51,925.806],[1400.51,791.782],[1400.51,888.344]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1361.53,324.276],[1361.53,228.517],[1367.53,329.672],[1367.53,236.317]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1367.53,329.672],[1367.53,236.317],[1368.64,333.219],[1368.64,241.445]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1401.01,441.448],[1401.01,344.975],[1449.5,450.082],[1449.5,362.125]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1401.01,552.422],[1401.01,455.949],[1449.5,551.26],[1449.5,463.303]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1401.01,563.475],[1401.01,659.949],[1449.5,561.337],[1449.5,649.294]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1401.01,677.212],[1401.01,773.686],[1449.5,665.033],[1449.5,752.99]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:22,
                    verts:[[1401.01,791.551],[1401.01,888.025],[1449.5,769.279],[1449.5,857.236]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[307.155,444.486],[307.155,351.008],[303.706,447.33],[303.706,356.659]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[307.155,552.013],[307.155,458.536],[303.706,551.63],[303.706,460.959]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[307.155,562.723],[307.155,656.201],[303.706,562.019],[303.706,652.69]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[307.155,672.928],[307.155,766.405],[303.706,668.915],[303.706,759.586]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[359.398,443.727],[359.398,349.501],[307.155,444.486],[307.155,351.008]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[359.398,552.116],[359.398,457.89],[307.155,552.013],[307.155,458.536]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[359.398,562.911],[359.398,657.137],[307.155,562.723],[307.155,656.201]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[359.398,673.998],[359.398,768.224],[307.155,672.928],[307.155,766.405]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[448.105,440.329],[448.105,342.751],[335.117,442.005],[335.117,346.081]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[448.105,552.573],[448.105,454.995],[335.117,552.347],[335.117,456.423]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[448.105,563.753],[448.105,661.331],[335.117,563.338],[335.117,659.262]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[448.105,678.791],[448.105,776.369],[335.117,676.427],[335.117,772.351]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[431.025,339.455],[431.026,250.458],[401.862,340.331],[401.862,251.724]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[421.172,328.865],[421.172,235.151],[402.599,335.002],[402.599,244.021]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[501.156,433.516],[501.156,329.218],[407.016,437.098],[407.016,336.334]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[501.156,553.49],[501.156,449.192],[407.016,553.008],[407.016,452.244]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[501.156,565.44],[501.156,669.738],[407.016,564.553],[407.016,665.317]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[501.156,688.401],[501.156,792.699],[407.016,683.348],[407.016,784.112]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[468.063,322.963],[468.063,226.619],[421.172,328.865],[421.172,235.15]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[556.719,315.389],[556.719,215.672],[468.064,322.963],[468.064,226.619]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[937.91,431.426],[937.91,321.489],[523.55,437.668],[523.55,334.096]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[937.91,557.886],[937.91,447.95],[523.55,556.807],[523.55,453.235]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[937.91,570.482],[937.91,680.418],[523.55,568.674],[523.55,672.246]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[937.91,700.09],[937.91,810.027],[523.55,690.779],[523.55,794.351]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[671.849,308.907],[671.849,206.302],[562.554,315.387],[562.554,215.667]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[820.857,303.926],[820.857,199.103],[671.849,308.907],[671.849,206.302]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[934.343,826.069],[934.343,935.742],[794.484,820.462],[794.484,927.99]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[962.377,301.962],[962.377,196.264],[820.858,303.926],[820.858,199.103]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[931.245,426.75],[1079.77,426.727],[931.245,315.777],[1079.77,315.733]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[931.245,554.402],[931.245,443.429],[1079.77,554.405],[1079.77,443.41]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[931.245,567.116],[1079.77,567.121],[931.245,678.088],[1079.77,678.116]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[931.245,697.946],[1079.77,697.977],[931.245,808.918],[1079.77,808.971]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[934.343,826.069],[934.343,935.742],[940.26,823.871],[940.26,932.703]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[963.638,301.946],[1104.67,302.374],[963.638,196.241],[1104.67,196.859]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1081.47,829.484],[1081.47,940.463],[940.26,823.871],[940.26,932.703]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1079.77,426.727],[1079.77,315.733],[1101.52,430.634],[1101.52,323.494]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1079.77,554.405],[1079.77,443.41],[1101.52,553.878],[1101.52,446.738]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1079.77,567.121],[1079.77,678.116],[1101.52,566.154],[1101.52,673.294]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1079.77,697.977],[1079.77,808.971],[1101.52,692.466],[1101.52,799.606]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1081.47,829.484],[1081.47,940.463],[1103.08,819.449],[1103.08,926.59]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1242.76,428.539],[1242.76,319.332],[1101.52,430.634],[1101.52,323.494]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1242.76,554.161],[1242.76,444.953],[1101.52,553.878],[1101.52,446.738]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1242.76,566.673],[1242.76,675.88],[1101.52,566.154],[1101.52,673.294]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1242.76,695.422],[1242.76,804.629],[1101.52,692.466],[1101.52,799.606]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1245.05,825.293],[1245.05,934.668],[1093.99,819.504],[1093.99,926.666]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1104.67,302.374],[1104.67,196.859],[1199.46,304.208],[1199.46,199.51]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1199.46,304.208],[1199.46,199.51],[1271.49,308.202],[1271.49,205.284]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1242.76,428.539],[1242.76,319.332],[1252.08,430.765],[1252.08,323.754]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1242.76,554.161],[1242.76,444.953],[1252.08,553.861],[1252.08,446.85]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1242.76,566.673],[1242.76,675.88],[1252.08,566.121],[1252.08,673.132]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1242.76,695.422],[1242.76,804.629],[1252.08,692.281],[1252.08,799.292]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1245.05,825.293],[1245.05,934.668],[1254.68,819.322],[1254.68,926.414]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1320.63,429.77],[1320.63,321.777],[1252.08,430.765],[1252.08,323.754]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1320.63,553.995],[1320.63,446.002],[1252.08,553.861],[1252.08,446.85]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1320.63,566.368],[1320.63,674.361],[1252.08,566.121],[1252.08,673.132]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1320.63,693.685],[1320.63,801.678],[1252.08,692.281],[1252.08,799.292]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1320.01,821.77],[1254.68,819.322],[1320.01,929.798],[1254.68,926.414]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1271.49,308.202],[1271.49,205.283],[1282.19,313.885],[1282.19,213.497]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1319.64,312.759],[1282.18,313.885],[1319.64,211.871],[1282.18,213.497]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1319.64,312.759],[1319.64,211.871],[1343.23,317.754],[1343.23,219.091]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1320.01,821.77],[1320.01,929.798],[1381.8,815.684],[1381.8,921.386]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1320.63,429.77],[1320.63,321.777],[1381.93,432.137],[1381.93,326.478]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1320.63,553.995],[1320.63,446.002],[1381.93,553.676],[1381.93,448.018]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1320.63,566.368],[1320.63,674.361],[1381.93,565.782],[1381.93,671.44]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1320.63,693.685],[1320.63,801.678],[1381.93,690.347],[1381.93,796.005]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1343.23,317.754],[1343.23,219.091],[1357.96,321.279],[1357.96,224.185]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1357.96,321.279],[1357.96,224.185],[1374.87,326.478],[1374.87,231.7]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1381.93,432.137],[1381.93,326.478],[1414.02,442.732],[1414.02,347.525]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1381.93,553.676],[1381.93,448.018],[1414.02,552.249],[1414.02,457.042]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1381.93,565.782],[1381.93,671.44],[1414.02,563.157],[1414.02,658.365]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1381.93,690.347],[1381.93,796.005],[1414.02,675.401],[1414.02,770.608]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1381.8,815.684],[1381.8,921.386],[1413.91,788.331],[1413.91,883.573]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1414.18,442.787],[1414.18,347.634],[1440.47,451.466],[1440.47,364.873]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1414.18,552.242],[1414.18,457.089],[1440.47,551.073],[1440.47,464.481]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1414.18,563.144],[1414.18,658.297],[1440.47,560.994],[1440.47,647.587]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1414.18,675.324],[1414.18,770.477],[1440.47,663.082],[1440.47,749.674]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:23,
                    verts:[[1414.18,788.098],[1414.18,883.251],[1440.47,765.71],[1440.47,852.303]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[304.453,441.675],[304.453,345.425],[293.719,444.586],[293.719,351.206]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[304.453,552.392],[304.453,456.142],[293.719,552],[293.719,458.621]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[304.453,563.419],[304.453,659.669],[293.719,562.698],[293.719,656.078]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[304.453,676.893],[304.453,773.143],[293.719,672.787],[293.719,766.166]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[361.197,441.107],[361.197,344.297],[304.453,441.675],[304.453,345.425]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[361.197,552.468],[361.197,455.658],[304.453,552.392],[304.453,456.142]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[361.197,563.56],[361.197,660.37],[304.453,563.419],[304.453,659.669]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[361.197,677.693],[361.197,774.504],[304.453,676.893],[304.453,773.143]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[462.217,437.993],[462.217,338.11],[340.027,439.241],[340.027,340.59]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[462.217,552.888],[462.217,453.005],[340.027,552.72],[340.027,454.069]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[462.217,564.331],[462.217,664.214],[340.027,564.022],[340.027,662.673]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[462.217,682.087],[462.217,781.969],[340.027,680.326],[340.027,778.977]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[422.861,334.56],[422.861,243.382],[391.45,335.211],[391.45,244.324]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[424.464,323.642],[424.464,227.601],[398.201,329.76],[398.201,236.445]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[479.85,318.031],[479.85,219.491],[424.463,323.642],[424.463,227.601]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[534.093,431.268],[534.093,324.752],[427.453,434.515],[427.453,331.203]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[534.093,553.793],[534.093,447.278],[427.453,553.356],[427.453,450.044]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[534.093,565.997],[534.093,672.512],[427.453,565.193],[427.453,668.505]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[534.093,691.572],[534.093,798.088],[427.453,686.992],[427.453,790.304]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[579.979,311.13],[579.979,209.515],[479.85,318.031],[479.85,219.491]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[991.704,431.082],[991.704,320.795],[555.416,435.602],[555.416,329.924]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[991.704,557.946],[991.704,447.659],[555.416,557.164],[555.416,451.486]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[991.704,570.581],[991.704,680.868],[555.416,569.272],[555.416,674.951]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[991.704,700.603],[991.704,810.89],[555.416,693.861],[555.416,799.539]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[705.201,305.637],[705.201,201.576],[585.997,311.182],[585.997,209.589]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[861.769,302.035],[861.769,196.369],[705.2,305.637],[705.2,201.576]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[987.497,827.027],[987.497,937.065],[841.85,823.011],[841.85,931.513]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1005.7,301.421],[861.77,302.035],[1005.7,195.482],[861.77,196.369]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[987.595,426.362],[987.595,315.008],[1134.98,427.012],[1134.98,316.298]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[987.595,554.454],[987.595,443.1],[1134.98,554.366],[1134.98,443.653]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[987.595,567.212],[987.595,678.566],[1134.98,567.051],[1134.98,677.764]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[987.595,698.492],[987.595,809.846],[1134.98,697.576],[1134.98,808.289]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[987.497,827.027],[987.497,937.065],[991.337,824.757],[991.337,933.928]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1136.63,828.73],[1136.63,939.42],[991.337,824.757],[991.337,933.928]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1006.97,301.417],[1006.97,195.476],[1146.18,303.185],[1146.18,198.031]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1134.98,427.012],[1134.98,316.298],[1147.04,430.996],[1147.04,324.212]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1134.98,554.366],[1134.98,443.653],[1147.04,553.83],[1147.04,447.046]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1134.98,567.051],[1134.98,677.764],[1147.04,566.064],[1147.04,672.848]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1134.98,697.576],[1134.98,808.289],[1147.04,691.956],[1147.04,798.74]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1136.63,828.73],[1136.63,939.42],[1148.57,818.499],[1148.57,925.277]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1146.17,303.185],[1146.17,198.031],[1237.19,305.894],[1237.19,201.947]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1290.35,429.532],[1290.35,321.304],[1147.04,430.996],[1147.04,324.212]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1290.35,554.027],[1290.35,445.799],[1147.04,553.83],[1147.04,447.046]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1290.35,566.427],[1290.35,674.655],[1147.04,566.064],[1147.04,672.848]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1290.35,694.021],[1290.35,802.25],[1147.04,691.956],[1147.04,798.74]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1292.99,822.701],[1292.99,931.086],[1139.67,818.655],[1139.67,925.493]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1237.19,305.894],[1237.19,201.947],[1303.1,310.509],[1303.1,208.618]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1290.35,429.532],[1290.35,321.304],[1294.11,431.774],[1294.11,325.757]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1290.35,554.027],[1290.35,445.799],[1294.11,553.725],[1294.11,447.709]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1290.35,566.427],[1290.35,674.655],[1294.11,565.872],[1294.11,671.888]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1290.35,694.021],[1290.35,802.25],[1294.11,690.859],[1294.11,796.875]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1292.99,822.701],[1292.99,931.086],[1296.84,816.689],[1296.84,922.775]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1363,431.085],[1294.11,431.774],[1363,324.388],[1294.11,325.757]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1363,553.818],[1363,447.122],[1294.11,553.725],[1294.11,447.709]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1363,566.042],[1363,672.739],[1294.11,565.872],[1294.11,671.888]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1363,691.831],[1294.11,690.859],[1363,798.527],[1294.11,796.875]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1362.49,818.384],[1296.84,816.69],[1362.49,925.118],[1296.84,922.775]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1303.1,310.509],[1303.1,208.618],[1307.38,316.22],[1307.38,216.872]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1344.92,315.441],[1307.38,316.219],[1344.92,215.747],[1307.38,216.872]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1344.92,315.441],[1344.92,215.747],[1362.39,320.573],[1362.39,223.165]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1362.39,320.573],[1362.39,223.165],[1372.85,324.172],[1372.85,228.367]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1363,431.085],[1363,324.388],[1416.57,433.675],[1416.57,329.534]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1363,553.818],[1363,447.122],[1416.57,553.469],[1416.57,449.328]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1363,566.042],[1363,672.739],[1416.57,565.401],[1416.57,669.542]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1363,691.831],[1363,798.527],[1416.57,688.177],[1416.57,792.318]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1362.49,818.384],[1362.49,925.118],[1416.54,811.715],[1416.54,915.899]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1372.85,324.172],[1372.85,228.367],[1383.61,329.434],[1383.61,235.972]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1416.57,433.675],[1416.57,329.534],[1422.36,444.221],[1422.36,350.483]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1416.57,553.469],[1416.57,449.328],[1422.36,552.049],[1422.36,458.31]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1416.57,565.401],[1416.57,669.542],[1422.36,562.789],[1422.36,656.527]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1416.57,688.177],[1416.57,792.318],[1422.36,673.301],[1422.36,767.039]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1416.54,811.715],[1416.54,915.899],[1422.34,784.489],[1422.34,878.262]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1422.39,444.276],[1422.39,350.591],[1427.12,452.897],[1427.12,367.716]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1422.39,552.042],[1422.39,458.357],[1427.12,550.881],[1427.12,465.7]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1422.39,562.775],[1422.39,656.46],[1427.12,560.64],[1427.12,645.821]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:24,
                    verts:[[1422.39,673.224],[1422.39,766.909],[1427.12,661.063],[1427.12,746.244]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[308.89,438.891],[308.89,339.896],[290.285,441.832],[290.285,345.738]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[308.89,552.767],[308.89,453.771],[290.285,552.371],[290.285,456.276]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[308.89,564.109],[308.89,663.104],[290.285,563.38],[290.285,659.475]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[308.89,680.819],[308.89,779.815],[290.285,676.67],[290.285,772.765]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[369.811,438.547],[369.811,339.211],[308.89,438.891],[308.89,339.896]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[369.811,552.813],[369.811,453.477],[308.89,552.767],[308.89,453.771]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[369.811,564.194],[369.811,663.53],[308.89,564.109],[308.89,663.104]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[369.811,681.305],[369.811,780.64],[308.89,680.819],[308.89,779.815]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[482.797,435.795],[482.797,333.745],[352.327,436.548],[352.327,335.241]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[482.797,553.184],[482.797,451.134],[352.327,553.082],[352.327,451.775]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[482.797,564.876],[482.797,666.926],[352.327,564.689],[352.327,665.996]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[482.797,685.187],[482.797,787.237],[352.327,684.124],[352.327,785.431]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[419.895,329.717],[419.896,236.382],[386.403,330.11],[386.403,236.95]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[433.871,318.591],[433.871,220.3],[399.605,324.6],[399.605,228.986]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[497.682,313.384],[497.682,212.774],[433.871,318.591],[433.871,220.3]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[573.779,429.275],[573.779,320.793],[455.373,432.1],[455.373,326.406]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[573.779,554.062],[573.779,445.58],[455.373,553.681],[455.373,447.987]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[573.779,566.49],[573.779,674.972],[455.373,565.791],[455.373,671.485]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[573.779,694.384],[573.779,802.865],[455.373,690.398],[455.373,796.092]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[608.656,307.32],[608.656,204.008],[497.682,313.384],[497.682,212.774]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1045.58,431.135],[1045.58,320.902],[593.617,433.779],[593.617,326.241]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1045.58,557.937],[1045.58,447.704],[593.617,557.48],[593.617,449.942]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1045.58,570.566],[1045.58,680.799],[593.617,569.8],[593.617,677.338]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1045.58,700.524],[1045.58,810.757],[593.617,696.581],[593.617,804.118]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[742.65,302.97],[742.65,197.721],[614.779,307.43],[614.779,204.166]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[904.648,300.864],[904.648,194.678],[742.65,302.97],[742.65,197.721]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1040.8,826.937],[1040.8,936.941],[891.67,824.615],[891.67,933.731]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[904.648,300.865],[1048.8,301.639],[904.648,194.678],[1048.8,195.797]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1040.8,826.937],[1040.8,936.941],[1042.48,824.632],[1042.48,933.755]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1189.44,826.901],[1042.48,824.632],[1189.44,936.891],[1042.48,933.755]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1044.13,426.403],[1044.13,315.089],[1187.89,427.714],[1187.89,317.693]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1044.13,554.448],[1044.13,443.134],[1187.89,554.272],[1187.89,444.251]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1044.13,567.202],[1044.13,678.516],[1187.89,566.877],[1187.89,676.898]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1044.13,698.435],[1044.13,809.749],[1187.89,696.585],[1187.89,806.606]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1050.07,301.647],[1050.07,195.809],[1185.33,304.725],[1185.33,200.257]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1185.33,304.725],[1185.33,200.257],[1271.29,308.252],[1271.29,205.355]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1187.89,427.714],[1187.89,317.693],[1190.14,431.712],[1190.14,325.634]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1187.89,554.272],[1187.89,444.251],[1190.14,553.733],[1190.14,447.656]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1187.89,566.877],[1187.89,676.898],[1190.14,565.887],[1190.14,671.965]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1187.89,696.585],[1187.89,806.606],[1190.14,690.947],[1190.14,797.024]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1189.44,826.901],[1189.44,936.891],[1191.63,816.636],[1191.63,922.702]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1190.14,431.712],[1333.24,430.886],[1190.14,325.634],[1333.24,323.993]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1190.14,553.733],[1333.24,553.845],[1190.14,447.656],[1333.24,446.952]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1190.14,565.887],[1333.24,566.092],[1190.14,671.965],[1333.24,672.984]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1190.14,690.947],[1333.24,692.112],[1190.14,797.025],[1333.24,799.005]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1183.05,816.89],[1336.17,819.173],[1183.05,923.052],[1336.17,926.208]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1271.29,308.252],[1271.29,205.355],[1330.29,313.401],[1330.29,212.798]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1328.3,319.059],[1365.43,318.623],[1328.3,220.976],[1365.43,220.346]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1331.54,433.108],[1399.7,432.723],[1331.54,328.408],[1399.7,327.643]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1331.54,553.545],[1331.54,448.845],[1399.7,553.597],[1399.7,448.517]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1331.54,565.541],[1399.7,565.636],[1331.54,670.241],[1399.7,670.717]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1331.54,688.976],[1399.7,689.52],[1331.54,793.676],[1399.7,794.6]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1334.35,813.214],[1399.3,814.162],[1334.35,917.971],[1399.3,919.281]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1365.43,318.623],[1365.43,220.346],[1376.78,323.816],[1376.78,227.852]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1376.78,323.816],[1376.78,227.852],[1383,327.439],[1383,233.089]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1383,327.439],[1383,233.089],[1387.74,332.694],[1387.74,240.685]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1399.3,814.162],[1399.3,919.281],[1445.13,807.04],[1445.13,909.436]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1399.7,432.723],[1399.7,327.643],[1445.05,435.487],[1445.05,333.133]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1399.7,553.597],[1399.7,448.517],[1445.05,553.225],[1445.05,450.871]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1399.7,565.636],[1399.7,670.717],[1445.05,564.952],[1445.05,667.306]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:25,
                    verts:[[1399.7,689.52],[1399.7,794.6],[1445.05,685.621],[1445.05,787.975]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[321.178,436.201],[321.178,334.551],[294.219,439.129],[294.219,340.368]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[321.178,553.129],[321.178,451.479],[294.219,552.735],[294.219,453.973]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[321.178,564.775],[321.178,666.425],[294.219,564.05],[294.219,662.811]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[321.178,684.614],[321.178,786.264],[294.219,680.484],[294.219,779.245]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[385.779,436.111],[385.779,334.372],[321.178,436.201],[321.178,334.551]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[385.779,553.141],[385.779,451.402],[321.178,553.129],[321.178,451.479]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[385.779,564.797],[385.779,666.536],[321.178,564.775],[321.178,666.425]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[385.779,684.741],[385.779,786.48],[321.178,684.614],[321.178,786.264]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[509.996,433.801],[509.996,329.784],[372.55,433.997],[372.55,330.174]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[509.996,553.452],[509.996,449.435],[372.55,553.426],[372.55,449.602]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[509.996,565.369],[509.996,669.386],[372.55,565.321],[372.55,669.144]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[509.996,687.999],[509.996,792.016],[372.55,687.723],[372.55,791.546]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[422.684,325.031],[387.354,325.134],[422.684,229.609],[387.354,229.757]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[449.795,313.841],[449.795,213.434],[407.363,319.639],[407.363,221.815]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[521.728,309.157],[521.728,206.663],[449.795,313.841],[449.795,213.434]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[619.835,427.61],[619.835,317.486],[490.859,429.931],[490.859,322.096]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[619.835,554.286],[619.835,444.162],[490.859,553.973],[490.859,446.139]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[619.835,566.903],[619.835,677.027],[490.859,566.328],[490.859,674.163]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[619.835,696.732],[619.835,806.856],[490.859,693.459],[490.859,801.293]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[642.545,304.088],[642.545,199.337],[521.728,309.157],[521.728,206.663]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1098.33,431.599],[1098.33,321.839],[637.775,432.264],[637.775,323.183]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1098.33,557.856],[1098.33,448.096],[637.775,557.741],[637.775,448.66]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1098.33,570.432],[1098.33,680.192],[637.775,570.239],[637.775,679.32]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1098.33,699.832],[1098.33,809.593],[637.775,698.84],[637.775,807.921]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[783.624,301.012],[783.624,194.891],[648.686,304.258],[648.686,199.581]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[948.64,300.482],[783.624,301.012],[948.64,194.125],[783.624,194.891]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1093.05,825.761],[942.912,825.184],[1093.05,935.316],[942.913,934.517]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[948.64,300.482],[948.64,194.125],[1090.77,302.64],[1090.77,197.244]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1092.01,302.66],[1092.01,197.273],[1221.32,306.979],[1221.32,203.515]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1092.56,823.458],[1238.72,824.016],[1092.56,932.132],[1238.72,932.903]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1099.53,426.886],[1099.53,316.049],[1237.28,428.826],[1237.28,319.902]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1099.53,554.383],[1099.53,443.546],[1237.28,554.122],[1237.28,445.198]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1099.53,567.082],[1099.53,677.92],[1237.28,566.602],[1237.28,675.526]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1099.53,697.753],[1099.53,808.591],[1237.28,695.017],[1237.28,803.941]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1221.32,306.979],[1221.32,203.515],[1301.1,311.242],[1301.1,209.677]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1229.92,432.774],[1229.92,327.743],[1370.58,432.573],[1370.58,327.345]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1229.92,553.591],[1229.92,448.56],[1370.58,553.617],[1370.58,448.389]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1229.92,565.624],[1229.92,670.654],[1370.58,565.674],[1370.58,670.902]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1229.92,689.448],[1229.92,794.479],[1370.58,689.732],[1370.58,794.96]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1223.21,814.225],[1223.21,919.369],[1373.75,814.78],[1373.75,920.136]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1301.09,311.242],[1301.09,209.678],[1352.62,316.826],[1352.62,217.749]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1344.63,322.355],[1380.89,322.25],[1344.63,225.741],[1380.89,225.589]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1363.68,434.743],[1363.68,331.656],[1430.12,434.65],[1430.12,331.471]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1363.68,553.325],[1363.68,450.238],[1430.12,553.338],[1430.12,450.159]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1363.68,565.136],[1363.68,668.223],[1430.12,565.159],[1430.12,668.338]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1363.68,686.67],[1363.68,789.757],[1430.12,686.801],[1430.12,789.98]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1366.52,808.963],[1429.83,809.192],[1366.52,912.095],[1429.83,912.41]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1380.89,322.25],[1380.89,225.589],[1386.25,327.431],[1386.25,233.077]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1386.25,327.431],[1386.25,233.077],[1388.37,331.029],[1388.37,238.278]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1430.12,434.651],[1430.12,331.471],[1467.01,437.535],[1467.01,337.202]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1430.12,553.338],[1430.12,450.159],[1467.01,552.949],[1467.01,452.616]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1430.12,565.159],[1430.12,668.338],[1467.01,564.445],[1467.01,664.778]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1430.12,686.801],[1430.12,789.98],[1467.01,682.732],[1467.01,783.065]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:26,
                    verts:[[1429.83,809.192],[1429.83,912.41],[1467.19,801.752],[1467.19,902.126]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[341.801,433.674],[341.801,329.531],[306.161,436.539],[306.161,335.223]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[341.801,553.469],[341.801,449.327],[306.161,553.083],[306.161,451.767]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[341.801,565.401],[341.801,669.544],[306.161,564.691],[306.161,666.007]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[341.801,688.179],[341.801,792.321],[306.161,684.137],[306.161,785.453]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[409.398,433.865],[409.398,329.911],[341.801,433.674],[341.801,329.531]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[409.398,553.444],[409.398,449.49],[341.801,553.469],[341.801,449.327]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[409.398,565.354],[409.398,669.307],[341.801,565.401],[341.801,669.544]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[409.398,687.909],[409.398,791.863],[341.801,688.179],[341.801,792.321]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[390.925,325.617],[390.925,230.455],[389.873,329.247],[389.873,235.702]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[394.797,320.396],[394.797,222.91],[390.925,325.617],[390.925,230.455]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[431.638,320.613],[394.797,320.396],[431.638,223.223],[394.797,222.91]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[543.693,432.073],[543.693,326.352],[400.956,431.661],[400.956,325.533]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[543.693,553.685],[543.693,447.964],[400.956,553.74],[400.956,447.612]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[543.693,565.797],[543.693,671.519],[400.956,565.9],[400.956,672.027]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[543.693,690.437],[543.693,796.158],[400.956,691.018],[400.956,797.146]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[472.419,309.524],[472.419,207.194],[421.849,315.002],[421.849,215.112]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[551.908,305.477],[551.909,201.344],[472.419,309.524],[472.419,207.194]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[671.541,426.337],[671.541,314.957],[533.653,428.079],[533.653,318.417]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[671.541,554.457],[671.541,443.077],[533.653,554.223],[533.653,444.561]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[671.541,567.218],[671.541,678.598],[533.653,566.787],[533.653,676.448]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[671.541,698.528],[671.541,809.908],[533.653,696.071],[533.653,805.732]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[681.189,301.546],[681.19,195.663],[551.908,305.477],[551.909,201.344]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[827.348,299.844],[827.348,193.203],[687.252,301.777],[687.252,195.995]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[687.191,431.117],[687.191,320.865],[1148.72,432.467],[1148.72,323.592]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[687.191,557.94],[687.191,447.688],[1148.72,557.706],[1148.72,448.831]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[687.191,570.571],[687.191,680.823],[1148.72,570.18],[1148.72,679.055]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[687.191,700.552],[687.191,810.803],[1148.72,698.538],[1148.72,807.413]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[827.347,299.844],[992.795,300.92],[827.347,193.203],[992.795,194.758]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[992.795,300.92],[992.795,194.758],[1130.69,304.412],[1130.69,199.806]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[994.422,824.672],[994.422,933.81],[1143.05,823.515],[1143.05,932.211]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1131.89,304.444],[1131.89,199.851],[1253.46,309.898],[1253.46,207.734]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1140.43,821.251],[1140.43,929.081],[1283.41,820.146],[1283.41,927.554]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1152.52,427.805],[1152.52,317.874],[1282.11,430.32],[1282.11,322.87]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1152.52,554.259],[1152.52,444.328],[1282.11,553.921],[1282.11,446.471]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1152.52,566.854],[1152.52,676.785],[1282.11,566.232],[1282.11,673.681]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1152.52,696.457],[1152.52,806.388],[1282.11,692.909],[1282.11,800.359]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1253.46,309.898],[1253.46,207.734],[1326.13,314.799],[1326.13,214.819]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1265.58,434.158],[1265.58,330.494],[1401.78,434.552],[1401.78,331.275]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1265.58,553.404],[1265.58,449.74],[1401.78,553.351],[1401.78,450.075]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1265.58,565.281],[1265.58,668.945],[1401.78,565.184],[1401.78,668.46]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1265.58,687.495],[1265.58,791.16],[1401.78,686.941],[1401.78,790.217]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1259.34,810.721],[1259.34,914.524],[1405.13,809.633],[1405.13,913.021]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1326.13,314.799],[1326.13,214.819],[1369.81,320.712],[1369.81,223.366]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1356.23,326.044],[1391.2,326.25],[1356.23,231.073],[1391.2,231.37]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1390.04,436.64],[1390.04,335.424],[1453.9,436.821],[1453.9,335.782]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1390.04,553.07],[1390.04,451.853],[1453.9,553.046],[1453.9,452.007]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1390.04,564.666],[1390.04,665.883],[1453.9,564.622],[1453.9,665.66]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1390.04,683.995],[1390.04,785.211],[1453.9,683.74],[1453.9,784.778]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1392.88,804.038],[1392.88,905.286],[1453.71,803.593],[1453.71,904.672]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1453.9,436.821],[1453.9,335.783],[1482.33,439.774],[1482.33,341.649]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1453.9,553.046],[1453.9,452.007],[1482.33,552.648],[1482.33,454.523]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1453.9,564.622],[1453.9,665.66],[1482.33,563.89],[1482.33,662.015]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1453.9,683.74],[1453.9,784.778],[1482.33,679.574],[1482.33,777.699]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:27,
                    verts:[[1453.71,803.593],[1453.71,904.672],[1482.59,795.972],[1482.59,894.136]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[370.947,431.379],[370.947,324.973],[326.51,434.128],[326.51,330.433]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[370.947,553.778],[370.947,447.372],[326.51,553.408],[326.51,449.714]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[370.947,565.969],[370.947,672.375],[326.51,565.289],[326.51,668.983]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[370.947,691.416],[370.947,797.822],[326.51,687.538],[326.51,791.233]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[440.679,431.873],[370.947,431.379],[440.679,325.955],[370.947,324.973]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[440.679,553.712],[440.679,447.793],[370.947,553.778],[370.947,447.372]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[440.679,565.847],[440.679,671.765],[370.947,565.969],[370.947,672.375]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[440.679,690.718],[370.947,691.416],[440.679,796.637],[370.947,797.822]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[393.844,324.927],[393.844,229.459],[390.643,330.259],[390.643,237.166]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[399.071,321.26],[399.071,224.158],[393.844,324.927],[393.844,229.459]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[409.034,316.011],[409.034,216.57],[399.071,321.26],[399.071,224.158]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[446.982,316.569],[409.034,316.011],[446.982,217.377],[409.034,216.57]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[501.666,305.76],[501.666,201.753],[443.216,310.807],[443.216,209.049]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[583.476,430.665],[437.475,429.608],[583.476,323.555],[437.475,321.456]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[583.476,553.874],[583.476,446.764],[437.475,554.017],[437.475,445.864]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[583.476,566.146],[583.476,673.256],[437.475,566.408],[437.475,674.56]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[583.476,692.423],[437.475,693.913],[583.476,799.533],[437.475,802.066]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[587.88,302.456],[587.88,196.978],[501.666,305.76],[501.666,201.753]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[727.859,425.502],[727.859,313.298],[583.135,426.607],[583.135,315.494]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[727.859,554.57],[727.859,442.366],[583.135,554.421],[583.135,443.308]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[727.859,567.425],[727.859,679.628],[583.135,567.151],[583.135,678.264]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[727.859,699.706],[727.859,811.91],[583.135,698.147],[583.135,809.26]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[723.9,299.779],[723.9,193.108],[587.88,302.456],[587.88,196.978]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[872.894,299.509],[872.894,192.719],[729.786,300.069],[729.786,193.525]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[740.878,430.377],[740.878,319.371],[1195.68,433.712],[1195.68,326.108]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[740.878,558.067],[740.878,447.062],[1195.68,557.491],[1195.68,449.886]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[740.878,570.786],[740.878,681.791],[1195.68,569.819],[1195.68,677.424]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[740.878,701.655],[740.878,812.661],[1195.68,696.679],[1195.68,804.284]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[872.894,299.509],[872.894,192.719],[1036.15,302.17],[1036.15,196.564]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1036.15,302.17],[1036.15,196.564],[1167.78,306.907],[1167.78,203.412]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1045.02,823.091],[1045.02,931.625],[1189.72,820.266],[1189.72,927.72]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1168.91,306.949],[1168.91,203.473],[1281.23,313.403],[1281.23,212.801]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1185.07,818.077],[1185.06,924.693],[1322.72,815.411],[1322.72,921.008]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1201.93,429.131],[1201.93,320.508],[1321.56,432.152],[1321.56,326.508]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1201.93,554.081],[1201.93,445.458],[1321.56,553.674],[1321.56,448.03]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1201.93,566.526],[1201.93,675.149],[1321.56,565.778],[1321.56,671.422]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1201.93,694.586],[1201.93,803.21],[1321.56,690.326],[1321.56,795.969]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1281.23,313.403],[1281.23,212.801],[1346.13,318.832],[1346.13,220.648]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1296.55,435.827],[1296.55,333.808],[1426.53,436.767],[1426.53,335.677]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1296.55,553.179],[1296.55,451.16],[1426.53,553.053],[1426.53,451.962]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1296.55,564.868],[1296.55,666.887],[1426.53,564.635],[1426.53,665.726]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1296.55,685.142],[1296.55,787.161],[1426.53,683.815],[1426.53,784.906]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1290.85,806.475],[1290.85,908.655],[1429.99,803.874],[1429.99,905.059]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1346.13,318.832],[1346.13,220.648],[1381.82,324.968],[1381.82,229.517]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1363.12,330.045],[1363.12,236.856],[1396.45,330.535],[1396.45,237.565]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1410.41,438.749],[1410.41,339.613],[1470.95,439.178],[1470.95,340.465]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1410.41,552.786],[1410.41,453.65],[1470.95,552.728],[1470.95,454.015]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1410.41,564.144],[1410.41,663.28],[1470.95,564.038],[1470.95,662.751]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1410.41,681.02],[1410.41,780.156],[1470.95,680.414],[1470.95,779.127]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1413.2,798.566],[1413.2,897.722],[1470.87,797.511],[1470.87,896.263]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1470.95,439.178],[1470.95,340.465],[1491.12,442.151],[1491.12,346.371]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1470.95,552.728],[1470.95,454.015],[1491.12,552.328],[1491.12,456.548]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1470.95,564.038],[1470.95,662.751],[1491.12,563.301],[1491.12,659.082]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1470.95,680.414],[1470.95,779.127],[1491.12,676.221],[1491.12,772.001]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:28,
                    verts:[[1470.87,797.511],[1470.87,896.263],[1491.47,789.834],[1491.47,885.651]]
                },
                ],
                [
                {
                    num:"504",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[408.456,429.381],[408.456,321.004],[355.353,431.957],[355.353,326.121]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[408.456,554.047],[408.456,445.67],[355.353,553.7],[355.353,447.865]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[408.456,566.464],[408.456,674.841],[355.353,565.826],[355.353,671.662]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[408.456,694.234],[408.456,802.612],[355.353,690.6],[355.353,796.436]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[404.263,320.936],[404.263,223.689],[394.875,326.291],[394.875,231.43]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[413.853,317.282],[413.853,218.408],[404.264,320.936],[404.264,223.689]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[408.456,429.381],[479.302,430.192],[408.456,321.004],[479.302,322.615]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[408.456,554.047],[408.456,445.67],[479.302,553.938],[479.302,446.361]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[408.456,566.464],[479.302,566.263],[408.456,674.841],[479.302,673.84]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[408.456,694.234],[479.302,693.09],[408.456,802.611],[479.302,800.668]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[430.134,312.081],[430.134,210.89],[413.853,317.282],[413.853,218.408]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[430.134,312.081],[468.713,312.996],[430.134,210.89],[468.713,212.213]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[471.349,307.162],[471.349,203.781],[468.713,312.996],[468.713,212.213]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[537.183,302.652],[537.183,197.26],[471.349,307.163],[471.349,203.781]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[481.672,427.9],[481.672,318.063],[479.302,430.192],[479.302,322.615]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[481.672,554.247],[481.672,444.409],[479.302,553.938],[479.302,446.361]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[481.672,566.831],[481.672,676.668],[479.302,566.263],[479.302,673.84]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[481.672,696.323],[481.672,806.16],[479.302,693.09],[479.302,800.668]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[481.672,427.9],[481.672,318.063],[628.645,429.618],[628.645,321.476]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[481.672,554.247],[481.672,444.409],[628.645,554.015],[628.645,445.873]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[481.672,566.831],[481.672,676.668],[628.645,566.405],[628.645,674.548]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[481.672,696.323],[481.672,806.16],[628.645,693.899],[628.645,802.042]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[629.034,300.18],[629.034,193.687],[537.183,302.651],[537.183,197.26]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[638.344,425.563],[638.344,313.419],[628.644,429.618],[628.644,321.476]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[638.344,554.561],[638.344,442.418],[628.644,554.015],[628.644,445.873]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[638.344,567.41],[638.344,679.553],[628.644,566.405],[628.644,674.548]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[638.344,699.62],[638.344,811.763],[628.644,693.899],[628.644,802.042]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[769.789,298.835],[769.789,191.745],[629.034,300.18],[629.034,193.687]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[787.503,425.131],[787.503,312.562],[638.343,425.563],[638.343,313.419]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[787.503,554.62],[787.503,442.051],[638.343,554.561],[638.343,442.418]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[787.503,567.517],[787.503,680.086],[638.343,567.41],[638.343,679.553]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[787.503,700.229],[787.503,812.798],[638.343,699.62],[638.343,811.763]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[775.4,299.181],[919.253,300.011],[775.4,192.242],[919.253,193.444]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[797.624,430.067],[797.624,318.746],[1238.3,435.292],[1238.3,329.298]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[797.624,558.121],[797.624,446.8],[1238.3,557.218],[1238.3,451.224]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[797.624,570.875],[797.624,682.197],[1238.3,569.362],[1238.3,675.356]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[797.624,702.117],[797.624,813.438],[1238.3,694.323],[1238.3,800.317]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[919.253,300.011],[919.253,193.444],[1077.78,304.185],[1077.78,199.477]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1077.78,304.185],[1077.78,199.477],[1201.36,310.044],[1201.36,207.946]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1093.59,820.503],[1093.59,928.046],[1232.16,816.13],[1232.16,922.001]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1202.41,310.096],[1202.41,208.021],[1304.31,317.395],[1304.31,218.572]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1225.64,814.044],[1225.64,919.118],[1356.11,809.961],[1356.11,913.474]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1246.79,430.816],[1246.79,323.856],[1355.11,434.261],[1355.11,330.698]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1246.79,553.854],[1246.79,446.893],[1355.11,553.39],[1355.11,449.827]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1246.79,566.109],[1246.79,673.069],[1355.11,565.256],[1355.11,668.819]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1246.79,692.209],[1246.79,799.17],[1355.11,687.35],[1355.11,790.913]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1304.31,317.395],[1304.31,218.572],[1361.01,323.235],[1361.01,227.013]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1322.45,437.729],[1322.45,337.588],[1444.78,439.16],[1444.78,340.429]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1322.45,552.923],[1322.45,452.781],[1444.78,552.731],[1444.78,453.999]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1322.45,564.397],[1322.45,664.538],[1444.78,564.042],[1444.78,662.773]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1322.45,682.458],[1322.45,782.6],[1444.78,680.44],[1444.78,779.172]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1317.34,801.614],[1317.34,901.935],[1448.31,797.659],[1448.31,896.468]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1361.01,323.235],[1361.01,227.013],[1388.76,329.492],[1388.76,236.057]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1365.48,334.269],[1365.48,242.961],[1396.9,335.014],[1396.9,244.039]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1424.8,441.015],[1424.8,344.114],[1481.48,441.664],[1481.48,345.403]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1424.8,552.481],[1424.8,455.58],[1481.48,552.393],[1481.48,456.132]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1424.8,563.583],[1424.8,660.484],[1481.48,563.422],[1481.48,659.683]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1424.8,677.823],[1424.8,774.724],[1481.48,676.908],[1481.48,773.169]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1427.5,792.691],[1427.5,889.6],[1481.49,791.096],[1481.49,887.395]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1481.48,441.664],[1481.48,345.403],[1493.75,444.613],[1493.75,351.261]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1481.48,552.393],[1481.48,456.132],[1493.75,551.996],[1493.75,458.644]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1481.48,563.422],[1481.48,659.683],[1493.75,562.692],[1493.75,656.044]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1481.48,676.908],[1481.48,773.169],[1493.75,672.748],[1493.75,766.1]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:29,
                    verts:[[1481.49,791.096],[1481.49,887.395],[1494.16,783.477],[1494.16,876.863]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[366.249,441.017],[366.249,344.118],[344.943,449.915],[344.943,361.794]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[366.249,552.48],[366.249,455.581],[344.943,551.282],[344.943,463.16]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[366.249,563.582],[366.249,660.481],[344.943,561.378],[344.943,649.5]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[366.249,677.82],[366.249,774.719],[344.943,665.269],[344.943,753.39]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[392.436,430.081],[392.436,322.394],[366.384,440.961],[366.384,344.006]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[392.436,553.953],[392.436,446.266],[366.384,552.488],[366.384,455.534]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[392.436,566.291],[392.436,673.978],[366.384,563.596],[366.384,660.551]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[392.436,693.247],[392.436,800.934],[366.384,677.9],[366.384,774.854]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[453.795,427.731],[453.795,317.727],[392.436,430.081],[392.436,322.394]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[453.795,554.269],[453.795,444.265],[392.436,553.953],[392.436,446.266]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[453.795,566.873],[453.795,676.877],[392.436,566.291],[392.436,673.978]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[453.795,696.561],[453.795,806.565],[392.436,693.247],[392.436,800.934]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[421.172,317.353],[421.172,218.51],[405.382,322.657],[405.382,226.177]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[435.221,313.767],[435.221,213.328],[421.172,317.353],[421.172,218.51]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[457.907,308.694],[457.907,205.994],[435.221,313.767],[435.221,213.328]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[453.795,427.731],[453.795,317.727],[524.622,428.863],[524.622,319.975]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[453.795,554.269],[453.795,444.265],[524.622,554.117],[524.622,445.229]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[453.795,566.873],[453.795,676.877],[524.622,566.593],[524.622,675.48]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[453.795,696.561],[453.795,806.565],[524.622,694.965],[524.622,803.853]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[457.907,308.694],[496.584,309.972],[457.907,205.994],[496.584,207.842]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[505.864,304.152],[505.864,199.429],[496.585,309.972],[496.585,207.842]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[578.345,300.273],[578.345,193.822],[505.864,304.152],[505.864,199.43]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[532.755,426.582],[532.755,315.444],[524.622,428.863],[524.622,319.975]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[532.755,554.424],[532.755,443.286],[524.622,554.117],[524.622,445.229]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[532.755,567.157],[532.755,678.295],[524.622,566.593],[524.622,675.48]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[532.755,698.182],[532.755,809.32],[524.622,694.965],[524.622,803.853]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[532.755,426.582],[532.755,315.444],[678.251,428.957],[678.251,320.162]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[532.755,554.424],[532.755,443.286],[678.251,554.104],[678.251,445.309]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[532.755,567.157],[532.755,678.295],[678.251,566.569],[678.251,675.364]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[532.755,698.182],[532.755,809.32],[678.251,694.832],[678.251,803.627]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[674.532,298.698],[674.533,191.546],[578.345,300.273],[578.345,193.822]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[817.835,298.725],[674.532,298.698],[817.835,191.585],[674.533,191.546]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[698.03,424.97],[698.03,312.243],[678.251,428.957],[678.251,320.162]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[698.03,554.641],[698.03,441.914],[678.251,554.104],[678.251,445.309]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[698.03,567.557],[698.03,680.284],[678.251,566.569],[678.251,675.364]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[698.03,700.456],[698.03,813.183],[678.251,694.832],[678.251,803.627]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[849.035,425.226],[698.03,424.97],[849.035,312.751],[698.03,312.243]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[849.035,554.607],[849.035,442.132],[698.03,554.641],[698.03,441.914]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[849.035,567.493],[849.035,679.968],[698.03,567.557],[698.03,680.284]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[849.035,700.095],[698.03,700.456],[849.035,812.57],[698.03,813.183]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[823.081,299.121],[823.081,192.155],[965.404,301.313],[965.404,195.326]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[856.081,430.188],[856.081,318.99],[1275.95,437.149],[1275.95,333.048]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[856.081,558.1],[856.081,446.902],[1275.95,556.897],[1275.95,452.796]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[856.081,570.84],[856.081,682.038],[1275.95,568.824],[1275.95,672.925]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[856.081,701.936],[856.081,813.134],[1275.95,691.553],[1275.95,795.654]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[965.404,301.313],[965.404,195.326],[1116.9,306.885],[1116.9,203.38]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1116.9,306.885],[1116.9,203.38],[1230.96,313.718],[1230.96,213.257]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1139.15,817.015],[1139.15,923.225],[1269.73,811.254],[1269.73,915.261]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1231.93,313.778],[1231.93,213.343],[1322.6,321.759],[1322.6,224.879]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1261.54,809.297],[1261.54,912.555],[1383.34,803.968],[1383.34,905.19]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1286.44,432.8],[1286.44,327.795],[1382.5,436.582],[1382.5,335.308]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1286.44,553.587],[1286.44,448.582],[1382.5,553.078],[1382.5,451.804]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1286.44,565.617],[1286.44,670.622],[1382.5,564.681],[1382.5,665.955]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1286.44,689.412],[1286.44,794.416],[1382.5,684.077],[1382.5,785.351]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1322.6,321.759],[1322.6,224.879],[1370.89,327.897],[1370.89,233.751]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1370.89,327.897],[1370.89,233.751],[1390.91,334.182],[1390.91,242.836]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1343.14,439.811],[1343.14,341.722],[1456.75,441.666],[1456.75,345.406]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1343.14,552.643],[1343.14,454.554],[1456.75,552.393],[1456.75,456.134]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1343.14,563.881],[1343.14,661.97],[1456.75,563.422],[1456.75,659.681]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1343.14,679.522],[1343.14,777.611],[1456.75,676.906],[1456.75,773.165]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1338.66,796.281],[1338.66,894.564],[1460.29,791.153],[1460.29,887.475]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1363.62,338.624],[1363.62,249.257],[1392.93,339.593],[1392.93,250.657]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1433.44,443.381],[1433.44,348.815],[1485.86,444.219],[1485.86,350.478]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1433.44,552.162],[1433.44,457.595],[1485.86,552.049],[1485.86,458.308]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1433.44,562.997],[1433.44,657.564],[1485.86,562.789],[1485.86,656.53]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1433.44,674.485],[1433.44,769.052],[1485.86,673.304],[1485.86,767.045]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1436.05,786.559],[1436.05,881.124],[1485.97,784.501],[1485.97,878.279]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1485.86,444.219],[1485.86,350.478],[1490.74,447.107],[1490.74,356.215]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1485.86,552.049],[1485.86,458.308],[1490.74,551.66],[1490.74,460.768]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1485.86,562.789],[1485.86,656.53],[1490.74,562.074],[1490.74,652.966]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1485.86,673.304],[1485.86,767.045],[1490.74,669.23],[1490.74,760.122]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:30,
                    verts:[[1485.97,784.501],[1485.97,878.279],[1491.21,777.037],[1491.21,867.96]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[382.719,439.396],[382.719,340.898],[338.232,448.266],[338.232,358.518]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[382.719,552.699],[382.719,454.201],[338.232,551.504],[338.232,461.756]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[382.719,563.984],[382.719,662.482],[338.232,561.787],[338.232,651.535]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[382.719,680.107],[382.719,778.606],[338.232,667.595],[338.232,757.343]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[383.892,796.792],[383.892,895.269],[339.31,773.917],[339.31,863.648]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[437.161,428.54],[437.161,319.333],[383,439.34],[383,340.786]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[437.161,554.161],[437.161,444.954],[383,552.706],[383,454.153]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[437.161,566.672],[437.161,675.879],[383,563.998],[383,662.551]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[437.161,695.421],[437.161,804.627],[383,680.186],[383,778.74]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[421.143,319.812],[421.144,222.065],[416.538,325.381],[416.538,230.115]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[444.383,314.242],[444.383,214.013],[422.111,319.418],[422.111,221.496]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[506.091,426.467],[506.091,315.216],[437.161,428.54],[437.161,319.333]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[506.091,554.44],[506.091,443.189],[437.161,554.161],[437.161,444.954]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[506.091,567.186],[506.091,678.437],[437.161,566.672],[437.161,675.879]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[506.091,698.344],[506.091,809.595],[437.161,695.421],[437.161,804.627]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[462.89,310.779],[462.89,209.008],[444.384,314.242],[444.384,214.013]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[491.908,305.914],[491.908,201.976],[462.89,310.779],[462.89,209.008]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[491.908,305.914],[530.12,307.551],[491.908,201.977],[530.12,204.343]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[506.091,426.467],[506.091,315.216],[575.707,427.913],[575.707,318.088]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[506.091,554.44],[506.091,443.189],[575.707,554.245],[575.707,444.42]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[506.091,567.186],[506.091,678.437],[575.707,566.828],[575.707,676.653]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[506.091,698.344],[506.091,809.595],[575.707,696.305],[575.707,806.13]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[546.12,301.832],[546.12,196.076],[530.121,307.552],[530.121,204.343]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[624.299,298.663],[624.299,191.495],[546.12,301.832],[546.12,196.076]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[589.621,425.68],[589.621,313.652],[575.707,427.913],[575.707,318.088]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[589.621,554.546],[589.621,442.518],[575.707,554.245],[575.707,444.42]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[589.621,567.381],[589.621,679.409],[575.707,566.828],[575.707,676.653]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[589.621,699.455],[589.621,811.483],[575.707,696.305],[575.707,806.13]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[589.622,425.68],[589.622,313.652],[731.175,428.686],[731.175,319.623]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[589.622,554.546],[589.622,442.518],[731.175,554.141],[731.175,445.078]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[589.622,567.381],[589.622,679.409],[731.175,566.636],[731.175,675.699]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[589.622,699.455],[589.622,811.483],[731.175,695.215],[731.175,804.277]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[723.37,298.024],[723.371,190.572],[624.299,298.663],[624.299,191.495]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[723.37,298.024],[866.963,299.417],[723.37,190.572],[866.964,192.586]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[760.768,424.833],[760.768,311.97],[731.175,428.686],[731.175,319.623]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[760.768,554.66],[760.768,441.797],[731.175,554.141],[731.175,445.078]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[760.768,567.591],[760.768,680.453],[731.175,566.636],[731.175,675.699]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[760.768,700.649],[760.768,813.512],[731.175,695.215],[731.175,804.277]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[760.768,424.833],[760.768,311.97],[910.987,425.766],[910.987,313.824]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[760.768,554.66],[760.768,441.797],[910.987,554.534],[910.987,442.592]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[760.768,567.591],[760.768,680.453],[910.987,567.359],[910.987,679.302]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[760.768,700.649],[760.768,813.512],[910.987,699.333],[910.987,811.276]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[871.766,299.857],[871.766,193.219],[1010.4,303.342],[1010.4,198.259]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[914.882,430.718],[914.882,320.061],[1308.25,439.219],[1308.25,337.228]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[914.882,558.008],[914.882,447.351],[1308.25,556.539],[1308.25,454.549]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[914.882,570.687],[914.882,681.344],[1308.25,568.225],[1308.25,670.216]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[914.882,701.146],[914.882,811.803],[1308.25,688.466],[1308.25,790.457]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1010.4,303.342],[1010.4,198.259],[1152.88,310.164],[1152.88,208.12]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1152.88,310.164],[1152.88,208.12],[1256.33,317.809],[1256.33,219.17]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1180.95,812.771],[1180.95,917.358],[1302.05,805.807],[1302.05,907.732]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1257.2,317.876],[1257.2,219.266],[1336.17,326.375],[1336.17,231.551]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1292.4,803.997],[1292.4,905.229],[1404.44,797.611],[1404.44,896.401]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1320.46,435.011],[1320.46,332.188],[1403.76,439.045],[1403.76,340.2]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1320.46,553.289],[1320.46,450.466],[1403.76,552.746],[1403.76,453.902]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1320.46,565.07],[1320.46,667.893],[1403.76,564.071],[1403.76,662.915]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1320.46,686.292],[1320.46,789.116],[1403.76,680.602],[1403.76,779.447]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1336.17,326.375],[1336.17,231.551],[1376.07,332.704],[1376.07,240.7]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1376.07,332.704],[1376.07,240.7],[1388.7,338.937],[1388.7,249.709]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1358.69,442.012],[1358.69,346.095],[1462.86,444.225],[1462.86,350.489]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1358.69,552.346],[1358.69,456.429],[1462.86,552.049],[1462.86,458.313]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1358.69,563.336],[1358.69,659.253],[1462.86,562.788],[1462.86,656.523]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1358.69,676.416],[1358.69,772.334],[1462.86,673.296],[1462.86,767.031]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1354.85,790.629],[1354.85,886.75],[1466.36,784.512],[1466.36,878.295]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1436.76,445.793],[1436.76,353.605],[1484.67,446.788],[1484.67,355.581]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1436.76,551.837],[1436.76,459.649],[1484.67,551.703],[1484.67,460.497]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1436.76,562.399],[1436.76,654.587],[1484.67,562.153],[1484.67,653.36]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1436.76,671.084],[1436.76,763.272],[1484.67,669.68],[1484.67,760.887]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:31,
                    verts:[[1439.24,780.314],[1439.24,872.491],[1484.86,777.869],[1484.86,869.111]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[405.669,437.973],[405.669,338.07],[337.439,446.7],[337.439,355.408]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[405.669,552.89],[405.669,452.988],[337.439,551.715],[337.439,460.422]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[405.669,564.336],[405.669,664.238],[337.439,562.175],[337.439,653.468]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[405.669,682.115],[405.669,782.017],[337.439,669.804],[337.439,761.096]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[406.827,800.451],[406.827,900.327],[338.513,777.947],[338.513,869.218]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[488.631,427.36],[488.631,316.99],[406.098,437.918],[406.098,337.961]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[488.631,554.319],[488.631,443.949],[406.098,552.898],[406.098,452.941]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[488.631,566.965],[488.631,677.335],[406.098,564.35],[406.098,664.306]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[488.631,697.085],[488.631,807.455],[406.098,682.192],[406.098,782.149]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[428.147,326.204],[428.147,231.304],[424.691,331.182],[424.691,238.499]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[432.379,322.533],[432.379,225.998],[428.147,326.204],[428.147,231.304]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[443.373,317.002],[443.374,218.003],[432.378,322.533],[432.379,225.998]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[473.503,311.643],[473.503,210.258],[444.811,316.616],[444.811,217.446]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[496.356,308.356],[496.356,205.507],[473.503,311.643],[473.503,210.258]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[564.194,425.606],[564.194,313.505],[488.631,427.36],[488.631,316.99]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[564.194,554.556],[564.194,442.455],[488.631,554.319],[488.631,443.949]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[564.194,567.399],[564.194,679.5],[488.631,566.965],[488.631,677.335]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[564.194,699.559],[564.194,811.66],[488.631,697.085],[488.631,807.455]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[531.475,303.777],[531.475,198.887],[496.356,308.356],[496.356,205.506]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[531.475,303.777],[531.475,198.888],[568.649,305.76],[568.649,201.754]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[564.194,425.606],[564.194,313.505],[631.414,427.349],[631.414,316.968]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[564.194,554.556],[564.194,442.455],[631.414,554.321],[631.414,443.94]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[564.194,567.399],[564.194,679.5],[631.414,566.967],[631.414,677.348]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[564.194,699.559],[564.194,811.66],[631.414,697.1],[631.414,807.481]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[591.277,300.226],[591.277,193.755],[568.65,305.76],[568.65,201.754]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[674.032,297.824],[674.032,190.283],[591.276,300.226],[591.276,193.755]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[650.958,425.2],[650.958,312.699],[631.414,427.349],[631.414,316.968]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[650.958,554.61],[650.958,442.109],[631.414,554.321],[631.414,443.94]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[650.958,567.5],[650.958,680.001],[631.414,566.967],[631.414,677.348]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[650.958,700.132],[650.958,812.633],[631.414,697.1],[631.414,807.481]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[650.958,425.2],[650.958,312.699],[786.211,428.792],[786.211,319.833]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[650.958,554.61],[650.958,442.109],[786.211,554.127],[786.211,445.169]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[650.958,567.5],[650.958,680.001],[786.211,566.61],[786.211,675.568]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[650.958,700.132],[650.958,812.633],[786.211,695.065],[786.211,804.024]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[774.457,298.131],[674.032,297.824],[774.457,190.727],[674.032,190.283]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[774.456,298.131],[774.457,190.727],[916.131,300.846],[916.131,194.65]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[825.068,425.13],[825.068,312.561],[786.211,428.792],[786.211,319.833]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[825.068,554.62],[825.068,442.05],[786.211,554.127],[786.211,445.169]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[825.068,567.517],[825.068,680.086],[786.211,566.61],[786.211,675.568]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[825.068,700.23],[825.068,812.799],[786.211,695.065],[786.211,804.023]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[825.068,425.13],[825.068,312.561],[971.983,426.708],[971.983,315.695]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[825.068,554.62],[825.068,442.05],[971.983,554.407],[971.983,443.394]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[825.068,567.517],[825.068,680.086],[971.983,567.126],[971.983,678.139]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[825.068,700.23],[825.068,812.799],[971.983,698.004],[971.983,809.017]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[920.425,301.321],[920.425,195.336],[1053.41,305.998],[1053.41,202.098]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[972.744,431.618],[972.744,321.878],[1335.11,441.435],[1335.11,341.704]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[972.744,557.853],[972.744,448.113],[1335.11,556.156],[1335.11,456.425]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[972.744,570.426],[972.744,680.166],[1335.11,567.583],[1335.11,667.314]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[972.744,699.803],[972.744,809.543],[1335.11,685.16],[1335.11,784.891]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1053.41,305.998],[1053.41,202.098],[1185.27,313.9],[1185.27,213.52]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1185.27,313.9],[1185.27,213.52],[1277.37,322.193],[1277.37,225.506]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1218.46,807.933],[1218.46,910.671],[1329,799.965],[1329,899.656]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1278.15,322.264],[1278.15,225.609],[1345.26,331.127],[1345.26,238.419]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1318.13,798.313],[1318.13,897.372],[1419.69,791.06],[1419.69,887.345]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1345.26,331.126],[1345.26,238.419],[1376.94,337.551],[1376.94,247.706]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1348.74,437.379],[1348.74,336.891],[1419.16,441.584],[1419.16,345.244]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1348.74,552.97],[1348.74,452.483],[1419.16,552.404],[1419.16,456.064]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1348.74,564.483],[1348.74,664.971],[1419.16,563.442],[1419.16,659.782]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1348.74,682.952],[1348.74,783.44],[1419.16,677.021],[1419.16,773.361]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1376.94,337.551],[1376.94,247.706],[1382.6,343.664],[1382.6,256.542]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1369.36,444.278],[1369.36,350.596],[1463.65,446.782],[1463.65,355.569]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1369.36,552.041],[1369.36,458.359],[1463.65,551.704],[1463.65,460.492]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1369.36,562.775],[1369.36,656.457],[1463.65,562.155],[1463.65,653.367]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1369.36,673.221],[1369.36,766.903],[1463.65,669.689],[1463.65,760.901]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1366.16,784.802],[1366.16,878.695],[1467.08,777.879],[1467.08,869.125]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1435.28,448.2],[1435.28,358.386],[1478.57,449.322],[1478.57,360.616]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1435.28,551.513],[1435.28,461.699],[1478.57,551.362],[1478.57,462.655]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1435.28,561.803],[1435.28,651.617],[1478.57,561.525],[1478.57,650.232]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1435.28,667.689],[1435.28,757.502],[1478.57,666.105],[1478.57,754.812]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:32,
                    verts:[[1437.61,774.084],[1437.61,863.879],[1478.82,771.326],[1478.82,860.066]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[434.683,436.76],[434.683,335.662],[342.584,445.23],[342.584,352.487]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[434.683,553.054],[434.683,451.956],[342.584,551.913],[342.584,459.17]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[434.683,564.637],[434.683,665.734],[342.584,562.539],[342.584,655.282]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[434.683,683.825],[434.683,784.923],[342.584,671.877],[342.584,764.62]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[435.81,803.566],[435.81,904.634],[343.643,781.729],[343.643,874.446]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[445.262,323.695],[445.262,227.678],[436.154,328.639],[436.154,234.823]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[545.717,426.549],[545.717,315.378],[435.261,436.707],[435.261,335.557]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[545.717,554.429],[545.717,443.258],[435.261,553.061],[435.261,451.911]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[545.717,567.166],[545.717,678.336],[435.261,564.65],[435.261,665.8]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[545.717,698.229],[545.717,809.399],[435.261,683.9],[435.261,785.05]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[453.703,320.066],[453.703,222.433],[445.262,323.695],[445.262,227.678]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[471.147,314.645],[471.147,214.596],[453.703,320.066],[453.703,222.433]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[507.954,309.575],[507.954,207.269],[473.05,314.274],[473.05,214.059]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[534.939,306.513],[534.939,202.842],[507.954,309.575],[507.954,207.269]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[575.773,302.287],[575.773,196.734],[534.939,306.513],[534.939,202.841]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[626.771,425.144],[626.771,312.589],[545.717,426.549],[545.717,315.378]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[626.771,554.618],[626.771,442.062],[545.717,554.429],[545.717,443.258]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[626.771,567.513],[626.771,680.069],[545.717,567.166],[545.717,678.336]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[626.771,700.21],[626.771,812.766],[545.717,698.229],[545.717,809.399]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[575.773,302.287],[575.773,196.734],[611.355,304.594],[611.355,200.068]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[640.35,299.324],[640.35,192.451],[611.356,304.594],[611.356,200.068]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[626.771,425.144],[626.771,312.589],[690.478,427.161],[690.478,316.595]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[626.771,554.618],[626.771,442.062],[690.478,554.346],[690.478,443.78]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[626.771,567.513],[626.771,680.069],[690.478,567.014],[690.478,677.58]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[626.771,700.21],[626.771,812.766],[690.478,697.365],[690.478,807.932]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[726.449,297.723],[726.449,190.137],[640.349,299.324],[640.349,192.451]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[715.339,425.127],[715.339,312.555],[690.478,427.161],[690.478,316.595]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[715.339,554.62],[715.339,442.048],[690.478,554.346],[690.478,443.78]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[715.339,567.518],[715.339,680.09],[690.478,567.014],[690.478,677.58]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[715.339,700.234],[715.339,812.807],[690.478,697.365],[690.478,807.932]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[715.339,425.127],[715.339,312.555],[842.164,429.244],[842.164,320.732]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[715.339,554.62],[715.339,442.048],[842.164,554.066],[842.164,445.554]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[715.339,567.518],[715.339,680.09],[842.164,566.498],[842.164,675.01]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[715.339,700.234],[715.339,812.807],[842.164,694.427],[842.164,802.94]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[726.449,297.723],[826.696,298.959],[726.449,190.137],[826.696,191.923]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[826.695,298.959],[826.695,191.924],[964.391,302.915],[964.391,197.642]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[889.495,425.823],[889.495,313.936],[842.164,429.244],[842.164,320.732]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[889.495,554.526],[889.495,442.64],[842.164,554.066],[842.164,445.554]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[889.495,567.345],[889.495,679.232],[842.164,566.498],[842.164,675.01]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[889.495,699.253],[889.495,811.14],[842.164,694.427],[842.164,802.94]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[889.495,425.823],[889.495,313.936],[1030.82,427.996],[1030.82,318.252]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[889.495,554.526],[889.495,442.64],[1030.82,554.234],[1030.82,444.491]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[889.495,567.345],[889.495,679.232],[1030.82,566.807],[1030.82,676.551]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[889.495,699.253],[889.495,811.14],[1030.82,696.188],[1030.82,805.932]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[968.13,303.419],[968.13,198.367],[1093.79,309.162],[1093.79,206.671]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1028.56,432.834],[1028.56,324.334],[1356.62,443.734],[1356.62,346.347]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1028.56,557.643],[1028.56,449.142],[1356.62,555.759],[1356.62,458.372]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1028.56,570.074],[1028.56,678.574],[1356.62,566.917],[1356.62,664.304]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1028.56,697.99],[1028.56,806.49],[1356.62,681.73],[1356.62,779.117]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1093.79,309.162],[1093.79,206.671],[1213.83,317.965],[1213.83,219.395]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1213.83,317.965],[1213.83,219.395],[1294.18,326.746],[1294.18,232.087]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1251.41,802.672],[1251.41,903.398],[1350.67,793.897],[1350.67,891.268]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1294.85,326.821],[1294.85,232.195],[1350.21,335.907],[1350.21,245.329]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1350.21,335.907],[1350.21,245.329],[1373.98,342.345],[1373.98,254.635]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1338.8,792.408],[1338.8,889.21],[1429.5,784.471],[1429.5,878.237]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1371.4,439.834],[1371.4,341.769],[1429.12,444.138],[1429.12,350.318]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1371.4,552.64],[1371.4,454.574],[1429.12,552.06],[1429.12,458.24]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1371.4,563.875],[1371.4,661.941],[1429.12,562.809],[1429.12,656.629]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1371.4,679.489],[1371.4,777.554],[1429.12,673.418],[1429.12,767.238]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1375.53,446.556],[1375.53,355.12],[1459.77,449.29],[1459.77,360.551]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1375.53,551.735],[1375.53,460.299],[1459.77,551.366],[1459.77,462.628]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1375.53,562.211],[1375.53,653.646],[1459.77,561.533],[1459.77,650.272]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1375.53,670.008],[1375.53,761.443],[1459.77,666.151],[1459.77,754.889]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1372.94,778.935],[1372.94,870.585],[1463.1,771.376],[1463.1,860.134]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1429.6,450.559],[1429.6,363.071],[1468.24,451.782],[1468.24,365.501]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1429.6,551.196],[1429.6,463.708],[1468.24,551.031],[1468.24,464.75]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1429.6,561.219],[1429.6,648.706],[1468.24,560.916],[1468.24,647.197]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1429.6,664.362],[1429.6,751.849],[1468.24,662.636],[1468.24,748.917]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:33,
                    verts:[[1431.77,767.982],[1431.77,855.443],[1468.56,764.976],[1468.56,851.288]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[469.184,435.763],[469.184,333.681],[353.546,443.864],[353.546,349.774]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[469.184,553.188],[469.184,451.106],[353.546,552.097],[353.546,458.006]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[469.184,564.884],[469.184,666.966],[353.546,562.877],[353.546,656.968]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[469.184,685.232],[469.184,787.314],[353.546,673.804],[353.546,767.895]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[470.265,806.129],[470.265,908.176],[354.577,785.243],[354.577,879.304]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[467.422,321.528],[467.422,224.545],[452.612,326.38],[452.612,231.559]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[480.078,317.986],[480.078,219.425],[467.422,321.528],[467.422,224.545]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[607.152,426.097],[607.152,314.48],[469.906,435.712],[469.906,333.58]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[607.152,554.49],[607.152,442.873],[469.906,553.195],[469.906,451.063]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[607.152,567.278],[607.152,678.894],[469.906,564.896],[469.906,667.028]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[607.152,698.867],[607.152,810.483],[469.906,685.304],[469.906,787.435]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[503.901,312.742],[503.901,211.846],[480.078,317.986],[480.078,219.425]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[547.027,308.031],[547.027,205.036],[506.255,312.39],[506.255,211.336]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[577.835,305.234],[577.835,200.994],[547.027,308.031],[547.027,205.036]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[623.865,301.421],[623.865,195.482],[577.835,305.234],[577.835,200.994]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[692.414,425.063],[692.414,312.427],[607.152,426.097],[607.152,314.48]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[692.414,554.629],[692.414,441.993],[607.152,554.49],[607.152,442.873]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[692.414,567.534],[692.414,680.17],[607.152,567.278],[607.152,678.894]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[692.414,700.325],[692.414,812.961],[607.152,698.867],[607.152,810.483]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[623.865,301.421],[623.865,195.482],[657.343,304.022],[657.343,199.241]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[692.298,299.084],[692.298,192.104],[657.344,304.022],[657.344,199.241]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[780.456,298.297],[780.456,190.966],[692.297,299.084],[692.297,192.105]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[692.414,425.063],[692.414,312.427],[751.61,427.321],[751.61,316.913]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[692.414,554.629],[692.414,441.992],[751.61,554.325],[751.61,443.916]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[692.414,567.534],[692.414,680.17],[751.61,566.974],[751.61,677.383]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[692.414,700.325],[692.414,812.961],[751.61,697.139],[751.61,807.548]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[781.341,425.43],[781.341,313.156],[751.61,427.321],[751.61,316.913]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[781.341,554.579],[781.341,442.305],[751.61,554.325],[751.61,443.916]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[781.341,567.443],[781.341,679.717],[751.61,566.974],[751.61,677.383]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[781.341,699.807],[781.341,812.081],[751.61,697.139],[751.61,807.548]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[780.456,298.297],[780.456,190.966],[879.063,300.421],[879.063,194.036]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[781.341,425.43],[781.341,313.156],[897.929,429.999],[897.929,322.233]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[781.341,554.579],[781.341,442.305],[897.929,553.964],[897.929,446.197]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[781.341,567.443],[781.341,679.717],[897.929,566.311],[897.929,674.078]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[781.341,699.807],[781.341,812.081],[897.929,693.362],[897.929,801.128]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[879.062,300.421],[879.062,194.036],[1010.95,305.513],[1010.95,201.397]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[952.768,426.856],[952.768,315.988],[897.928,429.999],[897.928,322.233]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[952.768,554.387],[952.768,443.52],[897.928,553.964],[897.928,446.197]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[952.768,567.09],[952.768,677.957],[897.928,566.311],[897.928,674.078]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[952.768,697.796],[952.768,808.663],[897.928,693.362],[897.928,801.128]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[952.768,426.856],[952.768,315.988],[1086.55,429.561],[1086.55,321.362]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[952.768,554.387],[952.768,443.52],[1086.55,554.023],[1086.55,445.824]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[952.768,567.09],[952.768,677.957],[1086.55,566.419],[1086.55,674.619]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[952.768,697.796],[952.768,808.663],[1086.55,693.98],[1086.55,802.179]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1014.1,306.037],[1014.1,202.151],[1131.09,312.707],[1131.09,211.795]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1081.43,434.305],[1081.43,327.303],[1373.07,446.058],[1373.07,351.041]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1081.43,557.389],[1081.43,450.387],[1373.07,555.357],[1373.07,460.34]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1081.43,569.648],[1081.43,676.649],[1373.07,566.244],[1373.07,661.261]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1081.43,695.796],[1081.43,802.797],[1373.07,678.264],[1373.07,773.281]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1131.09,312.707],[1131.09,211.795],[1238.5,322.233],[1238.5,225.564]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1238.5,322.233],[1238.5,225.564],[1306.97,331.356],[1306.97,238.751]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1279.7,797.153],[1279.7,895.768],[1367.35,787.757],[1367.35,882.78]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1307.54,331.434],[1307.54,238.863],[1351.44,340.621],[1351.44,252.144]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1351.44,340.621],[1351.44,252.144],[1367.69,347.004],[1367.69,261.37]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1354.69,786.432],[1354.69,880.949],[1434.42,777.977],[1434.42,869.259]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1388.74,442.316],[1388.74,346.698],[1434.19,446.657],[1434.19,355.321]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1388.74,552.306],[1388.74,456.687],[1434.19,551.721],[1434.19,460.385]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1388.74,563.261],[1388.74,658.879],[1434.19,562.186],[1434.19,653.522]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1388.74,675.989],[1388.74,771.607],[1434.19,669.865],[1434.19,761.202]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1377.64,448.801],[1377.64,359.58],[1451.87,451.71],[1451.87,365.359]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1377.64,551.432],[1377.64,462.211],[1451.87,551.04],[1451.87,464.689]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1377.64,561.654],[1377.64,650.876],[1451.87,560.934],[1451.87,647.285]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1377.64,666.841],[1377.64,756.062],[1451.87,662.737],[1451.87,749.088]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1375.65,773.146],[1375.65,862.582],[1455.09,765.102],[1455.09,851.462]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1420.32,452.833],[1420.32,367.59],[1454.39,454.133],[1454.39,370.172]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1420.32,550.889],[1420.32,465.646],[1454.39,550.714],[1454.39,466.753]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1420.32,560.656],[1420.32,645.899],[1454.39,560.334],[1454.39,644.295]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:34,
                    verts:[[1420.32,661.153],[1420.32,746.396],[1454.39,659.319],[1454.39,743.281]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[508.487,434.973],[508.487,332.112],[370.078,442.603],[370.078,347.269]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[508.487,553.294],[508.487,450.433],[370.078,552.267],[370.078,456.933]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[508.487,565.079],[508.487,667.94],[370.078,563.189],[370.078,658.524]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[508.487,686.346],[508.487,789.207],[370.078,675.583],[370.078,770.917]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[509.505,808.155],[509.505,910.978],[371.07,788.486],[371.07,883.787]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[503.821,326.729],[503.821,232.063],[472.036,330.309],[472.036,237.237]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[494.172,319.691],[494.172,221.89],[473.707,324.397],[473.707,228.693]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[510.973,316.276],[510.973,216.954],[494.172,319.691],[494.172,221.891]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[671.636,425.979],[671.636,314.246],[509.346,434.926],[509.346,332.018]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[671.636,554.505],[671.636,442.773],[509.346,553.301],[509.346,450.393]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[671.636,567.307],[671.636,679.04],[509.346,565.091],[509.346,667.998]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[671.636,699.033],[671.636,810.766],[509.346,686.413],[509.346,789.32]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[540.982,311.274],[540.982,209.724],[510.972,316.276],[510.973,216.954]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[589.941,306.98],[589.941,203.517],[543.763,310.944],[543.763,209.247]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[624.185,304.485],[624.185,199.911],[589.941,306.98],[589.941,203.517]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[674.788,301.129],[674.788,195.06],[624.185,304.485],[624.185,199.911]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[759.751,425.325],[759.751,312.947],[671.636,425.979],[671.636,314.246]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[759.751,554.594],[759.751,442.216],[671.636,554.505],[671.636,442.773]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[759.751,567.469],[759.751,679.847],[671.636,567.307],[671.636,679.04]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[759.751,699.956],[759.751,812.333],[671.636,699.033],[671.636,810.766]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[674.787,301.129],[674.787,195.06],[705.709,303.99],[705.709,199.195]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[746.093,299.441],[746.093,192.62],[705.709,303.99],[705.71,199.195]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[835.034,299.458],[746.092,299.441],[835.034,192.645],[746.092,192.62]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[759.751,425.325],[759.751,312.947],[813.6,427.789],[813.6,317.843]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[759.751,554.594],[759.751,442.216],[813.6,554.262],[813.6,444.315]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[759.751,567.469],[759.751,679.847],[813.6,566.858],[813.6,676.805]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[759.751,699.956],[759.751,812.333],[813.6,696.479],[813.6,806.426]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[847.649,426.062],[847.649,314.411],[813.6,427.789],[813.6,317.843]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[847.649,554.494],[847.649,442.843],[813.6,554.262],[813.6,444.315]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[847.649,567.286],[847.649,678.937],[813.6,566.858],[813.6,676.805]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[847.649,698.916],[847.649,810.567],[813.6,696.479],[813.6,806.426]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[835.034,299.458],[835.034,192.644],[930.666,302.411],[930.666,196.913]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[847.649,426.062],[847.649,314.411],[952.557,431.007],[952.557,324.234]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[847.649,554.494],[847.649,442.843],[952.557,553.828],[952.557,447.055]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[847.649,567.286],[847.649,678.937],[952.557,566.062],[952.557,672.834]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[847.649,698.916],[847.649,810.567],[952.557,691.941],[952.557,798.714]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[930.665,302.411],[930.666,196.913],[1055.19,308.517],[1055.19,205.739]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1013.83,428.167],[1013.83,318.593],[952.557,431.007],[952.557,324.234]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1013.83,554.211],[1013.83,444.637],[952.557,553.828],[952.557,447.055]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1013.83,566.765],[1013.83,676.339],[952.557,566.061],[952.557,672.834]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1013.83,695.946],[1013.83,805.52],[952.557,691.941],[952.557,798.714]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1013.83,428.167],[1013.83,318.593],[1138.48,431.335],[1138.48,324.886]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1013.83,554.211],[1013.83,444.637],[1138.48,553.784],[1138.48,447.335]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1013.83,566.765],[1013.83,676.339],[1138.48,565.98],[1138.48,672.429]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1013.83,695.946],[1013.83,805.52],[1138.48,691.478],[1138.48,797.927]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1057.74,309.054],[1057.74,206.512],[1165.02,316.509],[1165.02,217.29]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1130.73,435.965],[1130.73,330.656],[1384.88,448.357],[1384.88,355.684]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1130.73,557.102],[1130.73,451.793],[1384.88,554.96],[1384.88,462.287]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1130.73,569.167],[1130.73,674.476],[1384.88,565.578],[1384.88,658.251]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1130.73,693.32],[1130.73,798.628],[1384.88,674.834],[1384.88,767.508]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1165.02,316.509],[1165.02,217.29],[1259.34,326.59],[1259.34,231.862]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1259.34,326.59],[1259.34,231.862],[1316.06,335.925],[1316.06,245.356]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1303.47,791.525],[1303.47,887.988],[1379.41,781.677],[1379.41,874.375]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1316.53,336.005],[1316.53,245.47],[1349.41,345.192],[1349.41,258.749]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1349.41,345.191],[1349.41,258.749],[1358.56,351.465],[1358.56,267.817]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1366.16,780.513],[1366.16,872.766],[1435.04,771.687],[1435.04,860.565]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1401.2,444.769],[1401.2,351.571],[1434.93,449.096],[1434.93,360.166]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1401.2,551.975],[1401.2,458.777],[1434.93,551.392],[1434.93,462.463]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1401.2,562.653],[1401.2,655.851],[1434.93,561.581],[1434.93,650.511]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1401.2,672.528],[1401.2,765.726],[1434.93,666.424],[1434.93,755.354]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1376.18,450.976],[1376.18,363.9],[1440.61,454.013],[1440.61,369.933]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1376.18,551.139],[1376.18,464.064],[1440.61,550.73],[1440.61,466.65]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1376.18,561.116],[1376.18,648.192],[1440.61,560.364],[1440.61,644.444]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1376.18,663.773],[1376.18,750.849],[1440.61,659.489],[1440.61,743.569]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:35,
                    verts:[[1374.77,767.532],[1374.77,854.821],[1443.69,759.136],[1443.69,843.215]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[551.844,434.377],[551.844,330.928],[391.836,441.444],[391.836,344.965]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[551.844,553.375],[551.844,449.926],[391.836,552.423],[391.836,455.945]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[551.844,565.227],[551.844,668.676],[391.836,563.477],[391.836,659.955]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[551.844,687.187],[551.844,790.636],[391.836,677.219],[391.836,773.697]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[552.787,809.684],[552.787,913.091],[392.776,791.468],[392.776,887.91]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[527.215,325.226],[527.215,229.891],[490.887,328.535],[490.887,234.673]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[524.993,318.159],[524.993,219.676],[499.01,322.668],[499.01,226.194]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[545.798,314.909],[545.798,214.978],[524.993,318.159],[524.993,219.676]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[581.692,310.204],[581.692,208.177],[545.798,314.909],[545.798,214.978]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[737.921,426.158],[737.921,314.603],[552.831,434.333],[552.831,330.841]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[737.921,554.481],[737.921,442.926],[552.831,553.38],[552.831,449.888]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[737.921,567.262],[737.921,678.818],[552.831,565.238],[552.831,668.73]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[737.921,698.78],[737.921,810.335],[552.831,687.249],[552.831,790.741]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[635.893,306.375],[635.893,202.643],[584.868,309.901],[584.868,207.739]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[673.127,304.209],[673.127,199.511],[635.893,306.375],[635.893,202.643]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[727.604,301.344],[727.604,195.371],[673.127,304.209],[673.127,199.511]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[727.604,301.344],[727.604,195.371],[755.587,304.427],[755.587,199.827]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[827.527,425.884],[827.527,314.057],[737.921,426.159],[737.921,314.603]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[827.527,554.518],[827.527,442.692],[737.921,554.481],[737.921,442.926]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[827.527,567.33],[827.527,679.157],[737.921,567.262],[737.921,678.818]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[827.527,699.167],[827.527,810.994],[737.921,698.78],[737.921,810.335]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[800.784,300.311],[800.784,193.877],[755.588,304.427],[755.588,199.827]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[800.783,300.311],[889.29,301.105],[800.783,193.877],[889.29,195.026]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[827.527,425.884],[827.527,314.057],[875.367,428.517],[875.367,319.288]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[827.527,554.518],[827.527,442.692],[875.367,554.164],[875.367,444.935]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[827.527,567.33],[827.527,679.157],[875.367,566.678],[875.367,675.907]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[827.527,699.167],[827.527,810.994],[875.367,695.453],[875.367,804.682]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[913.118,426.968],[913.118,316.21],[875.367,428.517],[875.367,319.288]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[913.118,554.372],[913.118,443.615],[875.367,554.164],[875.367,444.935]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[913.118,567.062],[913.118,677.819],[875.367,566.678],[875.367,675.907]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[913.118,697.638],[913.118,808.395],[875.367,695.453],[875.367,804.682]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[889.29,301.105],[889.29,195.026],[980.776,304.815],[980.776,200.389]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[913.118,426.968],[913.118,316.21],[1005.29,432.211],[1005.29,326.625]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[913.118,554.372],[913.118,443.615],[1005.29,553.666],[1005.29,448.081]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[913.118,567.062],[913.118,677.819],[1005.29,565.763],[1005.29,671.349]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[913.118,697.638],[913.118,808.395],[1005.29,690.243],[1005.29,795.828]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[980.775,304.815],[980.775,200.388],[1096.68,311.807],[1096.69,210.495]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1071.87,429.69],[1071.87,321.619],[1005.29,432.211],[1005.29,326.625]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1071.87,554.006],[1071.87,445.934],[1005.29,553.666],[1005.29,448.081]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1071.87,566.388],[1071.87,674.459],[1005.29,565.763],[1005.29,671.349]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1071.87,693.798],[1071.87,801.869],[1005.29,690.243],[1005.29,795.828]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1071.87,429.69],[1071.87,321.619],[1186.19,433.249],[1186.19,328.688]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1071.87,554.006],[1071.87,445.934],[1186.19,553.526],[1186.19,448.965]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1071.87,566.388],[1071.87,674.459],[1186.19,565.506],[1186.19,670.067]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1071.87,693.798],[1071.87,801.869],[1186.19,688.778],[1186.19,793.339]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1098.63,312.349],[1098.63,211.276],[1195.48,320.449],[1195.48,222.986]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1176.07,437.752],[1176.07,334.266],[1392.49,450.591],[1392.49,360.194]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1176.07,556.793],[1176.07,453.307],[1392.49,554.574],[1392.49,464.178]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1176.07,568.649],[1176.07,672.136],[1392.49,564.931],[1392.49,655.328]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1176.07,690.654],[1176.07,794.14],[1392.49,671.503],[1392.49,761.9]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1195.48,320.449],[1195.48,222.986],[1276.53,330.933],[1276.53,238.14]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1276.53,330.933],[1276.53,238.14],[1321.78,340.371],[1321.78,251.781]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1322.16,340.451],[1322.16,251.897],[1344.56,349.554],[1344.56,265.055]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1322.94,785.92],[1322.94,880.24],[1387.32,775.767],[1387.32,866.204]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1344.56,349.554],[1344.56,265.055],[1347.07,355.676],[1347.07,273.904]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1373.63,774.758],[1373.63,864.81],[1431.93,765.687],[1431.93,852.27]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1409.26,447.151],[1409.26,356.303],[1431.94,451.424],[1431.94,364.79]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1409.26,551.654],[1409.26,460.806],[1431.94,551.079],[1431.94,464.445]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1409.26,562.063],[1409.26,652.911],[1431.94,561.005],[1431.94,647.638]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:36,
                    verts:[[1409.26,669.168],[1409.26,760.016],[1431.94,663.141],[1431.94,749.775]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[598.502,433.953],[598.502,330.086],[418.414,440.376],[418.414,342.845]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[598.502,553.432],[598.502,449.565],[418.414,552.567],[418.414,455.036]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[598.502,565.332],[598.502,669.199],[418.414,563.741],[418.414,661.272]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[598.502,687.785],[598.502,791.652],[418.414,678.724],[418.414,776.255]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[599.357,810.769],[599.357,914.591],[419.291,794.213],[419.291,891.704]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[554.039,323.926],[554.039,228.011],[513.478,326.929],[513.478,232.353]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[559.341,316.895],[559.341,217.848],[528.062,321.162],[528.062,224.017]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[583.948,313.843],[583.948,213.437],[559.341,316.895],[559.341,217.848]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[625.331,309.483],[625.331,207.135],[583.948,313.843],[583.948,213.437]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[804.875,426.592],[804.875,315.464],[599.604,433.914],[599.604,330.008]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[804.875,554.423],[804.875,443.295],[599.604,553.437],[599.604,449.531]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[804.875,567.155],[804.875,678.283],[599.604,565.342],[599.604,669.247]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[804.875,698.168],[804.875,809.296],[599.604,687.84],[599.604,791.746]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[684.108,306.157],[684.108,202.328],[628.866,309.21],[628.866,206.741]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[723.848,304.338],[723.848,199.698],[684.108,306.157],[684.108,202.328]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[781.46,301.985],[781.46,196.298],[723.848,304.338],[723.848,199.698]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[781.46,301.985],[781.46,196.298],[806.2,305.253],[806.201,201.021]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[894.663,426.687],[804.875,426.592],[894.663,315.654],[804.875,315.465]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[894.663,554.41],[894.663,443.376],[804.875,554.423],[804.875,443.295]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[894.663,567.131],[804.875,567.155],[894.663,678.165],[804.875,678.283]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[894.663,698.034],[804.875,698.168],[894.663,809.067],[804.875,809.296]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[855.537,301.599],[855.537,195.74],[806.201,305.253],[806.201,201.021]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[855.536,301.599],[942.485,303.133],[855.536,195.74],[942.485,197.956]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[894.663,426.687],[894.663,315.653],[936.011,429.452],[936.011,321.146]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[894.663,554.41],[894.663,443.376],[936.011,554.038],[936.011,445.731]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[894.663,567.131],[894.663,678.165],[936.011,566.447],[936.011,674.753]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[894.663,698.034],[894.663,809.067],[936.011,694.134],[936.011,802.44]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[976.818,428.09],[976.818,318.44],[936.011,429.452],[936.011,321.146]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[976.818,554.221],[976.818,444.571],[936.011,554.038],[936.011,445.731]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[976.818,566.784],[976.818,676.434],[936.011,566.447],[936.011,674.753]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[976.818,696.055],[976.818,805.705],[936.011,694.134],[936.011,802.44]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[942.486,303.133],[942.486,197.956],[1028.84,307.522],[1028.84,204.3]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[976.819,428.09],[976.819,318.44],[1055.55,433.556],[1055.55,329.297]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[976.819,554.221],[976.819,444.571],[1055.55,553.485],[1055.55,449.226]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[976.819,566.784],[976.819,676.434],[1055.55,565.43],[1055.55,669.689]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[976.819,696.055],[976.819,805.705],[1055.55,688.345],[1055.55,792.604]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1028.84,307.521],[1028.84,204.3],[1135.17,315.269],[1135.17,215.498]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1126.34,431.361],[1126.34,324.938],[1055.55,433.556],[1055.55,329.297]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1126.34,553.781],[1126.34,447.357],[1055.55,553.485],[1055.55,449.226]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1126.34,565.974],[1126.34,672.397],[1055.55,565.43],[1055.55,669.689]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1126.34,691.441],[1126.34,797.864],[1055.55,688.345],[1055.55,792.604]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1126.34,431.361],[1126.34,324.938],[1229.48,435.241],[1229.48,332.644]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1126.34,553.781],[1126.34,447.357],[1229.48,553.258],[1229.48,450.662]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1126.34,565.974],[1126.34,672.397],[1229.48,565.013],[1229.48,667.609]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1126.34,691.441],[1126.34,797.864],[1229.48,685.968],[1229.48,788.565]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1136.52,315.811],[1136.52,216.279],[1222.48,324.425],[1222.48,228.732]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1222.48,324.425],[1222.48,228.732],[1290.34,335.178],[1290.34,244.276]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1217.25,439.609],[1217.25,338.016],[1396.39,452.726],[1396.39,364.507]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1217.25,556.472],[1217.25,454.879],[1396.39,554.205],[1396.39,465.986]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1217.25,568.112],[1217.25,669.705],[1396.39,564.313],[1396.39,652.532]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1217.25,687.884],[1217.25,789.477],[1396.39,668.318],[1396.39,756.537]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1290.34,335.178],[1290.34,244.276],[1324.52,344.626],[1324.52,257.932]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1324.8,344.706],[1324.8,258.047],[1337.29,353.66],[1337.29,270.99]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1338.42,780.445],[1338.42,872.672],[1391.53,770.111],[1391.53,858.386]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1377.57,769.25],[1377.57,857.196],[1425.65,760.038],[1425.65,844.461]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1413.43,449.428],[1413.43,360.826],[1425.78,453.615],[1425.78,369.143]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1413.43,551.348],[1413.43,462.746],[1425.78,550.784],[1425.78,466.312]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1413.43,561.499],[1413.43,650.101],[1425.78,560.462],[1425.78,644.934]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:37,
                    verts:[[1413.43,665.956],[1413.43,754.558],[1425.78,660.05],[1425.78,744.522]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[647.745,433.676],[647.745,329.537],[449.379,439.389],[449.379,340.883]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[647.745,553.469],[647.745,449.329],[449.379,552.7],[449.379,454.194]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[647.745,565.4],[647.745,669.54],[449.379,563.986],[449.379,662.491]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[647.745,688.175],[647.745,792.315],[449.379,680.118],[449.379,778.623]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[648.504,811.475],[648.504,915.567],[450.183,796.753],[450.183,895.216]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[539.43,325.458],[539.43,230.226],[532.986,332.301],[532.986,240.117]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[583.866,322.788],[583.866,226.366],[539.431,325.458],[539.431,230.226]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[596.687,315.855],[596.687,216.345],[560.399,319.841],[560.399,222.107]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[624.842,313.029],[624.842,212.261],[596.687,315.855],[596.687,216.345]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[671.246,309.054],[671.246,206.516],[624.842,313.029],[624.842,212.261]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[871.538,427.232],[871.538,316.736],[648.951,433.642],[648.951,329.468]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[871.538,554.337],[871.538,443.84],[648.951,553.474],[648.951,449.299]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[871.538,566.996],[871.538,677.493],[648.951,565.409],[648.951,669.583]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[871.538,697.265],[871.538,807.761],[648.951,688.224],[648.951,792.398]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[733.886,306.259],[733.886,202.474],[675.098,308.814],[675.098,206.168]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[775.628,304.798],[775.628,200.363],[733.886,306.259],[733.886,202.474]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[835.622,302.968],[835.622,197.718],[775.628,304.798],[775.628,200.363]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[835.622,302.968],[835.622,197.718],[856.891,306.382],[856.891,202.653]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[909.667,303.211],[909.667,198.07],[856.891,306.382],[856.891,202.653]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[871.538,427.232],[960.291,427.681],[871.538,316.736],[960.291,317.628]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[871.538,554.337],[871.538,443.84],[960.291,554.276],[960.291,444.223]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[871.538,566.996],[871.538,677.493],[960.291,566.885],[960.291,676.938]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[871.538,697.265],[960.291,696.632],[871.538,807.762],[960.291,806.685]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[909.667,303.211],[909.667,198.07],[994.055,305.435],[994.055,201.284]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[960.291,427.681],[960.291,317.628],[994.835,430.542],[994.835,323.311]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[960.291,554.276],[960.291,444.223],[994.835,553.891],[994.835,446.66]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[960.291,566.885],[960.291,676.938],[994.835,566.177],[994.835,673.408]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[960.291,696.632],[960.291,806.685],[994.835,692.596],[994.835,799.827]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[994.055,305.435],[994.055,201.283],[1074.47,310.422],[1074.47,208.492]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1038.05,429.372],[1038.05,320.986],[994.835,430.542],[994.835,323.311]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1038.05,554.049],[1038.05,445.663],[994.835,553.891],[994.835,446.66]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1038.05,566.466],[1038.05,674.853],[994.835,566.177],[994.835,673.408]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1038.05,694.247],[1038.05,802.633],[994.835,692.596],[994.835,799.827]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1038.05,429.372],[1038.05,320.986],[1102.97,434.991],[1102.97,332.148]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1038.05,554.049],[1038.05,445.663],[1102.97,553.292],[1102.97,450.449]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1038.05,566.466],[1038.05,674.853],[1102.97,565.075],[1102.97,667.918]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1038.05,694.247],[1038.05,802.633],[1102.97,686.321],[1102.97,789.164]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1074.47,310.422],[1074.47,208.492],[1170.52,318.8],[1170.52,220.602]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1176.9,433.121],[1176.9,328.433],[1102.97,434.991],[1102.97,332.148]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1176.9,553.544],[1176.9,448.856],[1102.97,553.292],[1102.97,450.449]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1176.9,565.538],[1176.9,670.226],[1102.97,565.075],[1102.97,667.918]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1176.9,688.958],[1176.9,793.646],[1102.97,686.321],[1102.97,789.164]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1171.3,319.337],[1171.3,221.376],[1246.14,328.348],[1246.14,234.403]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1176.9,433.121],[1176.9,328.433],[1268.32,437.256],[1268.32,336.648]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1176.9,553.544],[1176.9,448.856],[1268.32,552.987],[1268.32,452.378]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1176.9,565.538],[1176.9,670.226],[1268.32,564.514],[1268.32,665.122]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1176.9,688.958],[1176.9,793.646],[1268.32,683.125],[1268.32,783.734]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1246.14,328.348],[1246.14,234.403],[1301.04,339.257],[1301.04,250.171]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1254.26,441.485],[1254.26,341.805],[1397.05,454.74],[1397.05,368.574]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1254.26,556.148],[1254.26,456.468],[1397.05,553.857],[1397.05,467.691]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1254.26,567.568],[1254.26,667.248],[1397.05,563.729],[1397.05,649.895]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1254.26,685.085],[1254.26,784.765],[1397.05,665.314],[1397.05,751.48]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1301.04,339.257],[1301.04,250.172],[1324.64,348.64],[1324.64,263.734]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1324.83,348.719],[1324.83,263.849],[1328.01,357.475],[1328.01,276.504]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1350.28,775.187],[1350.28,865.404],[1392.52,764.775],[1392.52,851.009]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1378.4,764.053],[1378.4,850.011],[1416.71,754.785],[1416.71,837.199]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1414.21,451.575],[1414.21,365.091],[1416.93,455.654],[1416.93,373.193]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1414.21,551.059],[1414.21,464.574],[1416.93,550.509],[1416.93,468.048]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1414.21,560.967],[1414.21,647.452],[1416.93,559.957],[1416.93,642.418]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:38,
                    verts:[[1414.21,662.927],[1414.21,749.412],[1416.93,657.174],[1416.93,739.635]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[698.922,433.52],[698.922,329.225],[484.297,438.465],[484.297,339.049]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[698.922,553.49],[698.922,449.196],[484.297,552.824],[484.297,453.408]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[698.922,565.439],[698.922,669.733],[484.297,564.214],[484.297,663.63]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[698.922,688.396],[698.922,792.69],[484.297,681.42],[484.297,780.837]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[699.575,811.874],[699.575,916.118],[485.017,799.128],[485.017,898.499]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[568.376,324.082],[568.376,228.237],[554.612,330.843],[554.612,238.01]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[616.291,321.769],[616.291,224.894],[568.376,324.082],[568.376,228.237]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[636.533,314.991],[636.533,215.097],[595.581,318.661],[595.581,220.401]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[667.943,312.416],[667.943,211.374],[636.533,314.991],[636.533,215.097]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[718.845,308.858],[718.845,206.232],[667.943,312.416],[667.943,211.374]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[937.128,428.031],[937.128,318.323],[700.217,433.49],[700.217,329.166]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[937.128,554.229],[937.128,444.521],[700.217,553.494],[700.217,449.17]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[937.128,566.799],[937.128,676.507],[700.217,565.446],[700.217,669.77]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[937.128,696.138],[937.128,805.846],[700.217,688.438],[700.217,792.762]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[784.608,306.609],[784.608,202.981],[722.969,308.652],[722.969,205.934]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[827.845,305.513],[827.845,201.396],[784.608,306.609],[784.608,202.981]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[889.48,304.207],[889.48,199.509],[827.846,305.513],[827.846,201.396]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[889.48,304.207],[889.48,199.509],[907.117,307.733],[907.117,204.606]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[962.635,305.054],[962.635,200.733],[907.117,307.733],[907.117,204.606]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[937.128,428.031],[937.128,318.323],[1023.75,428.814],[1023.75,319.878]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[937.128,554.229],[937.128,444.521],[1023.75,554.124],[1023.75,445.188]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[937.128,566.799],[937.128,676.507],[1023.75,566.605],[1023.75,675.541]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[937.128,696.138],[937.128,805.847],[1023.75,695.034],[1023.75,803.97]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[962.634,305.054],[962.634,200.733],[1043.59,307.914],[1043.59,204.867]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1023.75,428.814],[1023.75,319.878],[1051.33,431.738],[1051.33,325.687]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1023.75,554.124],[1023.75,445.187],[1051.33,553.73],[1051.33,447.678]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1023.75,566.605],[1023.75,675.541],[1051.33,565.88],[1051.33,671.932]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1023.75,695.034],[1023.75,803.97],[1051.33,690.909],[1051.33,796.961]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1043.59,307.914],[1043.59,204.867],[1117.43,313.42],[1117.43,212.825]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1096.32,430.759],[1096.32,323.742],[1051.33,431.738],[1051.33,325.687]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1096.32,553.862],[1096.32,446.844],[1051.33,553.73],[1051.33,447.678]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1096.32,566.123],[1096.32,673.14],[1051.33,565.88],[1051.33,671.932]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1096.32,692.29],[1096.32,799.308],[1051.33,690.909],[1051.33,796.961]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1096.32,430.759],[1096.32,323.742],[1147.33,436.47],[1147.33,335.086]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1096.32,553.862],[1096.32,446.844],[1147.33,553.093],[1147.33,451.709]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1096.32,566.123],[1096.32,673.14],[1147.33,564.708],[1147.33,666.092]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1096.32,692.29],[1096.32,799.308],[1147.33,684.234],[1147.33,785.618]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1117.43,313.42],[1117.43,212.825],[1202.73,322.314],[1202.73,225.682]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1223.41,434.918],[1223.41,332.003],[1147.33,436.47],[1147.33,335.086]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1223.41,553.302],[1223.41,450.387],[1147.33,553.093],[1147.33,451.709]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1223.41,565.093],[1223.41,668.008],[1147.33,564.708],[1147.33,666.092]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1223.41,686.424],[1223.41,789.339],[1147.33,684.234],[1147.33,785.618]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1202.96,322.842],[1202.96,226.443],[1266.63,332.146],[1266.63,239.893]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1223.41,434.918],[1223.41,332.003],[1302.85,439.251],[1302.85,340.609]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1223.41,553.302],[1223.41,450.387],[1302.85,552.718],[1302.85,454.077]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1223.41,565.093],[1223.41,668.008],[1302.85,564.02],[1302.85,662.661]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1223.41,686.424],[1223.41,789.339],[1302.85,680.312],[1302.85,778.953]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1266.63,332.146],[1266.63,239.893],[1308.93,343.116],[1308.93,255.749]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1287.21,443.34],[1287.21,345.55],[1394.91,456.616],[1394.91,372.362]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1287.21,555.827],[1287.21,458.038],[1394.91,553.533],[1394.91,469.279]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1287.21,567.031],[1287.21,664.821],[1394.91,563.186],[1394.91,647.44]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1287.21,682.319],[1287.21,780.109],[1394.91,662.516],[1394.91,746.77]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1308.93,343.116],[1308.93,255.749],[1322.46,352.376],[1322.46,269.134]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1358.87,770.21],[1358.87,858.524],[1390.71,759.802],[1390.71,844.135]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:39,
                    verts:[[1376.55,759.21],[1376.54,843.317],[1405.53,749.954],[1405.53,830.521]]
                },
                ],
                [
                {
                    num:"105",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[525.008,787.906],[525.008,882.985],[486.169,786.189],[486.169,880.613]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[525.689,442.915],[525.689,347.889],[488.251,443.556],[488.252,349.162]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[525.689,552.225],[525.689,457.198],[488.251,552.138],[488.252,457.744]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[525.689,563.112],[525.689,658.138],[488.252,562.953],[488.251,657.347]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[525.689,675.142],[525.689,770.169],[488.252,674.239],[488.251,768.633]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[522.762,437.589],[522.762,337.309],[492.493,440.49],[492.493,343.071]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[522.762,552.942],[522.762,452.662],[492.493,552.551],[492.493,455.132]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[522.762,564.431],[522.762,664.712],[492.493,563.713],[492.493,661.132]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[522.762,682.656],[522.762,782.936],[492.493,678.564],[492.493,775.983]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[523.391,801.382],[523.391,901.614],[493.393,793.865],[493.393,891.224]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[751.47,433.455],[751.47,329.098],[522.762,437.589],[522.762,337.309]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[751.47,553.499],[751.47,449.141],[522.762,552.942],[522.762,452.662]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[751.47,565.455],[751.47,669.813],[522.762,564.431],[522.762,664.712]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[751.47,688.487],[751.47,792.844],[522.762,682.656],[522.762,782.936]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[752.01,812.035],[752.01,916.341],[523.39,801.382],[523.39,901.614]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[599.979,322.763],[599.979,226.33],[578.941,329.393],[578.941,235.914]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[650.952,320.828],[650.952,223.533],[599.98,322.763],[599.98,226.33]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[678.438,314.256],[678.438,214.034],[633.213,317.58],[633.213,218.839]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[712.781,311.95],[712.781,210.701],[678.438,314.256],[678.438,214.034]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[767.624,308.835],[767.624,206.198],[712.78,311.95],[712.781,210.701]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1001.05,428.945],[1001.05,320.137],[752.838,433.431],[752.838,329.049]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1001.05,554.106],[1001.05,445.299],[752.838,553.502],[752.838,449.12]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1001.05,566.572],[1001.05,675.379],[752.838,565.461],[752.838,669.843]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1001.05,694.85],[1001.05,803.657],[752.838,688.521],[752.838,792.904]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[835.765,307.143],[835.765,203.752],[771.973,308.664],[771.973,205.951]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[880,306.41],[835.765,307.143],[880,202.694],[835.765,203.752]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[942.558,305.624],[879.999,306.41],[942.558,201.557],[879.999,202.694]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[942.558,305.624],[942.558,201.557],[956.466,309.228],[956.466,206.767]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1014.04,307.042],[1014.04,203.607],[956.467,309.228],[956.467,206.767]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1001.05,428.945],[1001.05,320.137],[1084.57,430.038],[1084.57,322.309]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1001.05,554.106],[1001.05,445.299],[1084.57,553.959],[1084.57,446.23]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1001.05,566.572],[1001.05,675.379],[1084.57,566.302],[1084.57,674.03]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1001.05,694.85],[1001.05,803.657],[1084.57,693.308],[1084.57,801.037]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1014.04,307.042],[1014.04,203.607],[1090.81,310.484],[1090.81,208.583]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1084.57,430.038],[1084.57,322.309],[1105.14,432.996],[1105.14,328.186]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1084.57,553.959],[1084.57,446.23],[1105.14,553.56],[1105.14,448.75]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1084.57,566.302],[1084.57,674.03],[1105.14,565.569],[1105.14,670.379]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1084.57,693.308],[1084.57,801.036],[1105.14,689.134],[1105.14,793.945]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1090.81,310.484],[1090.81,208.583],[1157.6,316.434],[1157.6,217.182]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1151.33,432.206],[1151.33,326.615],[1105.14,432.996],[1105.14,328.186]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1151.33,553.667],[1151.33,448.076],[1105.14,553.56],[1105.14,448.75]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1151.33,565.765],[1151.33,671.355],[1105.14,565.569],[1105.14,670.379]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1151.33,690.249],[1151.33,795.84],[1105.14,689.134],[1105.14,793.945]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1151.33,432.206],[1151.33,326.615],[1188.54,437.955],[1188.54,338.035]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1151.33,553.667],[1151.33,448.076],[1188.54,552.893],[1188.54,452.973]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1151.33,565.765],[1151.33,671.355],[1188.54,564.341],[1188.54,664.26]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1151.33,690.25],[1151.33,795.84],[1188.54,682.14],[1188.54,782.059]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1157.6,316.434],[1157.6,217.182],[1231.89,325.741],[1231.89,230.635]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1265.87,436.71],[1265.87,335.562],[1188.54,437.955],[1188.54,338.035]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1265.87,553.06],[1265.87,451.913],[1188.54,552.893],[1188.54,452.973]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1265.87,564.649],[1265.87,665.797],[1188.54,564.341],[1188.54,664.26]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1265.87,683.896],[1265.87,785.044],[1188.54,682.14],[1188.54,782.059]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1231.59,326.257],[1231.59,231.379],[1284.17,335.764],[1284.17,245.123]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1265.87,436.71],[1265.87,335.562],[1333.26,441.188],[1333.26,344.458]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1265.87,553.06],[1265.87,451.913],[1333.26,552.457],[1333.26,455.727]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1265.87,564.649],[1265.87,665.797],[1333.26,563.54],[1333.26,660.27]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1265.87,683.896],[1265.87,785.044],[1333.26,677.579],[1333.26,774.31]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1284.17,335.764],[1284.17,245.123],[1314.31,346.717],[1314.31,260.955]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1314.31,346.717],[1314.31,260.955],[1318.29,355.809],[1318.29,274.096]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1316.29,445.139],[1316.29,349.183],[1390.33,458.342],[1390.33,375.849]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1316.29,555.516],[1316.29,459.561],[1390.33,553.235],[1390.33,470.742]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1316.29,566.51],[1316.29,662.465],[1390.33,562.686],[1390.33,645.179]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1316.29,679.636],[1316.29,775.591],[1390.33,659.94],[1390.33,742.433]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1364.57,765.561],[1364.57,852.096],[1386.47,755.222],[1386.47,837.804]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:40,
                    verts:[[1372.35,754.752],[1372.35,837.154],[1392.47,745.559],[1392.47,824.447]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[571.601,447.423],[571.603,356.843],[506.982,448.213],[506.983,358.413]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[571.601,551.618],[571.603,461.038],[506.982,551.511],[506.983,461.711]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[571.603,561.996],[571.601,652.576],[506.983,561.8],[506.982,651.601]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[571.603,668.784],[571.601,759.364],[506.983,667.67],[506.982,757.47]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[572.648,776.193],[572.648,866.793],[508.274,774.162],[508.274,863.986]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[554.564,790.083],[554.564,885.995],[513.376,788.704],[513.376,884.089]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[555.136,442.074],[555.136,346.217],[515.438,442.589],[515.438,347.24]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[555.136,552.338],[555.136,456.481],[515.438,552.269],[515.438,456.92]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[555.136,563.32],[555.136,659.177],[515.438,563.193],[515.438,658.542]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[555.136,676.33],[555.136,772.186],[515.438,675.604],[515.438,770.952]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[564.402,436.744],[564.402,335.631],[526.846,439.536],[526.846,341.176]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[564.402,553.056],[564.402,451.942],[526.846,552.68],[526.846,454.32]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[564.402,564.641],[564.402,665.754],[526.846,563.949],[526.846,662.309]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[564.402,683.848],[564.402,784.961],[526.846,679.91],[526.846,778.27]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[564.932,803.556],[564.932,904.619],[527.624,796.318],[527.624,894.614]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[804.908,433.458],[804.908,329.103],[564.402,436.744],[564.402,335.631]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[804.908,553.498],[804.908,449.143],[564.402,553.056],[564.402,451.942]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[804.908,565.454],[804.908,669.81],[564.402,564.641],[564.402,665.754]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[804.908,688.483],[804.908,792.838],[564.402,683.847],[564.402,784.961]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[805.331,812.024],[805.331,916.327],[564.931,803.555],[564.931,904.619]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[633.945,321.463],[633.945,224.451],[605.735,327.917],[605.735,233.78]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[687.534,319.922],[687.534,222.223],[633.945,321.463],[633.945,224.451]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[722.019,313.602],[722.019,213.089],[672.944,316.556],[672.944,217.359]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[758.951,311.583],[758.951,210.17],[722.019,313.602],[722.019,213.089]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[817.155,308.929],[817.155,206.334],[758.951,311.582],[758.951,210.17]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1062.87,429.933],[1062.87,322.101],[806.335,433.439],[806.335,329.064]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1062.87,553.973],[1062.87,446.141],[806.335,553.501],[806.335,449.126]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1062.87,566.327],[1062.87,674.159],[806.335,565.459],[806.335,669.834]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1062.87,693.455],[1062.87,801.287],[806.335,688.511],[806.335,792.885]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[886.938,307.797],[886.938,204.697],[821.683,308.794],[821.683,206.14]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[931.69,307.425],[886.938,307.797],[931.69,204.161],[886.938,204.697]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[994.494,307.147],[931.691,307.425],[994.494,203.759],[931.691,204.161]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[994.494,307.147],[994.494,203.759],[1004.63,310.801],[1004.63,209.04]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1063.61,309.104],[1063.61,206.587],[1004.63,310.801],[1004.63,209.04]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1063.61,309.104],[1063.61,206.587],[1135.57,313.073],[1135.57,212.324]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1062.87,429.933],[1062.87,322.101],[1142.44,431.312],[1142.44,324.841]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1062.87,553.973],[1062.87,446.141],[1142.44,553.787],[1142.44,447.315]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1062.87,566.327],[1062.87,674.159],[1142.44,565.986],[1142.44,672.458]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1062.87,693.455],[1062.87,801.287],[1142.44,691.51],[1142.44,797.982]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1135.57,313.073],[1135.57,212.324],[1194.97,319.397],[1194.97,221.466]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1142.44,431.312],[1142.44,324.84],[1156.08,434.28],[1156.08,330.735]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1142.44,553.787],[1142.44,447.315],[1156.08,553.388],[1156.08,449.843]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1142.44,565.986],[1142.44,672.458],[1156.08,565.251],[1156.08,668.795]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1142.44,691.51],[1142.44,797.982],[1156.08,687.324],[1156.08,790.868]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1202.91,433.672],[1202.91,329.529],[1156.08,434.28],[1156.08,330.735]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1202.91,553.469],[1202.91,449.326],[1156.08,553.388],[1156.08,449.843]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1202.91,565.401],[1202.91,669.545],[1156.08,565.251],[1156.08,668.795]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1202.91,688.181],[1202.91,792.325],[1156.08,687.324],[1156.08,790.869]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1194.97,319.397],[1194.97,221.466],[1258.11,329.025],[1258.11,235.382]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1202.91,433.672],[1202.91,329.529],[1226.59,439.413],[1226.59,340.932]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1202.91,553.469],[1202.91,449.326],[1226.59,552.696],[1226.59,454.216]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1202.91,565.401],[1202.91,669.545],[1226.59,563.979],[1226.59,662.46]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1202.91,688.181],[1202.91,792.325],[1226.59,680.083],[1226.59,778.564]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1304.37,438.462],[1304.37,339.043],[1226.59,439.413],[1226.59,340.932]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1304.37,552.824],[1304.37,453.405],[1226.59,552.696],[1226.59,454.215]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1304.37,564.215],[1304.37,663.634],[1226.59,563.979],[1226.59,662.46]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1304.37,681.424],[1304.37,780.843],[1226.59,680.083],[1226.59,778.563]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1257.32,329.526],[1257.32,236.105],[1298.98,339.161],[1298.98,250.032]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1298.98,339.161],[1298.98,250.032],[1317.43,350.034],[1317.43,265.749]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1304.37,438.462],[1304.37,339.043],[1359.8,443.042],[1359.8,348.14]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1304.37,552.824],[1304.37,453.405],[1359.8,552.208],[1359.8,457.306]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1304.37,564.215],[1304.37,663.634],[1359.8,563.081],[1359.8,657.983]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1304.37,681.424],[1304.37,780.843],[1359.8,674.965],[1359.8,769.866]]
                },{
                    num:"503",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1341.72,446.858],[1341.72,352.655],[1383.64,459.915],[1383.64,379.025]]
                },{
                    num:"403",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1341.72,555.219],[1341.72,461.017],[1383.64,552.963],[1383.64,472.073]]
                },{
                    num:"303",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1341.72,566.012],[1341.72,660.215],[1383.64,562.231],[1383.64,643.12]]
                },{
                    num:"203",
                    tipo:"TorreC",
                    frame:41,
                    verts:[[1341.72,677.071],[1341.72,771.274],[1383.64,657.595],[1383.64,738.485]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[591.888,446.62],[591.889,355.248],[524.133,447.207],[524.133,356.413]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[591.888,551.726],[591.889,460.354],[524.133,551.647],[524.133,460.854]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[591.889,562.195],[591.888,653.567],[524.133,562.049],[524.133,652.843]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[591.889,669.917],[591.888,761.289],[524.133,669.089],[524.133,759.883]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[593.001,778.255],[593.001,869.645],[525.509,776.748],[525.509,867.56]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[586.874,792.309],[586.874,889.073],[543.64,791.286],[543.64,887.658]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[587.328,441.213],[587.328,344.507],[545.662,441.595],[545.662,345.265]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[587.328,552.454],[587.328,455.748],[545.662,552.403],[545.662,456.073]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[587.328,563.534],[587.328,660.24],[545.662,563.439],[545.662,659.768]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[587.328,677.544],[587.328,774.25],[545.662,677.006],[545.662,773.335]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[608.912,435.915],[608.912,333.984],[564.289,438.576],[564.289,339.269]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[608.912,553.167],[608.912,451.236],[564.289,552.809],[564.289,453.502]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[608.912,564.846],[608.912,666.777],[564.289,564.187],[564.289,663.494]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[608.912,685.017],[608.912,786.949],[564.289,681.264],[564.289,780.571]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[609.336,805.69],[609.336,907.569],[564.935,798.787],[564.935,898.027]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[858.858,433.505],[858.858,329.195],[608.912,435.915],[608.912,333.984]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[858.858,553.492],[858.858,449.183],[608.912,553.167],[608.912,451.236]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[858.858,565.443],[858.858,669.752],[608.912,564.846],[608.912,666.777]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[858.858,688.417],[858.858,792.727],[608.912,685.017],[608.912,786.949]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[859.161,811.902],[859.161,916.157],[609.335,805.69],[609.335,907.569]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[634.808,326.383],[634.809,231.563],[621.83,333.892],[621.83,242.416]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[670.034,320.148],[670.034,222.551],[634.808,326.383],[634.808,231.563]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[725.784,319.014],[725.784,220.912],[670.035,320.148],[670.035,222.551]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[766.971,312.99],[766.971,212.204],[714.494,315.552],[714.494,215.907]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[806.133,311.27],[806.133,209.717],[766.971,312.99],[766.971,212.204]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[867.105,309.092],[867.105,206.57],[806.133,311.269],[806.133,209.717]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1122.28,430.964],[1122.28,324.149],[860.328,433.49],[860.328,329.167]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1122.28,553.834],[1122.28,447.019],[860.328,553.494],[860.328,449.171]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1122.28,566.072],[1122.28,672.887],[860.328,565.446],[860.328,669.77]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1122.28,692.001],[1122.28,798.816],[860.328,688.437],[860.328,792.761]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[937.813,308.518],[871.765,308.994],[937.813,205.741],[871.765,206.429]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[982.624,308.502],[937.813,308.518],[982.624,205.717],[937.813,205.741]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[982.624,308.502],[1045.04,308.718],[982.624,205.717],[1045.04,206.03]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1045.04,308.718],[1045.04,206.03],[1051.4,312.394],[1051.4,211.342]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1111.17,311.178],[1051.4,312.394],[1111.17,209.586],[1051.4,211.343]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1111.17,311.179],[1111.17,209.586],[1177.8,315.622],[1177.8,216.008]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1122.28,430.964],[1122.28,324.149],[1197.2,432.604],[1197.2,327.407]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1122.28,553.834],[1122.28,447.019],[1197.2,553.613],[1197.2,448.416]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1122.28,566.072],[1122.28,672.887],[1197.2,565.666],[1197.2,670.863]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1122.28,692.001],[1122.28,798.816],[1197.2,689.687],[1197.2,794.885]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1177.8,315.622],[1177.8,216.008],[1229.57,322.258],[1229.57,225.6]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1197.2,432.604],[1197.2,327.407],[1204.04,435.558],[1204.04,333.275]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1197.2,553.613],[1197.2,448.416],[1204.04,553.215],[1204.04,450.932]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1197.2,565.666],[1197.2,670.863],[1204.04,564.934],[1204.04,667.217]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1197.2,689.687],[1197.2,794.885],[1204.04,685.52],[1204.04,787.803]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1251.02,435.128],[1204.04,435.558],[1251.02,332.419],[1204.04,333.275]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1251.02,553.273],[1251.02,450.565],[1204.04,553.215],[1204.04,450.932]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1251.02,565.041],[1251.02,667.749],[1204.04,564.934],[1204.04,667.217]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1251.02,686.128],[1204.04,685.52],[1251.02,788.836],[1204.04,787.804]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1229.57,322.258],[1229.57,225.6],[1281.55,332.126],[1281.55,239.864]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1251.02,435.128],[1251.02,332.419],[1261.57,440.821],[1261.57,343.729]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1251.02,553.273],[1251.02,450.565],[1261.57,552.507],[1261.57,455.415]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1251.02,565.041],[1251.02,667.749],[1261.57,563.631],[1261.57,660.723]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1251.02,686.128],[1251.02,788.836],[1261.57,678.096],[1261.57,775.188]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1339.09,440.15],[1261.57,440.821],[1339.09,342.396],[1261.57,343.729]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1339.09,552.597],[1339.09,454.843],[1261.57,552.507],[1261.57,455.415]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1339.09,563.797],[1339.09,661.551],[1261.57,563.631],[1261.57,660.723]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1339.09,679.043],[1261.57,678.096],[1339.09,776.797],[1261.57,775.188]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1280.29,332.61],[1280.29,240.562],[1311.28,342.308],[1311.28,254.582]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1311.28,342.308],[1311.28,254.582],[1318.51,353.05],[1318.51,270.109]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1339.09,440.15],[1339.09,342.396],[1382.74,444.793],[1382.74,351.618]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1339.09,552.597],[1339.09,454.843],[1382.74,551.972],[1382.74,458.797]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1339.09,563.797],[1339.09,661.551],[1382.74,562.647],[1382.74,655.822]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:42,
                    verts:[[1339.09,679.043],[1339.09,776.797],[1382.74,672.494],[1382.74,765.669]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[614.477,445.757],[614.478,353.534],[544.007,446.13],[544.008,354.275]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[614.477,551.842],[614.478,459.619],[544.007,551.792],[544.008,459.936]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[614.478,562.408],[614.477,654.632],[544.008,562.316],[544.007,654.171]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[614.478,671.134],[614.477,763.358],[544.008,670.608],[544.007,762.463]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[615.65,780.473],[615.65,872.71],[545.459,779.514],[545.459,871.385]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[621.767,794.616],[621.767,892.261],[576.808,793.966],[576.808,891.363]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[622.097,440.32],[622.097,342.734],[578.772,440.563],[578.773,343.216]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[622.097,552.574],[622.097,454.988],[578.772,552.542],[578.773,455.195]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[622.097,563.755],[622.097,661.341],[578.773,563.695],[578.772,661.042]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[622.097,678.803],[622.097,776.389],[578.773,678.461],[578.772,775.808]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[656.031,435.089],[656.031,332.342],[604.622,437.598],[604.622,337.326]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[656.031,553.279],[656.031,450.532],[604.622,552.941],[604.622,452.669]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[656.031,565.05],[656.031,667.797],[604.622,564.429],[604.622,664.701]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[656.031,686.183],[656.031,788.929],[604.622,682.643],[604.622,782.915]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[656.342,807.817],[656.342,910.51],[605.126,801.304],[605.126,901.506]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[645.164,332.191],[645.164,239.958],[635.837,342.435],[635.837,254.765]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[913.006,433.577],[913.006,329.338],[656.031,435.089],[656.031,332.342]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[913.006,553.482],[913.006,449.244],[656.031,553.279],[656.031,450.532]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[913.006,565.425],[913.006,669.663],[656.031,565.05],[656.031,667.797]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[913.006,688.316],[913.006,792.554],[656.031,686.183],[656.031,788.929]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[666.009,324.765],[666.009,229.224],[645.164,332.191],[645.164,239.958]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[708.052,318.789],[708.052,220.587],[666.008,324.765],[666.008,229.224]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[913.185,811.714],[913.185,915.898],[656.342,807.817],[656.342,910.51]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[765.495,318.076],[765.495,219.556],[708.053,318.789],[708.053,220.587]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[813.038,312.385],[813.038,211.33],[757.627,314.537],[757.627,214.44]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[854.061,310.975],[854.061,209.292],[813.038,312.385],[813.038,211.33]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[917.203,309.285],[917.203,206.849],[854.061,310.975],[854.061,209.292]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1179.09,432.011],[1179.09,326.228],[914.505,433.568],[914.505,329.321]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1179.09,553.693],[1179.09,447.91],[914.505,553.484],[914.505,449.237]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1179.09,565.813],[1179.09,671.596],[914.505,565.427],[914.505,669.674]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1179.09,690.524],[1179.09,796.307],[914.505,688.328],[914.505,792.575]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[921.949,309.224],[988.142,309.265],[921.949,206.761],[988.142,206.82]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[988.142,309.265],[1032.58,309.596],[988.142,206.82],[1032.58,207.298]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1032.58,309.596],[1094,310.29],[1032.58,207.298],[1094,208.302]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1094,310.29],[1094,208.302],[1096.62,313.964],[1096.62,213.612]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1156.61,313.219],[1096.62,313.964],[1156.61,212.535],[1096.62,213.612]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1156.61,313.219],[1156.61,212.535],[1217.47,318.087],[1217.47,219.571]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1179.09,432.011],[1179.09,326.228],[1248.75,433.888],[1248.75,329.957]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1179.09,553.693],[1179.09,447.91],[1248.75,553.44],[1248.75,449.509]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1179.09,565.813],[1179.09,671.596],[1248.75,565.348],[1248.75,669.279]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1179.09,690.524],[1179.09,796.307],[1248.75,687.877],[1248.75,791.808]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1217.47,318.087],[1217.47,219.571],[1261.46,324.978],[1261.46,229.531]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1248.99,436.81],[1295.67,436.548],[1248.99,335.761],[1295.67,335.241]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1248.99,553.047],[1295.67,553.082],[1248.99,451.998],[1295.67,451.775]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1248.99,564.624],[1295.67,564.689],[1248.99,665.673],[1295.67,665.996]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1248.99,683.755],[1295.67,684.124],[1248.99,784.804],[1295.67,785.431]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1261.46,324.978],[1261.46,229.531],[1302.35,335.015],[1302.35,244.04]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1293.57,442.162],[1370.18,441.756],[1293.57,346.392],[1370.18,345.586]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1293.57,552.326],[1293.57,456.556],[1370.18,552.381],[1370.18,456.211]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1293.57,563.299],[1370.18,563.399],[1293.57,659.069],[1370.18,659.569]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1293.57,676.206],[1370.18,676.778],[1293.57,771.976],[1370.18,772.948]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1300.66,335.482],[1300.66,244.713],[1321.25,345.189],[1321.25,258.745]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1370.18,441.756],[1370.18,345.586],[1402.33,446.43],[1402.33,354.87]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1370.18,552.381],[1370.18,456.211],[1402.33,551.752],[1402.33,460.192]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1370.18,563.399],[1370.18,659.569],[1402.33,562.242],[1402.33,653.802]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:43,
                    verts:[[1370.18,676.778],[1370.18,772.948],[1402.33,670.186],[1402.33,761.746]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[566.567,444.974],[566.568,351.977],[555.65,449.629],[555.65,361.224]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[566.567,551.948],[566.568,458.951],[555.65,551.321],[555.65,462.916]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[566.568,562.602],[566.567,655.599],[555.65,561.449],[555.65,649.854]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[566.568,672.24],[566.567,765.236],[555.65,665.673],[555.65,754.077]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[568.087,782.486],[568.087,875.493],[556.841,769.787],[556.841,857.939]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[639.308,444.824],[639.308,351.681],[566.567,444.974],[566.568,351.977]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[639.308,551.968],[639.308,458.824],[566.567,551.948],[566.568,458.951]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[639.308,562.639],[639.308,655.783],[566.568,562.602],[566.567,655.599]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[639.308,672.45],[639.308,765.593],[566.568,672.239],[566.567,765.236]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[640.534,782.869],[640.534,876.023],[568.088,782.486],[568.088,875.493]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[659.125,797.026],[612.782,796.767],[659.125,895.593],[612.782,895.235]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[659.325,439.387],[659.325,340.88],[614.671,439.484],[614.671,341.073]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[659.325,552.7],[659.325,454.193],[614.671,552.687],[614.671,454.276]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[659.325,563.986],[659.325,662.492],[614.671,563.962],[614.671,662.373]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[659.325,680.119],[659.325,778.626],[614.671,679.983],[614.671,778.394]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[642.535,341.035],[642.535,252.74],[641.557,350.611],[641.557,266.583]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[705.553,434.256],[705.553,330.688],[647.694,436.593],[647.694,335.329]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[705.553,553.391],[705.553,449.823],[647.694,553.076],[647.694,451.813]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[705.553,565.257],[705.553,668.825],[647.694,564.678],[647.694,665.941]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[705.553,687.358],[705.553,790.926],[647.694,684.061],[647.694,785.325]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[705.747,809.963],[705.747,913.477],[648.051,803.892],[648.051,905.084]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[670.53,330.344],[670.53,237.288],[650.623,340.569],[650.623,252.067]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[699.232,323.042],[699.233,226.733],[670.53,330.344],[670.53,237.288]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[747.851,317.365],[747.851,218.528],[699.232,323.042],[699.232,226.733]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[967.107,433.66],[967.107,329.504],[705.553,434.256],[705.553,330.687]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[967.107,553.471],[967.107,449.315],[705.553,553.391],[705.553,449.823]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[967.107,565.404],[967.107,669.56],[705.553,565.257],[705.553,668.825]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[967.107,688.198],[967.107,792.354],[705.553,687.358],[705.553,790.926]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[967.164,811.498],[967.164,915.599],[705.746,809.963],[705.746,913.477]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[806.507,317.083],[747.852,317.365],[806.507,218.121],[747.852,218.528]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[860.019,311.762],[860.019,210.429],[802.161,313.486],[802.161,212.921]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[902.526,310.672],[902.526,208.854],[860.019,311.762],[860.019,210.429]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[967.238,309.478],[967.238,207.127],[902.526,310.672],[902.526,208.854]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[968.619,433.657],[1233.18,433.054],[968.619,329.498],[1233.18,328.301]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[968.619,553.471],[968.619,449.312],[1233.18,553.553],[1233.18,448.799]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[968.619,565.405],[1233.18,565.555],[968.619,669.564],[1233.18,670.308]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[968.619,688.203],[1233.18,689.053],[968.619,792.362],[1233.18,793.806]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[972.025,309.454],[1037.73,310.005],[972.025,207.093],[1037.73,207.889]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1037.73,310.005],[1081.38,310.674],[1037.73,207.889],[1081.38,208.856]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1081.38,310.674],[1081.38,208.856],[1141.27,311.829],[1141.27,210.526]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1140.2,315.479],[1199.86,315.192],[1140.2,215.802],[1199.86,215.387]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1199.86,315.192],[1199.86,215.387],[1254.61,320.437],[1254.61,222.969]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1233.18,433.054],[1233.18,328.301],[1297.07,435.145],[1297.07,332.454]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1233.18,553.553],[1233.18,448.799],[1297.07,553.271],[1297.07,450.58]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1233.18,565.555],[1233.18,670.308],[1297.07,565.037],[1297.07,667.728]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1233.18,689.053],[1233.18,793.806],[1297.07,686.104],[1297.07,788.795]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1254.61,320.437],[1254.61,222.968],[1290.73,327.532],[1290.73,233.223]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1290.73,327.532],[1290.73,233.223],[1320.67,337.678],[1320.67,247.889]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1290.94,438.018],[1336.92,437.918],[1290.94,338.16],[1336.92,337.962]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1290.94,552.884],[1290.94,453.027],[1336.92,552.898],[1336.92,452.942]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1290.94,564.325],[1290.94,664.182],[1336.92,564.35],[1336.92,664.305]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1290.94,682.051],[1336.92,682.192],[1290.94,781.908],[1336.92,782.147]]
                },{
                    num:"603",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1318.57,338.125],[1318.57,248.533],[1329.06,347.794],[1329.06,262.512]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1322.69,443.423],[1322.69,348.897],[1397.84,443.269],[1397.84,348.591]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1322.69,552.156],[1322.69,457.631],[1397.84,552.177],[1397.84,457.499]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1322.69,562.986],[1322.69,657.512],[1397.84,563.025],[1397.84,657.702]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1322.69,674.427],[1322.69,768.953],[1397.84,674.644],[1397.84,769.322]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1397.84,443.269],[1397.84,348.591],[1418.8,447.946],[1418.8,357.881]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1397.84,552.177],[1397.84,457.499],[1418.8,551.547],[1418.8,461.483]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1397.84,563.025],[1397.84,657.702],[1418.8,561.866],[1418.8,651.931]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:44,
                    verts:[[1397.84,674.644],[1397.84,769.322],[1418.8,668.047],[1418.8,758.112]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[591.823,443.73],[591.824,349.507],[570.135,448.398],[570.135,358.78]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[591.823,552.115],[591.824,457.892],[570.135,551.486],[570.135,461.868]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[591.824,562.91],[591.823,657.133],[570.135,561.754],[570.135,651.372]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[591.824,673.994],[591.823,768.216],[570.135,667.408],[570.135,757.026]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[593.402,785.681],[593.402,879.91],[570.775,772.945],[570.775,862.304]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[666.361,443.816],[666.362,349.677],[591.823,443.73],[591.824,349.507]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[666.361,552.104],[666.362,457.965],[591.823,552.115],[591.824,457.892]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[666.362,562.889],[666.361,657.028],[591.824,562.91],[591.823,657.133]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[666.362,673.873],[666.361,768.011],[591.824,673.993],[591.823,768.216]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[667.633,785.461],[593.404,785.681],[667.633,879.606],[593.404,879.91]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[658.586,338.906],[658.586,249.662],[647.852,348.55],[647.852,263.604]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[698.87,799.556],[651.504,799.704],[698.87,899.09],[651.504,899.295]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[698.935,438.408],[653.299,438.352],[698.935,338.935],[653.299,338.825]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[698.935,552.832],[698.935,453.359],[653.299,552.839],[653.299,453.312]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[698.935,564.228],[698.935,663.701],[653.299,564.242],[653.299,663.77]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[698.935,681.501],[653.299,681.579],[698.935,780.974],[653.299,781.107]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[697.898,328.335],[697.898,234.384],[667.286,338.491],[667.286,249.064]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[757.311,433.41],[757.311,329.008],[693.402,435.555],[693.402,333.268]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[757.311,553.505],[757.311,449.103],[693.402,553.216],[693.402,450.929]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[757.311,565.466],[757.311,669.868],[693.402,564.935],[693.402,667.222]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[757.311,688.55],[757.311,792.952],[693.402,685.526],[693.402,787.813]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[757.384,812.141],[757.384,916.488],[693.602,806.565],[693.602,908.779]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[734.412,321.199],[734.412,224.07],[697.898,328.335],[697.898,234.384]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[789.321,315.862],[789.321,216.355],[734.411,321.199],[734.411,224.07]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1020.96,433.746],[757.311,433.41],[1020.96,329.676],[757.311,329.008]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1020.96,553.459],[757.311,553.505],[1020.96,449.389],[757.311,449.103]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1020.96,565.383],[757.311,565.466],[1020.96,669.454],[757.311,669.868]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1020.96,688.076],[757.311,688.55],[1020.96,792.147],[757.311,792.952]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1020.89,811.276],[757.384,812.141],[1020.89,915.291],[757.384,916.488]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[848.7,316.022],[789.322,315.862],[848.7,216.586],[789.322,216.355]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[907.752,311.106],[907.752,209.481],[847.954,312.387],[847.954,211.332]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[951.358,310.344],[907.752,311.106],[951.358,208.38],[907.752,209.481]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1017.04,309.652],[951.358,310.344],[1017.04,207.379],[951.358,208.38]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1021.82,309.665],[1021.82,207.398],[1086.44,310.717],[1086.44,208.919]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1022.47,433.748],[1022.47,329.679],[1284.43,434.082],[1284.43,330.342]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1022.47,553.459],[1022.47,449.39],[1284.43,553.414],[1284.43,449.675]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1022.47,565.382],[1022.47,669.451],[1284.43,565.3],[1284.43,669.039]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1022.47,688.074],[1022.47,792.142],[1284.43,687.603],[1284.43,791.342]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1086.44,310.717],[1086.44,208.919],[1128.9,311.714],[1128.9,210.36]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1128.9,311.714],[1128.9,210.36],[1186.74,313.313],[1186.74,212.671]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1182.07,316.919],[1240.89,317.077],[1182.07,217.883],[1240.89,218.111]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1240.89,317.077],[1240.89,218.111],[1289.23,322.655],[1289.23,226.175]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1284.43,434.082],[1284.43,330.342],[1342.14,436.364],[1342.14,334.875]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1284.43,553.414],[1284.43,449.675],[1342.14,553.107],[1342.14,451.618]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1284.43,565.3],[1284.43,669.039],[1342.14,564.735],[1342.14,666.224]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1284.43,687.603],[1284.43,791.342],[1342.14,684.384],[1342.14,785.873]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1289.24,322.655],[1289.24,226.175],[1317.46,329.907],[1317.46,236.656]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1317.46,329.907],[1317.46,236.656],[1336.61,340.107],[1336.61,251.4]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1329.92,439.173],[1329.92,340.455],[1374.82,439.228],[1374.82,340.564]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1329.92,552.729],[1329.92,454.011],[1374.82,552.721],[1374.82,454.057]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1329.92,564.039],[1329.92,662.757],[1374.82,564.026],[1374.82,662.69]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1329.92,680.422],[1329.92,779.139],[1374.82,680.345],[1374.82,779.009]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1349.03,444.599],[1349.03,351.233],[1422.22,444.683],[1422.22,351.4]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1349.03,551.998],[1349.03,458.632],[1422.22,551.987],[1422.22,458.704]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1349.03,562.695],[1349.03,656.061],[1422.22,562.674],[1422.22,655.957]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1349.03,672.768],[1349.03,766.133],[1422.22,672.649],[1422.22,765.932]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1422.22,444.683],[1422.22,351.4],[1432.34,449.339],[1432.34,360.649]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1422.22,551.987],[1422.22,458.704],[1432.34,551.36],[1432.34,462.67]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1422.22,562.674],[1422.22,655.957],[1432.34,561.521],[1432.34,650.211]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:45,
                    verts:[[1422.22,672.649],[1422.22,765.932],[1432.34,666.081],[1432.34,754.771]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[619.824,442.396],[619.826,346.857],[587.103,447.054],[587.103,356.11]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[619.824,552.295],[619.826,456.756],[587.103,551.667],[587.103,460.723]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[619.826,563.241],[619.824,658.78],[587.103,562.087],[587.103,653.031]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[619.826,675.875],[619.824,771.414],[587.103,669.305],[587.103,760.249]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[621.454,789.11],[621.454,884.65],[587.167,776.399],[587.167,867.078]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[695.652,442.728],[619.824,442.396],[695.652,347.516],[619.826,346.857]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[695.652,552.25],[695.652,457.038],[619.824,552.295],[619.826,456.756]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[695.652,563.159],[619.826,563.241],[695.652,658.37],[619.824,658.78]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[695.652,675.408],[619.826,675.875],[695.652,770.619],[619.824,771.414]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[696.96,788.258],[621.455,789.11],[696.96,883.472],[621.455,884.65]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[676.588,336.551],[676.588,246.258],[655.857,346.224],[655.857,260.242]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[727.272,326.158],[727.272,231.238],[685.861,336.192],[685.861,245.741]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[692.954,802.782],[740.958,802.208],[692.954,903.55],[740.958,902.757]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[694.636,437.166],[740.884,437.38],[694.637,336.469],[740.884,336.894]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[694.636,552.999],[740.884,552.97],[694.637,452.301],[740.884,452.484]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[694.637,564.536],[740.884,564.483],[694.636,665.233],[740.884,664.969]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[694.637,683.252],[740.884,682.951],[694.636,783.95],[740.884,783.437]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[741.669,434.483],[741.669,331.14],[740.884,437.38],[740.884,336.894]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[741.669,553.36],[741.669,450.016],[740.884,552.97],[740.884,452.484]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[741.669,565.201],[741.669,668.544],[740.884,564.483],[740.884,664.969]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[741.669,687.037],[741.669,790.38],[740.884,682.951],[740.884,783.437]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[811.172,432.552],[811.172,327.304],[741.669,434.483],[741.669,331.14]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[811.172,553.62],[811.172,448.372],[741.669,553.36],[741.669,450.016]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[811.172,565.679],[811.172,670.927],[741.669,565.2],[741.669,668.544]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[811.172,689.761],[811.172,795.009],[741.669,687.037],[741.669,790.38]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[811.12,814.353],[811.12,919.546],[741.707,809.325],[741.707,912.595]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[771.511,319.233],[771.511,221.229],[727.272,326.158],[727.272,231.238]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[832.379,314.276],[832.379,214.063],[771.51,319.234],[771.51,221.229]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[811.172,432.552],[811.172,327.304],[1074.37,433.832],[1074.37,329.845]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[811.172,553.62],[811.172,448.372],[1074.37,553.448],[1074.37,449.461]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[811.172,565.679],[811.172,670.927],[1074.37,565.362],[1074.37,669.348]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[811.172,689.761],[811.172,795.009],[1074.37,687.956],[1074.37,791.943]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[811.119,814.353],[811.119,919.546],[1074.18,811.057],[1074.18,914.988]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[832.38,314.276],[891.972,314.887],[832.38,214.063],[891.972,214.947]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[894.881,311.234],[894.881,209.667],[891.972,314.887],[891.972,214.947]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[956.097,310.411],[894.881,311.234],[956.097,208.477],[894.881,209.667]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1000.41,309.986],[956.097,310.411],[1000.41,207.862],[956.097,208.477]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1000.41,309.986],[1066.45,309.8],[1000.41,207.862],[1066.45,207.594]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1071.18,309.851],[1071.18,207.666],[1134.12,311.394],[1134.12,209.898]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1075.87,433.839],[1075.87,329.859],[1332.79,435.088],[1332.79,332.34]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1075.87,553.447],[1075.87,449.468],[1332.79,553.279],[1332.79,450.531]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1075.87,565.36],[1075.87,669.339],[1332.79,565.051],[1332.79,667.798]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1075.87,687.946],[1075.87,791.925],[1332.79,686.184],[1332.79,788.932]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1134.12,311.394],[1134.12,209.898],[1175.03,312.709],[1175.03,211.798]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1175.03,312.709],[1175.03,211.798],[1230.32,314.732],[1230.32,214.722]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1222.17,318.275],[1222.17,219.843],[1279.66,318.865],[1279.66,220.695]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1279.66,318.865],[1279.66,220.695],[1321.36,324.735],[1321.36,229.181]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1321.36,324.735],[1321.36,229.181],[1341.71,332.1],[1341.71,239.827]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1332.79,435.088],[1332.79,332.34],[1383.97,437.539],[1383.97,337.21]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1332.79,553.279],[1332.79,450.531],[1383.97,552.949],[1383.97,452.619]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1332.79,565.051],[1332.79,667.798],[1383.97,564.444],[1383.97,664.773]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1332.79,686.184],[1332.79,788.932],[1383.97,682.726],[1383.97,783.056]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1341.71,332.1],[1341.71,239.827],[1350.28,342.303],[1350.28,254.575]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1365.95,440.272],[1365.95,342.637],[1409.43,440.473],[1409.43,343.037]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1365.95,552.581],[1365.95,454.947],[1409.43,552.554],[1409.43,455.118]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1365.95,563.767],[1365.95,661.401],[1409.43,563.717],[1409.43,661.153]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1365.95,678.872],[1365.95,776.506],[1409.43,678.588],[1409.43,776.024]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1372.67,445.689],[1372.67,353.399],[1443.43,445.999],[1443.43,354.013]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1372.67,551.851],[1372.67,459.561],[1443.43,551.81],[1443.43,459.824]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1372.67,562.425],[1372.67,654.716],[1443.43,562.348],[1443.43,654.334]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:46,
                    verts:[[1372.67,671.23],[1372.67,763.521],[1443.43,670.794],[1443.43,762.779]]
                },
                ],
                [
                {
                    num:"505",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[650.651,440.971],[650.652,344.027],[606.662,445.593],[606.662,353.208]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[650.651,552.487],[650.652,455.542],[606.662,551.864],[606.662,459.479]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[650.652,563.594],[650.651,660.538],[606.662,562.449],[606.662,654.834]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[650.652,677.885],[650.651,774.83],[606.662,671.366],[606.662,763.751]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[652.318,792.771],[652.318,889.711],[606.123,780.156],[606.123,872.273]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[650.651,440.971],[727.214,441.561],[650.652,344.027],[727.214,345.199]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[650.651,552.487],[650.652,455.542],[727.214,552.407],[727.214,456.045]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[650.652,563.594],[650.651,660.538],[727.214,563.448],[727.214,659.81]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[650.652,677.885],[727.214,677.053],[650.651,774.829],[727.214,773.416]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[652.319,792.771],[728.549,791.256],[652.319,889.711],[728.549,887.616]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[665.64,343.626],[665.64,256.486],[658.171,354.273],[658.171,271.876]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[696.603,333.968],[696.603,242.524],[665.64,343.626],[665.64,256.486]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[758.671,323.815],[758.671,227.851],[706.407,333.669],[706.407,242.095]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[737.126,805.992],[737.126,907.987],[725,790.494],[725,886.564]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[738.676,435.929],[738.677,334.011],[727.214,441.561],[727.214,345.199]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[738.676,553.166],[738.677,451.247],[727.214,552.407],[727.214,456.045]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[738.677,564.842],[738.676,666.761],[727.214,563.448],[727.214,659.81]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[738.677,684.998],[738.676,786.916],[727.214,677.053],[727.214,773.416]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[737.126,805.992],[785.351,804.976],[737.126,907.987],[785.351,906.583]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[738.674,435.929],[785.135,436.307],[738.676,334.01],[785.135,334.763]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[738.674,553.166],[738.676,451.247],[785.135,553.115],[785.135,451.57]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[738.676,564.842],[738.674,666.761],[785.135,564.749],[785.135,666.293]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[738.676,684.998],[785.135,684.464],[738.674,786.916],[785.135,786.008]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[792.427,433.383],[792.427,328.954],[785.135,436.307],[785.135,334.763]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[792.427,553.508],[792.427,449.079],[785.135,553.115],[785.135,451.57]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[792.427,565.473],[792.427,669.902],[785.135,564.749],[785.135,666.293]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[792.427,688.589],[792.427,793.018],[785.135,684.464],[785.135,786.008]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[792.298,812.16],[792.298,916.515],[785.351,804.976],[785.351,906.583]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[866.996,431.686],[866.996,325.584],[792.427,433.383],[792.427,328.954]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[866.996,553.737],[866.996,447.634],[792.427,553.508],[792.427,449.079]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[866.996,565.893],[866.996,671.996],[792.427,565.473],[792.427,669.902]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[866.996,690.982],[866.996,797.085],[792.427,688.589],[792.427,793.018]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[866.817,816.586],[866.817,922.633],[792.298,812.16],[792.298,916.515]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[810.501,317.149],[810.501,218.216],[758.671,323.815],[758.671,227.851]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[876.945,312.614],[876.945,211.66],[810.5,317.149],[810.5,218.216]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[866.815,816.586],[866.815,922.633],[1126.85,810.836],[1126.85,914.683]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[866.996,431.686],[866.996,325.584],[1127.16,433.918],[1127.16,330.017]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[866.996,553.737],[866.996,447.634],[1127.16,553.436],[1127.16,449.535]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[866.996,565.893],[866.996,671.996],[1127.16,565.341],[1127.16,669.242]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[866.996,690.982],[866.996,797.085],[1127.16,687.834],[1127.16,791.736]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[876.946,312.613],[936.225,313.686],[876.946,211.66],[936.225,213.21]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[942.824,310.036],[942.824,207.934],[936.225,313.686],[936.225,213.21]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1004.91,309.684],[942.824,310.036],[1004.91,207.426],[942.824,207.934]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1004.91,309.684],[1049.52,309.602],[1004.91,207.426],[1049.52,207.307]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1049.52,309.602],[1115.3,309.927],[1049.52,207.306],[1115.3,207.777]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1119.94,310.014],[1119.94,207.902],[1180.63,312.038],[1180.63,210.828]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1128.62,433.931],[1128.62,330.042],[1378.15,436.071],[1378.15,334.293]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1128.62,553.435],[1128.62,449.546],[1378.15,553.146],[1378.15,451.369]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1128.62,565.337],[1128.62,669.226],[1378.15,564.807],[1378.15,666.585]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1128.62,687.816],[1128.62,791.705],[1378.15,684.797],[1378.15,786.575]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1180.63,312.038],[1180.63,210.829],[1219.63,313.659],[1219.63,213.171]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1219.63,313.659],[1219.63,213.171],[1271.92,316.088],[1271.92,216.682]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1260.39,319.549],[1260.39,221.685],[1316.11,320.557],[1316.11,223.142]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1316.11,320.557],[1316.11,223.142],[1350.97,326.679],[1350.97,231.99]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1350.98,326.679],[1350.98,231.99],[1363.48,334.117],[1363.48,242.741]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1378.15,436.071],[1378.15,334.293],[1422.5,438.671],[1422.5,339.458]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1378.15,553.146],[1378.15,451.369],[1422.5,552.796],[1422.5,453.583]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1378.15,564.807],[1378.15,666.585],[1422.5,564.163],[1422.5,663.376]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1378.15,684.797],[1378.15,786.575],[1422.5,681.13],[1422.5,780.342]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1399.01,441.314],[1399.01,344.709],[1440.76,441.655],[1440.76,345.385]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1399.01,552.44],[1399.01,455.835],[1440.76,552.395],[1440.76,456.125]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1399.01,563.509],[1399.01,660.114],[1440.76,563.424],[1440.76,659.694]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1399.01,677.401],[1399.01,774.007],[1440.76,676.921],[1440.76,773.191]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1393.64,446.695],[1393.64,355.398],[1461.57,447.219],[1461.57,356.437]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1393.64,551.716],[1393.64,460.418],[1461.57,551.645],[1461.57,460.864]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1393.64,562.176],[1393.64,653.474],[1461.57,562.046],[1461.57,652.828]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:47,
                    verts:[[1393.64,669.811],[1393.64,761.108],[1461.57,669.072],[1461.57,759.854]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[644.72,447.754],[644.72,354.464],[601.352,460.647],[601.352,380.503]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[644.72,555.065],[644.72,461.775],[601.352,552.836],[601.352,472.693]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[644.72,565.753],[644.72,659.042],[601.352,562.019],[601.352,642.162]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[644.72,675.735],[644.72,769.025],[601.352,656.503],[601.352,736.647]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[644.72,783.223],[644.72,876.513],[601.352,748.845],[601.352,828.989]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[684.413,439.461],[684.414,341.026],[628.967,444.017],[628.967,350.076]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[684.413,552.69],[684.414,454.256],[628.967,552.076],[628.967,458.136]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[684.414,563.968],[684.413,662.402],[628.967,562.839],[628.967,656.78]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[684.414,680.016],[684.413,778.45],[628.967,673.589],[628.967,767.53]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[686.107,796.653],[686.107,895.077],[627.799,784.214],[627.799,877.883]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[677.316,340.754],[677.316,252.335],[658.849,351.524],[658.849,267.903]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[718.728,331.161],[718.728,238.467],[677.316,340.754],[677.316,252.335]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[684.413,439.461],[684.413,341.026],[761.103,440.321],[761.104,342.736]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[684.413,552.69],[684.413,454.256],[761.103,552.574],[761.104,454.989]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[684.413,563.968],[684.413,662.402],[761.104,563.755],[761.103,661.34]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[684.413,680.016],[684.413,778.45],[761.104,678.802],[761.103,776.387]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[686.107,796.653],[762.456,794.442],[686.107,895.077],[762.456,892.021]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[792.134,321.317],[792.134,224.241],[729.012,330.928],[729.012,238.132]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[784.025,809.31],[784.025,912.574],[758.185,793.701],[758.185,890.997]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[785.422,434.649],[785.423,331.468],[761.103,440.321],[761.104,342.736]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[785.422,553.338],[785.423,450.157],[761.103,552.574],[761.104,454.989]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[785.423,565.159],[785.422,668.34],[761.104,563.755],[761.103,661.34]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[785.423,686.803],[785.422,789.984],[761.104,678.802],[761.103,776.387]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[784.024,809.31],[832.022,807.836],[784.024,912.574],[832.022,910.537]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[785.421,434.649],[785.422,331.468],[831.661,435.199],[831.661,332.561]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[785.421,553.338],[785.422,450.157],[831.661,553.264],[831.661,450.626]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[785.422,565.159],[785.421,668.34],[831.661,565.023],[831.661,667.661]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[785.422,686.803],[785.421,789.984],[831.661,686.027],[831.661,788.665]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[845.612,432.265],[845.612,326.732],[831.661,435.199],[831.661,332.561]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[845.612,553.659],[845.612,448.127],[831.661,553.264],[831.661,450.626]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[845.612,565.75],[845.612,671.282],[831.661,565.023],[831.661,667.661]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[845.612,690.166],[845.612,795.699],[831.661,686.027],[831.661,788.665]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[845.31,815.045],[845.31,920.502],[832.022,807.836],[832.022,910.537]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[924.64,430.824],[924.64,323.87],[845.612,432.265],[845.612,326.732]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[924.64,553.853],[924.64,446.9],[845.612,553.659],[845.612,448.127]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[924.64,566.107],[924.64,673.06],[845.612,565.75],[845.612,671.282]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[924.64,692.199],[924.64,799.152],[845.612,690.166],[845.612,795.699]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[924.331,818.812],[924.331,925.709],[845.31,815.045],[845.31,920.502]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[851.366,314.962],[851.366,215.054],[792.134,321.317],[792.134,224.241]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[922.942,310.893],[922.942,209.173],[851.365,314.962],[851.365,215.054]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[922.943,310.893],[922.943,209.174],[981.357,312.435],[981.357,211.401]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[924.64,430.824],[924.64,323.87],[1179.11,434.013],[1179.11,330.204]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[924.64,553.853],[924.64,446.9],[1179.11,553.424],[1179.11,449.615]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[924.64,566.107],[924.64,673.06],[1179.11,565.317],[1179.11,669.125]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[924.64,692.199],[924.64,799.152],[1179.11,687.701],[1179.11,791.509]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[924.33,818.812],[924.33,925.709],[1178.68,810.594],[1178.68,914.35]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[991.654,308.81],[991.654,206.163],[981.357,312.435],[981.357,211.401]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[991.654,308.81],[1054.03,308.943],[991.654,206.163],[1054.03,206.355]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1054.03,308.943],[1098.52,309.209],[1054.03,206.355],[1098.52,206.739]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1098.52,309.209],[1098.52,206.739],[1163.43,310.048],[1163.43,207.951]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1167.93,310.17],[1167.93,208.129],[1225.81,312.663],[1225.81,211.731]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1180.53,434.03],[1180.53,330.24],[1420.38,437.036],[1420.38,336.21]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1180.53,553.421],[1180.53,449.631],[1420.38,553.017],[1420.38,452.191]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1180.53,565.313],[1180.53,669.103],[1420.38,564.568],[1420.38,665.394]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1180.53,687.676],[1180.53,791.466],[1420.38,683.436],[1420.38,784.262]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1225.81,312.663],[1225.81,211.731],[1262.55,314.578],[1262.55,214.499]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1262.55,314.578],[1262.55,214.499],[1311.41,317.392],[1311.41,218.567]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1296.65,320.754],[1296.65,223.426],[1350.14,322.165],[1350.14,225.467]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1350.14,322.165],[1350.14,225.467],[1378.03,328.499],[1378.03,234.621]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1378.03,328.499],[1378.03,234.621],[1382.78,335.969],[1382.78,245.419]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1420.38,437.036],[1420.38,336.21],[1457.69,439.764],[1457.69,341.629]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1420.38,553.017],[1420.38,452.191],[1457.69,552.649],[1457.69,454.514]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1420.38,564.568],[1420.38,665.394],[1457.69,563.893],[1457.69,662.027]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1420.38,683.436],[1420.38,784.262],[1457.69,679.588],[1457.69,777.723]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1429.05,442.306],[1429.05,346.679],[1468.78,442.779],[1468.78,347.618]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1429.05,552.307],[1429.05,456.68],[1468.78,552.243],[1468.78,457.082]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1429.05,563.263],[1429.05,658.89],[1468.78,563.146],[1468.78,658.307]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1429.05,676.002],[1429.05,771.629],[1468.78,675.335],[1468.78,770.496]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1411.94,447.624],[1411.94,357.243],[1476.64,448.35],[1476.64,358.685]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1411.94,551.591],[1411.94,461.209],[1476.64,551.493],[1476.64,461.828]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1411.94,561.946],[1411.94,652.327],[1476.64,561.766],[1476.64,651.431]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:48,
                    verts:[[1411.94,668.5],[1411.94,758.882],[1476.64,667.476],[1476.64,757.142]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[668.845,446.187],[668.845,351.3],[594.194,459.214],[594.194,377.61]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[668.845,555.335],[668.845,460.449],[594.194,553.084],[594.194,471.48]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[668.845,566.207],[668.845,661.093],[594.194,562.433],[594.194,644.038]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[668.845,678.072],[668.845,772.959],[594.194,658.64],[594.194,740.245]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[668.845,787.401],[668.845,882.287],[594.194,752.665],[594.194,834.269]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[721.232,437.875],[721.233,337.877],[654.198,442.331],[654.198,346.728]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[721.232,552.904],[721.233,452.905],[654.198,552.303],[654.198,456.701]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[721.233,564.36],[721.232,664.359],[654.198,563.257],[654.198,658.86]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[721.233,682.252],[721.232,782.251],[654.198,675.967],[654.198,771.57]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[661.138,348.463],[661.138,263.478],[657.103,357.429],[657.103,276.438]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[691.021,337.615],[691.021,247.798],[661.138,348.463],[661.138,263.478]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[722.938,800.727],[722.938,900.709],[652.376,788.558],[652.376,883.887]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[743.073,328.145],[743.073,234.108],[691.021,337.615],[691.021,247.798]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[721.232,437.875],[721.233,337.877],[797.379,439.019],[797.379,340.149]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[721.232,552.904],[721.233,452.905],[797.379,552.749],[797.379,453.88]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[721.233,564.36],[721.232,664.359],[797.379,564.077],[797.379,662.947]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[721.233,682.252],[721.232,782.251],[797.379,680.639],[797.379,779.509]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[722.939,800.727],[722.939,900.709],[798.739,797.789],[798.739,896.648]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[827.695,318.689],[827.695,220.442],[753.78,327.983],[753.78,233.876]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[833.638,812.698],[833.638,917.257],[793.752,797.074],[793.752,895.66]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[834.862,433.342],[834.862,328.873],[797.379,439.019],[797.379,340.149]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[834.862,553.514],[834.862,449.044],[797.379,552.749],[797.379,453.879]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[834.862,565.483],[834.862,669.953],[797.379,564.077],[797.379,662.947]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[834.862,688.647],[834.862,793.116],[797.379,680.639],[797.379,779.509]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[833.637,812.698],[880.924,810.75],[833.637,917.257],[880.924,914.564]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[834.861,433.342],[834.862,328.872],[880.415,434.069],[880.415,330.317]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[834.861,553.514],[834.862,449.044],[880.415,553.416],[880.415,449.664]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[834.862,565.483],[834.861,669.953],[880.415,565.303],[880.415,669.055]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[834.862,688.647],[834.861,793.116],[880.415,687.621],[880.415,791.373]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[901.122,431.145],[901.122,324.508],[880.415,434.069],[880.415,330.317]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[901.122,553.81],[901.122,447.173],[880.415,553.416],[880.415,449.664]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[901.122,566.027],[901.122,672.664],[880.415,565.303],[880.415,669.055]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[901.122,691.746],[901.122,798.382],[880.415,687.621],[880.415,791.373]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[900.645,817.933],[900.645,924.494],[880.924,810.75],[880.924,914.564]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[894.071,312.7],[894.07,211.785],[827.695,318.689],[827.695,220.442]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[970.261,309.146],[970.261,206.648],[894.07,312.7],[894.07,211.786]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[983.475,820.984],[983.475,928.711],[900.645,817.933],[900.645,924.494]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[983.913,429.982],[983.913,322.199],[901.122,431.145],[901.122,324.508]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[983.913,553.966],[983.913,446.183],[901.122,553.81],[901.122,447.173]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[983.913,566.315],[983.913,674.099],[901.122,566.027],[901.122,672.664]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[983.913,693.386],[983.913,801.169],[901.122,691.746],[901.122,798.382]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[970.262,309.146],[970.262,206.648],[1027.23,311.163],[1027.23,209.563]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[983.474,820.984],[983.474,928.711],[1229.43,810.301],[1229.43,913.944]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[983.913,429.982],[983.913,322.199],[1229.97,434.128],[1229.97,330.433]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[983.913,553.966],[983.913,446.183],[1229.97,553.408],[1229.97,449.714]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[983.913,566.315],[983.913,674.099],[1229.97,565.289],[1229.97,668.983]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[983.913,693.385],[983.913,801.169],[1229.97,687.538],[1229.97,791.233]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1041.21,307.588],[1041.21,204.396],[1027.23,311.163],[1027.23,209.563]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1041.21,307.588],[1103.28,308.218],[1041.21,204.396],[1103.28,205.306]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1103.28,308.218],[1147.21,308.836],[1103.28,205.306],[1147.21,206.201]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1147.21,308.836],[1147.21,206.2],[1210.61,310.188],[1210.61,208.154]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1214.93,310.346],[1214.93,208.383],[1269.45,313.291],[1269.45,212.639]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1231.33,434.151],[1231.33,330.478],[1459.31,437.991],[1459.31,338.107]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1231.33,553.405],[1231.33,449.733],[1459.31,552.888],[1459.31,453.004]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1231.33,565.283],[1231.33,668.955],[1459.31,564.332],[1459.31,664.215]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1231.33,687.506],[1231.33,791.178],[1459.31,682.089],[1459.31,781.973]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1269.45,313.291],[1269.45,212.639],[1303.61,315.487],[1303.61,215.813]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1303.61,315.487],[1303.61,215.813],[1348.62,318.666],[1348.62,220.408]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1330.79,321.909],[1330.79,225.096],[1381.64,323.709],[1381.64,227.698]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1381.64,323.709],[1381.64,227.698],[1402.44,330.214],[1402.44,237.1]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1459.31,437.991],[1459.31,338.107],[1489.41,440.826],[1489.41,343.739]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1459.31,552.888],[1459.31,453.004],[1489.41,552.506],[1489.41,455.419]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1459.31,564.332],[1459.31,664.215],[1489.41,563.63],[1489.41,660.716]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1459.31,682.089],[1459.31,781.973],[1489.41,678.089],[1489.41,775.176]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1455.98,443.256],[1455.98,348.566],[1493.43,443.854],[1493.43,349.753]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1455.98,552.179],[1455.98,457.489],[1493.43,552.098],[1493.43,457.998]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1455.98,563.028],[1455.98,657.718],[1493.43,562.88],[1493.43,656.98]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:49,
                    verts:[[1455.98,674.662],[1455.98,769.353],[1493.43,673.819],[1493.43,767.92]]
                },
                ],
                [
                {
                    num:"506",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[695.9,444.527],[695.9,347.947],[588.648,457.622],[588.648,374.394]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[695.9,555.622],[695.9,459.043],[588.648,553.359],[588.648,470.132]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[695.9,566.687],[695.9,663.267],[588.648,562.895],[588.648,646.122]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[695.9,680.549],[695.9,777.128],[588.648,661.015],[588.648,744.243]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[695.9,791.828],[695.9,888.407],[588.648,756.91],[588.648,840.138]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[665.2,345.095],[665.2,258.61],[651.869,354.228],[651.869,271.811]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[706.912,334.226],[706.912,242.899],[665.199,345.095],[665.199,258.61]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[761.211,436.232],[761.212,334.613],[682.549,440.548],[682.549,343.186]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[761.211,553.125],[761.212,451.506],[682.549,552.544],[682.549,455.182]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[761.212,564.767],[761.211,666.386],[682.549,563.698],[682.549,661.06]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[761.212,684.57],[761.211,786.189],[682.549,678.482],[682.549,775.844]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[762.914,804.949],[762.914,906.545],[680.05,793.158],[680.05,890.246]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[769.745,324.946],[769.745,229.485],[706.912,334.226],[706.912,242.899]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[761.211,436.232],[761.212,334.613],[836.07,437.671],[836.071,337.472]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[761.211,553.125],[761.212,451.506],[836.07,552.931],[836.071,452.732]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[761.212,564.767],[761.211,666.386],[836.071,564.411],[836.07,664.61]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[761.212,684.57],[761.211,786.189],[836.071,682.54],[836.07,782.74]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[762.915,804.949],[762.915,906.545],[837.424,801.253],[837.424,901.437]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[865.362,315.966],[865.362,216.507],[780.808,324.862],[780.808,229.364]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[885.896,816.096],[885.896,921.955],[831.735,800.571],[831.735,900.493]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[886.928,432.031],[886.929,326.268],[836.07,437.671],[836.071,337.472]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[886.928,553.69],[886.929,447.928],[836.07,552.931],[836.071,452.732]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[886.929,565.808],[886.928,671.571],[836.071,564.411],[836.07,664.61]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[886.929,690.496],[886.928,796.259],[836.071,682.54],[836.07,782.74]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[885.895,816.096],[885.895,921.955],[931.946,813.66],[931.946,918.588]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[886.927,432.031],[886.928,326.268],[931.291,432.94],[931.291,328.074]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[886.927,553.69],[886.928,447.928],[931.291,553.568],[931.291,448.702]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[886.928,565.808],[886.927,671.571],[931.291,565.583],[931.291,670.449]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[886.928,690.496],[886.927,796.259],[931.291,689.214],[931.291,794.08]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[958.788,430.049],[958.788,322.331],[931.291,432.94],[931.291,328.074]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[958.788,553.957],[958.788,446.24],[931.291,553.568],[931.291,448.702]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[958.788,566.299],[958.788,674.017],[931.291,565.583],[931.291,670.449]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[958.788,693.292],[958.788,801.01],[931.291,689.214],[931.291,794.08]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[938.534,310.407],[938.534,208.47],[865.362,315.966],[865.362,216.507]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[958.135,820.762],[958.135,928.405],[931.946,813.66],[931.946,918.588]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1018.73,307.416],[1018.73,204.147],[938.533,310.407],[938.533,208.47]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1043.98,823.039],[1043.98,931.553],[958.135,820.762],[958.135,928.405]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1044.54,429.187],[1044.54,320.618],[958.788,430.049],[958.788,322.331]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1044.54,554.073],[1044.54,445.505],[958.788,553.957],[958.788,446.24]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1044.54,566.512],[1044.54,675.081],[958.788,566.299],[958.788,674.016]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1044.54,694.508],[1044.54,803.077],[958.788,693.292],[958.788,801.01]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1018.73,307.416],[1018.73,204.147],[1073.66,309.912],[1073.66,207.755]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1044.54,429.187],[1044.54,320.618],[1279.43,434.28],[1279.43,330.736]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1044.54,554.073],[1044.54,445.505],[1279.43,553.388],[1279.43,449.843]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1044.54,566.512],[1044.54,675.081],[1279.43,565.251],[1279.43,668.795]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1044.54,694.508],[1044.54,803.076],[1279.43,687.323],[1279.43,790.868]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1043.98,823.039],[1043.98,931.553],[1278.78,809.913],[1278.78,913.407]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1091.25,306.414],[1091.25,202.699],[1073.66,309.912],[1073.66,207.755]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1091.25,306.414],[1091.25,202.699],[1152.38,307.549],[1152.38,204.339]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1152.38,307.549],[1152.38,204.339],[1195.3,308.523],[1195.3,205.748]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1195.3,308.523],[1195.3,205.748],[1256.56,310.385],[1256.56,208.438]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1260.66,310.578],[1260.66,208.717],[1311.28,313.956],[1311.28,213.601]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1280.72,434.308],[1280.72,330.791],[1494.71,438.948],[1494.71,340.009]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1280.72,553.384],[1280.72,449.867],[1494.71,552.759],[1494.71,453.82]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1280.72,565.244],[1280.72,668.761],[1494.71,564.095],[1494.71,663.034]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1280.72,687.284],[1280.72,790.801],[1494.71,680.738],[1494.71,779.678]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1311.28,313.956],[1311.28,213.601],[1342.54,316.418],[1342.54,217.159]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1342.54,316.418],[1342.54,217.159],[1383.33,319.937],[1383.33,222.245]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1362.61,323.043],[1362.61,226.736],[1410.41,325.216],[1410.41,229.876]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:50,
                    verts:[[1410.41,325.216],[1410.41,229.876],[1424.06,331.85],[1424.06,239.465]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[569.833,452.8],[569.833,367.524],[566.82,456.787],[566.821,375.444]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[569.833,550.894],[569.833,465.617],[566.82,550.357],[566.821,469.014]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[569.833,560.664],[569.833,645.94],[566.821,559.676],[566.82,641.02]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[569.833,661.2],[569.833,746.476],[566.821,655.575],[566.82,736.919]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[726.073,442.79],[726.073,344.44],[584.949,455.872],[584.949,370.859]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[726.073,555.922],[726.073,457.573],[584.949,553.662],[584.949,468.649]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[726.073,567.19],[726.073,665.54],[584.949,563.402],[584.949,648.414]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[726.073,683.139],[726.073,781.489],[584.949,663.626],[584.949,748.638]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[726.073,796.458],[726.073,894.808],[584.949,761.577],[584.949,846.59]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[671.235,341.435],[671.235,253.32],[648.135,350.695],[648.135,266.704]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[725.168,330.613],[725.168,237.677],[671.234,341.435],[671.234,253.32]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[804.427,434.556],[804.428,331.284],[714.219,438.686],[714.219,339.487]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[804.427,553.35],[804.428,450.079],[714.219,552.794],[714.219,453.596]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[804.428,565.182],[804.427,668.454],[714.219,564.16],[714.219,663.358]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[804.428,686.934],[804.427,790.206],[714.219,681.109],[714.219,780.307]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[798.852,321.604],[798.852,224.654],[725.168,330.613],[725.168,237.676]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[806.109,809.254],[806.109,912.496],[711.025,797.966],[711.025,896.893]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[804.427,434.556],[804.427,331.284],[877.176,436.301],[877.177,334.75]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[804.427,553.35],[804.427,450.079],[877.176,553.115],[877.177,451.565]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[804.427,565.182],[804.427,668.454],[877.177,564.75],[877.176,666.301]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[804.427,686.934],[804.427,790.206],[877.177,684.473],[877.176,786.023]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[806.109,809.254],[806.109,912.496],[878.511,804.774],[878.511,906.303]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[905.108,313.2],[905.108,212.507],[810.193,321.604],[810.193,224.655]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[940.665,819.426],[940.665,926.558],[872.143,804.131],[872.143,905.415]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[941.484,430.746],[941.484,323.715],[877.176,436.301],[877.177,334.75]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[941.484,553.864],[941.484,446.833],[877.176,553.115],[877.177,451.565]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[941.484,566.126],[941.484,673.157],[877.177,564.75],[877.176,666.301]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[941.484,692.309],[941.484,799.339],[877.177,684.473],[877.176,786.023]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[940.664,819.426],[940.664,926.558],[984.916,816.494],[984.916,922.505]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[941.483,430.746],[941.484,323.715],[984.114,431.84],[984.114,325.888]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[941.483,553.863],[941.484,446.833],[984.114,553.716],[984.114,447.765]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[941.484,566.126],[941.483,673.157],[984.114,565.855],[984.114,671.806]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[941.484,692.309],[941.483,799.339],[984.114,690.766],[984.114,796.717]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[984.621,308.137],[984.62,205.189],[905.108,313.2],[905.108,212.507]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1068.13,305.76],[1068.13,201.754],[984.62,308.137],[984.62,205.189]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1018.35,429.008],[1018.35,320.263],[984.114,431.84],[984.114,325.888]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1018.35,554.098],[1018.35,445.353],[984.114,553.716],[984.114,447.765]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1018.35,566.557],[1018.35,675.301],[984.114,565.855],[984.114,671.807]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1018.35,694.76],[1018.35,803.505],[984.114,690.766],[984.114,796.717]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1017.52,823.451],[1017.52,932.122],[984.916,816.494],[984.916,922.505]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1105.48,824.898],[1017.52,823.451],[1105.48,934.123],[1017.52,932.122]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1106.17,428.468],[1018.35,429.008],[1106.17,319.19],[1018.35,320.263]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1106.17,554.17],[1106.17,444.893],[1018.35,554.097],[1018.35,445.353]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1106.17,566.69],[1106.17,675.968],[1018.35,566.557],[1018.35,675.301]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1106.17,695.523],[1018.35,694.76],[1106.17,804.8],[1018.35,803.505]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1068.13,305.76],[1068.13,201.754],[1120.38,308.735],[1120.38,206.053]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1105.48,824.898],[1105.48,934.123],[1326.33,809.375],[1326.33,912.664]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1106.17,428.467],[1106.17,319.19],[1327.09,434.491],[1327.09,331.154]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1106.17,554.17],[1106.17,444.892],[1327.09,553.359],[1327.09,450.023]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1106.17,566.69],[1106.17,675.968],[1327.09,565.199],[1327.09,668.535]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1106.17,695.522],[1106.17,804.8],[1327.09,687.026],[1327.09,790.363]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1141.5,305.342],[1141.5,201.15],[1120.38,308.735],[1120.38,206.053]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1141.5,305.342],[1141.5,201.15],[1201.01,306.988],[1201.01,203.529]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1201.01,306.988],[1201.01,203.529],[1242.47,308.318],[1242.47,205.451]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1242.47,308.318],[1242.47,205.451],[1300.93,310.682],[1300.93,208.868]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1304.76,310.909],[1304.76,209.196],[1350.98,314.699],[1350.98,214.674]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1328.29,434.523],[1328.29,331.219],[1526.3,439.922],[1526.3,341.943]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1328.29,553.355],[1328.29,450.051],[1526.3,552.628],[1526.3,454.649]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1328.29,565.19],[1328.29,668.495],[1526.3,563.853],[1526.3,661.832]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1328.29,686.98],[1328.29,790.284],[1526.3,679.365],[1526.3,777.344]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1350.98,314.699],[1350.98,214.674],[1379.05,317.408],[1379.05,218.59]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1379.05,317.408],[1379.05,218.59],[1415.27,321.24],[1415.27,224.13]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1391.86,324.19],[1391.86,228.393],[1436.23,326.716],[1436.23,232.045]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:51,
                    verts:[[1436.23,326.716],[1436.23,232.045],[1442.71,333.436],[1442.71,241.757]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[568.376,450.776],[568.376,363.503],[556.092,454.87],[556.092,371.636]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[568.376,551.166],[568.376,463.894],[556.092,550.615],[556.092,467.381]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[568.376,561.165],[568.376,648.438],[556.092,560.151],[556.092,643.386]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[568.376,664.055],[568.376,751.327],[556.092,658.28],[556.092,741.514]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[759.524,441.002],[759.524,340.829],[583.384,453.968],[583.384,367.015]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[759.524,556.231],[759.524,456.059],[583.384,553.991],[583.384,467.037]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[759.524,567.708],[759.524,667.881],[583.384,563.953],[583.384,650.906]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[759.524,685.806],[759.524,785.979],[583.384,666.466],[583.384,753.419]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[759.524,801.226],[759.524,901.398],[583.384,766.653],[583.384,853.606]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[655.696,347.328],[655.696,261.838],[643.268,356.103],[643.268,274.521]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[679.474,337.508],[679.474,247.644],[646.127,346.845],[646.127,261.139]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[745.969,326.816],[745.969,232.189],[679.473,337.508],[679.473,247.644]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[830.469,318.173],[830.469,219.693],[745.969,326.816],[745.969,232.189]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[850.885,432.881],[850.885,327.958],[749.381,436.772],[749.381,335.686]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[850.885,553.576],[850.885,448.652],[749.381,553.052],[749.381,451.966]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[850.885,565.597],[850.885,670.521],[749.381,564.634],[749.381,665.72]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[850.885,689.296],[850.885,794.22],[749.381,683.808],[749.381,784.895]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[852.526,813.556],[852.526,918.443],[745.478,802.916],[745.478,903.735]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[946.839,310.454],[946.838,208.539],[841.993,318.262],[841.992,219.825]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[850.885,432.881],[850.885,327.958],[920.624,434.94],[920.624,332.047]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[850.885,553.576],[850.885,448.652],[920.624,553.299],[920.624,450.405]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[850.885,565.597],[850.885,670.521],[920.624,565.087],[920.624,667.981]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[850.885,689.296],[850.885,794.22],[920.624,686.393],[920.624,789.286]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[852.527,813.556],[852.527,918.443],[921.924,808.271],[921.924,911.137]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[997.694,822.59],[997.694,930.932],[914.911,807.677],[914.911,910.317]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[998.281,429.525],[998.282,321.289],[920.624,434.94],[920.624,332.047]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[998.281,554.028],[998.282,445.793],[920.624,553.299],[920.624,450.405]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[998.282,566.429],[998.281,674.664],[920.624,565.087],[920.624,667.981]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[998.282,694.031],[998.281,802.267],[920.624,686.392],[920.624,789.286]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[997.693,822.59],[997.693,930.932],[1039.55,819.159],[1039.55,926.189]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[998.281,429.524],[998.281,321.289],[1038.6,430.805],[1038.6,323.832]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[998.281,554.028],[998.281,445.793],[1038.6,553.856],[1038.6,446.883]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[998.281,566.429],[998.281,674.664],[1038.6,566.112],[1038.6,673.084]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[998.281,694.031],[998.281,802.267],[1038.6,692.226],[1038.6,799.198]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1032.11,305.961],[1032.11,202.044],[946.839,310.454],[946.838,208.539]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1118.12,304.248],[1032.11,305.961],[1118.12,199.568],[1032.11,202.044]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1079.43,428.061],[1079.43,318.383],[1038.6,430.805],[1038.6,323.832]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1079.43,554.225],[1079.43,444.546],[1038.6,553.856],[1038.6,446.883]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1079.43,566.791],[1079.43,676.47],[1038.6,566.112],[1038.6,673.084]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1079.43,696.096],[1079.43,805.774],[1038.6,692.226],[1038.6,799.198]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1078.43,825.899],[1078.43,935.506],[1039.55,819.159],[1039.55,926.189]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1078.43,825.899],[1167.48,826.465],[1078.43,935.506],[1167.48,936.288]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1079.43,428.061],[1168.29,427.862],[1079.43,318.383],[1168.29,317.987]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1079.43,554.225],[1079.43,444.546],[1168.29,554.252],[1168.29,444.377]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1079.43,566.791],[1168.29,566.84],[1079.43,676.47],[1168.29,676.715]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1079.43,696.096],[1168.29,696.376],[1079.43,805.774],[1168.29,806.251]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1118.12,304.248],[1118.12,199.568],[1167.05,307.695],[1167.05,204.55]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1191.53,304.44],[1191.53,199.846],[1167.05,307.695],[1167.05,204.55]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1167.48,826.465],[1167.48,936.288],[1371.62,808.626],[1371.62,911.629]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1168.29,427.862],[1168.29,317.987],[1372.48,434.784],[1372.48,331.736]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1168.29,554.252],[1168.29,444.377],[1372.48,553.32],[1372.48,450.272]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1168.29,566.84],[1168.29,676.715],[1372.48,565.126],[1372.48,668.174]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1168.29,696.376],[1168.29,806.251],[1372.48,686.613],[1372.48,789.661]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1191.53,304.44],[1191.53,199.846],[1248.75,306.597],[1248.75,202.963]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1248.75,306.597],[1248.75,202.963],[1288.27,308.279],[1288.27,205.395]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1288.27,308.279],[1288.27,205.394],[1343.29,311.133],[1343.29,209.52]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1346.82,311.391],[1346.82,209.893],[1388.15,315.565],[1388.15,215.926]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1373.58,434.821],[1373.58,331.81],[1553.75,440.928],[1553.75,343.941]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1373.58,553.315],[1373.58,450.304],[1553.75,552.492],[1553.75,455.506]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1373.58,565.117],[1373.58,668.128],[1553.75,563.604],[1553.75,660.591]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1373.58,686.561],[1373.58,789.571],[1553.75,677.946],[1553.75,774.933]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1388.15,315.565],[1388.15,215.926],[1412.76,318.5],[1412.76,220.168]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1412.76,318.5],[1412.76,220.168],[1444.09,322.615],[1444.09,226.117]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:52,
                    verts:[[1418.24,325.388],[1418.24,230.125],[1458.82,328.247],[1458.82,234.257]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[569.519,448.6],[569.519,359.181],[547.309,452.782],[547.309,367.487]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[569.519,551.459],[569.519,462.04],[547.309,550.896],[547.309,465.602]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[569.519,561.704],[569.519,651.123],[547.309,560.669],[547.309,645.963]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[569.519,667.124],[569.519,756.543],[547.309,661.226],[547.309,746.52]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[796.363,439.196],[796.363,337.181],[584.299,451.921],[584.299,362.881]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[796.363,556.543],[796.363,454.529],[584.299,554.344],[584.299,465.304]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[796.363,568.232],[796.363,670.246],[584.299,564.546],[584.299,653.586]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[796.363,688.501],[796.363,790.515],[584.299,669.519],[584.299,758.559]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[796.363,806.042],[796.363,908.057],[584.299,772.111],[584.299,861.151]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[633.488,352.196],[633.488,268.874],[631.042,358.178],[631.042,277.521]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[655.455,343.267],[655.455,255.967],[633.488,352.196],[633.488,268.874]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[690.169,333.352],[690.169,241.636],[646.112,342.701],[646.112,255.149]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[769.479,322.892],[769.479,226.517],[690.168,333.352],[690.168,241.636]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[864.614,314.721],[864.614,214.705],[769.479,322.892],[769.479,226.517]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[900.488,431.25],[900.488,324.716],[788.154,434.842],[788.154,331.851]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[900.488,553.796],[900.488,447.262],[788.154,553.312],[788.154,450.322]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[900.488,566.001],[900.488,672.535],[788.154,565.112],[788.154,668.102]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[900.488,691.598],[900.488,798.131],[788.154,686.531],[788.154,789.522]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[902.066,817.746],[902.066,924.236],[783.537,807.915],[783.537,910.646]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[990.364,307.81],[990.364,204.717],[876.214,314.908],[876.213,214.976]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[900.488,431.25],[900.488,324.716],[966.243,433.626],[966.244,329.436]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[900.488,553.796],[900.488,447.262],[966.243,553.476],[966.244,449.286]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[900.488,566.001],[900.488,672.535],[966.244,565.413],[966.243,669.603]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[900.488,691.598],[900.488,798.131],[966.244,688.246],[966.243,792.436]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[902.067,817.746],[902.067,924.236],[967.492,811.647],[967.492,915.804]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1056.59,825.469],[1056.59,934.913],[959.883,811.111],[959.883,915.063]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1056.92,428.413],[1056.92,319.081],[966.243,433.626],[966.244,329.436]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1056.92,554.178],[1056.92,444.846],[966.243,553.476],[966.244,449.286]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1056.92,566.704],[1056.92,676.036],[966.244,565.413],[966.243,669.602]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1056.92,695.6],[1056.92,804.932],[966.244,688.246],[966.243,792.436]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1056.59,825.469],[1056.59,934.913],[1095.42,821.546],[1095.42,929.489]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1056.92,428.412],[1056.92,319.08],[1094.34,429.876],[1094.34,321.989]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1056.92,554.178],[1056.92,444.846],[1094.34,553.98],[1094.34,446.093]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1056.92,566.704],[1056.92,676.036],[1094.34,566.341],[1094.34,674.229]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1056.92,695.6],[1056.92,804.932],[1094.34,693.535],[1094.34,801.423]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1080.66,303.962],[1080.66,199.155],[990.364,307.81],[990.364,204.717]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1168.25,302.961],[1080.66,303.962],[1168.25,197.708],[1080.66,199.155]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1141.47,427.253],[1141.47,316.778],[1094.34,429.876],[1094.34,321.989]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1141.47,554.334],[1141.47,443.859],[1094.34,553.981],[1094.34,446.093]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1141.47,566.991],[1141.47,677.466],[1094.34,566.341],[1094.34,674.229]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1141.47,697.235],[1141.47,807.71],[1094.34,693.535],[1094.34,801.423]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1140.31,827.99],[1140.31,938.397],[1095.42,821.546],[1095.42,929.489]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1140.31,827.99],[1229.33,827.631],[1140.31,938.397],[1229.33,937.901]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1141.47,427.253],[1141.47,316.778],[1230.25,427.413],[1230.25,317.094]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1141.47,554.334],[1141.47,443.858],[1230.25,554.312],[1230.25,443.994]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1141.47,566.991],[1141.47,677.466],[1230.25,566.952],[1230.25,677.27]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1141.47,697.235],[1141.47,807.71],[1230.25,697.01],[1230.25,807.329]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1168.25,302.961],[1168.25,197.708],[1213.21,306.865],[1213.21,203.351]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1240.86,303.782],[1240.86,198.895],[1213.21,306.865],[1213.21,203.351]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1229.33,827.631],[1229.33,937.901],[1414.1,807.601],[1414.1,910.212]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1230.25,427.413],[1230.25,317.094],[1415.03,435.184],[1415.03,332.531]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1230.25,554.312],[1230.25,443.994],[1415.03,553.266],[1415.03,450.613]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1230.25,566.952],[1230.25,677.27],[1415.03,565.027],[1415.03,667.68]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1230.25,697.01],[1230.25,807.329],[1415.03,686.048],[1415.03,788.701]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1240.86,303.783],[1240.86,198.895],[1295.08,306.444],[1295.08,202.742]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1295.08,306.444],[1295.08,202.742],[1332.19,308.469],[1332.19,205.669]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1332.19,308.469],[1332.19,205.669],[1383.15,311.792],[1383.15,210.473]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1386.33,312.081],[1386.33,210.89],[1422.33,316.603],[1422.33,217.426]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1416.02,435.226],[1416.02,332.614],[1576.66,441.982],[1576.66,346.034]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1416.02,553.26],[1416.02,450.649],[1576.66,552.35],[1576.66,456.403]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1416.02,565.017],[1416.02,667.628],[1576.66,563.343],[1576.66,659.291]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1416.02,685.99],[1416.02,788.601],[1576.66,676.46],[1576.66,772.407]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1422.33,316.603],[1422.33,217.426],[1443.25,319.739],[1443.25,221.96]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1443.25,319.739],[1443.25,221.96],[1469.42,324.102],[1469.42,228.266]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:53,
                    verts:[[1441.39,326.679],[1441.39,231.99],[1477.84,329.844],[1477.84,236.565]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[600.588,764.036],[600.588,849.989],[533.195,755.694],[533.195,838.456]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[598.54,452.306],[598.541,366.542],[535.553,455.325],[535.554,372.539]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[598.54,550.96],[598.541,465.197],[535.553,550.554],[535.554,467.768]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[598.541,560.786],[598.54,646.55],[535.554,560.039],[535.553,642.824]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[598.541,661.897],[598.54,747.661],[535.554,657.638],[535.553,740.424]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[573.677,446.289],[573.677,354.59],[540.872,450.532],[540.872,363.019]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[573.677,551.771],[573.677,460.072],[540.872,551.199],[540.872,463.686]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[573.677,562.277],[573.677,653.975],[540.872,561.226],[540.872,648.739]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[573.677,670.384],[573.677,762.083],[540.872,664.399],[540.872,751.912]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[836.61,437.413],[836.61,333.58],[588.087,449.747],[588.087,358.491]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[836.61,556.852],[836.61,453.019],[588.087,554.72],[588.087,463.463]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[836.61,568.748],[836.61,672.58],[588.087,565.175],[588.087,656.432]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[836.61,691.16],[836.61,794.993],[588.087,672.762],[588.087,764.018]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[836.61,810.796],[836.61,914.629],[588.087,777.908],[588.087,869.164]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[625.375,347.98],[625.375,262.781],[616.546,354.12],[616.546,271.655]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[657.425,338.952],[657.425,249.731],[625.375,347.981],[625.375,262.781]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[703.579,329.019],[703.579,235.374],[648.399,338.299],[648.399,248.787]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[795.823,318.913],[795.823,220.766],[703.579,329.019],[703.579,235.374]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[901.224,311.337],[901.224,209.813],[795.823,318.913],[795.823,220.766]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[952.991,429.712],[952.991,321.663],[830.559,432.94],[830.559,328.074]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[952.991,554.003],[952.991,445.953],[830.559,553.568],[830.559,448.702]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[952.991,566.382],[952.991,674.432],[830.559,565.583],[830.559,670.448]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[952.991,693.766],[952.991,801.816],[830.559,689.213],[830.559,794.079]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[954.483,821.693],[954.483,929.692],[825.237,812.849],[825.237,917.467]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1035.38,305.361],[1035.38,201.178],[912.775,311.627],[912.775,210.234]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[952.99,429.712],[952.991,321.663],[1013.73,432.404],[1013.73,327.008]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[952.99,554.003],[952.991,445.953],[1013.73,553.64],[1013.73,448.245]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[952.991,566.382],[952.99,674.432],[1013.73,565.716],[1013.73,671.111]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[952.991,693.766],[952.99,801.816],[1013.73,689.97],[1013.73,795.366]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[954.483,821.692],[954.483,929.691],[1014.92,814.785],[1014.92,920.143]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1116.76,827.932],[1116.76,938.316],[1006.77,814.316],[1006.77,919.495]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1116.84,427.461],[1116.84,317.191],[1013.73,432.404],[1013.73,327.008]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1116.84,554.306],[1116.84,444.036],[1013.73,553.64],[1013.73,448.245]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1116.84,566.94],[1116.84,677.21],[1013.73,565.716],[1013.73,671.111]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1116.84,696.942],[1116.84,807.212],[1013.73,689.97],[1013.73,795.366]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1116.84,427.461],[1116.84,317.191],[1150.74,429.103],[1150.74,320.452]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1116.84,554.306],[1116.84,444.035],[1150.74,554.085],[1150.74,445.434]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1116.84,566.94],[1116.84,677.21],[1150.74,566.533],[1150.74,675.184]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1116.84,696.942],[1116.84,807.212],[1150.74,694.626],[1150.74,803.277]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1116.76,827.932],[1116.76,938.316],[1151.95,823.532],[1151.95,932.235]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1129.8,302.235],[1129.8,196.659],[1035.38,305.361],[1035.38,201.178]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1129.8,302.235],[1217.93,301.987],[1129.8,196.659],[1217.93,196.3]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1203.76,426.635],[1203.76,315.549],[1150.74,429.103],[1150.74,320.452]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1203.76,554.417],[1203.76,443.332],[1150.74,554.085],[1150.74,445.434]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1203.76,567.144],[1203.76,678.23],[1150.74,566.533],[1150.74,675.184]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1203.76,698.107],[1203.76,809.193],[1150.74,694.626],[1150.74,803.277]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1202.44,829.596],[1202.44,940.617],[1151.95,823.532],[1151.95,932.235]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1202.44,829.596],[1202.44,940.617],[1290.22,828.282],[1290.22,938.8]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1203.76,426.635],[1203.76,315.549],[1291.25,427.164],[1291.25,316.6]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1203.76,554.417],[1203.76,443.332],[1291.25,554.346],[1291.25,443.782]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1203.76,567.144],[1203.76,678.23],[1291.25,567.013],[1291.25,677.577]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1203.76,698.107],[1203.76,809.193],[1291.25,697.362],[1291.25,807.926]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1217.93,301.987],[1217.93,196.3],[1258.3,306.325],[1258.3,202.57]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1288.83,303.45],[1288.83,198.414],[1258.3,306.325],[1258.3,202.57]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1288.83,303.45],[1288.83,198.414],[1339.36,306.6],[1339.36,202.968]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1290.22,828.282],[1290.22,938.8],[1453.12,806.232],[1453.12,908.32]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1291.25,427.164],[1291.25,316.6],[1454.13,435.718],[1454.13,333.592]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1291.25,554.346],[1291.25,443.782],[1454.13,553.194],[1454.13,451.068]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1291.25,567.013],[1291.25,677.577],[1454.13,564.895],[1454.13,667.021]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1291.25,697.362],[1291.25,807.925],[1454.13,685.295],[1454.13,787.421]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1339.36,306.6],[1339.36,202.968],[1373.61,308.953],[1373.61,206.369]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1373.61,308.953],[1373.61,206.369],[1419.9,312.719],[1419.9,211.813]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1422.7,313.035],[1422.7,212.269],[1453,317.864],[1453,219.249]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1453,317.864],[1453,219.249],[1470.03,321.172],[1470.03,224.031]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1454.99,435.763],[1454.99,333.682],[1594.66,443.098],[1594.66,348.252]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1454.99,553.188],[1454.99,451.107],[1594.66,552.2],[1594.66,457.354]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1454.99,564.883],[1454.99,666.965],[1594.66,563.067],[1594.66,657.913]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1454.99,685.231],[1454.99,787.312],[1594.66,674.885],[1594.66,769.731]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1470.03,321.172],[1470.03,224.031],[1490.83,325.742],[1490.83,230.637]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:54,
                    verts:[[1460.92,328.102],[1460.92,234.048],[1492.95,331.545],[1492.95,239.024]]
                },
                ],
                [
                {
                    num:"101",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[595.454,769.546],[595.454,857.605],[517.933,761.516],[517.933,846.505]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[551.465,454.14],[551.465,370.185],[518.216,455.438],[518.216,372.764]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[551.465,550.713],[551.465,466.758],[518.216,550.539],[518.216,467.865]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[551.465,560.332],[551.465,644.287],[518.216,560.011],[518.216,642.685]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[551.465,659.31],[551.465,743.265],[518.216,657.478],[518.216,740.152]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[592.884,450.169],[592.884,362.297],[520.439,453.075],[520.44,368.07]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[592.884,551.248],[592.884,463.376],[520.439,550.857],[520.44,465.852]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[592.884,561.316],[592.884,649.187],[520.44,560.596],[520.439,645.601]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[592.884,664.911],[592.884,752.782],[520.44,660.812],[520.439,745.817]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[581.31,443.868],[581.31,349.781],[537.257,448.138],[537.258,358.262]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[581.31,552.096],[581.31,458.01],[537.257,551.522],[537.258,461.646]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[581.31,562.876],[581.31,656.963],[537.258,561.819],[537.257,651.694]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[581.31,673.799],[581.31,767.886],[537.258,667.776],[537.257,757.652]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[584.857,785.757],[584.857,880.015],[537.704,774.096],[537.704,863.895]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[880.168,435.703],[880.168,330.129],[595.184,447.47],[595.184,353.892]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[880.168,557.147],[880.168,451.572],[595.184,555.114],[595.184,461.535]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[880.168,569.243],[880.168,674.818],[595.184,565.835],[595.184,659.413]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[880.168,693.71],[880.168,799.284],[595.184,676.158],[595.184,769.736]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[880.168,815.353],[880.168,920.928],[595.184,783.979],[595.184,877.557]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[619.277,343.49],[619.277,256.29],[603.63,349.751],[603.63,265.34]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[661.935,334.435],[661.935,243.201],[619.277,343.49],[619.277,256.29]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[719.964,324.58],[719.964,228.957],[653.329,333.691],[653.329,242.126]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[825.069,314.97],[825.069,215.066],[719.963,324.58],[719.963,228.957]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[940.133,308.123],[940.133,205.167],[825.068,314.97],[825.068,215.066]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1007.97,428.328],[1007.97,318.912],[876.492,431.122],[876.492,324.463]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1007.97,554.189],[1007.97,444.773],[876.492,553.813],[876.492,447.154]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1007.97,566.725],[1007.97,676.141],[876.492,566.033],[876.492,672.692]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1007.97,695.72],[1007.97,805.136],[876.492,691.778],[876.492,798.437]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1009.35,825.246],[1009.35,934.604],[870.487,817.579],[870.487,924.004]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1081.43,303.214],[1081.43,198.073],[951.493,308.52],[951.493,205.743]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1007.97,428.328],[1007.97,318.912],[1062.65,431.324],[1062.65,324.863]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1007.97,554.189],[1007.97,444.773],[1062.65,553.786],[1062.65,447.325]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1007.97,566.725],[1007.97,676.141],[1062.65,565.983],[1062.65,672.443]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1007.97,695.72],[1007.97,805.136],[1062.65,691.494],[1062.65,797.954]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1009.36,825.246],[1009.36,934.603],[1063.75,817.556],[1063.75,923.974]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1177.46,829.833],[1177.46,940.945],[1055.15,817.164],[1055.15,923.432]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1177.26,426.726],[1177.26,315.731],[1062.65,431.324],[1062.65,324.863]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1177.26,554.405],[1177.26,443.409],[1062.65,553.786],[1062.65,447.325]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1177.26,567.122],[1177.26,678.117],[1062.65,565.983],[1062.65,672.443]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1177.26,697.979],[1177.26,808.974],[1062.65,691.493],[1062.65,797.954]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1178.92,300.881],[1178.92,194.702],[1081.43,303.214],[1081.43,198.073]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1177.26,426.726],[1177.26,315.731],[1207.06,428.534],[1207.06,319.322]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1177.26,554.405],[1177.26,443.409],[1207.06,554.161],[1207.06,444.949]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1177.26,567.122],[1177.26,678.117],[1207.06,566.674],[1207.06,675.886]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1177.26,697.979],[1177.26,808.974],[1207.06,695.428],[1207.06,804.64]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1177.46,829.833],[1177.46,940.945],[1208.38,824.989],[1208.38,934.248]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1178.92,300.882],[1178.92,194.702],[1266.47,301.418],[1266.47,195.478]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1265.38,426.257],[1265.38,314.798],[1207.06,428.534],[1207.06,319.322]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1265.38,554.468],[1265.38,443.01],[1207.06,554.161],[1207.06,444.949]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1265.38,567.238],[1265.38,678.696],[1207.06,566.674],[1207.06,675.886]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1265.38,698.641],[1265.38,810.099],[1207.06,695.428],[1207.06,804.64]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1263.92,830.583],[1263.92,941.982],[1208.38,824.989],[1208.38,934.248]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1263.92,830.583],[1263.92,941.982],[1349.18,828.302],[1349.18,938.828]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1265.38,426.257],[1265.38,314.798],[1350.29,427.16],[1350.29,316.592]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1265.38,554.468],[1265.38,443.01],[1350.29,554.346],[1350.29,443.779]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1265.38,567.238],[1265.38,678.696],[1350.29,567.014],[1350.29,677.582]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1265.38,698.641],[1265.38,810.099],[1350.29,697.367],[1350.29,807.934]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1266.47,301.418],[1266.47,195.477],[1301.64,306.154],[1301.64,202.324]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1334.71,303.523],[1334.71,198.52],[1301.64,306.154],[1301.64,202.324]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1334.71,303.523],[1334.71,198.52],[1380.89,307.136],[1380.89,203.743]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1350.29,427.16],[1350.29,316.592],[1489.08,436.409],[1489.08,334.965]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1350.29,554.346],[1350.29,443.779],[1489.08,553.101],[1489.08,451.657]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1350.29,567.014],[1350.29,677.582],[1489.08,564.724],[1489.08,666.168]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1350.29,697.367],[1350.29,807.934],[1489.08,684.32],[1489.08,785.765]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1349.18,828.302],[1349.18,938.828],[1488.01,804.459],[1488.01,905.869]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1380.89,307.136],[1380.89,203.743],[1411.85,309.796],[1411.85,207.588]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1411.85,309.796],[1411.85,207.588],[1452.94,313.966],[1452.94,213.615]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1455.32,314.306],[1455.32,214.107],[1479.62,319.393],[1479.62,221.459]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1479.62,319.393],[1479.62,221.459],[1492.62,322.84],[1492.62,226.442]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1489.82,436.458],[1489.82,335.062],[1607.34,444.29],[1607.34,350.619]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1489.82,553.094],[1489.82,451.698],[1607.34,552.04],[1607.34,458.369]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1489.82,564.711],[1489.82,666.107],[1607.34,562.772],[1607.34,656.442]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1489.82,684.252],[1489.82,785.648],[1607.34,673.204],[1607.34,766.875]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:55,
                    verts:[[1492.62,322.84],[1492.62,226.442],[1507.91,327.572],[1507.91,233.282]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[537.502,451.88],[537.502,365.695],[499.824,453.109],[499.824,368.138]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[537.502,551.018],[537.502,464.834],[499.824,550.852],[499.824,465.881]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[537.502,560.892],[537.502,647.076],[499.824,560.587],[499.824,645.558]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[537.502,662.498],[537.502,748.682],[499.824,660.763],[499.824,745.734]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[535.978,764.507],[535.978,850.64],[500.11,761.487],[500.11,846.465]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[593.015,775.331],[593.015,865.602],[505.105,767.736],[505.105,855.103]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[589.902,447.923],[589.903,357.837],[507.755,450.672],[507.756,363.297]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[589.902,551.55],[589.903,461.464],[507.755,551.18],[507.756,463.805]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[589.903,561.872],[589.902,651.958],[507.756,561.191],[507.755,648.566]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[589.903,668.078],[589.902,758.165],[507.756,664.201],[507.755,751.576]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[592.893,441.371],[592.893,344.822],[536.997,445.623],[536.997,353.267]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[592.893,552.433],[592.893,455.883],[536.997,551.86],[536.997,459.504]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[592.893,563.495],[592.893,660.044],[536.997,562.442],[536.997,654.797]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[592.893,677.321],[592.893,773.87],[536.997,671.324],[536.997,763.68]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[596.981,792.177],[596.981,888.89],[537.278,780.572],[537.278,872.848]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[615.589,338.773],[615.589,249.471],[592.692,345.109],[592.692,258.63]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[926.765,434.127],[926.765,326.944],[606.039,445.123],[606.039,349.151]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[926.765,557.419],[926.765,450.237],[606.039,555.519],[606.039,459.548]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[926.765,569.7],[926.765,676.882],[606.039,566.515],[606.039,662.486]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[926.765,696.062],[926.765,803.244],[606.039,679.659],[606.039,775.631]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[926.765,819.558],[926.765,926.74],[606.039,790.238],[606.039,886.209]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[669.32,329.781],[669.32,236.475],[615.589,338.773],[615.589,249.471]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[739.533,320.123],[739.533,222.515],[661.251,328.945],[661.251,235.266]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[857.179,311.169],[857.179,209.572],[739.533,320.123],[739.533,222.515]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[981.026,305.194],[981.026,200.934],[857.179,311.169],[857.179,209.572]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1064.79,427.159],[1064.79,316.591],[925.656,429.451],[925.656,321.143]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1064.79,554.346],[1064.79,443.778],[925.656,554.038],[925.656,445.73]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1064.79,567.014],[1064.79,677.583],[925.656,566.447],[925.656,674.754]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1064.79,697.368],[1064.79,807.936],[925.656,694.135],[925.656,802.443]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1066.04,828.242],[1066.04,938.745],[919.011,821.941],[919.011,930.035]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1127.93,301.478],[1127.93,195.565],[992.039,305.702],[992.039,201.669]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1064.79,427.159],[1064.79,316.591],[1112.37,430.441],[1112.37,323.11]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1064.79,554.346],[1064.79,443.778],[1112.37,553.905],[1112.37,446.573]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1064.79,567.014],[1064.79,677.583],[1112.37,566.202],[1112.37,673.533]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1064.79,697.368],[1064.79,807.936],[1112.37,692.739],[1112.37,800.07]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1066.04,828.242],[1066.04,938.745],[1113.36,819.82],[1113.36,927.103]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1237.69,831.029],[1237.69,942.598],[1104.42,819.514],[1104.42,926.68]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1237.21,426.264],[1237.21,314.812],[1112.37,430.441],[1112.37,323.11]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1237.21,554.467],[1237.21,443.015],[1112.37,553.905],[1112.37,446.573]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1237.21,567.236],[1237.21,678.688],[1112.37,566.202],[1112.37,673.533]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1237.21,698.631],[1237.21,810.083],[1112.37,692.739],[1112.37,800.07]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1227.26,300.005],[1127.93,301.478],[1227.26,193.435],[1127.93,195.565]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1227.26,300.005],[1227.26,193.435],[1313.03,301.344],[1313.03,195.371]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1237.21,426.263],[1237.21,314.812],[1262.38,428.221],[1262.38,318.699]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1237.21,554.467],[1237.21,443.015],[1262.38,554.203],[1262.38,444.682]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1237.21,567.236],[1237.21,678.688],[1262.38,566.751],[1262.38,676.273]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1237.21,698.631],[1237.21,810.083],[1262.38,695.87],[1262.38,805.392]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1237.69,831.029],[1237.69,942.598],[1263.8,825.784],[1263.8,935.348]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1325.23,426.169],[1325.23,314.625],[1262.38,428.221],[1262.38,318.7]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1325.23,554.48],[1325.23,442.935],[1262.38,554.204],[1262.38,444.682]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1325.23,567.26],[1325.23,678.804],[1262.38,566.751],[1262.38,676.273]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1325.23,698.764],[1325.23,810.309],[1262.38,695.87],[1262.38,805.392]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1323.66,830.824],[1323.66,942.315],[1263.8,825.784],[1263.8,935.348]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1313.03,301.344],[1313.03,195.371],[1342.48,306.432],[1342.48,202.725]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1323.66,830.824],[1323.66,942.315],[1405.1,827.584],[1405.1,937.835]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1325.23,426.169],[1325.23,314.625],[1406.29,427.443],[1406.29,317.154]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1325.23,554.48],[1325.23,442.935],[1406.29,554.308],[1406.29,444.02]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1325.23,567.26],[1325.23,678.804],[1406.29,566.944],[1406.29,677.233]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1325.23,698.764],[1325.23,810.309],[1406.29,696.968],[1406.29,807.257]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1377.67,304.078],[1377.67,199.323],[1342.48,306.432],[1342.48,202.725]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1377.67,304.078],[1377.67,199.323],[1418.88,308.117],[1418.88,205.161]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1406.29,427.443],[1406.29,317.154],[1519.2,437.277],[1519.2,336.69]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1406.29,554.308],[1406.29,444.02],[1519.2,552.984],[1519.2,452.396]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1406.29,566.944],[1406.29,677.233],[1519.2,564.508],[1519.2,665.096]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1406.29,696.968],[1406.29,807.257],[1519.2,683.095],[1519.2,783.683]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1405.1,827.584],[1405.1,937.835],[1518.08,802.23],[1518.08,902.787]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1418.88,308.117],[1418.88,205.161],[1446.17,311.055],[1446.17,209.407]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1446.17,311.055],[1446.17,209.407],[1481.59,315.582],[1481.59,215.95]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1483.54,315.942],[1483.54,216.471],[1501.63,321.229],[1501.63,224.113]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1501.63,321.229],[1501.63,224.113],[1510.51,324.778],[1510.51,229.244]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1510.51,324.778],[1510.51,229.244],[1520.22,329.623],[1520.22,236.246]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1519.79,437.329],[1519.79,336.792],[1614.36,445.565],[1614.36,353.153]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1519.79,552.977],[1519.79,452.44],[1614.36,551.868],[1614.36,459.456]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1519.79,564.496],[1519.79,665.032],[1614.36,562.456],[1614.36,654.868]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:56,
                    verts:[[1519.79,683.023],[1519.79,783.56],[1614.36,671.405],[1614.36,763.817]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[526.183,449.495],[526.183,360.958],[483.975,450.633],[483.975,363.219]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[526.183,551.339],[526.183,462.802],[483.975,551.186],[483.975,463.772]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[526.183,561.483],[526.183,650.019],[483.975,561.201],[483.975,648.615]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[526.183,665.862],[526.183,754.398],[483.975,664.257],[483.975,751.671]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[524.471,770.669],[524.471,859.157],[484.289,767.874],[484.289,855.294]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[593.745,781.312],[593.745,873.87],[495.309,774.296],[495.309,864.172]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[590.071,445.599],[590.071,353.221],[498.094,448.138],[498.094,358.264]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[590.071,551.863],[590.071,459.484],[498.094,551.521],[498.094,461.647]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[590.071,562.447],[590.071,654.826],[498.094,561.819],[498.094,651.693]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[590.071,671.357],[590.071,763.736],[498.094,667.775],[498.094,757.65]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[608.888,438.845],[608.888,339.804],[540.667,443.022],[540.667,348.1]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[608.888,552.773],[608.888,453.731],[540.667,552.211],[540.667,457.289]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[608.888,564.12],[608.888,663.161],[540.667,563.086],[540.667,658.008]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[608.888,680.884],[608.888,779.925],[540.667,674.993],[540.667,769.915]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[613.52,798.666],[613.52,897.86],[540.763,787.272],[540.763,882.109]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[584.193,340.243],[584.193,251.597],[579.182,346.233],[579.182,260.254]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[614.747,333.893],[614.747,242.418],[584.193,340.243],[584.193,251.597]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[679.912,325.077],[679.912,229.676],[614.747,333.893],[614.747,242.418]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[975.931,432.746],[975.931,324.156],[621.089,442.748],[621.089,344.355]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[975.931,557.658],[975.931,449.068],[621.089,555.93],[621.089,457.537]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[975.931,570.099],[975.931,678.69],[621.089,567.203],[621.089,665.595]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[975.931,698.121],[975.931,806.711],[621.089,683.202],[621.089,781.595]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[975.931,823.239],[975.931,931.83],[621.089,796.57],[621.089,894.963]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[762.443,315.755],[762.443,216.201],[672.509,324.147],[672.509,228.332]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[891.994,307.633],[891.994,204.461],[762.443,315.755],[762.443,216.201]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1023.43,302.675],[1023.43,197.292],[891.994,307.633],[891.994,204.461]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1122.58,426.272],[1122.58,314.829],[977.547,427.995],[977.547,318.251]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1122.58,554.466],[1122.58,443.023],[977.547,554.234],[977.547,444.49]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1122.58,567.234],[1122.58,678.677],[977.547,566.807],[977.547,676.551]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1122.58,698.619],[1122.58,810.062],[977.547,696.189],[977.547,805.933]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1123.67,830.513],[1123.67,941.884],[970.324,825.76],[970.324,935.315]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1174.11,300.267],[1174.11,193.814],[1033.94,303.293],[1033.94,198.188]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1122.58,426.272],[1122.58,314.829],[1162.1,429.809],[1162.1,321.855]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1122.58,554.466],[1122.58,443.023],[1162.1,553.99],[1162.1,446.035]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1122.58,567.234],[1122.58,678.677],[1162.1,566.358],[1162.1,674.313]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1122.58,698.619],[1122.58,810.062],[1162.1,693.63],[1162.1,801.584]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1123.67,830.513],[1123.67,941.884],[1162.96,821.437],[1162.96,929.339]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1296.31,831.383],[1296.31,943.087],[1153.79,821.226],[1153.79,929.046]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1295.55,426.125],[1295.55,314.537],[1162.1,429.809],[1162.1,321.855]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1295.55,554.486],[1295.55,442.898],[1162.1,553.99],[1162.1,446.035]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1295.55,567.27],[1295.55,678.859],[1162.1,566.358],[1162.1,674.313]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1295.55,698.826],[1295.55,810.414],[1162.1,693.63],[1162.1,801.584]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1174.11,300.267],[1273.92,299.703],[1174.11,193.814],[1273.92,192.999]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1273.92,299.703],[1273.92,192.999],[1356.68,301.846],[1356.68,196.096]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1295.55,426.125],[1295.55,314.537],[1315.62,428.209],[1315.62,318.676]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1295.55,554.486],[1295.55,442.898],[1315.62,554.205],[1315.62,444.672]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1295.55,567.27],[1295.55,678.859],[1315.62,566.754],[1315.62,676.287]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1295.55,698.826],[1295.55,810.414],[1315.62,695.887],[1315.62,805.42]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1296.31,831.383],[1296.31,943.087],[1317.11,825.8],[1317.11,935.37]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1382.1,426.416],[1382.1,315.115],[1315.62,428.209],[1315.62,318.676]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1382.1,554.447],[1382.1,443.145],[1315.62,554.205],[1315.62,444.672]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1382.1,567.198],[1382.1,678.5],[1315.62,566.754],[1315.62,676.287]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1382.1,698.416],[1382.1,809.717],[1315.62,695.887],[1315.62,805.42]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1380.43,830.204],[1380.43,941.458],[1317.11,825.8],[1317.11,935.37]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1356.68,301.846],[1356.68,196.096],[1379.98,307.225],[1379.98,203.871]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1416.83,305.18],[1416.83,200.916],[1379.97,307.225],[1379.97,203.871]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1380.43,830.204],[1380.43,941.458],[1456.79,826.041],[1456.79,935.703]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1382.1,426.416],[1382.1,315.115],[1458.04,428.046],[1458.04,318.352]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1382.1,554.447],[1382.1,443.145],[1458.04,554.227],[1458.04,444.533]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1382.1,567.198],[1382.1,678.5],[1458.04,566.795],[1458.04,676.489]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1382.1,698.416],[1382.1,809.717],[1458.04,696.117],[1458.04,805.811]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1416.83,305.18],[1416.83,200.916],[1452.53,309.595],[1452.53,207.297]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1452.53,309.595],[1452.53,207.297],[1475.83,312.773],[1475.83,211.891]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1458.04,428.046],[1458.04,318.352],[1543.81,438.337],[1543.81,338.794]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1458.04,554.227],[1458.04,444.533],[1543.81,552.841],[1543.81,453.299]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1458.04,566.795],[1458.04,676.489],[1543.81,564.246],[1543.81,663.789]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1458.04,696.117],[1458.04,805.811],[1543.81,681.601],[1543.81,781.144]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1456.79,826.041],[1456.79,935.703],[1542.65,799.509],[1542.65,899.025]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1475.83,312.773],[1475.83,211.891],[1505.23,317.6],[1505.22,218.868]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1506.72,317.976],[1506.72,219.411],[1518.49,323.401],[1518.49,227.253]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1518.49,323.401],[1518.49,227.253],[1523.24,327.011],[1523.24,232.471]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1523.24,327.011],[1523.24,232.471],[1527.39,331.914],[1527.39,239.558]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1544.26,438.39],[1544.26,338.901],[1615.42,446.929],[1615.42,355.862]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1544.26,552.834],[1544.26,453.344],[1615.42,551.684],[1615.42,460.617]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1544.26,564.233],[1544.26,663.723],[1615.42,562.118],[1615.42,653.185]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:57,
                    verts:[[1544.26,681.526],[1544.26,781.015],[1615.42,669.481],[1615.42,760.548]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[518.114,447.014],[518.114,356.03],[471.334,448.034],[471.334,358.056]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[518.114,551.673],[518.114,460.689],[471.334,551.536],[471.334,461.558]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[518.114,562.097],[518.114,653.081],[471.334,561.844],[471.334,651.822]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[518.114,669.361],[518.114,760.345],[471.334,667.923],[471.334,757.9]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[516.214,777.081],[516.214,868.021],[471.677,774.576],[471.677,864.558]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[598.129,787.386],[598.129,882.267],[489.214,781.117],[489.214,873.6]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[593.885,443.236],[593.885,348.526],[492.117,445.505],[492.117,353.033]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[593.885,552.182],[593.885,457.471],[492.117,551.876],[492.117,459.404]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[593.885,563.033],[593.885,657.743],[492.117,562.471],[492.117,654.943]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[593.885,674.69],[593.885,769.401],[492.117,671.49],[492.117,763.962]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[629.702,436.345],[629.702,334.838],[548.854,440.379],[548.854,342.85]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[629.702,553.109],[629.702,451.602],[548.854,552.566],[548.854,455.038]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[629.702,564.739],[629.702,666.247],[548.854,563.74],[548.854,661.269]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[629.702,684.41],[629.702,785.918],[548.854,678.721],[548.854,776.249]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[634.864,805.078],[634.864,906.723],[548.747,794.081],[548.747,891.522]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[578.643,335.221],[578.643,244.338],[566.911,341.356],[566.911,253.206]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[617.201,328.933],[617.201,235.248],[578.643,335.222],[578.643,244.338]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[694.005,320.426],[694.005,222.952],[617.201,328.933],[617.201,235.248]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1026.98,431.627],[1026.98,321.895],[640.719,440.398],[640.719,339.609]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1026.98,557.852],[1026.98,448.12],[640.719,556.336],[640.719,455.547]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1026.98,570.424],[1026.98,680.155],[640.719,567.883],[640.719,668.672]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1026.98,699.791],[1026.98,809.522],[640.719,686.707],[640.719,787.496]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1026.98,826.223],[1026.98,935.955],[640.719,802.836],[640.719,903.624]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[788.743,311.598],[788.743,210.192],[687.407,319.404],[687.407,221.475]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[929.201,304.494],[929.201,199.924],[788.743,311.598],[788.743,210.192]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1066.73,300.69],[1066.73,194.423],[929.2,304.494],[929.2,199.924]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1180.26,425.729],[1180.26,313.75],[1031.42,426.825],[1031.42,315.927]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1180.26,554.539],[1180.26,442.56],[1031.42,554.391],[1031.42,443.493]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1180.26,567.369],[1180.26,679.348],[1031.42,567.097],[1031.42,677.995]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1180.26,699.385],[1180.26,811.365],[1031.42,697.84],[1031.42,808.738]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1181.16,831.9],[1023.71,828.854],[1181.16,943.802],[1023.71,939.591]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1219.1,299.684],[1076.54,301.418],[1219.1,192.971],[1076.54,195.477]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1180.26,425.729],[1180.26,313.75],[1210.88,429.479],[1210.88,321.2]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1180.26,554.539],[1180.26,442.56],[1210.88,554.034],[1210.88,445.754]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1180.26,567.369],[1180.26,679.348],[1210.88,566.44],[1210.88,674.72]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1180.26,699.385],[1180.26,811.364],[1210.88,694.095],[1210.88,802.375]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1181.16,831.899],[1181.16,943.801],[1211.61,822.277],[1211.61,930.5]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1352.02,830.782],[1352.02,942.257],[1202.34,822.166],[1202.34,930.346]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1351,426.355],[1351,314.994],[1210.88,429.479],[1210.88,321.2]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1351,554.455],[1351,443.093],[1210.88,554.034],[1210.88,445.754]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1351,567.214],[1351,678.575],[1210.88,566.44],[1210.88,674.72]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1351,698.502],[1351,809.863],[1210.88,694.095],[1210.88,802.375]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1219.1,299.684],[1219.1,192.971],[1317.92,300.06],[1317.92,193.515]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1317.92,300.06],[1317.92,193.515],[1396.46,302.985],[1396.46,197.742]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1351,426.355],[1351,314.994],[1365.61,428.536],[1365.61,319.327]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1351,554.455],[1351,443.093],[1365.61,554.161],[1365.61,444.951]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1351,567.213],[1351,678.575],[1365.61,566.673],[1365.61,675.883]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1351,698.502],[1351,809.863],[1365.61,695.425],[1365.61,804.635]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1352.02,830.782],[1352.02,942.257],[1367.16,824.938],[1367.16,934.179]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1434.69,427.03],[1434.69,316.335],[1365.61,428.536],[1365.61,319.327]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1434.69,554.364],[1434.69,443.668],[1365.61,554.161],[1365.61,444.951]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1434.69,567.046],[1434.69,677.742],[1365.61,566.673],[1365.61,675.883]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1434.69,697.55],[1434.69,808.245],[1365.61,695.425],[1365.61,804.635]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1432.95,828.638],[1432.95,939.293],[1367.16,824.938],[1367.16,934.179]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1396.46,302.985],[1396.46,197.742],[1413.3,308.584],[1413.3,205.835]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1451.29,306.874],[1413.3,308.584],[1451.29,203.364],[1413.3,205.835]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1432.95,828.638],[1432.95,939.293],[1503.07,823.616],[1503.07,932.351]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1434.69,427.03],[1434.69,316.335],[1504.35,428.991],[1504.35,320.23]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1434.69,554.364],[1434.69,443.668],[1504.35,554.1],[1504.35,445.339]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1434.69,567.046],[1434.69,677.742],[1504.35,566.561],[1504.35,675.322]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1434.69,697.55],[1434.69,808.245],[1504.35,694.784],[1504.35,803.545]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1451.29,306.874],[1451.29,203.364],[1481.07,311.604],[1481.07,210.201]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1481.07,311.604],[1481.07,210.201],[1500.14,314.979],[1500.14,215.079]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1500.14,314.979],[1500.14,215.079],[1523.26,320.04],[1523.26,222.395]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1504.35,428.991],[1504.35,320.23],[1562.32,439.593],[1562.32,341.289]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1504.35,554.1],[1504.35,445.339],[1562.32,552.672],[1562.32,454.369]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1504.35,566.561],[1504.35,675.322],[1562.32,563.935],[1562.32,662.239]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1504.35,694.784],[1504.35,803.545],[1562.32,679.829],[1562.32,778.133]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1503.07,823.616],[1503.07,932.351],[1561.15,796.281],[1561.15,894.562]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1524.29,320.427],[1524.29,222.954],[1529.77,325.923],[1529.77,230.898]]
                },{
                    num:"604",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1529.77,325.923],[1529.77,230.898],[1530.44,329.551],[1530.44,236.141]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1562.62,439.648],[1562.62,341.399],[1610.37,448.381],[1610.37,358.745]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1562.62,552.665],[1562.62,454.415],[1610.37,551.489],[1610.37,461.853]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1562.62,563.921],[1562.62,662.171],[1610.37,561.759],[1610.37,651.394]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:58,
                    verts:[[1562.62,679.752],[1562.62,778.001],[1610.37,667.434],[1610.37,757.069]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[462.639,445.347],[462.639,352.719],[458.667,448.186],[458.667,358.359]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[462.639,551.897],[462.639,459.269],[458.667,551.515],[458.667,461.688]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[462.639,562.51],[462.639,655.138],[458.667,561.807],[458.667,651.634]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[462.639,671.713],[462.639,764.341],[458.667,667.708],[458.667,757.535]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[463.01,781.504],[463.01,874.136],[458.667,774.17],[458.667,863.997]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[513.943,444.475],[513.943,350.987],[462.639,445.347],[462.639,352.719]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[513.943,552.015],[513.943,458.527],[462.639,551.897],[462.639,459.269]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[513.943,562.726],[513.943,656.214],[462.639,562.51],[462.639,655.138]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[513.943,672.943],[513.943,766.431],[462.639,671.713],[462.639,764.341]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[511.857,783.645],[511.857,877.096],[463.01,781.504],[463.01,874.136]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[606.631,793.43],[606.631,890.622],[487.523,788.091],[487.523,883.241]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[601.818,440.881],[601.818,343.848],[490.524,442.814],[490.525,347.687]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[601.818,552.499],[601.818,455.466],[490.524,552.238],[490.525,457.112]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[601.818,563.616],[601.818,660.649],[490.525,563.137],[490.524,658.264]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[601.818,678.012],[601.818,775.045],[490.525,675.286],[490.524,770.413]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[585.119,340.661],[585.119,252.201],[556.359,341.672],[556.359,253.663]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[576.576,330.129],[576.576,236.978],[557.657,336.349],[557.657,245.968]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[661.288,811.239],[661.288,915.241],[561.779,800.855],[561.779,900.885]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[655.622,433.938],[655.622,330.057],[562.107,437.751],[562.107,337.63]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[655.622,553.434],[655.622,449.552],[562.107,552.92],[562.107,452.799]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[655.622,565.336],[655.622,669.217],[562.107,564.391],[562.107,664.512]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[655.622,687.806],[655.622,791.687],[562.107,682.428],[562.107,782.549]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[623.388,323.993],[623.388,228.108],[576.575,330.129],[576.575,236.978]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[711.815,315.946],[711.815,216.476],[623.388,323.993],[623.388,228.108]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1078.99,430.832],[1078.99,320.29],[665.204,438.136],[665.204,335.04]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1078.99,557.989],[1078.99,447.447],[665.204,556.727],[665.204,453.631]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1078.99,570.654],[1078.99,681.195],[665.204,568.538],[665.204,671.634]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1078.99,700.976],[1078.99,811.518],[665.204,690.082],[665.204,793.177]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1078.99,828.343],[1078.99,938.884],[665.204,808.868],[665.204,911.964]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[818.348,307.787],[818.348,204.684],[706.166,314.837],[706.166,214.874]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[968.309,301.886],[968.309,196.154],[818.347,307.787],[818.347,204.684]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1110.1,299.358],[1110.1,192.497],[968.309,301.886],[968.309,196.154]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1086.29,426.008],[1236.55,425.582],[1086.29,314.304],[1236.55,313.458]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1086.29,554.501],[1086.29,442.798],[1236.55,554.559],[1236.55,442.435]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1086.29,567.299],[1086.29,679.003],[1236.55,567.405],[1236.55,679.529]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1086.29,698.992],[1236.55,699.593],[1086.29,810.696],[1236.55,811.717]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1078.19,831.046],[1237.25,832.266],[1078.19,942.622],[1237.25,944.309]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1119.07,300.188],[1261.89,299.814],[1119.07,193.7],[1261.89,193.159]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1236.55,425.582],[1236.55,313.458],[1257.65,429.494],[1257.65,321.228]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1236.55,554.559],[1236.55,442.435],[1257.65,554.032],[1257.65,445.767]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1236.55,567.405],[1236.55,679.529],[1257.65,566.436],[1257.65,674.702]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1236.55,699.593],[1236.55,811.717],[1257.65,694.075],[1257.65,802.341]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1237.25,832.266],[1237.25,944.308],[1258.22,822.231],[1258.22,930.436]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1403.48,829.15],[1403.48,940],[1249,822.225],[1249,930.427]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1402.21,426.984],[1402.21,316.242],[1257.65,429.494],[1257.65,321.228]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1402.21,554.37],[1402.21,443.629],[1257.65,554.032],[1257.65,445.766]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1402.21,567.058],[1402.21,677.799],[1257.65,566.436],[1257.65,674.702]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1402.21,697.616],[1402.21,808.357],[1257.65,694.075],[1257.65,802.341]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1261.89,299.814],[1261.89,193.159],[1358.25,301.136],[1358.25,195.07]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1358.25,301.136],[1358.25,195.07],[1431.42,304.799],[1431.42,200.365]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1402.21,426.983],[1402.21,316.242],[1411.16,429.229],[1411.16,320.702]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1402.21,554.37],[1402.21,443.628],[1411.16,554.068],[1411.16,445.541]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1402.21,567.058],[1402.21,677.799],[1411.16,566.502],[1411.16,675.028]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1402.21,697.616],[1402.21,808.357],[1411.16,694.448],[1411.16,802.975]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1403.48,829.15],[1403.48,940],[1412.74,823.134],[1412.74,931.684]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1481.7,428.03],[1481.7,318.321],[1411.16,429.229],[1411.16,320.702]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1481.7,554.229],[1481.7,444.52],[1411.16,554.068],[1411.16,445.541]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1481.7,566.799],[1481.7,676.508],[1411.16,566.502],[1411.16,675.028]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1481.7,696.139],[1481.7,805.848],[1411.16,694.448],[1411.16,802.975]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1479.92,826.079],[1412.74,823.134],[1479.92,935.755],[1412.74,931.684]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1431.42,304.799],[1431.42,200.365],[1441.66,310.538],[1441.66,208.661]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1480.23,309.182],[1441.66,310.538],[1480.23,206.701],[1441.66,208.661]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1480.23,309.182],[1480.23,206.701],[1503.82,314.156],[1503.82,213.89]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1479.92,826.079],[1479.92,935.755],[1542.81,820.289],[1542.81,927.751]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1481.7,428.03],[1481.7,318.321],[1544.1,430.287],[1544.1,322.803]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1481.7,554.229],[1481.7,444.52],[1544.1,553.925],[1544.1,446.442]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1481.7,566.799],[1481.7,676.508],[1544.1,566.24],[1544.1,673.723]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1481.7,696.139],[1481.7,805.848],[1544.1,692.956],[1544.1,800.44]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1503.82,314.156],[1503.82,213.89],[1518.51,317.678],[1518.51,218.98]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1518.51,317.678],[1518.51,218.98],[1535.24,322.902],[1535.24,226.532]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1544.1,430.287],[1544.1,322.803],[1574.27,441.043],[1574.27,344.169]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1544.1,553.925],[1544.1,446.442],[1574.27,552.477],[1574.27,455.603]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1544.1,566.24],[1544.1,673.723],[1574.27,563.576],[1574.27,660.45]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1544.1,692.956],[1544.1,800.44],[1574.27,677.784],[1574.27,774.658]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1542.81,820.289],[1542.81,927.751],[1573.09,792.553],[1573.09,889.41]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1574.42,441.098],[1574.42,344.28],[1599.14,449.912],[1599.14,361.787]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1574.42,552.469],[1574.42,455.651],[1599.14,551.283],[1599.14,463.158]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1574.42,563.562],[1574.42,660.381],[1599.14,561.379],[1599.14,649.504]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:59,
                    verts:[[1574.42,677.706],[1574.42,774.524],[1599.14,665.273],[1599.14,753.398]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[458.655,442.617],[458.655,347.296],[447.511,445.533],[447.511,353.089]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[458.655,552.265],[458.655,456.944],[447.511,551.872],[447.511,459.428]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[458.655,563.186],[458.655,658.507],[447.511,562.464],[447.511,654.908]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[458.655,675.564],[458.655,770.885],[447.511,671.45],[447.511,763.894]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[459.053,788.544],[459.053,883.867],[447.511,781.013],[447.511,873.457]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[514.321,441.926],[514.321,345.923],[458.655,442.617],[458.655,347.296]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[514.321,552.358],[514.321,456.355],[458.655,552.265],[458.655,456.944]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[514.321,563.357],[514.321,659.36],[458.655,563.186],[458.655,658.507]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[514.321,676.539],[514.321,772.542],[458.655,675.564],[458.655,770.885]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[512.056,790.241],[512.056,886.214],[459.053,788.544],[459.053,883.867]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[619.645,799.297],[619.645,898.732],[490.937,795.084],[490.937,892.908]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[614.279,438.591],[614.279,339.299],[494.009,440.116],[494.01,342.328]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[614.279,552.807],[614.279,453.515],[494.009,552.602],[494.01,454.814]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[614.279,564.183],[614.279,663.475],[494.01,563.805],[494.009,661.594]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[614.279,681.243],[614.279,780.535],[494.01,679.092],[494.009,776.88]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[575.68,335.965],[575.68,245.413],[544.754,336.761],[544.754,246.563]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[578.51,325.068],[578.51,229.662],[552.005,331.296],[552.005,238.665]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[633.687,319.189],[633.687,221.165],[578.509,325.068],[578.509,229.662]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[686.763,431.699],[686.763,325.608],[580.878,435.203],[580.878,332.569]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[686.763,553.735],[686.763,447.645],[580.878,553.263],[580.878,450.629]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[686.763,565.89],[686.763,671.981],[580.878,565.022],[580.878,667.656]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[686.763,690.964],[686.763,797.055],[580.878,686.022],[580.878,788.656]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[692.885,816.959],[692.885,923.148],[580.314,807.424],[580.314,909.967]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[733.444,311.768],[733.444,210.439],[633.687,319.189],[633.687,221.165]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1130.85,430.416],[1130.85,319.449],[694.656,436.03],[694.656,330.787]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1130.85,558.061],[1130.85,447.094],[694.656,557.091],[694.656,451.848]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1130.85,570.774],[1130.85,681.741],[694.656,569.148],[694.656,674.391]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1130.85,701.597],[1130.85,812.563],[694.656,693.223],[694.656,798.465]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1130.85,829.453],[1130.85,940.419],[694.656,814.483],[694.656,919.726]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[851,304.462],[851,199.878],[728.886,310.581],[728.886,208.722]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1008.66,299.935],[1008.66,193.334],[851,304.462],[851,199.878]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1152.64,298.776],[1008.65,299.935],[1152.64,191.657],[1008.65,193.334]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1140.95,425.602],[1140.95,313.497],[1290.09,425.869],[1290.09,314.029]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1140.95,554.556],[1140.95,442.452],[1290.09,554.52],[1290.09,442.68]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1140.95,567.4],[1140.95,679.505],[1290.09,567.334],[1290.09,679.174]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1140.95,699.565],[1140.95,811.669],[1290.09,699.187],[1290.09,811.028]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1160.6,299.7],[1160.6,192.994],[1301.49,300.714],[1301.49,194.461]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1132.61,832.188],[1132.61,944.2],[1290.57,831.517],[1290.57,943.272]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1290.09,425.869],[1290.09,314.029],[1301.29,429.881],[1301.29,321.997]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1290.09,554.52],[1290.09,442.68],[1301.29,553.98],[1301.29,446.096]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1290.09,567.334],[1290.09,679.174],[1301.29,566.34],[1301.29,674.224]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1290.09,699.187],[1290.09,811.028],[1301.29,693.529],[1301.29,801.412]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1290.57,831.517],[1290.57,943.272],[1301.7,821.225],[1301.7,929.046]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1449.4,826.455],[1292.67,821.325],[1449.4,936.274],[1292.67,929.183]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1447.9,428.022],[1447.9,318.305],[1301.29,429.881],[1301.29,321.997]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1447.9,554.23],[1447.9,444.513],[1301.29,553.98],[1301.29,446.096]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1447.9,566.801],[1447.9,676.518],[1301.29,566.34],[1301.29,674.224]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1447.9,696.151],[1447.9,805.868],[1301.29,693.529],[1301.29,801.412]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1301.49,300.714],[1301.49,194.461],[1393.91,302.961],[1393.91,197.708]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1393.91,302.961],[1393.91,197.708],[1460.72,307.297],[1460.72,203.976]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1447.9,428.022],[1447.9,318.305],[1451.15,430.295],[1451.15,322.82]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1447.9,554.23],[1447.9,444.513],[1451.15,553.924],[1451.15,446.449]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1447.9,566.801],[1447.9,676.518],[1451.15,566.238],[1451.15,673.712]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1447.9,696.151],[1447.9,805.868],[1451.15,692.944],[1451.15,800.419]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1449.4,826.455],[1449.4,936.275],[1452.73,820.365],[1452.73,927.857]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1521.98,429.416],[1451.15,430.295],[1521.98,321.074],[1451.15,322.82]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1521.98,554.043],[1521.98,445.7],[1451.15,553.924],[1451.15,446.449]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1521.98,566.456],[1451.15,566.238],[1521.98,674.798],[1451.15,673.712]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1521.98,694.185],[1451.15,692.944],[1521.98,802.527],[1451.15,800.419]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1520.19,822.526],[1452.73,820.365],[1520.19,930.843],[1452.73,927.857]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1460.72,307.297],[1460.72,203.976],[1464.37,313.091],[1464.37,212.35]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1502.96,312.097],[1464.37,313.091],[1502.96,210.914],[1464.37,212.35]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1502.96,312.098],[1502.96,210.914],[1520.22,317.237],[1520.22,218.344]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1520.22,317.237],[1520.22,218.344],[1530.49,320.853],[1530.49,223.57]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1520.19,822.526],[1520.19,930.843],[1575.06,816.083],[1575.06,921.938]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1521.98,429.416],[1521.98,321.074],[1576.35,431.923],[1576.35,326.053]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1521.98,554.043],[1521.98,445.7],[1576.35,553.705],[1576.35,447.836]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1521.98,566.455],[1521.98,674.798],[1576.35,565.835],[1576.35,671.704]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1521.98,694.185],[1521.98,802.527],[1576.35,690.649],[1576.35,796.518]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1530.49,320.853],[1530.49,223.57],[1540.86,326.164],[1540.86,231.247]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1575.06,816.083],[1575.06,921.938],[1578.22,788.36],[1578.22,883.613]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1576.35,431.923],[1576.35,326.053],[1579.38,442.673],[1579.38,347.407]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1576.35,553.705],[1576.35,447.836],[1579.38,552.257],[1579.38,456.992]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1576.35,565.835],[1576.35,671.704],[1579.38,563.172],[1579.38,658.438]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1576.35,690.648],[1576.35,796.518],[1579.38,675.485],[1579.38,770.75]]
                },{
                    num:"504",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1579.4,442.729],[1579.4,347.518],[1581.87,451.512],[1581.87,364.964]]
                },{
                    num:"404",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1579.4,552.25],[1579.4,457.039],[1581.87,551.067],[1581.87,464.52]]
                },{
                    num:"304",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1579.4,563.158],[1579.4,658.369],[1581.87,560.983],[1581.87,647.53]]
                },{
                    num:"204",
                    tipo:"TorreC",
                    frame:60,
                    verts:[[1579.4,675.406],[1579.4,770.617],[1581.87,663.017],[1581.87,749.564]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[460.133,439.898],[460.133,341.895],[441.252,442.857],[441.252,347.774]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[460.133,552.631],[460.133,454.628],[441.252,552.233],[441.252,457.149]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[460.133,563.859],[460.133,661.862],[441.252,563.126],[441.252,658.21]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[460.133,679.399],[460.133,777.402],[441.252,675.225],[441.252,770.308]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[460.554,795.553],[460.554,893.557],[441.252,787.916],[441.252,883]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[519.855,439.421],[519.855,340.948],[460.133,439.898],[460.133,341.895]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[519.855,552.695],[519.855,454.222],[460.133,552.631],[460.133,454.628]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[519.855,563.977],[519.855,662.45],[460.133,563.859],[460.133,661.862]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[519.855,680.071],[519.855,778.544],[460.133,679.399],[460.133,777.402]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[517.424,796.724],[517.424,895.175],[460.554,795.553],[460.554,893.557]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[637.45,804.825],[637.45,906.374],[500.093,801.937],[500.093,902.382]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[631.562,436.428],[631.563,335.003],[503.202,437.473],[503.202,337.079]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[631.562,553.098],[631.563,451.673],[503.202,552.958],[503.202,452.563]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[631.563,564.719],[631.562,666.144],[503.202,564.46],[503.202,664.854]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[631.563,684.293],[631.562,785.719],[503.202,682.819],[503.202,783.214]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[569.834,331.3],[569.834,238.671],[536.904,331.845],[536.904,239.458]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[584.912,320.155],[584.912,222.561],[550.522,326.302],[550.522,231.446]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[648.38,314.651],[648.38,214.605],[584.912,320.155],[584.912,222.561]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[729.516,822.034],[729.516,930.163],[604.648,813.599],[604.648,918.503]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[723.004,429.705],[723.004,321.649],[605.459,432.809],[605.459,327.814]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[723.004,554.004],[723.004,445.947],[605.459,553.586],[605.459,448.59]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[723.004,566.384],[723.004,674.441],[605.459,565.615],[605.459,670.61]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[723.004,693.776],[723.004,801.833],[605.459,689.398],[605.459,794.394]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[758.84,308.031],[758.84,205.036],[648.38,314.651],[648.38,214.605]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1181.33,430.417],[1181.33,319.452],[728.966,434.154],[728.966,326.998]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1181.33,558.06],[1181.33,447.096],[728.966,557.415],[728.966,450.259]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1181.33,570.774],[1181.33,681.739],[728.966,569.692],[728.966,676.847]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1181.33,701.595],[1181.33,812.56],[728.966,696.022],[728.966,803.177]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1181.33,829.449],[1181.33,940.413],[728.966,819.486],[728.966,926.642]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[886.259,301.758],[886.259,195.969],[755.507,306.777],[755.507,203.223]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1049.42,298.75],[1049.42,191.621],[886.259,301.758],[886.259,195.969]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1049.42,298.75],[1193.34,299.016],[1049.42,191.621],[1193.34,192.004]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1194.09,425.648],[1194.09,313.589],[1339.49,426.609],[1339.49,315.497]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1194.09,554.55],[1194.09,442.491],[1339.49,554.421],[1339.49,443.309]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1194.09,567.389],[1194.09,679.448],[1339.49,567.151],[1339.49,678.262]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1194.09,699.5],[1194.09,811.559],[1339.49,698.145],[1339.49,809.256]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1200.16,300.02],[1200.16,193.457],[1336.92,302.41],[1336.92,196.911]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1185.64,832.17],[1185.64,944.175],[1339.75,829.605],[1339.75,940.629]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1339.49,426.609],[1339.49,315.497],[1340.7,430.654],[1340.7,323.532]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1339.49,554.421],[1339.49,443.309],[1340.7,553.876],[1340.7,446.754]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1339.49,567.151],[1339.49,678.262],[1340.7,566.149],[1340.7,673.271]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1339.49,698.144],[1339.49,809.256],[1340.7,692.439],[1340.7,799.56]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1339.75,829.605],[1339.75,940.629],[1340.95,819.228],[1340.95,926.285]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1332.26,819.431],[1488.63,822.718],[1332.26,926.565],[1488.63,931.109]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1340.7,430.654],[1486.94,429.463],[1340.7,323.532],[1486.94,321.167]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1340.7,553.876],[1340.7,446.754],[1486.94,554.036],[1486.94,445.74]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1340.7,566.149],[1486.94,566.444],[1340.7,673.271],[1486.94,674.74]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1340.7,692.439],[1486.94,694.119],[1340.7,799.56],[1486.94,802.415]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1336.92,302.41],[1336.92,196.911],[1424.05,305.531],[1424.05,201.423]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1424.05,305.531],[1424.05,201.423],[1483.69,310.453],[1483.69,208.538]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1480.91,316.214],[1519,315.583],[1480.91,216.864],[1519,215.953]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1484.6,431.726],[1554.58,431.168],[1484.6,325.663],[1554.58,324.554]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1484.6,553.732],[1484.6,447.668],[1554.58,553.807],[1554.58,447.193]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1484.6,565.883],[1484.6,671.947],[1554.58,566.022],[1554.58,672.636]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1484.6,690.926],[1554.58,691.713],[1484.6,796.99],[1554.58,798.327]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1486.16,816.656],[1552.81,818.028],[1486.16,922.729],[1552.81,924.625]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1519,315.583],[1519,215.953],[1529.95,320.809],[1529.95,223.505]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1529.95,320.809],[1529.95,223.505],[1535.85,324.463],[1535.85,228.788]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1535.85,324.463],[1535.85,228.788],[1540.02,329.786],[1540.02,236.481]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1552.81,818.028],[1552.81,924.625],[1599.15,811.067],[1599.15,915.003]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1554.58,431.168],[1554.58,324.554],[1600.41,433.873],[1600.41,329.927]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1554.58,553.807],[1554.58,447.193],[1600.41,553.442],[1600.41,449.497]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1554.58,566.022],[1554.58,672.636],[1600.41,565.352],[1600.41,669.297]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:61,
                    verts:[[1554.58,691.713],[1554.58,798.327],[1600.41,687.898],[1600.41,791.843]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[467.736,437.253],[467.736,336.642],[440.65,440.213],[440.65,342.521]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[467.736,552.987],[467.736,452.376],[440.65,552.589],[440.65,454.897]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[467.736,564.514],[467.736,665.126],[440.65,563.781],[440.65,661.473]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[467.736,683.129],[467.736,783.741],[440.65,678.954],[440.65,776.646]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[468.178,802.37],[468.178,902.981],[440.65,794.737],[440.65,892.429]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[531.043,437.025],[531.043,336.189],[467.736,437.253],[467.736,336.642]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[531.043,553.018],[531.043,452.181],[467.736,552.987],[467.736,452.376]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[531.043,564.571],[531.043,665.407],[467.736,564.514],[467.736,665.126]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[531.043,683.451],[531.043,784.288],[467.736,683.129],[467.736,783.741]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[528.466,802.931],[528.466,903.756],[468.178,802.37],[468.178,902.981]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[660.154,809.846],[660.154,913.315],[515.498,808.472],[515.498,911.416]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[653.797,434.458],[653.797,331.089],[518.6,434.955],[518.6,332.077]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[653.797,553.364],[653.797,449.995],[518.6,553.297],[518.6,450.418]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[653.797,565.207],[653.797,668.576],[518.6,565.083],[518.6,667.962]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[653.797,687.073],[653.797,790.442],[518.6,686.371],[518.6,789.249]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[568.089,326.768],[533.392,327.028],[568.089,232.12],[533.392,232.495]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[596.144,315.518],[596.144,215.858],[553.715,321.479],[553.715,224.475]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[667.604,310.512],[667.604,208.623],[596.144,315.518],[596.144,215.858]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[770.77,826.268],[770.77,936.017],[634.852,819.181],[634.852,926.219]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[763.956,428.034],[763.956,318.329],[635.915,430.647],[635.915,323.519]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[763.956,554.229],[763.956,444.524],[635.915,553.877],[635.915,446.749]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[763.956,566.798],[763.956,676.503],[635.915,566.151],[635.915,673.278]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[763.956,696.133],[763.956,805.838],[635.915,692.448],[635.915,799.576]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[787.774,304.865],[787.774,200.46],[667.604,310.512],[667.604,208.623]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1229.15,430.856],[1229.15,320.34],[767.775,432.578],[767.775,323.816]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1229.15,557.985],[1229.15,447.468],[767.775,557.687],[767.775,448.925]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1229.15,570.647],[1229.15,681.163],[767.775,570.148],[767.775,678.91]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1229.15,700.94],[1229.15,811.456],[767.775,698.372],[767.775,807.134]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1229.15,828.277],[1229.15,938.794],[767.775,823.688],[767.775,932.45]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[923.504,299.791],[923.504,193.126],[785.781,303.56],[785.781,198.573]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1089.69,298.407],[923.504,299.791],[1089.69,191.125],[923.504,193.126]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1089.68,298.407],[1089.68,191.125],[1231.22,300.11],[1231.22,193.584]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1236.79,301.176],[1236.79,195.128],[1367.33,304.885],[1367.33,200.489]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1244.33,426.166],[1244.33,314.617],[1383.52,427.795],[1383.52,317.853]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1244.33,554.48],[1244.33,442.932],[1383.52,554.261],[1383.52,444.319]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1244.33,567.26],[1244.33,678.809],[1383.52,566.857],[1383.52,676.799]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1244.33,698.769],[1244.33,810.318],[1383.52,696.472],[1383.52,806.413]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1235.92,830.937],[1235.92,942.471],[1383.56,826.545],[1383.56,936.399]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1374.95,431.804],[1374.95,325.818],[1518.47,431.276],[1518.47,324.769]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1374.95,553.721],[1374.95,447.734],[1518.47,553.792],[1518.47,447.285]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1374.95,565.864],[1374.95,671.85],[1518.47,565.995],[1518.47,672.502]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1374.95,690.816],[1374.95,796.802],[1518.47,691.561],[1518.47,798.068]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1366.81,816.559],[1366.81,922.595],[1520.31,818.017],[1520.31,924.61]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1367.33,304.885],[1367.33,200.489],[1448,308.802],[1448,206.151]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1448,308.802],[1448,206.151],[1499.88,314.209],[1499.88,213.967]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1490.99,319.853],[1528.08,319.575],[1490.99,222.124],[1528.08,221.723]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1510.81,433.493],[1510.81,329.173],[1578.87,433.248],[1578.87,328.685]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1510.81,553.494],[1510.81,449.173],[1578.87,553.527],[1578.87,448.964]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1510.81,565.446],[1510.81,669.766],[1578.87,565.507],[1578.87,670.069]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1510.81,688.434],[1510.81,792.754],[1578.87,688.78],[1578.87,793.342]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1512.33,812.08],[1577.15,812.683],[1512.33,916.403],[1577.15,917.237]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1528.08,319.575],[1528.08,221.723],[1532.89,324.806],[1532.89,229.283]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1532.89,324.806],[1532.89,229.283],[1534.58,328.446],[1534.58,234.545]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1577.15,812.683],[1577.15,917.237],[1614.71,805.349],[1614.71,907.098]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1578.87,433.248],[1578.87,328.685],[1615.93,436.095],[1615.93,334.342]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1578.87,553.527],[1578.87,448.964],[1615.93,553.143],[1615.93,451.389]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1578.87,565.507],[1578.87,670.069],[1615.93,564.801],[1615.93,666.555]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:62,
                    verts:[[1578.87,688.78],[1578.87,793.342],[1615.93,684.763],[1615.93,786.517]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[481.97,434.753],[481.97,331.674],[446.354,437.663],[446.354,337.455]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[481.97,553.324],[481.97,450.246],[446.354,552.932],[446.354,452.724]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[481.97,565.134],[481.97,668.212],[446.354,564.413],[446.354,664.621]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[481.97,686.657],[481.97,789.735],[446.354,682.552],[446.354,782.76]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[482.427,808.816],[482.427,911.891],[446.354,801.317],[446.354,901.525]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[548.21,434.803],[548.21,331.775],[481.97,434.753],[481.97,331.674]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[548.21,553.317],[548.21,450.289],[481.97,553.324],[481.97,450.246]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[548.21,565.121],[548.21,668.149],[481.97,565.134],[481.97,668.212]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[548.21,686.585],[548.21,789.614],[481.97,686.657],[481.97,789.735]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[545.515,808.692],[482.427,808.816],[545.515,911.719],[482.427,911.891]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[530.245,327.609],[530.245,233.336],[528.746,331.213],[528.746,238.544]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[534.715,322.417],[534.715,225.831],[530.245,327.61],[530.245,233.336]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[570.868,322.474],[534.715,322.417],[570.868,225.913],[534.715,225.831]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[687.653,814.197],[687.653,919.329],[537.445,814.499],[537.445,919.747]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[680.897,432.744],[680.897,327.685],[540.492,432.635],[540.492,327.467]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[680.897,553.594],[680.897,448.535],[540.492,553.609],[540.492,448.442]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[680.897,565.631],[680.897,670.691],[540.492,565.658],[540.492,670.826]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[680.897,689.49],[680.897,794.55],[540.492,689.645],[540.492,794.812]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[612.408,311.287],[612.408,209.742],[561.971,316.949],[561.971,217.927]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[691.307,306.903],[691.307,203.406],[612.408,311.287],[612.408,209.742]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[815.943,829.489],[815.943,940.469],[670.715,823.974],[670.715,932.845]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[808.934,426.754],[808.934,315.785],[672.029,428.793],[672.029,319.836]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[808.934,554.401],[808.934,443.433],[672.029,554.126],[672.029,445.17]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[808.934,567.115],[808.934,678.083],[672.029,566.61],[672.029,675.567]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[808.934,697.94],[808.934,808.908],[672.029,695.064],[672.029,804.021]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[819.817,302.388],[819.817,196.879],[691.307,306.903],[691.307,203.406]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[961.953,298.652],[961.953,191.479],[819.252,301.05],[819.252,194.946]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[810.447,431.365],[810.447,321.367],[1273.09,431.731],[1273.09,322.105]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[810.447,557.897],[810.447,447.899],[1273.09,557.833],[1273.09,448.208]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[810.447,570.499],[810.447,680.497],[1273.09,570.393],[1273.09,680.019]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[810.447,700.181],[810.447,810.179],[1273.09,699.635],[1273.09,809.261]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[810.447,826.921],[810.447,936.919],[1273.09,825.946],[1273.09,935.571]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[961.953,298.651],[1128.48,298.945],[961.953,191.479],[1128.48,191.903]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1128.48,298.945],[1128.48,191.903],[1265.35,302.046],[1265.35,196.383]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1269.62,303.157],[1269.62,197.992],[1392.08,308.084],[1392.08,205.113]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1290.39,427.15],[1290.39,316.573],[1421.12,429.398],[1421.12,321.038]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1290.39,554.348],[1290.39,443.771],[1421.12,554.045],[1421.12,445.685]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1290.39,567.017],[1290.39,677.594],[1421.12,566.46],[1421.12,674.82]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1290.39,697.38],[1290.39,807.958],[1421.12,694.21],[1421.12,802.57]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1282.17,828.498],[1282.17,939.1],[1420.95,822.411],[1420.95,930.685]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1403.29,433.307],[1403.29,328.802],[1541.93,433.415],[1541.93,329.017]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1403.29,553.519],[1403.29,449.014],[1541.93,553.504],[1541.93,449.106]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1403.29,565.492],[1403.29,669.996],[1541.93,565.465],[1541.93,669.863]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1403.29,688.696],[1403.29,793.201],[1541.93,688.544],[1541.93,792.942]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1395.56,812.773],[1395.56,917.361],[1543.89,812.475],[1543.89,916.949]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1392.08,308.084],[1392.08,205.113],[1465.35,312.699],[1465.35,211.783]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1465.35,312.699],[1465.35,211.783],[1509.11,318.479],[1509.11,220.138]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1494.57,323.929],[1530.22,323.986],[1494.57,228.016],[1530.22,228.098]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1529.37,435.552],[1529.37,333.263],[1594.6,435.602],[1594.6,333.361]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1529.37,553.216],[1529.37,450.927],[1594.6,553.21],[1594.6,450.969]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1529.37,564.936],[1529.37,667.225],[1594.6,564.923],[1594.6,667.164]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1529.37,685.529],[1529.37,787.819],[1594.6,685.459],[1594.6,787.699]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1530.82,806.752],[1530.82,909.038],[1592.94,806.629],[1592.94,908.869]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1592.94,806.629],[1592.94,908.869],[1621.74,799.068],[1621.74,898.415]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1594.6,435.602],[1594.6,333.361],[1622.9,438.535],[1622.9,339.189]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1594.6,553.21],[1594.6,450.969],[1622.9,552.815],[1622.9,453.468]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1594.6,564.923],[1594.6,667.164],[1622.9,564.197],[1622.9,663.544]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:63,
                    verts:[[1594.6,685.459],[1594.6,787.699],[1622.9,681.321],[1622.9,780.668]]
                },
                ],
                [
                {
                    num:"501",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[503.109,432.466],[503.109,327.133],[458.836,435.271],[458.836,332.703]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[503.109,553.632],[503.109,448.298],[458.836,553.254],[458.836,450.687]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[503.109,565.7],[503.109,671.033],[458.836,565.005],[458.836,667.573]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[503.109,689.882],[503.109,795.215],[458.836,685.926],[458.836,788.494]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[503.575,814.709],[503.575,920.037],[458.836,807.488],[458.836,910.055]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[571.454,432.821],[503.109,432.466],[571.454,327.837],[503.109,327.133]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[571.454,553.584],[571.454,448.6],[503.109,553.632],[503.109,448.298]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[571.454,565.612],[571.454,670.596],[503.109,565.7],[503.109,671.033]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[571.454,689.382],[503.109,689.882],[571.454,794.366],[503.109,795.215]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[568.674,813.837],[503.575,814.709],[568.674,918.833],[503.575,920.037]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[525.163,327.013],[525.163,232.474],[521.323,332.303],[521.323,240.12]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[530.774,323.362],[530.774,227.197],[525.163,327.013],[525.163,232.474]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[541.245,318.126],[541.245,219.628],[530.774,323.362],[530.774,227.197]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[578.464,318.526],[541.245,318.126],[578.464,220.206],[541.245,219.627]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[719.606,817.731],[565.965,819.831],[719.606,924.215],[565.965,927.119]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[712.541,431.344],[568.902,430.583],[712.541,324.903],[568.902,323.392]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[712.541,553.783],[712.541,447.342],[568.902,553.885],[568.902,446.694]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[712.541,565.978],[568.902,566.166],[712.541,672.419],[568.902,673.358]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[712.541,691.465],[568.902,692.539],[712.541,797.906],[568.902,799.73]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[633.709,307.586],[633.709,204.393],[575.515,312.833],[575.515,211.977]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[719.227,303.94],[719.227,199.123],[633.709,307.586],[633.709,204.393]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[864.075,831.564],[864.075,943.338],[711.725,827.805],[711.725,938.142]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[713.279,427.313],[713.278,316.896],[712.541,431.344],[712.541,324.903]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[713.279,554.326],[713.278,443.909],[712.541,553.783],[712.541,447.342]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[713.278,566.976],[713.279,677.393],[712.541,565.978],[712.541,672.419]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[713.278,697.151],[713.279,807.568],[712.541,691.465],[712.541,797.906]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[856.988,425.916],[856.988,314.121],[713.279,427.313],[713.279,316.896]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[856.988,554.514],[856.988,442.719],[713.279,554.326],[713.279,443.909]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[856.988,567.322],[856.988,679.117],[713.279,566.976],[713.279,677.393]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[856.988,699.122],[856.988,810.917],[713.279,697.151],[713.279,807.568]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[854.364,300.69],[854.364,194.425],[719.227,303.94],[719.227,199.123]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1000.72,298.391],[855.276,299.342],[1000.72,191.102],[855.276,192.477]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[856.099,430.565],[856.099,319.751],[1312.12,433.015],[1312.12,324.699]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[856.099,558.035],[856.099,447.221],[1312.12,557.612],[1312.12,449.295]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[856.099,570.731],[856.099,681.545],[1312.12,570.021],[1312.12,678.338]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[856.099,701.374],[856.099,812.188],[1312.12,697.72],[1312.12,806.036]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[856.099,829.054],[856.099,939.868],[1312.12,822.522],[1312.12,930.838]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1000.72,298.39],[1000.72,191.101],[1164.87,300.359],[1164.87,193.947]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1164.87,300.359],[1164.87,193.947],[1295,304.773],[1295,200.325]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1297.93,305.909],[1297.93,201.969],[1410.77,311.92],[1410.77,210.657]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1331.17,428.572],[1331.17,319.398],[1451.59,431.369],[1451.59,324.954]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1331.17,554.156],[1331.17,444.982],[1451.59,553.779],[1451.59,447.364]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1331.17,566.664],[1331.17,675.839],[1451.59,565.972],[1451.59,672.387]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1331.17,695.375],[1331.17,804.549],[1451.59,691.429],[1451.59,797.845]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1323.28,824.927],[1323.28,934.163],[1451.22,817.333],[1451.22,923.665]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1418.01,808.182],[1418.01,911.014],[1559.2,806.251],[1559.2,908.346]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1425.22,435.118],[1425.22,332.401],[1557.16,435.817],[1557.16,333.789]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1425.22,553.275],[1425.22,450.557],[1557.16,553.181],[1557.16,451.152]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1425.22,565.043],[1425.22,667.761],[1557.16,564.87],[1557.16,666.899]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1425.22,686.141],[1425.22,788.859],[1557.16,685.156],[1557.16,787.184]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1410.77,311.92],[1410.77,210.657],[1475.97,317.116],[1475.97,218.168]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1475.97,317.116],[1475.97,218.168],[1511.5,323.156],[1511.5,226.898]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1491.83,328.348],[1491.83,234.403],[1525.69,328.712],[1525.69,234.929]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1540.2,437.846],[1540.2,337.82],[1601.84,438.166],[1601.84,338.455]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1540.2,552.907],[1540.2,452.881],[1601.84,552.864],[1601.84,453.153]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1540.2,564.368],[1540.2,664.394],[1601.84,564.288],[1601.84,663.999]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1540.2,682.293],[1540.2,782.319],[1601.84,681.842],[1601.84,781.553]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1541.57,800.818],[1541.57,900.835],[1600.28,800.032],[1600.28,899.749]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1600.28,800.032],[1600.28,899.749],[1620.55,792.382],[1620.55,889.173]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1601.84,438.166],[1601.84,338.455],[1621.65,441.132],[1621.65,344.346]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1601.84,552.864],[1601.84,453.153],[1621.65,552.465],[1621.65,455.679]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1601.84,564.288],[1601.84,663.999],[1621.65,563.554],[1621.65,660.34]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:64,
                    verts:[[1601.84,681.842],[1601.84,781.553],[1621.65,677.659],[1621.65,774.444]]
                },
                ],
                [
                {
                    num:"402",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[476.527,552.102],[476.527,457.974],[475.065,550.929],[475.065,465.393]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[476.527,562.887],[476.527,657.015],[475.065,560.729],[475.065,646.265]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[476.527,673.858],[476.527,767.986],[475.065,661.571],[475.065,747.106]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[476.527,443.826],[476.527,349.698],[475.065,452.537],[475.065,367.001]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[478.327,433.101],[478.327,328.394],[476.536,443.771],[476.536,349.588]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[478.327,553.546],[478.327,448.839],[476.536,552.11],[476.536,457.927]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[478.327,565.543],[478.327,670.25],[476.536,562.9],[476.536,657.083]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[478.327,688.986],[478.327,793.693],[476.536,673.936],[476.536,768.119]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[478.327,813.083],[478.327,917.79],[476.536,785.56],[476.536,879.742]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[531.139,430.462],[531.139,323.151],[478.327,433.101],[478.327,328.395]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[531.139,553.902],[531.139,446.591],[478.327,553.546],[478.327,448.839]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[531.139,566.197],[531.139,673.507],[478.327,565.543],[478.327,670.25]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[531.139,692.71],[531.139,800.021],[478.327,688.986],[478.327,793.693]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[531.607,819.874],[531.607,927.178],[478.327,813.083],[478.327,917.79]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[526.584,323.109],[526.584,226.83],[516.655,328.435],[516.655,234.529]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[536.487,319.463],[536.487,221.56],[526.583,323.109],[526.583,226.83]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[531.139,430.462],[600.602,431.137],[531.139,323.151],[600.602,324.493]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[531.139,553.902],[531.139,446.591],[600.602,553.811],[600.602,447.167]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[531.139,566.197],[600.602,566.029],[531.139,673.507],[600.602,672.673]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[531.139,692.71],[600.602,691.756],[531.139,800.021],[600.602,798.401]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[531.607,819.874],[597.778,818.213],[531.607,927.178],[597.778,924.882]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[553.175,314.26],[553.175,214.04],[536.487,319.463],[536.487,221.56]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[553.175,314.26],[591.001,315.023],[553.175,214.04],[591.001,215.142]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[594.366,309.241],[594.366,206.786],[591.001,315.023],[591.001,215.142]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[659.831,304.524],[659.831,199.967],[594.366,309.241],[594.366,206.786]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[600.774,824.301],[600.774,933.297],[597.778,818.213],[597.778,924.882]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[603.547,428.865],[603.547,319.979],[600.602,431.137],[600.602,324.493]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[603.547,554.117],[603.547,445.231],[600.602,553.811],[600.602,447.167]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[603.547,566.592],[603.547,675.478],[600.602,566.029],[600.602,672.673]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[603.547,694.962],[603.547,803.847],[600.602,691.756],[600.602,798.401]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[600.774,824.301],[755.44,820.333],[600.774,933.297],[755.44,927.812]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[603.547,428.865],[603.546,319.979],[748.173,430.302],[748.172,322.834]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[603.547,554.117],[603.546,445.231],[748.173,553.923],[748.172,446.455]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[603.546,566.592],[603.547,675.478],[748.172,566.236],[748.173,673.704]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[603.546,694.962],[603.547,803.847],[748.172,692.934],[748.173,800.403]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[750.895,301.716],[750.895,195.909],[659.83,304.524],[659.83,199.967]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[757.071,830.54],[757.071,941.922],[746.511,820.168],[746.511,927.584]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[758.846,426.26],[758.846,314.804],[748.173,430.302],[748.172,322.834]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[758.846,554.468],[758.846,443.012],[748.173,553.923],[748.172,446.455]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[758.846,567.237],[758.846,678.693],[748.172,566.236],[748.173,673.704]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[758.846,698.636],[758.846,810.092],[748.172,692.934],[748.173,800.403]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[890.658,299.827],[890.658,193.178],[750.895,301.716],[750.895,195.909]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[914.002,832.416],[914.002,944.515],[757.071,830.54],[757.071,941.922]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[906.966,425.552],[906.966,313.398],[758.846,426.26],[758.846,314.804]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[906.966,554.563],[906.966,442.409],[758.846,554.468],[758.846,443.012]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[906.966,567.413],[906.966,679.566],[758.846,567.237],[758.846,678.693]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[906.966,699.636],[906.966,811.79],[758.846,698.636],[758.846,810.092]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[893.058,298.491],[1038.88,299.017],[893.058,191.247],[1038.88,192.007]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[903.649,430.206],[903.649,319.026],[1345.45,434.663],[1345.45,328.028]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[903.649,558.097],[903.649,446.917],[1345.45,557.327],[1345.45,450.691]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[903.649,570.835],[903.649,682.015],[1345.45,569.544],[1345.45,676.18]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[903.649,701.909],[903.649,813.089],[1345.45,695.261],[1345.45,801.896]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[903.649,830.011],[903.649,941.191],[1345.45,818.127],[1345.45,924.762]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1038.88,299.017],[1038.88,192.007],[1198.03,302.599],[1198.03,197.185]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1198.03,302.599],[1198.03,197.185],[1319.63,308.202],[1319.63,205.281]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1321.24,309.343],[1321.24,206.932],[1423.28,316.277],[1423.28,216.955]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1365.85,430.38],[1365.85,322.989],[1474.57,433.643],[1474.57,329.47]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1365.85,553.913],[1365.85,446.522],[1474.57,553.473],[1474.57,449.301]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1365.85,566.217],[1365.85,673.608],[1474.57,565.409],[1474.57,669.581]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1365.85,692.824],[1365.85,800.215],[1474.57,688.222],[1474.57,792.395]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1358.4,820.351],[1358.4,927.837],[1474.01,811.478],[1474.01,915.571]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1433.96,802.927],[1433.96,903.751],[1566.44,799.529],[1566.44,899.053]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1423.28,316.277],[1423.28,216.955],[1480,321.933],[1480,225.13]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1440.58,437.182],[1440.58,336.501],[1564.35,438.412],[1564.35,338.944]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1440.58,552.997],[1440.58,452.315],[1564.35,552.831],[1564.35,453.363]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1440.58,564.532],[1440.58,665.213],[1564.35,564.227],[1564.35,663.695]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1440.58,683.229],[1440.58,783.911],[1564.35,681.494],[1564.35,780.963]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1480,321.933],[1480,225.13],[1507.38,328.121],[1507.38,234.075]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1483.18,333.002],[1483.18,241.13],[1514.97,333.643],[1514.97,242.057]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1543.56,440.312],[1543.56,342.718],[1601.04,440.871],[1601.04,343.829]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1543.56,552.575],[1543.56,454.981],[1601.04,552.5],[1601.04,455.457]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1543.56,563.757],[1543.56,661.351],[1601.04,563.618],[1601.04,660.661]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1543.56,678.815],[1543.56,776.409],[1601.04,678.026],[1601.04,775.068]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1544.83,794.444],[1544.83,892.023],[1599.58,793.07],[1599.58,890.124]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1599.58,793.07],[1599.58,890.124],[1611.77,785.456],[1611.77,879.598]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1601.04,440.871],[1601.04,343.829],[1612.79,443.821],[1612.79,349.688]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1601.04,552.5],[1601.04,455.457],[1612.79,552.103],[1612.79,457.97]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1601.04,563.618],[1601.04,660.661],[1612.79,562.888],[1612.79,657.021]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:65,
                    verts:[[1601.04,678.026],[1601.04,775.068],[1612.79,673.865],[1612.79,767.999]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[476.113,442.047],[476.113,346.163],[452.806,450.86],[452.806,363.67]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[476.113,552.342],[476.113,456.458],[452.806,551.155],[452.806,463.965]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[476.113,563.327],[476.113,659.211],[452.806,561.145],[452.806,648.335]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[476.113,676.368],[476.113,772.252],[452.806,663.937],[452.806,751.127]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[476.018,789.915],[476.018,885.763],[452.727,767.197],[452.727,854.357]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[504.764,431.213],[504.764,324.643],[476.26,441.991],[476.26,346.053]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[504.764,553.801],[504.764,447.231],[476.26,552.349],[476.26,456.411]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[504.764,566.01],[504.764,672.581],[476.26,563.341],[476.26,659.279]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[504.764,691.65],[504.764,798.22],[476.26,676.447],[476.26,772.385]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[504.764,817.955],[504.764,924.525],[476.26,790.152],[476.26,886.09]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[565.725,428.795],[565.725,319.841],[504.764,431.213],[504.764,324.643]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[565.725,554.126],[565.725,445.172],[504.764,553.801],[504.764,447.231]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[565.725,566.609],[565.725,675.563],[504.764,566.01],[504.764,672.581]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[565.725,695.06],[565.725,804.014],[504.764,691.65],[504.764,798.22]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[566.188,824.166],[566.188,933.111],[504.764,817.955],[504.764,924.525]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[533.215,319.582],[533.215,221.732],[516.991,324.868],[516.991,229.373]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[547.504,315.997],[547.504,216.55],[533.214,319.582],[533.214,221.732]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[570.493,310.912],[570.493,209.201],[547.504,315.997],[547.504,216.55]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[565.725,428.795],[565.725,319.841],[635.201,429.8],[635.201,321.837]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[565.725,554.126],[565.725,445.172],[635.201,553.991],[635.201,446.027]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[565.725,566.609],[565.725,675.563],[635.201,566.36],[635.201,674.324]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[565.725,695.06],[565.725,804.014],[635.201,693.643],[635.201,801.606]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[566.188,824.166],[632.378,821.697],[566.188,933.111],[632.378,929.698]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[570.493,310.912],[608.411,312.046],[570.493,209.201],[608.411,210.84]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[618.319,306.264],[618.319,202.483],[608.411,312.046],[608.411,210.84]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[690.329,302.181],[690.329,196.58],[618.319,306.265],[618.319,202.483]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[641.274,827.776],[641.274,938.102],[632.378,821.697],[632.378,929.698]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[643.827,427.531],[643.827,317.33],[635.201,429.8],[635.201,321.836]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[643.827,554.296],[643.827,444.095],[635.201,553.991],[635.201,446.027]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[643.827,566.922],[643.827,677.123],[635.201,566.36],[635.201,674.324]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[643.827,696.843],[643.827,807.044],[635.201,693.643],[635.201,801.606]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[641.274,827.776],[641.274,938.102],[794.382,821.936],[794.382,930.027]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[643.826,427.531],[643.826,317.33],[787.027,429.647],[787.027,321.534]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[643.826,554.296],[643.826,444.095],[787.027,554.011],[787.027,445.898]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[643.826,566.922],[643.826,677.123],[787.027,566.398],[787.027,674.512]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[643.826,696.843],[643.826,807.044],[787.027,693.858],[787.027,801.972]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[785.653,300.288],[785.653,193.844],[690.329,302.181],[690.329,196.58]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[927.857,299.813],[785.653,300.288],[927.857,193.158],[785.653,193.844]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[805.7,832.099],[805.7,944.078],[785.222,821.877],[785.222,929.947]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[807.669,425.664],[807.669,313.621],[787.027,429.647],[787.027,321.534]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[807.669,554.548],[807.669,442.505],[787.027,554.011],[787.027,445.898]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[807.669,567.385],[807.669,679.428],[787.027,566.398],[787.027,674.512]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[807.669,699.477],[807.669,811.52],[787.027,693.858],[787.027,801.972]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[964.461,832.034],[805.7,832.099],[964.461,943.987],[805.7,944.078]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[957.6,425.667],[807.669,425.664],[957.6,313.627],[807.669,313.621]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[957.6,554.547],[957.6,442.507],[807.669,554.548],[807.669,442.505]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[957.6,567.384],[957.6,679.424],[807.669,567.385],[807.669,679.428]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[957.6,699.473],[807.669,699.477],[957.6,811.513],[807.669,811.52]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[931.709,298.512],[931.709,191.277],[1075.54,300.493],[1075.54,194.14]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[951.912,430.294],[951.912,319.204],[1372.61,436.614],[1372.61,331.968]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[951.912,558.082],[951.912,446.992],[1372.61,556.99],[1372.61,452.343]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[951.912,570.81],[951.912,681.9],[1372.61,568.979],[1372.61,673.625]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[951.912,701.778],[951.912,812.868],[1372.61,692.351],[1372.61,796.997]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[951.912,829.777],[951.912,940.867],[1372.61,812.925],[1372.61,917.571]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1075.55,300.493],[1075.55,194.14],[1227.34,305.577],[1227.34,201.488]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1227.34,305.576],[1227.34,201.488],[1338.95,312.212],[1338.95,211.077]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1339.28,313.34],[1339.28,212.71],[1429.75,321.024],[1429.75,223.817]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1393.97,432.506],[1393.97,327.212],[1490.06,436.143],[1490.06,334.436]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1393.97,553.626],[1393.97,448.332],[1490.06,553.137],[1490.06,451.43]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1393.97,565.69],[1393.97,670.984],[1490.06,564.789],[1490.06,666.496]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1393.97,689.826],[1393.97,795.119],[1490.06,684.696],[1490.06,786.403]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1387.06,814.944],[1387.06,920.363],[1489.35,805.041],[1489.35,906.673]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1429.75,321.024],[1429.75,223.817],[1477.83,327.016],[1477.83,232.478]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1477.83,327.016],[1477.83,232.478],[1497.34,333.251],[1497.34,241.491]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1449.47,439.436],[1449.47,340.977],[1564.01,441.128],[1564.01,344.339]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1449.47,552.693],[1449.47,454.235],[1564.01,552.465],[1564.01,455.676]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1449.47,563.974],[1449.47,662.432],[1564.01,563.555],[1564.01,660.344]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1449.47,680.051],[1449.47,778.51],[1564.01,677.663],[1564.01,774.453]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1443.49,797.174],[1443.49,895.797],[1566.11,792.496],[1566.11,889.331]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1469.21,337.785],[1469.21,248.043],[1498.74,338.668],[1498.74,249.32]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1539.96,442.883],[1539.96,347.824],[1592.91,443.648],[1592.91,349.345]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1539.96,552.229],[1539.96,457.17],[1592.91,552.126],[1592.91,457.823]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1539.96,563.12],[1539.96,658.179],[1592.91,562.931],[1592.91,657.234]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1539.96,675.189],[1539.96,770.248],[1592.91,674.109],[1592.91,768.413]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1541.13,787.801],[1541.13,882.841],[1591.56,785.92],[1591.56,880.24]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1591.56,785.92],[1591.56,880.24],[1596.22,778.45],[1596.22,869.913]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1592.91,443.648],[1592.91,349.345],[1597.15,446.54],[1597.15,355.089]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1592.91,552.126],[1592.91,457.823],[1597.15,551.737],[1597.15,460.286]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1592.91,562.931],[1592.91,657.234],[1597.15,562.214],[1597.15,653.665]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:66,
                    verts:[[1592.91,674.109],[1592.91,768.413],[1597.15,670.03],[1597.15,761.48]]
                },
                ],
                [
                {
                    num:"102",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[481.149,794.091],[481.149,891.535],[435.087,771.402],[435.087,860.171]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[481.337,440.428],[481.337,342.948],[435.243,449.229],[435.243,360.431]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[481.337,552.56],[481.337,455.08],[435.243,551.375],[435.243,462.576]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[481.337,563.728],[481.337,661.208],[435.243,561.548],[435.243,650.347]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[481.337,678.651],[481.337,776.131],[435.243,666.236],[435.243,755.035]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[537.778,429.651],[537.778,321.541],[481.628,440.373],[481.628,342.838]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[537.778,554.011],[537.778,445.901],[481.628,552.567],[481.628,455.033]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[537.778,566.397],[537.778,674.507],[481.628,563.742],[481.628,661.277]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[537.778,693.853],[537.778,801.963],[481.628,678.73],[481.628,776.264]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[537.778,821.983],[537.778,930.094],[481.628,794.326],[481.628,891.861]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[515.124,327.514],[515.124,233.198],[514.555,331.134],[514.555,238.43]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[520.36,322.008],[520.36,225.239],[515.124,327.514],[515.124,233.198]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[545.075,316.502],[545.075,217.28],[522.479,321.667],[522.479,224.747]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[606.224,427.511],[606.224,317.289],[537.778,429.651],[537.778,321.541]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[606.224,554.299],[606.224,444.077],[537.778,554.011],[537.778,445.901]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[606.224,566.927],[606.224,677.149],[537.778,566.397],[537.778,674.507]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[606.224,696.872],[606.224,807.094],[537.778,693.853],[537.778,801.963]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[606.673,827.475],[606.673,937.685],[537.778,821.983],[537.778,930.094]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[563.747,313.035],[563.747,212.269],[545.075,316.502],[545.075,217.28]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[592.966,308.154],[592.966,205.214],[563.747,313.035],[563.747,212.269]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[592.967,308.154],[630.425,309.659],[592.967,205.214],[630.425,207.389]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[606.224,427.511],[606.224,317.289],[674.54,428.84],[674.54,319.93]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[606.224,554.299],[606.224,444.078],[674.54,554.12],[674.54,445.21]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[606.224,566.927],[606.224,677.149],[674.54,566.598],[674.54,675.508]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[606.224,696.872],[606.224,807.094],[674.54,694.997],[674.54,803.906]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[606.673,827.475],[606.673,937.685],[671.764,824.207],[671.764,933.167]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[646.949,303.968],[646.949,199.163],[630.425,309.659],[630.425,207.389]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[724.565,300.605],[724.565,194.303],[646.949,303.968],[646.949,199.163]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[686.583,830.171],[686.583,941.412],[671.764,824.207],[671.764,933.167]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[688.865,426.615],[688.865,315.51],[674.54,428.84],[674.54,319.93]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[688.865,554.42],[688.865,443.315],[674.54,554.12],[674.54,445.21]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[688.865,567.149],[688.865,678.254],[674.54,566.598],[674.54,675.508]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[688.865,698.136],[688.865,809.241],[674.54,694.997],[674.54,803.906]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[686.583,830.171],[686.583,941.412],[835.513,822.516],[835.513,930.83]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[688.865,426.615],[688.865,315.51],[828.191,429.389],[828.191,321.02]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[688.865,554.42],[688.865,443.315],[828.191,554.046],[828.191,445.677]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[688.865,567.149],[688.865,678.254],[828.191,566.462],[828.191,674.831]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[688.865,698.135],[688.865,809.241],[828.191,694.223],[828.191,802.592]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[822.704,299.675],[822.704,192.958],[724.565,300.605],[724.565,194.303]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[822.704,299.675],[965.091,300.621],[822.704,192.958],[965.091,194.325]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[856.397,832.462],[856.397,944.58],[826.271,822.567],[826.271,930.9]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[858.526,425.533],[858.526,313.361],[828.191,429.389],[828.191,321.02]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[858.526,554.565],[858.526,442.393],[828.191,554.046],[828.191,445.677]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[858.526,567.417],[858.526,679.589],[828.191,566.462],[828.191,674.831]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[858.526,699.661],[858.526,811.833],[828.191,694.223],[828.191,802.592]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[856.397,832.463],[1014.19,830.469],[856.397,944.58],[1014.19,941.824]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[858.526,425.533],[858.526,313.361],[1007.62,426.243],[1007.62,314.77]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[858.526,554.565],[858.526,442.393],[1007.62,554.47],[1007.62,442.997]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[858.526,567.417],[858.526,679.589],[1007.62,567.241],[1007.62,678.714]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[858.526,699.661],[858.526,811.833],[1007.62,698.661],[1007.62,810.133]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[970.321,299.374],[970.321,192.523],[1109.94,302.742],[1109.94,197.391]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[999.692,430.812],[999.692,320.25],[1393.45,438.797],[1393.45,336.377]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[999.692,557.992],[999.692,447.43],[1393.45,556.612],[1393.45,454.192]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[999.692,570.66],[999.692,681.222],[1393.45,568.347],[1393.45,670.767]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[999.692,701.006],[999.692,811.568],[1393.45,689.095],[1393.45,791.515]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[999.692,828.396],[999.692,938.958],[1393.45,807.104],[1393.45,909.524]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1109.94,302.742],[1109.94,197.391],[1252.34,309.173],[1252.34,206.687]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1252.34,309.173],[1252.34,206.687],[1352.92,316.668],[1352.92,217.519]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1352.04,317.768],[1352.04,219.11],[1430.53,326.027],[1430.53,231.048]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1415.38,434.873],[1415.38,331.914],[1498.39,438.792],[1498.39,339.698]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1415.38,553.308],[1415.38,450.349],[1498.39,552.78],[1498.39,453.686]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1415.38,565.104],[1415.38,668.063],[1498.39,564.133],[1498.39,663.227]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1415.38,686.486],[1415.38,789.445],[1498.39,680.959],[1498.39,780.053]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1409.07,808.904],[1409.07,912.013],[1497.54,798.222],[1497.54,897.247]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1430.53,326.027],[1430.53,231.048],[1470.04,332.239],[1470.04,240.027]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1470.04,332.239],[1470.04,240.027],[1482.07,338.432],[1482.07,248.979]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1446.94,791.09],[1446.94,887.387],[1558.95,785.334],[1558.95,879.43]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1452.25,441.812],[1452.25,345.698],[1556.86,443.895],[1556.86,349.835]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1452.25,552.373],[1452.25,456.259],[1556.86,552.093],[1556.86,458.033]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1452.25,563.385],[1452.25,659.5],[1556.86,562.869],[1556.86,656.929]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1452.25,676.698],[1452.25,772.813],[1556.86,673.761],[1556.86,767.821]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1530.13,445.495],[1530.13,353.013],[1578.32,446.433],[1578.32,354.876]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1530.13,551.877],[1530.13,459.395],[1578.32,551.751],[1578.32,460.194]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1530.13,562.473],[1530.13,654.955],[1578.32,562.241],[1578.32,653.798]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1530.13,671.504],[1530.13,763.986],[1578.32,670.181],[1578.32,761.738]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:67,
                    verts:[[1531.19,781.053],[1531.19,873.512],[1577.09,778.748],[1577.09,870.326]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[492.21,438.997],[492.21,340.105],[422.759,447.666],[422.759,357.325]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[492.21,552.752],[492.21,453.861],[422.759,551.585],[422.759,461.245]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[492.21,564.083],[492.21,662.974],[422.759,561.936],[422.759,652.276]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[492.21,680.67],[492.21,779.562],[422.759,668.442],[422.759,758.782]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[491.928,797.785],[491.928,896.641],[422.524,775.436],[422.524,865.748]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[576.716,428.448],[576.716,319.152],[492.647,438.942],[492.647,339.997]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[576.716,554.173],[576.716,444.876],[492.647,552.76],[492.647,453.814]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[576.716,566.695],[576.716,675.992],[492.647,564.096],[492.647,663.042]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[576.716,695.549],[576.716,804.846],[492.647,680.747],[492.647,779.693]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[576.716,825.086],[576.716,934.383],[492.647,798.016],[492.647,896.961]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[514.389,328.307],[514.389,234.345],[510.365,333.221],[510.365,241.447]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[519.014,324.68],[519.014,229.102],[514.389,328.308],[514.389,234.345]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[530.534,319.205],[530.534,221.187],[519.014,324.68],[519.014,229.102]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[561.997,313.918],[561.997,213.545],[533.088,318.883],[533.088,220.722]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[584.944,310.626],[584.944,208.787],[561.997,313.918],[561.997,213.545]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[651.724,426.631],[651.724,315.541],[576.715,428.448],[576.715,319.152]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[651.724,554.418],[651.724,443.328],[576.715,554.173],[576.715,444.876]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[651.724,567.145],[651.724,678.235],[576.715,566.695],[576.715,675.992]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[651.724,698.114],[651.724,809.203],[576.715,695.549],[576.715,804.846]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[652.151,829.74],[652.151,940.816],[576.715,825.086],[576.715,934.383]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[620.163,306.03],[620.163,202.144],[584.944,310.626],[584.944,208.787]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[620.164,306.03],[620.164,202.144],[656.603,307.893],[656.603,204.837]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[651.724,426.631],[651.724,315.541],[717.707,428.271],[717.707,318.8]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[651.724,554.418],[651.724,443.328],[717.707,554.197],[717.707,444.725]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[651.724,567.145],[651.724,678.235],[717.707,566.739],[717.707,676.21]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[651.724,698.114],[651.724,809.203],[717.707,695.799],[717.707,805.271]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[652.151,829.74],[652.151,940.816],[715.025,825.707],[715.025,935.241]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[679.645,302.383],[679.645,196.873],[656.603,307.893],[656.603,204.837]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[761.754,299.807],[761.754,193.149],[679.644,302.383],[679.644,196.873]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[735.611,831.455],[735.611,943.186],[715.025,825.707],[715.025,935.241]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[737.579,426.127],[737.579,314.541],[717.707,428.271],[717.707,318.799]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[737.579,554.485],[737.579,442.899],[717.707,554.197],[717.707,444.725]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[737.579,567.27],[737.579,678.856],[717.707,566.739],[717.707,676.21]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[737.579,698.824],[737.579,810.41],[717.707,695.799],[717.707,805.271]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[735.61,831.455],[735.61,943.186],[877.853,822.106],[877.853,930.263]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[737.579,426.127],[737.578,314.541],[870.683,429.516],[870.683,321.272]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[737.579,554.485],[737.578,442.899],[870.683,554.029],[870.683,445.785]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[737.578,567.27],[737.579,678.856],[870.683,566.431],[870.683,674.675]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[737.578,698.824],[737.579,810.41],[870.683,694.044],[870.683,802.288]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[861.182,299.857],[761.753,299.807],[861.182,193.221],[761.753,193.149]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[861.182,299.857],[861.182,193.221],[1001.54,302.183],[1001.54,196.584]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[910.147,425.851],[910.146,313.992],[870.683,429.516],[870.683,321.272]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[910.147,554.523],[910.146,442.664],[870.683,554.029],[870.683,445.785]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[910.146,567.339],[910.147,679.198],[870.683,566.431],[870.683,674.675]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[910.146,699.214],[910.147,811.073],[870.683,694.044],[870.683,802.288]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[907.896,831.672],[907.896,943.486],[868.68,822.263],[868.68,930.48]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[907.896,831.672],[907.896,943.486],[1062.04,827.832],[1062.04,938.179]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[910.147,425.851],[910.147,313.992],[1055.87,427.237],[1055.87,316.746]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[910.147,554.523],[910.147,442.664],[1055.87,554.336],[1055.87,443.845]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[910.147,567.339],[910.147,679.198],[1055.87,566.995],[1055.87,677.486]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[910.147,699.214],[910.147,811.073],[1055.87,697.258],[1055.87,807.749]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1008.04,301.009],[1008.04,194.887],[1141.44,305.655],[1141.44,201.602]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1045.89,431.721],[1045.89,322.086],[1408.09,441.139],[1408.09,341.106]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1045.89,557.835],[1045.89,448.2],[1408.09,556.208],[1408.09,456.175]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1045.89,570.396],[1045.89,680.031],[1408.09,567.669],[1408.09,667.701]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1045.89,699.649],[1045.89,809.284],[1408.09,685.601],[1408.09,785.634]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1045.89,825.971],[1045.89,935.606],[1408.09,800.86],[1408.09,900.892]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1141.44,305.655],[1141.44,201.602],[1272.85,313.253],[1272.85,212.585]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1272.85,313.253],[1272.85,212.585],[1361.72,321.43],[1361.72,224.401]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1359.74,322.488],[1359.74,225.932],[1426.16,331.153],[1426.16,238.458]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1430.26,437.402],[1430.26,336.938],[1500.13,441.514],[1500.13,345.106]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1430.26,552.967],[1430.26,452.503],[1500.13,552.413],[1500.13,456.005]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1430.26,564.478],[1430.26,664.942],[1500.13,563.459],[1500.13,659.867]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1430.26,682.919],[1430.26,783.384],[1500.13,677.119],[1500.13,773.527]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1424.59,802.434],[1424.59,903.068],[1499.16,791.214],[1499.16,887.559]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1426.16,331.153],[1426.16,238.458],[1457.32,337.481],[1457.32,247.604]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1457.32,337.481],[1457.32,247.604],[1462.37,343.558],[1462.37,256.388]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1444.84,784.841],[1444.84,878.748],[1545.83,778.203],[1545.83,869.572]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1449.46,444.249],[1449.46,350.538],[1543.78,446.65],[1543.78,355.308]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1449.46,552.045],[1449.46,458.334],[1543.78,551.722],[1543.78,460.379]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1449.46,562.782],[1449.46,656.493],[1543.78,562.187],[1543.78,653.529]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1449.46,673.261],[1449.46,766.972],[1543.78,669.874],[1543.78,761.217]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1514.91,448.092],[1514.91,358.171],[1558.26,449.17],[1558.26,360.312]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1514.91,551.528],[1514.91,461.607],[1558.26,551.383],[1558.26,462.525]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1514.91,561.83],[1514.91,651.75],[1558.26,561.563],[1558.26,650.42]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1514.91,667.841],[1514.91,757.761],[1558.26,666.32],[1558.26,755.178]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:68,
                    verts:[[1515.86,774.346],[1515.86,864.24],[1557.15,771.697],[1557.15,860.579]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[508.545,437.77],[508.545,337.668],[415.59,446.185],[415.59,354.384]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[508.545,552.918],[508.545,452.816],[415.59,551.784],[415.59,459.983]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[508.545,564.386],[508.545,664.488],[415.59,562.302],[415.59,654.104]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[508.545,682.401],[508.545,782.503],[415.59,670.531],[415.59,762.332]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[508.17,800.953],[508.17,901.021],[415.274,779.258],[415.274,871.031]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[519.017,325.798],[519.017,230.718],[509.434,330.683],[509.434,237.778]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[620.687,427.617],[620.687,317.501],[509.128,437.717],[509.128,337.563]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[620.687,554.285],[620.687,444.168],[509.128,552.925],[509.128,452.771]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[620.687,566.901],[620.687,677.017],[509.128,564.4],[509.128,664.554]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[620.687,696.721],[620.687,806.838],[509.128,682.475],[509.128,782.629]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[620.687,827.23],[620.687,937.346],[509.128,801.177],[509.128,901.331]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[527.782,322.21],[527.782,225.531],[519.017,325.798],[519.017,230.718]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[545.644,316.841],[545.644,217.77],[527.782,322.21],[527.782,225.531]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[583.631,311.854],[583.631,210.563],[548.614,316.542],[548.614,217.339]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[610.641,308.789],[610.641,206.132],[583.631,311.854],[583.631,210.563]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[651.479,304.552],[651.479,200.008],[610.642,308.789],[610.642,206.132]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[701.124,426.158],[701.124,314.603],[620.687,427.618],[620.687,317.501]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[701.124,554.481],[701.124,442.926],[620.687,554.285],[620.687,444.169]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[701.124,567.262],[701.124,678.818],[620.687,566.901],[620.687,677.017]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[701.124,698.78],[701.124,810.336],[620.687,696.721],[620.687,806.838]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[701.523,830.953],[701.523,942.494],[620.687,827.229],[620.687,937.346]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[651.479,304.552],[651.479,200.008],[686.354,306.752],[686.354,203.188]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[715.651,301.508],[715.651,195.607],[686.354,306.752],[686.354,203.188]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[701.124,426.158],[701.124,314.603],[763.662,428.085],[763.662,318.43]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[701.124,554.481],[701.124,442.926],[763.662,554.222],[763.662,444.567]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[701.124,567.262],[701.124,678.818],[763.662,566.785],[763.662,676.44]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[701.124,698.78],[701.124,810.336],[763.662,696.062],[763.662,805.717]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[701.523,830.953],[701.523,942.494],[761.119,826.217],[761.119,935.946]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[801.025,299.759],[801.025,193.079],[715.651,301.508],[715.651,195.607]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[787.145,831.654],[787.145,943.462],[761.119,826.217],[761.119,935.946]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[788.766,426.057],[788.766,314.402],[763.662,428.085],[763.662,318.43]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[788.766,554.495],[788.766,442.839],[763.662,554.222],[763.662,444.567]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[788.766,567.287],[788.766,678.943],[763.662,566.785],[763.662,676.44]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[788.766,698.922],[788.766,810.578],[763.662,696.062],[763.662,805.717]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[787.145,831.654],[787.145,943.462],[920.434,820.781],[920.434,928.431]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[788.765,426.057],[788.765,314.402],[913.525,429.999],[913.525,322.232]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[788.765,554.495],[788.765,442.84],[913.525,553.964],[913.525,446.197]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[788.765,567.287],[788.765,678.943],[913.525,566.311],[913.525,674.078]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[788.765,698.922],[788.765,810.578],[913.525,693.362],[913.525,801.13]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[801.025,299.759],[900.214,300.775],[801.025,193.079],[900.214,194.548]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[900.214,300.775],[900.214,194.548],[1036.49,304.404],[1036.49,199.793]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[961.312,426.577],[961.311,315.435],[913.525,429.999],[913.525,322.232]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[961.312,554.425],[961.311,443.283],[913.525,553.964],[913.525,446.197]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[961.311,567.158],[961.312,678.301],[913.525,566.311],[913.525,674.078]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[961.311,698.189],[961.312,809.331],[913.525,693.362],[913.525,801.13]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[958.979,829.825],[958.979,940.934],[911.471,821.041],[911.471,928.79]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[958.979,829.825],[958.979,940.934],[1107.05,824.278],[1107.05,933.265]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[961.312,426.577],[961.312,315.435],[1101.36,428.591],[1101.36,319.435]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[961.312,554.425],[961.312,443.283],[1101.36,554.154],[1101.36,444.998]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[961.312,567.158],[961.312,678.301],[1101.36,566.66],[1101.36,675.816]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[961.312,698.189],[961.312,809.331],[1101.36,695.348],[1101.36,804.504]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1044.12,303.317],[1044.12,198.222],[1169.61,309.103],[1169.61,206.586]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1089.57,432.968],[1089.57,324.604],[1416.92,443.569],[1416.92,346.013]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1089.57,557.62],[1089.57,449.256],[1416.92,555.788],[1416.92,458.232]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1089.57,570.035],[1089.57,678.399],[1416.92,566.965],[1416.92,664.521]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1089.57,697.79],[1089.57,806.154],[1416.92,681.978],[1416.92,779.533]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1089.57,822.647],[1089.57,931.011],[1416.92,794.382],[1416.92,891.938]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1169.61,309.103],[1169.61,206.586],[1288.85,317.673],[1288.85,218.974]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1288.85,317.673],[1288.85,218.974],[1365.72,326.359],[1365.72,231.526]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1362.73,327.365],[1362.73,232.982],[1417.25,336.284],[1417.25,245.874]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1417.25,336.284],[1417.25,245.874],[1440.44,342.637],[1440.44,255.057]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1439,440.017],[1439,342.131],[1496,444.244],[1496,350.527]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1439,552.615],[1439,454.729],[1496,552.046],[1496,458.33]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1439,563.83],[1439,661.716],[1496,562.783],[1496,656.499]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1439,679.232],[1439,777.117],[1496,673.269],[1496,766.986]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1434.01,795.731],[1434.01,893.803],[1494.94,784.19],[1494.94,877.848]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1437.82,778.575],[1437.82,870.087],[1527.72,771.242],[1527.72,859.949]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1441.76,446.688],[1441.76,355.383],[1525.72,449.34],[1525.72,360.652]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1441.76,551.717],[1441.76,460.411],[1525.72,551.36],[1525.72,462.671]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1441.76,562.178],[1441.76,653.483],[1525.72,561.521],[1525.72,650.21]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1441.76,669.821],[1441.76,761.127],[1525.72,666.08],[1525.72,754.769]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1495.18,450.625],[1495.18,363.203],[1533.73,451.812],[1533.73,365.562]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1495.18,551.187],[1495.18,463.765],[1533.73,551.027],[1533.73,464.776]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1495.18,561.203],[1495.18,648.625],[1533.73,560.909],[1533.73,647.159]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1495.18,664.268],[1495.18,751.69],[1533.73,662.593],[1533.73,748.843]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:69,
                    verts:[[1496.02,767.806],[1496.02,855.2],[1532.74,764.888],[1532.74,851.166]]
                },
                ],
                [
                {
                    num:"502",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[529.99,436.755],[529.99,335.652],[413.824,444.798],[413.824,351.629]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[529.99,553.054],[529.99,451.951],[413.824,551.971],[413.824,458.802]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[529.99,564.638],[529.99,665.741],[413.824,562.646],[413.824,655.815]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[529.99,683.833],[529.99,784.936],[413.824,672.487],[413.824,765.656]]
                },{
                    num:"102",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[529.523,803.576],[529.523,904.647],[413.428,782.839],[413.428,875.981]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[528.297,323.618],[528.297,227.566],[513.104,328.412],[513.104,234.495]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[541.209,320.116],[541.209,222.504],[528.297,323.618],[528.297,227.566]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[668.647,427.154],[668.647,316.581],[530.715,436.705],[530.715,335.552]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[668.647,554.347],[668.647,443.774],[530.715,553.061],[530.715,451.908]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[668.647,567.016],[668.647,677.589],[530.715,564.65],[530.715,665.803]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[668.647,697.375],[668.647,807.949],[530.715,683.904],[530.715,785.056]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[668.647,828.425],[668.647,938.998],[530.715,803.788],[530.715,904.941]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[565.347,314.925],[565.347,215.001],[541.209,320.115],[541.209,222.504]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[609.491,310.313],[609.491,208.335],[568.703,314.655],[568.703,214.611]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[640.258,307.52],[640.258,204.298],[609.491,310.313],[609.491,208.335]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[686.197,303.705],[686.197,198.784],[640.258,307.521],[640.258,204.298]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[753.232,426.077],[753.232,314.441],[668.647,427.154],[668.647,316.581]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[753.232,554.492],[753.232,442.856],[668.647,554.347],[668.647,443.774]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[753.232,567.282],[753.232,678.918],[668.647,567.016],[668.647,677.589]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[753.232,698.894],[753.232,810.53],[668.647,697.375],[668.647,807.948]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[753.594,831.159],[753.594,942.778],[668.647,828.425],[668.647,938.998]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[686.198,303.705],[686.198,198.783],[719.001,306.213],[719.001,202.408]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[754.143,301.307],[754.143,195.317],[719.002,306.212],[719.002,202.408]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[753.232,426.077],[753.232,314.441],[811.329,428.258],[811.329,318.774]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[753.232,554.492],[753.232,442.856],[811.329,554.198],[811.329,444.714]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[753.232,567.282],[753.232,678.918],[811.329,566.742],[811.329,676.227]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[753.232,698.894],[753.232,810.53],[811.329,695.818],[811.329,805.302]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[753.594,831.159],[753.594,942.778],[808.964,825.797],[808.964,935.365]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[841.499,300.401],[841.499,194.007],[754.142,301.307],[754.142,195.317]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[839.96,830.845],[839.96,942.344],[808.964,825.797],[808.964,935.365]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[841.212,426.375],[841.211,315.034],[811.33,428.258],[811.33,318.774]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[841.212,554.452],[841.211,443.111],[811.33,554.198],[811.33,444.714]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[841.211,567.208],[841.212,678.55],[811.33,566.742],[811.33,676.227]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[841.211,698.473],[841.212,809.815],[811.33,695.818],[811.33,805.302]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[839.96,830.845],[839.96,942.344],[962.37,818.654],[962.37,925.491]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[841.499,300.401],[841.499,194.007],[938.992,302.344],[938.992,196.815]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[841.211,426.375],[841.21,315.034],[955.82,430.796],[955.82,323.815]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[841.211,554.452],[841.21,443.111],[955.82,553.857],[955.82,446.876]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[841.21,567.208],[841.211,678.55],[955.82,566.114],[955.82,673.095]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[841.21,698.473],[841.211,809.815],[955.82,692.238],[955.82,799.219]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[938.992,302.344],[938.992,196.815],[1069.37,307.165],[1069.37,203.785]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1010.95,427.659],[1010.94,317.584],[955.82,430.796],[955.82,323.815]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1010.95,554.279],[1010.94,444.204],[955.82,553.857],[955.82,446.876]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1010.94,566.891],[1010.95,676.965],[955.82,566.114],[955.82,673.095]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1010.94,696.662],[1010.95,806.737],[955.82,692.238],[955.82,799.219]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1008.57,827.063],[1008.57,937.116],[953.747,819.008],[953.747,925.981]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1008.57,827.063],[1008.57,937.116],[1148.5,819.987],[1148.5,927.333]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1010.95,427.659],[1010.95,317.584],[1143.36,430.235],[1143.36,322.7]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1010.95,554.279],[1010.95,444.204],[1143.36,553.932],[1143.36,446.398]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1010.95,566.891],[1010.95,676.965],[1143.36,566.253],[1143.36,673.787]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1010.95,696.662],[1010.95,806.737],[1143.36,693.029],[1143.36,800.564]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1077.97,306.176],[1077.97,202.355],[1194.22,312.948],[1194.22,212.143]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1130.03,434.488],[1130.03,327.673],[1420.44,446.022],[1420.44,350.967]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1130.03,557.357],[1130.03,450.542],[1420.44,555.364],[1420.44,460.309]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1130.03,569.595],[1130.03,676.41],[1420.44,566.254],[1420.44,661.309]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1130.03,695.523],[1130.03,802.338],[1420.44,678.318],[1420.44,773.373]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1130.03,818.595],[1130.03,925.41],[1420.44,787.841],[1420.44,882.895]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1194.22,312.948],[1194.22,212.143],[1300.53,322.296],[1300.53,225.655]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1300.53,322.296],[1300.53,225.655],[1365.37,331.331],[1365.37,238.713]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1361.48,332.277],[1361.48,240.083],[1404.49,341.317],[1404.49,253.149]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1404.49,341.317],[1404.49,253.149],[1420.15,347.621],[1420.15,262.261]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1442.19,442.648],[1442.19,347.359],[1486.82,446.922],[1486.82,355.848]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1442.19,552.261],[1442.19,456.971],[1486.82,551.685],[1486.82,460.611]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1442.19,563.178],[1442.19,658.468],[1486.82,562.12],[1486.82,653.194]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1442.19,675.519],[1442.19,770.809],[1486.82,669.491],[1486.82,760.565]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1437.87,788.972],[1437.87,884.46],[1485.69,777.296],[1485.69,868.318]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1426.59,772.42],[1426.59,861.579],[1505.52,764.559],[1505.52,850.712]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1429.87,449.08],[1429.87,360.134],[1503.59,451.923],[1503.59,365.782]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1429.87,551.395],[1429.87,462.449],[1503.59,551.012],[1503.59,464.871]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1429.87,561.585],[1429.87,650.531],[1503.59,560.881],[1503.59,647.022]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1429.87,666.447],[1429.87,755.393],[1503.59,662.436],[1503.59,748.578]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1471.81,453.054],[1471.81,368.029],[1505.66,454.326],[1505.66,370.554]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1471.81,550.86],[1471.81,465.834],[1505.66,550.688],[1505.66,466.917]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1471.81,560.601],[1471.81,645.626],[1505.66,560.286],[1505.66,644.058]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:70,
                    verts:[[1471.81,660.841],[1471.81,745.866],[1505.66,659.048],[1505.66,742.819]]
                },
                ],
                [
                {
                    num:"102",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[555.502,805.658],[555.502,907.526],[416.938,786.165],[416.938,880.579]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[556.057,435.95],[556.057,334.052],[417.414,443.51],[417.414,349.071]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[556.057,553.163],[556.057,451.265],[417.414,552.145],[417.414,457.705]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[556.057,564.837],[556.057,666.735],[417.414,562.965],[417.414,657.404]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[556.057,684.969],[556.057,786.866],[417.414,674.303],[417.414,768.743]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[550.733,328.674],[550.733,234.874],[518.898,332.223],[518.898,240.004]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[541.97,321.762],[541.97,224.883],[521.21,326.407],[521.21,231.598]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[558.961,318.39],[558.961,220.009],[541.97,321.762],[541.97,224.883]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[719.488,427.037],[719.488,316.348],[556.917,435.903],[556.917,333.959]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[719.488,554.363],[719.488,443.674],[556.917,553.169],[556.917,451.225]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[719.488,567.045],[719.488,677.734],[556.917,564.849],[556.917,666.793]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[719.488,697.54],[719.488,808.229],[556.917,685.035],[556.917,786.978]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[719.488,828.727],[719.488,939.416],[556.917,805.857],[556.917,907.801]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[589.186,313.446],[589.186,212.863],[558.961,318.39],[558.961,220.009]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[638.99,309.271],[638.99,206.829],[592.892,313.208],[592.892,212.519]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[673.129,306.789],[673.129,203.242],[638.99,309.271],[638.99,206.829]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[723.547,303.446],[723.547,198.409],[673.129,306.789],[673.129,203.242]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[806.859,426.353],[806.859,314.99],[719.487,427.037],[719.487,316.348]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[806.859,554.455],[806.859,443.092],[719.487,554.363],[719.487,443.674]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[806.859,567.214],[806.859,678.577],[719.487,567.045],[719.487,677.734]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[806.859,698.505],[806.859,809.868],[719.487,697.541],[719.487,808.229]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[807.181,830.443],[807.181,941.788],[719.487,828.727],[719.487,939.416]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[723.548,303.446],[723.548,198.409],[753.833,306.224],[753.833,202.425]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[794.287,301.718],[794.287,195.912],[753.834,306.224],[753.834,202.425]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[882.349,301.647],[794.286,301.719],[882.349,195.809],[794.286,195.912]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[806.859,426.353],[806.859,314.99],[859.679,428.751],[859.679,319.753]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[806.859,554.455],[806.859,443.092],[859.679,554.132],[859.679,445.134]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[806.859,567.214],[806.859,678.577],[859.679,566.62],[859.679,675.618]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[806.859,698.505],[806.859,809.868],[859.679,695.122],[859.679,804.12]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[807.181,830.443],[807.181,941.788],[857.525,824.547],[857.525,933.638]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[892.913,829.145],[892.913,939.994],[857.525,824.547],[857.525,933.638]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[893.783,427.037],[893.782,316.348],[859.68,428.751],[859.68,319.753]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[893.783,554.363],[893.782,443.674],[859.68,554.132],[859.68,445.134]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[893.782,567.045],[893.783,677.734],[859.68,566.62],[859.68,675.618]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[893.782,697.541],[893.783,808.23],[859.68,695.122],[859.68,804.12]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[882.349,301.648],[882.349,195.809],[976.816,304.455],[976.816,199.868]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[893.782,427.037],[893.781,316.348],[996.808,431.854],[996.807,325.917]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[893.782,554.363],[893.781,443.674],[996.808,553.714],[996.807,447.777]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[893.781,567.045],[893.782,677.734],[996.807,565.852],[996.808,671.789]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[893.781,697.541],[893.782,808.23],[996.807,690.745],[996.808,796.682]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[892.913,829.145],[892.913,939.994],[1002.92,815.862],[1002.92,921.631]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[976.816,304.456],[976.816,199.868],[1099.75,310.341],[1099.75,208.375]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1058.18,429.031],[1058.18,320.31],[996.808,431.854],[996.807,325.917]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1058.18,554.094],[1058.18,445.373],[996.808,553.714],[996.807,447.777]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1058.18,566.551],[1058.18,675.272],[996.807,565.852],[996.808,671.789]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1058.18,694.727],[1058.18,803.448],[996.807,690.745],[996.808,796.682]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1055.8,823.552],[1055.8,932.261],[994.747,816.301],[994.747,922.239]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1055.8,823.552],[1055.8,932.261],[1185.94,815.149],[1185.94,920.645]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1058.18,429.031],[1058.18,320.31],[1181.38,432.095],[1181.38,326.395]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1058.18,554.094],[1058.18,445.373],[1181.38,553.682],[1181.38,447.982]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1058.18,566.551],[1058.18,675.272],[1181.38,565.792],[1181.38,671.492]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1058.18,694.727],[1058.18,803.448],[1181.38,690.406],[1181.38,796.106]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1109.18,309.456],[1109.18,207.096],[1215.19,317.054],[1215.19,218.078]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1166.78,436.212],[1166.78,331.155],[1419.27,448.444],[1419.27,355.859]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1166.78,557.059],[1166.78,452.002],[1419.27,554.945],[1419.27,462.36]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1166.78,569.096],[1166.78,674.152],[1419.27,565.553],[1419.27,658.138]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1166.78,692.951],[1166.78,798.008],[1419.27,674.705],[1419.27,767.29]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1166.78,813.998],[1166.78,919.055],[1419.27,781.382],[1419.27,873.967]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1215.19,317.054],[1215.19,218.078],[1308.18,326.995],[1308.18,232.447]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1308.18,326.994],[1308.18,232.447],[1361.21,336.238],[1361.21,245.806]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1356.53,337.12],[1356.53,247.083],[1388.54,346.169],[1388.54,260.163]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1440.5,445.24],[1440.5,352.507],[1473.41,449.505],[1473.41,360.978]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1440.5,551.912],[1440.5,459.178],[1473.41,551.337],[1473.41,462.811]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1440.5,562.536],[1440.5,655.27],[1473.41,561.48],[1473.41,650.007]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1440.5,671.863],[1440.5,764.597],[1473.41,665.848],[1473.41,754.374]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1436.83,782.307],[1436.83,875.246],[1472.22,770.649],[1472.22,859.13]]
                },{
                    num:"105",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1411.85,766.481],[1411.85,853.369],[1480.12,758.238],[1480.12,841.974]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1414.5,451.385],[1414.5,364.714],[1478.26,454.367],[1478.26,370.636]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1414.5,551.084],[1414.5,464.413],[1478.26,550.683],[1478.26,466.952]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1414.5,561.014],[1414.5,647.686],[1478.26,560.276],[1478.26,644.007]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:71,
                    verts:[[1414.5,663.195],[1414.5,749.867],[1478.26,658.99],[1478.26,742.72]]
                },
                ],
                [
                {
                    num:"102",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[585.529,807.23],[585.529,909.699],[425.632,789.237],[425.632,884.825]]
                },{
                    num:"502",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[586.164,435.343],[586.164,332.847],[426.185,442.321],[426.185,346.709]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[586.164,553.245],[586.164,450.748],[426.185,552.305],[426.185,456.693]]
                },{
                    num:"302",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[586.164,564.988],[586.164,667.484],[426.185,563.259],[426.185,658.871]]
                },{
                    num:"202",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[586.164,685.824],[586.164,788.32],[426.185,675.98],[426.185,771.593]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[561.144,327.156],[561.144,232.68],[524.828,330.424],[524.828,237.403]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[559.681,320.212],[559.681,222.643],[533.488,324.654],[533.488,229.064]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[580.612,317.01],[580.612,218.015],[559.681,320.212],[559.681,222.643]]
                },{
                    num:"602",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[616.624,312.373],[616.624,211.312],[580.612,317.01],[580.612,218.015]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[772.112,427.231],[772.112,316.734],[587.15,435.3],[587.15,332.761]]
                },{
                    num:"402",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[772.112,554.337],[772.112,443.84],[587.15,553.25],[587.15,450.712]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[772.112,566.997],[772.112,677.494],[587.15,564.998],[587.15,667.537]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[772.112,697.266],[772.112,807.764],[587.15,685.885],[587.15,788.424]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[772.112,828.226],[772.112,938.723],[587.15,807.412],[587.15,909.951]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[671.491,308.687],[671.491,205.985],[620.638,312.17],[620.638,211.019]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[708.557,306.545],[708.557,202.888],[671.491,308.687],[671.491,205.985]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[762.755,303.709],[762.755,198.79],[708.556,306.545],[708.556,202.888]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[762.756,303.709],[762.756,198.79],[790.147,306.72],[790.147,203.141]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[860.903,426.941],[860.903,316.157],[772.111,427.231],[772.111,316.734]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[860.903,554.376],[860.903,443.592],[772.111,554.337],[772.111,443.84]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[860.903,567.068],[860.903,677.852],[772.111,566.997],[772.111,677.494]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[860.903,697.676],[860.903,808.459],[772.111,697.266],[772.111,807.764]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[861.179,828.924],[772.111,828.226],[861.179,939.688],[772.111,938.723]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[835.289,302.66],[835.289,197.273],[790.147,306.72],[790.147,203.141]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[835.288,302.661],[922.843,303.397],[835.288,197.274],[922.843,198.338]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[860.903,426.941],[860.903,316.157],[907.787,429.516],[907.787,321.272]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[860.903,554.376],[860.903,443.592],[907.787,554.029],[907.787,445.785]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[860.903,567.068],[860.903,677.852],[907.787,566.431],[907.787,674.674]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[860.903,697.676],[860.903,808.459],[907.787,694.044],[907.787,802.287]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[861.179,828.924],[861.179,939.688],[905.869,822.593],[905.869,930.936]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[945.002,826.697],[945.002,936.61],[905.869,822.593],[905.869,930.936]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[945.488,427.986],[945.487,318.233],[907.787,429.516],[907.787,321.272]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[945.488,554.235],[945.487,444.482],[907.787,554.029],[907.787,445.785]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[945.487,566.81],[945.488,676.563],[907.787,566.431],[907.787,674.674]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[945.487,696.202],[945.488,805.955],[907.787,694.044],[907.787,802.287]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[922.843,303.397],[922.843,198.338],[1013.12,306.994],[1013.12,203.537]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[945.487,427.986],[945.486,318.233],[1035.89,433.117],[1035.89,328.425]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[945.487,554.235],[945.486,444.482],[1035.89,553.544],[1035.89,448.852]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[945.486,566.81],[945.487,676.563],[1035.89,565.539],[1035.89,670.231]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[945.486,696.202],[945.487,805.955],[1035.89,688.965],[1035.89,793.657]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[945.001,826.697],[945.001,936.609],[1041.49,812.552],[1041.49,917.056]]
                },{
                    num:"601",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1013.12,306.994],[1013.12,203.537],[1127.4,313.804],[1127.4,213.381]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1102.37,430.625],[1102.37,323.475],[1035.89,433.117],[1035.89,328.425]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1102.37,553.88],[1102.37,446.73],[1035.89,553.544],[1035.89,448.852]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1102.37,566.156],[1102.37,673.306],[1035.89,565.539],[1035.89,670.231]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1102.37,692.48],[1102.37,799.629],[1035.89,688.965],[1035.89,793.657]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1100.02,819.468],[1100.02,926.616],[1033.86,813.067],[1033.86,917.767]]
                },{
                    num:"101",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1100.02,819.468],[1100.02,926.616],[1219.13,809.95],[1219.13,913.458]]
                },{
                    num:"501",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1102.37,430.625],[1102.37,323.475],[1215.18,434.099],[1215.18,330.375]]
                },{
                    num:"401",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1102.37,553.88],[1102.37,446.73],[1215.18,553.412],[1215.18,449.689]]
                },{
                    num:"301",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1102.37,566.156],[1102.37,673.306],[1215.18,565.296],[1215.18,669.019]]
                },{
                    num:"201",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1102.37,692.48],[1102.37,799.629],[1215.18,687.58],[1215.18,791.303]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1137.48,313.026],[1137.48,212.257],[1232.6,321.293],[1232.6,224.206]]
                },{
                    num:"506",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1199.58,438.073],[1199.58,334.915],[1414.06,450.791],[1414.06,360.599]]
                },{
                    num:"406",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1199.58,556.737],[1199.58,453.579],[1414.06,554.54],[1414.06,464.348]]
                },{
                    num:"306",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1199.58,568.556],[1199.58,671.715],[1414.06,564.873],[1414.06,655.065]]
                },{
                    num:"206",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1199.58,690.175],[1199.58,793.333],[1414.06,671.204],[1414.06,761.396]]
                },{
                    num:"106",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1199.58,809.034],[1199.58,912.193],[1414.06,775.124],[1414.06,865.316]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1232.6,321.293],[1232.6,224.206],[1312.18,331.659],[1312.18,239.189]]
                },{
                    num:"606",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1312.18,331.659],[1312.18,239.189],[1353.79,340.991],[1353.79,252.676]]
                },{
                    num:"605",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1348.41,341.807],[1348.41,253.858],[1370.01,350.774],[1370.01,266.819]]
                },{
                    num:"505",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1434.6,447.746],[1434.6,357.484],[1456.53,451.957],[1456.53,365.849]]
                },{
                    num:"405",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1434.6,551.574],[1434.6,461.312],[1456.53,551.007],[1456.53,464.899]]
                },{
                    num:"305",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1434.6,561.916],[1434.6,652.178],[1456.53,560.873],[1456.53,646.981]]
                },{
                    num:"205",
                    tipo:"TorreC",
                    frame:72,
                    verts:[[1434.6,668.329],[1434.6,758.591],[1456.53,662.389],[1456.53,748.497]]
                },
                ],
                [
                
                ]
        ]
    }
}